(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9891],{

/***/ 79274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78593);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(70131);





var AnimateInView = function(param) {
    var children = param.children, _duration = param.duration, duration = _duration === void 0 ? 1 : _duration, variants = param.variants;
    var controls = (0,framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .useAnimation */ ._7)();
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__/* .useInView */ .YD)(), 2), ref1 = ref[0], inView = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (inView) {
            controls.start("visible");
        }
    }, [
        controls,
        inView
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_1__/* .motion.div */ .ww.div, {
        ref: ref1,
        animate: controls,
        initial: "hidden",
        transition: {
            duration: duration
        },
        variants: variants !== null && variants !== void 0 ? variants : {
            visible: {
                opacity: 1
            },
            hidden: {
                opacity: 0,
                scale: 1
            }
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (AnimateInView);


/***/ }),

/***/ 71137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Lottie; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(60460);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11248);
/* harmony import */ var lottie_web__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lottie_web__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);











var Lottie = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Lottie, _Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Lottie);
    function Lottie() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, Lottie);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "handleClickToPause", function() {
            if (_this.anim.isPaused) {
                _this.anim.play();
            } else {
                _this.anim.pause();
            }
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(Lottie, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _props = this.props, options = _props.options, eventListeners = _props.eventListeners;
                var loop = options.loop, autoplay = options.autoplay, animationData = options.animationData, rendererSettings = options.rendererSettings, segments = options.segments;
                this.options = {
                    container: this.el,
                    renderer: "svg",
                    loop: loop !== false,
                    autoplay: autoplay !== false,
                    segments: segments !== false,
                    animationData: animationData,
                    rendererSettings: rendererSettings
                };
                this.options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.options, options);
                this.anim = lottie_web__WEBPACK_IMPORTED_MODULE_1___default().loadAnimation(this.options);
                this.registerEvents(eventListeners);
                this.first = true;
                this.anim.setSpeed(1);
                // console.log(this.props.speed);
                if (this.props.speed === 1) this.anim.goToAndPlay(1000000, false);
            }
        },
        {
            // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
            key: "componentWillUpdate",
            value: function componentWillUpdate(nextProps /* , nextState */ ) {
                /* Recreate the animation handle if the data is changed */ if (this.options.animationData !== nextProps.options.animationData) {
                    this.deRegisterEvents(this.props.eventListeners);
                    this.destroy();
                    this.options = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({}, this.options, nextProps.options);
                    this.anim = lottie_web__WEBPACK_IMPORTED_MODULE_1___default().loadAnimation(this.options);
                    this.registerEvents(nextProps.eventListeners);
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.props.isStopped) {
                    this.stop();
                } else if (this.props.segments) {
                    this.playSegments();
                } else {
                    this.play();
                }
                // console.log(this.first);
                this.pause();
                this.setSpeed();
                this.setDirection();
            // this.setFinished();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.deRegisterEvents(this.props.eventListeners);
                this.destroy();
                this.options.animationData = null;
                this.anim = null;
            }
        },
        {
            // setFinished() {
            //   if (this.props.finished === true) {
            //     //   this.anim.goToAndPlay(1000, false);
            //   }
            // }
            key: "setSpeed",
            value: function setSpeed() {
                this.anim.setSpeed(this.props.speed);
            // this.first = false;
            }
        },
        {
            key: "setDirection",
            value: function setDirection() {
                this.anim.setDirection(this.props.direction);
            }
        },
        {
            key: "play",
            value: function play() {
                this.anim.play();
            }
        },
        {
            key: "playSegments",
            value: function playSegments() {
                this.anim.playSegments(this.props.segments);
            }
        },
        {
            key: "stop",
            value: function stop() {
                this.anim.stop();
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this.props.isPaused && !this.anim.isPaused) {
                    this.anim.pause();
                } else if (!this.props.isPaused && this.anim.isPaused) {
                    this.anim.pause();
                }
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                this.anim.destroy();
            }
        },
        {
            key: "registerEvents",
            value: function registerEvents(eventListeners) {
                var _this = this;
                eventListeners.forEach(function(eventListener) {
                    _this.anim.addEventListener(eventListener.eventName, eventListener.callback);
                });
            }
        },
        {
            key: "deRegisterEvents",
            value: function deRegisterEvents(eventListeners) {
                var _this = this;
                eventListeners.forEach(function(eventListener) {
                    _this.anim.removeEventListener(eventListener.eventName, eventListener.callback);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, width = _props.width, height = _props.height, ariaRole = _props.ariaRole, ariaLabel = _props.ariaLabel, isClickToPauseDisabled = _props.isClickToPauseDisabled, title = _props.title;
                var getSize = function(initial) {
                    var size;
                    if (typeof initial === "number") {
                        size = "".concat(initial, "px");
                    } else {
                        size = initial || "100%";
                    }
                    return size;
                };
                var lottieStyles = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                    width: getSize(width),
                    height: getSize(height),
                    overflow: "hidden",
                    margin: "0 auto",
                    outline: "none"
                }, this.props.style);
                var onClickHandler = isClickToPauseDisabled ? function() {
                    return null;
                } : this.handleClickToPause;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    ref: function(c) {
                        _this.el = c;
                    },
                    style: lottieStyles,
                    onClick: onClickHandler,
                    title: title,
                    role: ariaRole,
                    "aria-label": ariaLabel,
                    tabIndex: "0"
                });
            }
        }
    ]);
    return Lottie;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);

Lottie.propTypes = {
    eventListeners: prop_types__WEBPACK_IMPORTED_MODULE_10___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_10___default().object)),
    options: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object.isRequired),
    height: prop_types__WEBPACK_IMPORTED_MODULE_10___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number)
    ]),
    width: prop_types__WEBPACK_IMPORTED_MODULE_10___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number)
    ]),
    isStopped: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    isPaused: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    speed: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    segments: prop_types__WEBPACK_IMPORTED_MODULE_10___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_10___default().number)),
    direction: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    ariaRole: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    ariaLabel: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    isClickToPauseDisabled: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    title: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    style: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().any),
    mode: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string)
};
Lottie.defaultProps = {
    eventListeners: [],
    isStopped: false,
    isPaused: false,
    speed: 1,
    ariaRole: "button",
    ariaLabel: "animation",
    isClickToPauseDisabled: false,
    title: "",
    finished: false
};


/***/ }),

/***/ 23108:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78593);



var ParallaxEffect = function(param) {
    var _offset = param.offset, offset = _offset === void 0 ? 35 : _offset, children = param.children;
    var prefersReducedMotion = (0,framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .useReducedMotion */ .JZ)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), elementTop = ref[0], setElementTop = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), clientHeight = ref1[0], setClientHeight = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var scrollY = (0,framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .useViewportScroll */ .ME)().scrollY;
    var initial = elementTop - clientHeight;
    var final = elementTop + offset;
    var yRange = (0,framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .useTransform */ .Hm)(scrollY, [
        initial,
        final
    ], [
        offset,
        -offset
    ]);
    var y = (0,framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .useSpring */ .q_)(yRange, {
        stiffness: 400,
        damping: 90
    });
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useLayoutEffect)(function() {
        var element = ref2.current;
        var onResize = function() {
            if (element === null) {
                return;
            }
            var _top;
            setElementTop(((_top = element.getBoundingClientRect().top) !== null && _top !== void 0 ? _top : 0) + window.scrollY || window.pageYOffset);
            setClientHeight(window.innerHeight);
        };
        onResize();
        window.addEventListener("resize", onResize);
        return function() {
            return window.removeEventListener("resize", onResize);
        };
    }, [
        ref2
    ]);
    // Don't parallax if the user has "reduced motion" enabled
    if (prefersReducedMotion) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(framer_motion__WEBPACK_IMPORTED_MODULE_2__/* .motion.div */ .ww.div, {
        ref: ref2,
        style: {
            y: y
        },
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ParallaxEffect);


/***/ }),

/***/ 69119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51599);







var APP_STATS = {
    rating: utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_3__/* ["default"].appScore */ .Z.appScore,
    installs: utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_3__/* ["default"].installCount */ .Z.installCount
};
var AppStats = function(_param) {
    var containersStyle = _param.containersStyle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "containersStyle"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                alignItems: "center",
                flexDir: "column",
                justifyContent: isMobileView ? "center" : "flex-start"
            }, containersStyle), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.GooglePlayColoredSvg, {}),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.AppStoreColoredSvg, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                        size: "m",
                        type: "bold",
                        children: APP_STATS.installs
                    })
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                alignItems: "center",
                ml: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.L.rem,
                flexDir: "column",
                justifyContent: isMobileView ? "center" : "flex-start"
            }, containersStyle), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.StarFullSvg, {
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].secondary.default
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.StarFullSvg, {
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].secondary.default
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.StarFullSvg, {
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].secondary.default
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.StarFullSvg, {
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].secondary.default
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.StarHalfSvg, {
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].secondary.default
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                        type: "bold",
                        size: "m",
                        children: APP_STATS.rating
                    })
                ]
            }))
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (AppStats);


/***/ }),

/***/ 26202:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var hooks_purchases_useCurrentSubscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12678);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var providers_hooks_useProfile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2334);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var theme_icons_ProBadgeSvg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(76476);
/* harmony import */ var theme_icons_ProShieldSvg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(59352);
/* harmony import */ var types_enums__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41390);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63069);
/* harmony import */ var _paywall_WhatsIncludedDropdown__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71278);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(14531);















var GetTheAppBanner = function(_param) {
    var isNsi = _param.isNsi, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_param, [
        "isNsi"
    ]);
    var isDesktopView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsDesktopView)();
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var profile = (0,providers_hooks_useProfile__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().profile;
    var currentSubscription = (0,hooks_purchases_useCurrentSubscription__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().currentSubscription;
    var isPro = (profile === null || profile === void 0 ? void 0 : profile.subscriptionType) === types_enums__WEBPACK_IMPORTED_MODULE_8__/* .UserSubscriptionType.Premium */ .A5.Premium;
    var subscriptionLoaded = !!profile && (profile.subscriptionType !== types_enums__WEBPACK_IMPORTED_MODULE_8__/* .UserSubscriptionType.Premium */ .A5.Premium || !!currentSubscription);
    var isLifetime = isPro && currentSubscription ? Date.parse(currentSubscription.endDate) > new Date(2050, 1, 1).getTime() : false;
    var title = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryHeading, {
        size: "h3",
        textSize: "l",
        type: "bold",
        textAlign: "left",
        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
        children: isPro ? "Special Sale" : "Read like a Pro"
    });
    var renderCard = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
            flexDir: "column",
            alignItems: {
                base: "flex-start",
                md: "center"
            },
            backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface,
            w: {
                base: "100%",
                md: (0,utils_global__WEBPACK_IMPORTED_MODULE_9__/* .getRemWidthFromColumns */ ._P)(4)
            },
            background: "linear-gradient(180deg, ".concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].top, " 0%, ").concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].background, " 100%)"),
            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
            onClick: function() {
                return isPro ? router.push(utils_constants__WEBPACK_IMPORTED_MODULE_11__/* .STRIPE_URLS.LIFETIME_199 */ .b6.LIFETIME_199) : router.push("/special-offer");
            },
            cursor: "pointer",
            position: "relative",
            boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.1); 0px 8px 4px rgba(0, 0, 0, 0.05);",
            _hover: {
                transform: "scale(1.01)",
                boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.2); 0px 8px 4px rgba(0, 0, 0, 0.1);"
            },
            transition: "all 0.3s cubic-bezier(.11,.57,.44,.8)",
            borderRadius: "1rem",
            overflow: "hidden"
        }, props), {
            children: [
                isPro && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    w: "100%",
                    height: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(48),
                    backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.failure.darker,
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.light.textInverted,
                    alignItems: "center",
                    justifyContent: "center",
                    position: "absolute",
                    zIndex: 1,
                    top: 48,
                    right: -104,
                    transform: {
                        base: "",
                        md: "rotate(45deg)"
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                        fontSize: "2rem",
                        type: "bold",
                        children: "-$100 OFF"
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                    position: "absolute",
                    w: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(192),
                    right: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(-72),
                    top: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(16),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(theme_icons_ProShieldSvg__WEBPACK_IMPORTED_MODULE_7__/* .ProShieldSvg */ .f, {
                        width: 192,
                        height: 192
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    flexDir: "column",
                    alignItems: "start",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                            flexDir: "column",
                            mx: utils_global__WEBPACK_IMPORTED_MODULE_9__/* .SQUARE_WIDTH_REM */ .wY,
                            my: utils_global__WEBPACK_IMPORTED_MODULE_9__/* .SQUARE_WIDTH_REM */ .wY,
                            children: [
                                title,
                                isPro && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryHeading, {
                                    size: "h4",
                                    textSize: "s",
                                    type: "bold",
                                    textAlign: "left",
                                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                                    children: "Lifetime Plan"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                            w: (0,utils_global__WEBPACK_IMPORTED_MODULE_9__/* .getRemWidthFromColumns */ ._P)(4),
                            overflow: "hidden",
                            mb: utils_global__WEBPACK_IMPORTED_MODULE_9__/* .SQUARE_WIDTH_REM */ .wY,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                                flexDir: "column",
                                ml: utils_global__WEBPACK_IMPORTED_MODULE_9__/* .SQUARE_WIDTH_REM */ .wY,
                                mr: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(8),
                                gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(8),
                                width: "230px",
                                minWidth: "144px",
                                children: _paywall_WhatsIncludedDropdown__WEBPACK_IMPORTED_MODULE_10__/* .PAYWALL_INCLUDED_LIST.map */ .L.map(function(included, index) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                                        gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(8),
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                                                alignItems: "center",
                                                borderRadius: "full",
                                                boxSize: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(32),
                                                p: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(4),
                                                children: included.renderIcon(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text)
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.medium.regular), {
                                                children: included.text
                                            }))
                                        ]
                                    }, "paywall-included-".concat(index));
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    w: "100%",
                    flexDirection: "column",
                    paddingX: utils_global__WEBPACK_IMPORTED_MODULE_9__/* .SQUARE_WIDTH_REM */ .wY,
                    alignItems: "center",
                    mb: isPro ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(24) : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
                    zIndex: 0,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryButton, {
                            h: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(48),
                            w: "100%",
                            backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                            _hover: undefined,
                            _active: undefined,
                            mb: isPro ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(8) : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                                alignItems: "center",
                                gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XXS.rem,
                                justifyContent: "center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, {
                                        fontWeight: 400,
                                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textInverted,
                                        children: isPro ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: "Claim Lifetime"
                                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                            children: [
                                                "Get deep",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                                    children: "stash"
                                                })
                                            ]
                                        })
                                    }),
                                    " ",
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(theme_icons_ProBadgeSvg__WEBPACK_IMPORTED_MODULE_6__/* .ProBadgeSvg */ .r, {
                                        height: 20
                                    }),
                                    isPro && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, {
                                        fontWeight: 400,
                                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textInverted,
                                        children: [
                                            " ",
                                            "Offer"
                                        ]
                                    })
                                ]
                            })
                        }),
                        isPro && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.medium.semiBold), {
                            textAlign: "left",
                            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.failure.darker,
                            children: [
                                "Only ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    style: {
                                        textDecoration: "line-through"
                                    },
                                    children: "$299.99"
                                }),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                    children: "$199.99"
                                }),
                                ". Pay once."
                            ]
                        }))
                    ]
                })
            ]
        }));
    };
    return isNsi || isDesktopView && !isLifetime && subscriptionLoaded ? renderCard() : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (GetTheAppBanner);


/***/ }),

/***/ 31072:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63069);
/* harmony import */ var utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89134);
/* harmony import */ var _app_stats_AppStats__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69119);
/* harmony import */ var _cards_BaseCard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46039);











var SIGN_UP_BENEFITS = [
    {
        text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                    children: "Replace doomscrolling"
                }),
                " with 200,000+ curated ideas"
            ]
        }),
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.BookSvg, {
            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.light.top
        })
    },
    {
        text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                "Unlock ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                    children: "100+"
                }),
                " tailored journeys on over ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                    children: "50"
                }),
                " topics"
            ]
        }),
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.StarFullSvg, {
            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.light.top
        })
    },
    {
        text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                "Unlock unlimited ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                    children: "listening"
                }),
                " to all of our ideas"
            ]
        }),
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.HeadphonesSvg, {
            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.light.top
        })
    },
    {
        text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: "Get rid of all ads"
        }),
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.CheckSvg, {
            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.light.top
        })
    },
    {
        text: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                "Get access to the ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                    children: "mobile app"
                })
            ]
        }),
        icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PhoneSvg, {
            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.light.top
        })
    }, 
];
var SignUpBanner = function(_param) {
    var size = _param.size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "size"
    ]);
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    // const { nsiDispatch } = useNsi();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var isSmallStyle = isMobileView || size === "sm";
    var openSignUp = function(e) {
        e.stopPropagation();
        router.push("/setup?from=banner");
    // TODO No Trial Changes
    // nsiDispatch({
    //   type: 'openAuth',
    //   payload: {
    //     type: 'sign-up',
    //     onAuthSuccess: () => router.push('/setup'),
    //     shouldSkipOnboarding: true,
    //   },
    // });
    // Analytics.logEvent({
    //   eventName: Events.modals.openAuthModal,
    //   properties: {
    //     location: 'feed-banner',
    //     chosenOption: 'signup',
    //   },
    //   platforms: ['amplitude'],
    // });
    };
    var title = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryHeading, {
        size: "h3",
        textSize: "l",
        type: "bold",
        textAlign: "left",
        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
        children: [
            "It's time to ",
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                w: "auto",
                display: "inline-flex",
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Icon, {
                        viewBox: "0 0 53 13",
                        width: "100%",
                        height: 13,
                        fill: "none",
                        bottom: 2,
                        preserveAspectRatio: "none",
                        position: "absolute",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            opacity: 0.8,
                            fillRule: "evenodd",
                            clipRule: "evenodd",
                            d: "M3.788 2.298c-2.867.448-3.186.783-2.335 2.356.935 1.743-1.847 2.921 3.168 2.705-5.369.423-4.103 1.534-3.378 3.56.926 2.542 6.476 1.838 33.523-.204 8.104-.594 12.62-.197 14.92-.555 3.191-.518 2.359-2.49 1.01-3.315l.726-.279c1.911-.726.663-4.262-1.827-5.13-2.19-.758-14.677-.749-26.686.02-15.885 1.075-15.848.318-19.12.842Z",
                            fill: colorMode === "light" ? "#FFE34C" : "#474733"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        style: {
                            zIndex: 1,
                            fontWeight: 900,
                            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].primary.default
                        },
                        children: "Read like a Pro."
                    })
                ]
            })
        ]
    });
    var description = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
        flexDir: "column",
        alignItems: "center",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
            size: "s",
            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
            textAlign: "start",
            my: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
            children: [
                "Jump-start your",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                    size: "m",
                    type: "bold",
                    display: "inline",
                    children: " reading habits"
                }),
                ", gather your ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                    size: "m",
                    type: "bold",
                    display: "inline",
                    children: "knowledge"
                }),
                ", ",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                    size: "m",
                    type: "bold",
                    display: "inline",
                    children: "remember what you read "
                }),
                "and stay ahead of the crowd!"
            ]
        })
    });
    var benefits = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
        flexDirection: "column",
        my: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
        gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem,
        children: SIGN_UP_BENEFITS.map(function(benefit, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(8),
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        alignItems: "center",
                        bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].primary.default,
                        borderRadius: "full",
                        boxSize: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(24),
                        p: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(4),
                        children: benefit.icon
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                        size: "m",
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                        children: benefit.text
                    })
                ]
            }, "paywall-included-".concat(index));
        })
    });
    var renderDesktopVersion = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_cards_BaseCard__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
            h: "auto",
            hasHoverEffect: true,
            alignItems: isSmallStyle ? "center" : "flex-start",
            backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface,
            p: utils_global__WEBPACK_IMPORTED_MODULE_4__/* .SQUARE_WIDTH_REM */ .wY,
            w: {
                base: "100%",
                md: isSmallStyle ? (0,utils_global__WEBPACK_IMPORTED_MODULE_4__/* .getRemWidthFromColumns */ ._P)(4) : (0,utils_global__WEBPACK_IMPORTED_MODULE_4__/* .getRemWidthFromColumns */ ._P)(8)
            },
            cursor: "pointer",
            onClick: function() {
                // TODO Add analytics
                router.push("/get-pro");
            },
            gridGap: utils_global__WEBPACK_IMPORTED_MODULE_4__/* .GAP_SIZE_REM */ .L3
        }, props), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    flexDir: "column",
                    w: isSmallStyle ? "100%" : (0,utils_global__WEBPACK_IMPORTED_MODULE_4__/* .getRemWidthFromColumns */ ._P)(4),
                    children: [
                        title,
                        !isSmallStyle && description,
                        isSmallStyle && benefits,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryButton, {
                            my: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
                            w: "100%",
                            onClick: function(e) {
                                return openSignUp(e);
                            },
                            size: "md",
                            backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].primary.default,
                            _hover: undefined,
                            _active: undefined,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                                size: "l",
                                type: "semiBold",
                                children: utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_5__/* ["default"].startToday */ .Z.startToday
                            })
                        }),
                        isSmallStyle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_stats_AppStats__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            mt: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
                            w: "100%",
                            justifyContent: "center"
                        })
                    ]
                }),
                !isSmallStyle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    flexDirection: "column",
                    w: (0,utils_global__WEBPACK_IMPORTED_MODULE_4__/* .getRemWidthFromColumns */ ._P)(4),
                    children: [
                        benefits,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_stats_AppStats__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                            mt: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(48),
                            w: "100%",
                            justifyContent: "start"
                        })
                    ]
                })
            ]
        }));
    };
    return renderDesktopVersion();
};
/* harmony default export */ __webpack_exports__["Z"] = (SignUpBanner);


/***/ }),

/***/ 920:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_schemaorg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45363);








var BackButton = function(_param) {
    var items = _param.items, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "items"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var structuredDataObject = !!items.length ? (0,react_schemaorg__WEBPACK_IMPORTED_MODULE_4__/* .jsonLdScriptProps */ .h6)({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: items.map(function(item, index) {
            return {
                "@type": "ListItem",
                position: index + 1,
                item: {
                    "@id": "https://deepstash.com" + item.link,
                    name: item.title
                }
            };
        })
    }) : undefined;
    return !!items.length ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, structuredDataObject))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Breadcrumb, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                opacity: 0.6
            }, props), {
                children: items.map(function(item, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.BreadcrumbItem, {
                        isCurrentPage: index === items.length - 1,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.BreadcrumbLink, {
                            href: item.link,
                            children: item.title
                        })
                    }, index);
                })
            }))
        ]
    }) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (BackButton);


/***/ }),

/***/ 53032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63069);
/* harmony import */ var utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51599);
/* harmony import */ var _metacontent_components_SubsectionHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17005);









var CuratorsNote = function(_param) {
    var text = _param.text, quoteColor = _param.quoteColor, showLabel = _param.showLabel, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "text",
        "quoteColor",
        "showLabel"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        width: "100%"
    }, props), {
        flexDirection: "column",
        children: [
            showLabel && (isMobileView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_metacontent_components_SubsectionHeader__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                pb: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .GAP_SIZE_REM */ .L3,
                children: utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__/* ["default"].curatorsNote */ .Z.curatorsNote
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.large.bold), {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                type: "bold",
                children: utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__/* ["default"].curatorsNote */ .Z.curatorsNote
            }))),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text
                    }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.medium.regular), {
                        zIndex: 1,
                        mt: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XXS.rem,
                        children: text
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, {
                        position: "absolute",
                        fontSize: "8rem",
                        fontWeight: 900,
                        color: quoteColor !== null && quoteColor !== void 0 ? quoteColor : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].background,
                        left: "-1rem",
                        top: "2rem",
                        lineHeight: "1rem",
                        opacity: 0.6,
                        children: "“"
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (CuratorsNote);


/***/ }),

/***/ 28907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_page_components_collection_old_ProgressBar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93240);
/* harmony import */ var src_services_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62687);
/* harmony import */ var theme_size__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(28953);
/* harmony import */ var utils_collection_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85295);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14531);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63069);
/* harmony import */ var utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(89134);
/* harmony import */ var _counter_IdeaCounter__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(32306);
/* harmony import */ var _image_NextImage__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91260);
/* harmony import */ var _navigation_NextLink__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(50752);
















var IMAGE_WRAPPER_STYLE = {
    height: "50%",
    width: "100%",
    position: "relative"
};
var IMAGE_FALLBACK_COLORS = {
    light: [
        deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.light.semantic.cyan,
        deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.light.semantic.purple,
        deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.light.semantic.yellow,
        deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.light.semantic.green,
        deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.light.semantic.grey,
        deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.light.semantic.red, 
    ],
    dark: [
        deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.dark.semantic.cyan,
        deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.dark.semantic.purple,
        deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.dark.semantic.yellow,
        deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.dark.semantic.green,
        deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.dark.semantic.grey,
        deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.dark.semantic.red, 
    ]
};
var GroupCardSvg = function(_param) {
    var data = _param.data, dataType = _param.dataType, onClick = _param.onClick, _withLink = _param.withLink, withLink = _withLink === void 0 ? true : _withLink, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_param, [
        "data",
        "dataType",
        "onClick",
        "withLink"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    //The link the user is redirected to when clicking the card
    var url = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return "/".concat(dataType, "/").concat(data.id, "/").concat((0,utils_global__WEBPACK_IMPORTED_MODULE_8__/* .slugify */ .lV)(data.name));
    }, [
        dataType,
        data.id,
        data.name
    ]);
    var logTapEvent = function() {
        src_services_analytics__WEBPACK_IMPORTED_MODULE_4__/* .Analytics.logEvent */ .c.logEvent({
            eventName: src_services_analytics__WEBPACK_IMPORTED_MODULE_4__/* .Events.consumption.groupCardTap */ .z.consumption.groupCardTap,
            properties: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
                id: data.id,
                dataType: dataType
            }, dataType === "collection" ? {
                status: (0,utils_collection_utils__WEBPACK_IMPORTED_MODULE_6__/* .getCollectionStatus */ .t2)({
                    collection: data
                })
            } : {}),
            platforms: [
                "amplitude"
            ]
        });
    };
    var renderProgressBar = function() {
        var collection = data;
        if (!(collection === null || collection === void 0 ? void 0 : collection.progress)) return null;
        return collection.progress.totalReadIdeas > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_page_components_collection_old_ProgressBar__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            currentValue: collection.progress.totalReadIdeas,
            totalValue: collection.ideaCount,
            flexGrow: 1,
            left: 0,
            width: "100%",
            bottom: 0,
            height: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(4),
            borderRadius: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(4),
            position: "absolute",
            bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].underground,
            isPadded: true
        });
    };
    var renderImage = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(function() {
        if (!data.imageUrl) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, IMAGE_WRAPPER_STYLE), {
                backgroundColor: IMAGE_FALLBACK_COLORS[colorMode][data.id % 6]
            }));
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_NextImage__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
            alt: data.name,
            imageUrl: data.imageUrl,
            wrapperStyle: {
                width: "100%",
                height: "100%"
            }
        });
    }, [
        data.imageUrl
    ]);
    var onLinkClickHandler = function(e) {
        logTapEvent();
        e.preventDefault();
    };
    var renderTitle = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navigation_NextLink__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
            href: url,
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Link, {
                _hover: undefined,
                _active: undefined,
                _focus: undefined,
                backgroundColor: undefined,
                title: data.name,
                mx: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
                mt: "-".concat(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(16)),
                mb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.S.rem,
                zIndex: 3,
                // min height for placing the button lower when the title is on one line
                flexGrow: 1,
                onClick: onClick ? onLinkClickHandler : logTapEvent,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryHeading, {
                        overflow: "hidden",
                        size: "h2",
                        textAlign: "left",
                        lineHeight: "1.3",
                        paddingBottom: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XXS.rem,
                        children: data.emoji
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryHeading, {
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        type: "bold",
                        size: "h2",
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                        textAlign: "left",
                        wordBreak: "break-word",
                        lineHeight: "1.3",
                        height: 52,
                        children: data.name
                    })
                ]
            })
        });
    };
    var startReadingStatus = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
        mx: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
        alignItems: "center",
        justifyContent: "space-between",
        mb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navigation_NextLink__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                h: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(20),
                href: url,
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].primary,
                fontWeight: "bold",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    align: "center",
                    cursor: "pointer",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                            fontWeight: "bold",
                            children: utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_9__/* ["default"].start */ .Z.start
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.ArrowLeftSvg, {
                            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].primary,
                            transform: "rotate(180deg)",
                            w: "1rem",
                            h: "1rem",
                            ml: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XXS.rem
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_counter_IdeaCounter__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                ideaCount: data.ideaCount,
                fontSize: "0.875rem"
            })
        ]
    });
    var doneReadingStatus = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
        mx: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
        alignItems: "center",
        justifyContent: "space-between",
        mb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.CheckFillSvg, {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color.success
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_counter_IdeaCounter__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                ideaCount: data.ideaCount,
                fontSize: "0.875rem"
            })
        ]
    });
    var getContinueReadingStatus = function(collection) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
            mx: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
            alignItems: "center",
            justifyContent: "space-between",
            mb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navigation_NextLink__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    h: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(20),
                    href: url,
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].primary,
                    fontWeight: "bold",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        align: "center",
                        cursor: "pointer",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, {
                                fontWeight: "bold",
                                children: utils_strings_actionStrings__WEBPACK_IMPORTED_MODULE_9__/* ["default"]["continue"] */ .Z["continue"]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.ArrowLeftSvg, {
                                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].primary,
                                transform: "rotate(180deg)",
                                w: "1rem",
                                h: "1rem",
                                ml: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XXS.rem
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_counter_IdeaCounter__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    ideaCount: collection.ideaCount,
                    readCount: collection.progress.totalReadIdeas,
                    fontSize: "0.875rem"
                })
            ]
        });
    };
    var renderStatus = function() {
        if (dataType === "stash") {
            return startReadingStatus;
        } else if (dataType === "collection") {
            var collection = data;
            if (!(collection === null || collection === void 0 ? void 0 : collection.progress) || collection.progress.totalReadIdeas === 0) {
                return startReadingStatus;
            } else if (collection.progress.totalReadIdeas === collection.ideaCount) {
                return doneReadingStatus;
            } else return getContinueReadingStatus(collection);
        } else return null;
    };
    var onClickHandler = function(e) {
        logTapEvent();
        e.stopPropagation();
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    var content = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
        width: (0,utils_global__WEBPACK_IMPORTED_MODULE_8__/* .getRemWidthFromColumns */ ._P)(3),
        aspectRatio: "9/16",
        zIndex: 2,
        pos: "relative",
        cursor: "pointer",
        onClick: onClick ? onClickHandler : logTapEvent,
        flexShrink: 0,
        borderRadius: theme_size__WEBPACK_IMPORTED_MODULE_5__/* .BORDER_RADIUS_M */ .$W,
        overflow: "hidden",
        transition: "all 0.3s cubic-bezier(.11,.57,.44,.8)",
        boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.1); 0px 8px 4px rgba(0, 0, 0, 0.05);",
        _hover: {
            transform: "scale(1.01)",
            boxShadow: "0px 6px 16px rgba(0, 0, 0, 0.2); 0px 8px 4px rgba(0, 0, 0, 0.1);"
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                w: "100%",
                flexDir: "column",
                position: "absolute",
                bottom: 0,
                zIndex: 2,
                children: [
                    renderTitle(),
                    renderStatus(),
                    dataType === "collection" && renderProgressBar()
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                w: "100%",
                h: "50%",
                position: "absolute",
                bottom: 0,
                background: (0,utils_constants__WEBPACK_IMPORTED_MODULE_7__/* .createGradient */ .FK)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].top, -90),
                zIndex: 1
            }),
            renderImage()
        ]
    }));
    return onClick || !withLink ? content : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navigation_NextLink__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
        href: url,
        children: content
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (GroupCardSvg);


/***/ }),

/***/ 84768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50752);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63069);
/* harmony import */ var _image_NextImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91260);
/* harmony import */ var _BaseCard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46039);










var PreviewCardSmall = function(_param) {
    var name = _param.name, imageUrl = _param.imageUrl, targetUrl = _param.targetUrl, onClick = _param.onClick, hasShadow = _param.hasShadow, _hasText = _param.hasText, hasText = _hasText === void 0 ? true : _hasText, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_param, [
        "name",
        "imageUrl",
        "targetUrl",
        "onClick",
        "hasShadow",
        "hasText"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var card = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_BaseCard__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        onClick: targetUrl ? undefined : onClick,
        cursor: targetUrl || onClick ? "pointer" : "unset",
        px: utils_global__WEBPACK_IMPORTED_MODULE_4__/* .GAP_SIZE */ .DG,
        gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem
    }, props), {
        hasHoverEffect: true,
        boxShadow: hasShadow ? "0px 6px 16px rgba(0, 0, 0, 0.1); 0px 8px 4px rgba(0, 0, 0, 0.05);" : "",
        cardSize: "sm",
        bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].surface,
        _hover: {
            backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].top
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_NextImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                wrapperStyle: {
                    width: utils_global__WEBPACK_IMPORTED_MODULE_4__/* .COLUMN_WIDTH */ .pU,
                    height: utils_global__WEBPACK_IMPORTED_MODULE_4__/* .COLUMN_WIDTH */ .pU,
                    transition: "0.3s ease"
                },
                objectFit: "contain",
                imageUrl: imageUrl
            }),
            hasText && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                height: "2rem",
                alignItems: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryHeading, {
                    size: "h3",
                    style: {
                        fontSize: "1rem",
                        lineHeight: "1rem"
                    },
                    type: "bold",
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                    noOfLines: 2,
                    textOverflow: "ellipsis",
                    width: "100%",
                    textAlign: "center",
                    children: name
                })
            })
        ]
    }));
    return targetUrl ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        href: targetUrl,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Link, {
            _focus: undefined,
            _hover: undefined,
            title: name,
            onClick: onClick,
            children: card
        })
    }) : card;
};
/* harmony default export */ __webpack_exports__["Z"] = (PreviewCardSmall);


/***/ }),

/***/ 97683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50752);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63069);
/* harmony import */ var _image_NextImage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(91260);
/* harmony import */ var _BaseCard__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46039);
/* harmony import */ var _CuratorsNote__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(53032);











var ReviewCard = function(_param) {
    var review = _param.review, onClick = _param.onClick, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "review",
        "onClick"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var name = review.name, text = review.text, imageUrl = review.imageUrl, url = review.url;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var getPlatformIcon = function() {
        switch(review.platform){
            case "android":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.GooglePlayColoredSvg, {});
            case "ios":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.AppStoreColoredSvg, {});
            case "twitter":
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.TwitterSvg, {
                    color: "#00acee"
                });
            default:
                return null;
        }
    };
    var card = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_BaseCard__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
        alignItems: "top",
        p: utils_global__WEBPACK_IMPORTED_MODULE_4__/* .SQUARE_WIDTH_REM */ .wY,
        justifyContent: "center",
        onClick: url ? undefined : onClick,
        cursor: url || onClick ? "pointer" : "unset",
        px: utils_global__WEBPACK_IMPORTED_MODULE_4__/* .GAP_SIZE_REM */ .L3,
        gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(utils_global__WEBPACK_IMPORTED_MODULE_4__/* .GAP_SIZE */ .DG / 2),
        flexDirection: {
            base: "column",
            md: "row"
        },
        height: "unset"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_NextImage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                wrapperStyle: {
                    width: utils_global__WEBPACK_IMPORTED_MODULE_4__/* .BLOCK_WIDTH_REM */ .sC,
                    height: utils_global__WEBPACK_IMPORTED_MODULE_4__/* .BLOCK_WIDTH_REM */ .sC,
                    borderRadius: utils_global__WEBPACK_IMPORTED_MODULE_4__/* .SQUARE_WIDTH_REM */ .wY,
                    cursor: "inherit",
                    flexShrink: 0
                },
                objectFit: "fill",
                imageUrl: imageUrl,
                priority: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                flexGrow: 1,
                alignItems: "center",
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                                alignItems: "center",
                                flexGrow: 1,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({
                                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                                        noOfLines: 1,
                                        textOverflow: "ellipsis",
                                        width: "auto"
                                    }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.large.bold), {
                                        mr: {
                                            base: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(4),
                                            md: "1rem"
                                        },
                                        children: name
                                    })),
                                    !isMobileView && (review.platform === "android" || review.platform === "ios") && Array(5).fill(1).map(function(_, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.FullStarSvg, {
                                            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].secondary.default,
                                            boxSize: "1rem"
                                        }, index);
                                    })
                                ]
                            }),
                            !isMobileView && getPlatformIcon()
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CuratorsNote__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        text: text
                    })
                ]
            })
        ]
    }));
    return url ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        href: url,
        passHref: true,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Link, {
            _focus: undefined,
            _hover: undefined,
            title: name,
            onClick: onClick,
            isExternal: true,
            rel: "noopener nofollow noreferrer",
            children: card
        })
    }) : card;
};
/* harmony default export */ __webpack_exports__["Z"] = (ReviewCard);


/***/ }),

/***/ 72426:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);
/* harmony import */ var _image_NextImage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91260);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63069);
/* harmony import */ var _navigation_NextLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50752);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);








 // Use it instead of own useRouter for fixing scroll problems
var COLLECTION_IMAGE_SIZE = {
    WIDTH: 200,
    HEIGHT: 300,
    BORDER_RADIUS: 16
};
var CollectionCard = function(param) {
    var collection = param.collection, shouldOpenInNewTab = param.shouldOpenInNewTab;
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useColorMode)().colorMode;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var collectionSlug = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return (0,utils_global__WEBPACK_IMPORTED_MODULE_4__/* .slugify */ .lV)(collection.name);
    }, [
        collection.name
    ]);
    var collectionPageRoute = "/collection/".concat(collection.id, "/").concat(collectionSlug);
    var link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Link, {
        cursor: "pointer",
        _focus: undefined,
        _hover: undefined,
        href: collectionPageRoute,
        target: shouldOpenInNewTab ? "_blank" : "",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            textAlign: "center"
        }, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryHeadingFonts.small.semiBold), {
            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text,
            children: "".concat(collection.name)
        }))
    });
    if (!collection.id) return null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
        w: COLLECTION_IMAGE_SIZE.WIDTH,
        flexDirection: "column",
        gridRowGap: 16,
        alignItems: "center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_image_NextImage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                wrapperStyle: {
                    width: COLLECTION_IMAGE_SIZE.WIDTH,
                    height: COLLECTION_IMAGE_SIZE.HEIGHT,
                    borderRadius: COLLECTION_IMAGE_SIZE.BORDER_RADIUS,
                    cursor: "pointer"
                },
                imageUrl: collection.image,
                blurhash: collection.image_blurhash,
                alt: "".concat(collection.name),
                priority: false,
                onClick: function() {
                    shouldOpenInNewTab ? window.open(collectionPageRoute) : router.push(collectionPageRoute);
                }
            }),
            shouldOpenInNewTab ? link : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_navigation_NextLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                href: collectionPageRoute,
                passHref: true,
                children: link
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CollectionCard);


/***/ }),

/***/ 11194:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _CollectionCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72426);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63069);








var NewCollectionCarousel = function(_param) {
    var collections = _param.collections, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "collections"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        gridGap: utils_global__WEBPACK_IMPORTED_MODULE_4__/* .GAP_SIZE_REM */ .L3,
        justifyContent: "left",
        width: "100%",
        overflowX: "scroll",
        alignItems: "flex-start"
    }, props), {
        children: collections.map(function(collection, index) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CollectionCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                collection: collection
            }, "collection-".concat(index));
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (NewCollectionCarousel);


/***/ }),

/***/ 27984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(828);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);
/* harmony import */ var _FaqItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64802);








var FaqGroup = function(_param) {
    var faqItems = _param.faqItems, groupTitle = _param.groupTitle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "faqItems",
        "groupTitle"
    ]);
    //   const isMobileView = useIsMobileView();
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useColorMode)().colorMode;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(react__WEBPACK_IMPORTED_MODULE_1__.useState(undefined), 2), selectedIndex = ref[0], setSelectedIndex = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        flexDirection: "column",
        width: "100%",
        gridRowGap: 16
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryHeadingFonts.small.semiBold), {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text,
                children: groupTitle
            })),
            faqItems.map(function(faqItem, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_FaqItem__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    title: faqItem.title,
                    description: faqItem.description,
                    isSelected: selectedIndex === index,
                    onClick: function() {
                        setSelectedIndex(function(prevIndex) {
                            if (prevIndex === index) {
                                return undefined;
                            }
                            return index;
                        });
                    }
                }, "faq-item-".concat(index));
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqGroup);


/***/ }),

/***/ 64802:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);






var FaqItem = function(_param) {
    var title = _param.title, description = _param.description, isSelected = _param.isSelected, onClick = _param.onClick, titleTextProps = _param.titleTextProps, descriptionTextProps = _param.descriptionTextProps, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "title",
        "description",
        "isSelected",
        "onClick",
        "titleTextProps",
        "descriptionTextProps"
    ]);
    //   const isMobileView = useIsMobileView();
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useColorMode)().colorMode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        flexDirection: "column",
        width: "100%",
        bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].surface,
        borderRadius: 8,
        px: 16,
        py: 16,
        cursor: "pointer",
        _hover: {
            backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].underground
        },
        onClick: onClick
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                flexDirection: "row",
                alignItems: "center",
                gridColumnGap: 8,
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryHeadingFonts.small.semiBold), {
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text
                    }), titleTextProps), {
                        children: title
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.ArrowUpSvg, {
                        flexShrink: 0,
                        transition: "transform 0.3s cubic-bezier(.09,1.72,.43,1)",
                        transform: isSelected ? "rotate(0deg)" : "rotate(180deg)",
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                overflow: "hidden",
                // bgColor="red"
                height: "auto",
                maxHeight: isSelected ? "288px" : 0,
                transition: "all 0.3s cubic-bezier(.02,.98,.23,1.01)",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.large.regular), {
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].textSecondary,
                    mt: 16
                }), descriptionTextProps), {
                    children: description
                }))
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (FaqItem);


/***/ }),

/***/ 82188:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);
/* harmony import */ var src_components_faq_FaqGroup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27984);







var TITLE = "Frequently asked questions";
var FAQ_ITEMS_GENERAL = [
    {
        title: "What is Deepstash?",
        description: "Deepstash is a platform where users read and curate bite-sized insights and ideas from anywhere online, may that be books, articles, podcasts, or videos. You can learn good habits, useful skills and build your knowledge, on your own time. Deepstash makes your personal growth manageable!"
    },
    {
        title: "Why are ideas important?",
        description: "Ideas are important because they form the foundation for progress and innovation. The idea format used by Deepstash is important because it condenses complex concepts and profound thoughts into simple, digestible sentences that are easy to understand and remember. This format makes ideas more accessible and easier to apply in daily life, helping people to make positive changes and achieve their goals."
    },
    {
        title: "How can I use Deepstash?",
        description: "Deepstash can be found on both the Apple App Store and Google Play Store. Additionally, Deepstash can be found on the web, where you can login and use Deepstash at deepstash.com."
    }, 
];
var FAQ_ITEMS_PRO = [
    // TODO No Trial Changes
    // {
    //   title: 'How does the free 7-day trial work?',
    //   description:
    //     "Start your free 7-day trial by signing up for a Deepstash Pro yearly plan. There’s no obligation to stay subscribed, and you'll only be charged on the day the free 7-day trial ends. You have access to all the Pro features during the trial.",
    // },
    {
        title: "What is included in my Deepstash subscription?",
        description: "With Pro, you get all of Deepstash amazing content, but your interaction with it is unrestrained. Save as many ideas as you want, in as many stashes you desire. You can also go offline and still have access to your content, while also listening to your ideas whenever, wherever."
    },
    {
        title: "Can I cancel at any time?",
        description: "Yes. If you have an ongoing subscription, you will keep your benefits until the next billing date."
    },
    {
        title: "When is my Lifetime Pro subscription activated?",
        description: "Due to the nature of payment processing, please allow up to 24h for your Lifetime Pro subscription to become active."
    }, 
];
var OverallFaq = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, _param);
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useIsMobileView)();
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useColorMode)().colorMode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        flexDirection: "column",
        alignItems: "center",
        width: "100%"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, isMobileView ? deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryHeadingFonts.small.bold : deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryHeadingFonts.large.bold), {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].text,
                textAlign: "center",
                children: TITLE
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                width: isMobileView ? "100%" : "80%",
                mt: 32,
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_faq_FaqGroup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        faqItems: FAQ_ITEMS_GENERAL,
                        groupTitle: "General"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_faq_FaqGroup__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        faqItems: FAQ_ITEMS_PRO,
                        groupTitle: "Pro Subscription",
                        mt: 48
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (OverallFaq);


/***/ }),

/***/ 28146:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ layout_Layout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./src/providers/layout/LayoutProvider.tsx
var LayoutProvider = __webpack_require__(96546);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/components/layout/components/Footer.tsx + 3 modules
var Footer = __webpack_require__(56096);
// EXTERNAL MODULE: ./src/hooks/auth/index.ts + 10 modules
var auth = __webpack_require__(12849);
;// CONCATENATED MODULE: ./src/hooks/measurements/useMeasureElement.ts

/**
 * Get a ref function to measure the width and height of an element
 * Also get the position of the element
 * @param relativeTo Whether the position measurement is relative to the whole document or the viewport
 */ var useMeasureElement = function() {
    var relativeTo = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "document";
    var ref = useState(0), width = ref[0], setWidth = ref[1];
    var ref1 = useState(0), height = ref1[0], setHeight = ref1[1];
    var ref2 = useState(0), x = ref2[0], setX = ref2[1];
    var ref3 = useState(0), y = ref3[0], setY = ref3[1];
    var elementRef = useRef();
    var getElementPosition = function(element) {
        var incomingX = element.getBoundingClientRect().x + (relativeTo === "document" ? window.scrollX : 0);
        var incomingY = element.getBoundingClientRect().y + (relativeTo === "document" ? window.scrollY : 0);
        if (incomingX !== x) {
            setX(incomingX);
        }
        if (incomingY !== y) {
            setY(incomingY);
        }
    };
    var getElementSize = function(element) {
        var newWidth = element.getBoundingClientRect().width;
        var newHeight = element.getBoundingClientRect().height;
        if (newHeight !== height) {
            setHeight(newHeight);
        }
        if (newWidth !== width) {
            setWidth(newWidth);
        }
    };
    var measureElement = function(element) {
        if (element === null) {
            // The ref prop of the JSX element is still not set.
            // Nothing to do yet
            return;
        }
        if (element === undefined && elementRef.current) {
            // Recalculate the size and position of the saved element
            getElementPosition(elementRef.current);
            getElementSize(elementRef.current);
        }
        if (element) {
            elementRef.current = element;
            getElementPosition(element);
            getElementSize(element);
        }
    };
    return {
        width: width,
        height: height,
        x: x,
        y: y,
        measureElement: measureElement
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./src/hooks/measurements/useMeasureElementList.ts


/**
 * Get a ref function to measure the width and height of an element
 * Also get the position of the element
 * @param elementCount This will init the measurementsList to have at least this many elements so we don't get any undefined elements accessing
 * @param relativeTo Whether the position measurement is relative to the whole document or the viewport
 */ var DEFAULT_MEASUREMENT = {
    x: 0,
    y: 0,
    width: 0,
    height: 0
};
var useMeasureElementList = function(param) {
    var elementCount = param.elementCount, _relativeTo = param.relativeTo, relativeTo = _relativeTo === void 0 ? "document" : _relativeTo, debugId = param.debugId, initialState = param.initialState;
    var ref = (0,react.useState)(function() {
        // Init the state with elementCount elements
        var state = initialState ? (0,_to_consumable_array/* default */.Z)(initialState) : [];
        var elementsLeftToPush = elementCount - state.length;
        for(var i = 0; i < elementsLeftToPush; i++){
            state.push(DEFAULT_MEASUREMENT);
        }
        return state;
    }), measurementsList = ref[0], setMeasurementsList = ref[1];
    var elementRefs = (0,react.useRef)([]);
    (0,react.useEffect)(function() {
        if (measurementsList.length < elementCount) {
            setMeasurementsList(function(prevState) {
                var newState = (0,_to_consumable_array/* default */.Z)(prevState);
                // Push the remaining elements
                for(var i = 0; i < elementCount - measurementsList.length; i++){
                    newState.push(DEFAULT_MEASUREMENT);
                }
                return newState;
            });
        }
    }, [
        elementCount
    ]);
    var getElementSizeAndPosition = function(element, index) {
        var ref, ref1;
        var incomingX = element.getBoundingClientRect().x + (relativeTo === "document" ? window.scrollX : 0);
        var incomingY = element.getBoundingClientRect().y + (relativeTo === "document" ? window.scrollY : 0);
        if (incomingX !== ((ref = measurementsList[index]) === null || ref === void 0 ? void 0 : ref.x) || incomingY !== ((ref1 = measurementsList[index]) === null || ref1 === void 0 ? void 0 : ref1.y) || element.clientWidth !== measurementsList[index].width || element.clientHeight !== measurementsList[index].height) {
            //Debug
            if (debugId) {
                var ref2, ref3;
                console.log("Hook ".concat(debugId, " - element ").concat(index, " :  X changed: ").concat(incomingX !== ((ref2 = measurementsList[index]) === null || ref2 === void 0 ? void 0 : ref2.x), "; Y changed: ").concat(incomingY !== ((ref3 = measurementsList[index]) === null || ref3 === void 0 ? void 0 : ref3.y), "; Width changed:").concat(element.clientWidth !== measurementsList[index].width, "; Height changed:").concat(element.clientHeight !== measurementsList[index].height));
                console.log("New state for Hook ".concat(debugId, " - element ").concat(index, ":"), {
                    width: element.clientWidth,
                    height: element.clientHeight,
                    x: incomingX,
                    y: incomingY
                });
            }
            // The dimensions of the element changed
            setMeasurementsList(function(prevState) {
                var newState = (0,_to_consumable_array/* default */.Z)(prevState);
                newState[index] = {
                    width: element.clientWidth,
                    height: element.clientHeight,
                    x: incomingX,
                    y: incomingY
                };
                return newState;
            });
        }
    };
    var measureElement = function(element, index) {
        if (element === null) {
            // The ref prop of the JSX element is still not set.
            // Nothing to do yet
            return;
        }
        if (element === undefined || index === undefined) {
            // Recalculate the size and position of the saved elements
            for(var i = 0; i < elementRefs.current.length; i++){
                var refElement = elementRefs.current[i];
                getElementSizeAndPosition(refElement, i);
            }
        }
        if (element && index !== undefined) {
            elementRefs.current[index] = element;
            getElementSizeAndPosition(element, index);
        }
    };
    return {
        measurementsList: measurementsList,
        measureElement: measureElement
    };
};

;// CONCATENATED MODULE: ./src/hooks/measurements/index.ts



// EXTERNAL MODULE: ./src/hooks/useRouter.ts
var useRouter = __webpack_require__(98377);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./src/providers/hooks/useNavigation.ts
var useNavigation = __webpack_require__(40480);
;// CONCATENATED MODULE: ./src/components/layout/hooks/useLayoutMetacontent.ts

var useLayoutMetaContent = function(param) {
    var setMetaContentPosition = param.setMetaContentPosition, sectionMeasurements = param.sectionMeasurements, layoutStateRef = param.layoutStateRef, contentMeasurements = param.contentMeasurements, metaContentMeasurements = param.metaContentMeasurements, stickyOffsets = param.stickyOffsets, topOffsets = param.topOffsets, isSectionInfinite = param.isSectionInfinite, sectionDisplayedHeights = param.sectionDisplayedHeights;
    // The scroll position when the meta content should be fixed
    var stickThresholds = (0,react.useMemo)(function() {
        var thresholds = [];
        for(var i = 0; i < sectionMeasurements.length; i++){
            var ref, ref1;
            thresholds.push(sectionMeasurements[i].y - ((ref = stickyOffsets === null || stickyOffsets === void 0 ? void 0 : stickyOffsets[i]) !== null && ref !== void 0 ? ref : 0) + ((ref1 = topOffsets === null || topOffsets === void 0 ? void 0 : topOffsets[i]) !== null && ref1 !== void 0 ? ref1 : 0));
        }
        return thresholds;
    }, [
        sectionMeasurements,
        stickyOffsets,
        topOffsets
    ]);
    var bottomThresholds = (0,react.useMemo)(function() {
        var thresholds = [];
        for(var i = 0; i < sectionMeasurements.length; i++){
            var ref;
            thresholds.push(sectionMeasurements[i].y + sectionDisplayedHeights[i] - metaContentMeasurements[i].height - ((ref = stickyOffsets === null || stickyOffsets === void 0 ? void 0 : stickyOffsets[i]) !== null && ref !== void 0 ? ref : 0));
        }
        return thresholds;
    }, [
        contentMeasurements,
        metaContentMeasurements,
        stickyOffsets
    ]);
    var updateMetaContentPosition = (0,react.useCallback)(function(scrollTop) {
        for(var sectionIndex = 0; sectionIndex < sectionMeasurements.length; sectionIndex++){
            var ref, ref1, ref2, ref3;
            // If the meta content is bigger than the content, it will scroll with the content from the start
            if (metaContentMeasurements[sectionIndex].height >= contentMeasurements[sectionIndex].height && ((ref = layoutStateRef.current) === null || ref === void 0 ? void 0 : ref.metaContentPositions[sectionIndex]) !== "top") {
                setMetaContentPosition("top", sectionIndex);
            }
            // The scroll position when the meta content should be placed at the bottom of the section and start scrolling with the section
            var bottomThreshold = bottomThresholds[sectionIndex];
            var topThreshold = stickThresholds[sectionIndex];
            if (((ref1 = layoutStateRef.current) === null || ref1 === void 0 ? void 0 : ref1.metaContentPositions[sectionIndex]) !== "fixed" && scrollTop >= topThreshold && scrollTop <= bottomThreshold) {
                setMetaContentPosition("fixed", sectionIndex);
            }
            if (((ref2 = layoutStateRef.current) === null || ref2 === void 0 ? void 0 : ref2.metaContentPositions[sectionIndex]) !== "top" && scrollTop < topThreshold) {
                setMetaContentPosition("top", sectionIndex);
            }
            if (((ref3 = layoutStateRef.current) === null || ref3 === void 0 ? void 0 : ref3.metaContentPositions[sectionIndex]) !== "bottom" && scrollTop > bottomThreshold && !isSectionInfinite[sectionIndex]) {
                setMetaContentPosition("bottom", sectionIndex);
            }
        }
    }, [
        setMetaContentPosition,
        sectionMeasurements,
        layoutStateRef,
        contentMeasurements,
        metaContentMeasurements,
        stickyOffsets, 
    ]);
    return {
        updateMetaContentPosition: updateMetaContentPosition,
        bottomThresholds: bottomThresholds,
        stickThresholds: stickThresholds
    };
};

;// CONCATENATED MODULE: ./src/components/layout/hooks/useLayoutInternals.ts










var clearSelection = function() {
    if (window && window.getSelection) {
        var ref;
        (ref = window.getSelection()) === null || ref === void 0 ? void 0 : ref.removeAllRanges();
    }
};
var useLayoutInternals = function(sections) {
    var router = (0,useRouter/* default */.Z)();
    var navigationStatePreserveKey = router.asPath;
    var ref = (0,esm.useWindowSize)(), windowWidth = ref.width, windowHeight = ref.height;
    var isMobileView = (0,esm.useIsMobileView)();
    var isDesktopView = (0,esm.useIsDesktopView)();
    (0,auth/* useGoogleOneTapLogin */._7)();
    (0,react.useEffect)(function() {
        router_default().events.on("routeChangeStart", clearSelection);
        //Prevent scroll preservation default behavior
        window.history.scrollRestoration = "manual";
        return function() {
            router_default().events.off("routeChangeStart", clearSelection);
        };
    }, []);
    var ref1 = (0,useNavigation/* default */.Z)(), layoutCache = ref1.layoutCache, preserveLayoutState = ref1.preserveLayoutState, offScrollRestoreComplete = ref1.offScrollRestoreComplete, onScrollRestoreComplete = ref1.onScrollRestoreComplete;
    var ref2 = (0,react.useState)(function() {
        // Restore the state from the navigation cache if present
        var prevState = layoutCache.current.get(router.asPath);
        return prevState !== null && prevState !== void 0 ? prevState : {
            isRootScrollEnabled: true,
            metaContentPositions: sections.map(function() {
                return "top";
            })
        };
    }), layoutState = ref2[0], _setLayoutState = ref2[1];
    // We also keep the state in a ref to be able to save it at unmount in the navigation provider
    var layoutStateRef = (0,react.useRef)(layoutState);
    var metaContentPositions = layoutState.metaContentPositions, isRootScrollEnabled = layoutState.isRootScrollEnabled;
    var setLayoutState = (0,react.useCallback)(function(newState) {
        if (typeof newState === "function") {
            // Use the ref as prevState to keep this function referentially stable
            var newStateValue = newState(layoutStateRef.current);
            layoutStateRef.current = newStateValue;
            _setLayoutState(newStateValue);
        } else {
            layoutStateRef.current = newState;
            _setLayoutState(newState);
        }
    }, []);
    var setMetaContentPosition = function(val, index) {
        return setLayoutState(function(prevState) {
            var newState = (0,_object_spread/* default */.Z)({}, prevState);
            newState.metaContentPositions[index] = val;
            return newState;
        });
    };
    var setIsRootScrollEnabled = function(val) {
        setLayoutState(function(prevState) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevState), {
                isRootScrollEnabled: val
            });
        });
    };
    var ref3 = useMeasureElementList({
        elementCount: sections.length
    }), sectionMeasurements = ref3.measurementsList, measureSection = ref3.measureElement;
    var ref4 = useMeasureElementList({
        elementCount: sections.length
    }), metaContentMeasurements = ref4.measurementsList, measureMetaContent = ref4.measureElement;
    var ref5 = useMeasureElementList({
        elementCount: sections.length
    }), contentMeasurements = ref5.measurementsList, measureContent = ref5.measureElement;
    var metaContentStickyOffsets = (0,react.useMemo)(function() {
        return sections.map(function(section) {
            return section.metaContentStickyOffset;
        });
    }, [
        sections
    ]);
    var metaContentTopOffsets = (0,react.useMemo)(function() {
        return sections.map(function(section) {
            return section.metaContentTopOffset;
        });
    }, [
        sections
    ]);
    var isMetaContentInfiniteList = (0,react.useMemo)(function() {
        return sections.map(function(section) {
            return !!section.infiniteScroll;
        });
    }, [
        sections
    ]);
    var _sectionIndex;
    // This calculates the height of the section taking into account the fact that the meta content is fixed positioned
    // and thus not included in the actual div height
    // The section height on the desktop is the max between the content and the metacontent
    // On mobile/tablet, they are stacked
    var sectionDisplayedHeights = (0,react.useMemo)(function() {
        return sections.map(function(_, sectionIndex) {
            return isDesktopView ? Math.max(contentMeasurements[sectionIndex].height, metaContentMeasurements[sectionIndex].height + ((_sectionIndex = metaContentTopOffsets[sectionIndex]) !== null && _sectionIndex !== void 0 ? _sectionIndex : 0)) : contentMeasurements[sectionIndex].height + metaContentMeasurements[sectionIndex].height;
        });
    }, [
        contentMeasurements,
        metaContentMeasurements
    ]);
    var updateMetaContentPosition = useLayoutMetaContent({
        setMetaContentPosition: setMetaContentPosition,
        metaContentMeasurements: metaContentMeasurements,
        contentMeasurements: contentMeasurements,
        layoutStateRef: layoutStateRef,
        sectionMeasurements: sectionMeasurements,
        stickyOffsets: metaContentStickyOffsets,
        topOffsets: metaContentTopOffsets,
        isSectionInfinite: isMetaContentInfiniteList,
        sectionDisplayedHeights: sectionDisplayedHeights
    }).updateMetaContentPosition;
    // Use the scroll top to:
    // - Update the meta content stickiness
    var onRootScroll = (0,react.useCallback)(function() {
        var scrollTop = window.scrollY;
        updateMetaContentPosition(scrollTop);
    }, [
        updateMetaContentPosition
    ]);
    var remeasureLayout = function() {
        measureMetaContent();
        measureContent();
        measureSection();
    };
    (0,react.useEffect)(function() {
        // The size of the window changed, recompute all the heights and positions of the elements that affect the layout
        remeasureLayout();
    }, [
        windowWidth,
        windowHeight
    ]);
    // Register navigation events to enable / disable the scroll listener when needed
    (0,react.useEffect)(function() {
        // Enable root scroll listener after scroll was restored
        var onScrollRestore = function() {
            return setIsRootScrollEnabled(true);
        };
        var onNavigationStart = function() {
            return setIsRootScrollEnabled(false);
        };
        var onNavigationCancel = function() {
            return setIsRootScrollEnabled(true);
        };
        router_default().events.on("routeChangeStart", onNavigationStart);
        router_default().events.on("routeChangeError", onNavigationCancel);
        onScrollRestoreComplete(onScrollRestore);
        return function() {
            router_default().events.off("routeChangeStart", onNavigationStart);
            router_default().events.off("routeChangeError", onNavigationCancel);
            offScrollRestoreComplete(onScrollRestore);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (isRootScrollEnabled && !isMobileView) {
            window.addEventListener("scroll", onRootScroll);
            return function() {
                window.removeEventListener("scroll", onRootScroll);
            };
        } else {
            return function() {
                return;
            };
        }
    }, [
        onRootScroll,
        isRootScrollEnabled
    ]);
    (0,react.useEffect)(function() {
        // Preserve the state on navigation
        return function() {
            preserveLayoutState(navigationStatePreserveKey, (0,_object_spread/* default */.Z)({}, layoutStateRef.current));
        };
    }, []);
    return {
        remeasureLayout: remeasureLayout,
        metaContentMeasurements: metaContentMeasurements,
        measureMetaContent: measureMetaContent,
        contentMeasurement: contentMeasurements,
        measureContent: measureContent,
        measureSection: measureSection,
        metaContentPositions: metaContentPositions,
        sectionDisplayedHeights: sectionDisplayedHeights
    };
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./src/services/analytics/index.ts
var analytics = __webpack_require__(62687);
// EXTERNAL MODULE: ./src/components/navigation/NextLink.tsx
var NextLink = __webpack_require__(50752);
;// CONCATENATED MODULE: ./src/components/metacontent/sections/PublicLinksSection.tsx









var PublicLinksSection = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var colorMode = (0,esm.useColorMode)().colorMode;
    var ref = (0,react.useState)(false), isExpanded = ref[0], setIsExpanded = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        color: esm.color[colorMode].textSecondary,
        bgColor: esm.color[colorMode].background,
        flexDirection: "column"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.PrimaryText, {
                size: "l",
                children: [
                    "deep",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                        children: "stash"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                pt: esm.spacing.XS.rem,
                justifyContent: "space-between",
                children: Footer/* FOOTER_SECTIONS.map */.V.map(function(section) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        flexDirection: "column",
                        alignItems: "left",
                        width: esm.spacing.toRem(96),
                        gridGap: "1rem",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                                size: "m",
                                fontWeight: 600,
                                cursor: "pointer",
                                onClick: function() {
                                    return setIsExpanded(function(e) {
                                        return !e;
                                    });
                                },
                                children: section.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                                transition: "all 0.3s ease-in-out",
                                height: isExpanded ? esm.spacing.toRem(144) : 0,
                                overflow: "hidden",
                                flexDirection: "column",
                                gridGap: "1rem",
                                children: section.links.map(function(link, index) {
                                    return link.href.startsWith("https") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                                        href: link.href,
                                        children: link.title
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                        href: link.href,
                                        passHref: true,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                                            _focus: undefined,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                                                onClick: function() {
                                                    analytics/* Analytics.logEvent */.c.logEvent({
                                                        eventName: analytics/* Events.consumption.footerTap */.z.consumption.footerTap,
                                                        properties: {
                                                            button: ""
                                                        },
                                                        platforms: [
                                                            "amplitude"
                                                        ]
                                                    });
                                                },
                                                children: link.title
                                            })
                                        })
                                    }, index);
                                })
                            })
                        ]
                    }, section.id);
                })
            })
        ]
    }));
};
/* harmony default export */ var sections_PublicLinksSection = (PublicLinksSection);

// EXTERNAL MODULE: ./src/components/metadata/HeadMetadata.tsx
var HeadMetadata = __webpack_require__(37066);
// EXTERNAL MODULE: ./src/components/navbar/Navbar.tsx + 2 modules
var Navbar = __webpack_require__(43117);
// EXTERNAL MODULE: ./src/components/page-sections/pro-benefits/ProAdSection.tsx + 3 modules
var ProAdSection = __webpack_require__(85429);
// EXTERNAL MODULE: ./src/components/layout/components/FullWidthSectionWrapper.tsx
var FullWidthSectionWrapper = __webpack_require__(41140);
// EXTERNAL MODULE: ./src/page-components/special-offer/SpecialOfferBannerWrapper.tsx + 1 modules
var SpecialOfferBannerWrapper = __webpack_require__(16923);
// EXTERNAL MODULE: ./src/components/breadcrumbs/BreadcrumbList.tsx
var BreadcrumbList = __webpack_require__(920);
;// CONCATENATED MODULE: ./src/components/layout/Layout.tsx
















var Layout = function(param) {
    var pageMetadata = param.pageMetadata, sections = param.sections, firstSection = param.firstSection, disableNewsletter = param.disableNewsletter, disableProAd = param.disableProAd, disableSaleBanner = param.disableSaleBanner, customNavbar = param.customNavbar, _shouldHideFooter = param.shouldHideFooter, shouldHideFooter = _shouldHideFooter === void 0 ? false : _shouldHideFooter, isShortProAd = param.isShortProAd, showFooterPrices = param.showFooterPrices, breadcrumbs = param.breadcrumbs;
    var isDesktopView = (0,esm.useIsDesktopView)();
    var isMobileView = (0,esm.useIsMobileView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var ref = useLayoutInternals(sections), metaContentMeasurements = ref.metaContentMeasurements, measureContent = ref.measureContent, measureMetaContent = ref.measureMetaContent, measureSection = ref.measureSection, metaContentPositions = ref.metaContentPositions, sectionDisplayedHeights = ref.sectionDisplayedHeights, remeasureLayout = ref.remeasureLayout;
    var renderMetaContent = function(param) {
        var metaContentPosition = param.metaContentPosition, metaContentTopOffset = param.metaContentTopOffset, _metaContentColumnStart = param.metaContentColumnStart, metaContentColumnStart = _metaContentColumnStart === void 0 ? 8 : _metaContentColumnStart, metaContentStickyOffset = param.metaContentStickyOffset, metaContentBottomPosition = param.metaContentBottomPosition, sectionIndex = param.sectionIndex, metaContentWrapperStyle = param.metaContentWrapperStyle, metaContent = param.metaContent;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            w: {
                base: "unset",
                lg: (0,global/* getRemWidthFromColumns */._P)(4)
            },
            pos: {
                base: "unset",
                lg: metaContentPosition === "fixed" ? "fixed" : "absolute"
            },
            top: metaContentPosition === "fixed" ? esm.spacing.toRem(metaContentStickyOffset !== null && metaContentStickyOffset !== void 0 ? metaContentStickyOffset : 0) : metaContentPosition === "top" ? esm.spacing.toRem(metaContentTopOffset !== null && metaContentTopOffset !== void 0 ? metaContentTopOffset : 0) : esm.spacing.toRem(metaContentBottomPosition),
            left: metaContentPosition === "fixed" ? "calc(50vw + ".concat((0,global/* getRemWidthFromColumns */._P)(metaContentColumnStart - 6 + 0.25), ")") : "calc(".concat((0,global/* getRemWidthFromColumns */._P)(metaContentColumnStart), " + ").concat(global/* GAP_SIZE_REM */.L3, ")"),
            ref: isMobileView ? undefined : function(el) {
                return measureMetaContent(el, sectionIndex);
            },
            flexDirection: "column",
            minH: sections[sectionIndex].infiniteScroll && metaContent && isDesktopView ? "calc(100vh - ".concat(metaContentStickyOffset, "px)") : "auto"
        }, metaContentWrapperStyle), {
            children: [
                metaContent,
                sections[sectionIndex].infiniteScroll && metaContent && isDesktopView && /*#__PURE__*/ (0,jsx_runtime.jsx)(sections_PublicLinksSection, {
                    position: "fixed",
                    bottom: 0,
                    width: {
                        base: "100%",
                        md: (0,global/* getRemWidthFromColumns */._P)(4)
                    },
                    pt: esm.spacing.XS.rem
                })
            ]
        }));
    };
    var renderSection = function(param, sectionIndex) {
        var content = param.content, metaContent = param.metaContent, metaContentStickyOffset = param.metaContentStickyOffset, metaContentTopOffset = param.metaContentTopOffset, metaContentColumnStart = param.metaContentColumnStart, metaContentWrapperStyle = param.metaContentWrapperStyle, sectionStyle = param.sectionStyle, contentWrapperStyle = param.contentWrapperStyle, infiniteScroll = param.infiniteScroll, isFullscreen = param.isFullscreen;
        var sectionHeight = sectionDisplayedHeights[sectionIndex];
        var metaContentPosition = metaContentPositions[sectionIndex];
        // Align the metaContent at the bottom of the section
        var metaContentBottomPosition = sectionHeight - metaContentMeasurements[sectionIndex].height;
        return(//Section root
        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            pos: "relative",
            height: {
                base: "unset",
                lg: sectionHeight === 0 ? "unset" : sectionHeight
            },
            ref: isMobileView ? undefined : function(el) {
                return measureSection(el, sectionIndex);
            }
        }, sectionStyle), {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                    w: {
                        base: "100%",
                        md: isFullscreen ? "100%" : (0,global/* getRemWidthFromColumns */._P)(8)
                    },
                    children: [
                        !isDesktopView && infiniteScroll && renderMetaContent({
                            metaContentStickyOffset: metaContentStickyOffset,
                            metaContentBottomPosition: metaContentBottomPosition,
                            metaContentColumnStart: metaContentColumnStart,
                            sectionIndex: sectionIndex,
                            metaContentPosition: metaContentPosition,
                            metaContent: metaContent,
                            metaContentTopOffset: metaContentTopOffset,
                            metaContentWrapperStyle: metaContentWrapperStyle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            ref: isMobileView ? undefined : function(el) {
                                return measureContent(el, sectionIndex);
                            }
                        }, contentWrapperStyle), {
                            children: content
                        }))
                    ]
                }),
                (isDesktopView || !infiniteScroll) && renderMetaContent({
                    metaContentStickyOffset: metaContentStickyOffset,
                    metaContentBottomPosition: metaContentBottomPosition,
                    metaContentColumnStart: metaContentColumnStart,
                    sectionIndex: sectionIndex,
                    metaContentPosition: metaContentPosition,
                    metaContent: metaContent,
                    metaContentTopOffset: metaContentTopOffset,
                    metaContentWrapperStyle: metaContentWrapperStyle
                }),
                " "
            ]
        }), sectionIndex));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LayoutProvider/* default */.Z, {
        remeasureLayoutCallback: remeasureLayout,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                position: "absolute",
                w: "100%",
                h: "100%",
                zIndex: -9999,
                backgroundColor: esm.color[colorMode].background
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadMetadata/* default */.Z, {
                pageMetadata: pageMetadata
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthSectionWrapper/* default */.Z, {
                containerProps: breadcrumbs ? {
                    flexDirection: "column",
                    gridGap: 0,
                    marginBottom: global/* GAP_SIZE_REM */.L3
                } : {},
                children: [
                    customNavbar !== null && customNavbar !== void 0 ? customNavbar : /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {}),
                    breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(BreadcrumbList/* default */.Z, {
                        items: breadcrumbs
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, {
                children: firstSection ? firstSection : null
            }),
            sections.map(function(section, index) {
                return section.isFullscreen ? renderSection(section, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, {
                    children: renderSection(section, index)
                }, index);
            }),
            !disableProAd && !sections[sections.length - 1].infiniteScroll && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProAdSection/* default */.Z, {
                mt: esm.spacing.toRem(64),
                pb: esm.spacing.toRem(64),
                isShort: isShortProAd,
                showPrices: showFooterPrices
            }),
            !shouldHideFooter && (isMobileView || !sections[sections.length - 1].infiniteScroll) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                disableNewsletter: disableNewsletter,
                disableStickyStartTrial: true
            }),
            !disableSaleBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialOfferBannerWrapper/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var layout_Layout = (Layout);


/***/ }),

/***/ 39891:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79139);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63069);
/* harmony import */ var _banner_GetTheAppBanner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26202);
/* harmony import */ var _banner_SignUpBanner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(31072);
/* harmony import */ var _Layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(28146);







var LayoutAdapter = function(param) {
    var children = param.children, pageMetadata = param.pageMetadata, hasInfiniteScroll = param.hasInfiniteScroll, beforeSection = param.beforeSection, _showMetacontentBanner = param.showMetacontentBanner, showMetacontentBanner = _showMetacontentBanner === void 0 ? true : _showMetacontentBanner, disableNewsletter = param.disableNewsletter, disableProAd = param.disableProAd;
    var isLoggedIn = (0,providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().isLoggedIn;
    var metaContent = !isLoggedIn ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_banner_SignUpBanner__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        size: "sm",
        mb: {
            base: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .GAP_SIZE_REM */ .L3,
            md: 0
        }
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_banner_GetTheAppBanner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {});
    var mainLayoutSection = {
        content: children,
        infiniteScroll: hasInfiniteScroll,
        metaContent: showMetacontentBanner ? metaContent : undefined,
        metaContentStickyOffset: 32
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        pageMetadata: pageMetadata,
        sections: beforeSection ? [
            beforeSection,
            mainLayoutSection
        ] : [
            mainLayoutSection
        ],
        disableNewsletter: disableNewsletter,
        disableProAd: disableProAd
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LayoutAdapter);


/***/ }),

/***/ 56096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "V": function() { return /* binding */ FOOTER_SECTIONS; },
  "Z": function() { return /* binding */ components_Footer; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/navigation/NextLink.tsx
var NextLink = __webpack_require__(50752);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/services/analytics/index.ts
var analytics = __webpack_require__(62687);
// EXTERNAL MODULE: ./src/api/Auth.ts
var Auth = __webpack_require__(92361);
;// CONCATENATED MODULE: ./src/components/newsletter/NewsletterSection.tsx










var TITLE = "Supercharge your mind with one idea per day";
var SUBTITLE = "Enter your email and spend 1 minute every day to learn something new.";
var CHECKBOX_LABEL = "I agree to receive email updates";
var CHECKBOX_ERROR = "You need to agree to receive updates";
var EMAIL_ERROR = "Must be a valid email address";
var FINISHED_TITLE = "Thanks for signing up!";
var FINISHED_SUBTITLE = "We'll let you know about new ideas from books, podcasts, and articles.";
var NewsletterSection = function(param) {
    var containerProps = param.containerProps;
    var colorMode = (0,esm.useColorMode)().colorMode;
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState("introduce-email"), 2), newsletterState = ref[0], setNewsletterState = ref[1];
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(undefined), 2), email = ref1[0], setEmail = ref1[1];
    var ref2 = (0,_sliced_to_array/* default */.Z)(react.useState(true), 2), isAgreeChecked = ref2[0], setIsAgreeChecked = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)(react.useState({
        email: false,
        agree: false
    }), 2), haveError = ref3[0], setHaveError = ref3[1];
    var onChangeEmail = function(value) {
        setEmail(value);
    };
    var onChangeCheckbox = function(_event) {
        setIsAgreeChecked(function(prevValue) {
            return !prevValue;
        });
    };
    var submitEmailForNewsletter = function() {
        if (email === undefined) {
            return;
        }
        // POST save in backend
        Auth/* addEmailToNewsletter */.bk({
            email: email
        }).catch(function(_) {
            return undefined;
        });
        // Send Event to Amplitude
        analytics/* Analytics.logEvent */.c.logEvent({
            eventName: analytics/* Events.newsletter.submitEmailNewsletter */.z.newsletter.submitEmailNewsletter,
            properties: {
                email: email,
                url: router.asPath
            },
            platforms: [
                "amplitude"
            ]
        });
        // Update UI
        setNewsletterState("finished");
    };
    var onClickSubmit = function() {
        setHaveError(function(_prevValue) {
            var haveEmailError = email === undefined || !(0,global/* validateEmail */.oH)(email);
            var haveAgreeError = isAgreeChecked === false;
            if (haveEmailError === false && haveAgreeError === false) {
                submitEmailForNewsletter();
                return {
                    email: false,
                    agree: false
                };
            } else {
                return {
                    email: haveEmailError,
                    agree: haveAgreeError
                };
            }
        });
    };
    var onKeyPressTextInput = react.useCallback(function(e) {
        if (e.key === "Enter") {
            onClickSubmit();
        }
    }, [
        onClickSubmit
    ]);
    var renderErrorMessage = function(param) {
        var message = param.message;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.smaller.regular), {
                color: esm.color.failure["default"],
                children: message
            }))
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            newsletterState === "introduce-email" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                flexDirection: {
                    sm: "column",
                    md: "column",
                    lg: "row"
                },
                justifyContent: "space-between",
                gridColumnGap: 16
            }, containerProps), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        flexDirection: "column",
                        flex: 1,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.small.semiBold), {
                                color: esm.color[colorMode].text,
                                textAlign: {
                                    sm: "center",
                                    md: "center",
                                    lg: "unset"
                                },
                                children: TITLE
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.medium.regular), {
                                color: esm.color[colorMode].textSecondary,
                                textAlign: {
                                    sm: "center",
                                    md: "center",
                                    lg: "unset"
                                },
                                children: SUBTITLE
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        flex: 1,
                        flexDirection: "column",
                        mt: {
                            sm: 16,
                            lg: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.smaller.semiBold), {
                                color: esm.color[colorMode].text,
                                children: "Email"
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                                flexDirection: {
                                    sm: "column",
                                    md: "column",
                                    lg: "row"
                                },
                                gridColumnGap: 8,
                                mt: 4,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                                        flexDirection: "column",
                                        flex: 1,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.TextInput, {
                                                flex: 1,
                                                name: "email",
                                                placeholder: "Enter Email Address",
                                                py: 8,
                                                value: email,
                                                onChange: onChangeEmail,
                                                onKeyPress: onKeyPressTextInput
                                            }),
                                            haveError.email ? renderErrorMessage({
                                                message: EMAIL_ERROR
                                            }) : null,
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                                                flexDirection: "column",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Checkbox, {
                                                        px: 0,
                                                        isChecked: isAgreeChecked,
                                                        onChange: onChangeCheckbox,
                                                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.smaller.regular), {
                                                            color: esm.color[colorMode].text,
                                                            children: CHECKBOX_LABEL
                                                        }))
                                                    }),
                                                    haveError.agree ? renderErrorMessage({
                                                        message: CHECKBOX_ERROR
                                                    }) : null
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                                        flexDirection: "column",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            size: "sm",
                                            type: "button"
                                        }, esm.typography.primaryTextFonts.medium.semiBold), {
                                            borderRadius: 8,
                                            px: 48,
                                            py: 8,
                                            onClick: onClickSubmit,
                                            children: "Submit"
                                        }))
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })) : null,
            newsletterState === "finished" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                flexDirection: "column",
                alignItems: "center"
            }, containerProps), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.medium.semiBold), {
                        color: esm.color[colorMode].text,
                        textAlign: "center",
                        children: FINISHED_TITLE
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.medium.regular), {
                        color: esm.color[colorMode].textSecondary,
                        textAlign: "center",
                        children: FINISHED_SUBTITLE
                    }))
                ]
            })) : null
        ]
    });
};
/* harmony default export */ var newsletter_NewsletterSection = (NewsletterSection);

// EXTERNAL MODULE: ./src/components/layout/components/FullWidthSectionWrapper.tsx
var FullWidthSectionWrapper = __webpack_require__(41140);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./src/components/footer/FooterStickyStartTrial.module.scss
var FooterStickyStartTrial_module = __webpack_require__(40792);
var FooterStickyStartTrial_module_default = /*#__PURE__*/__webpack_require__.n(FooterStickyStartTrial_module);
// EXTERNAL MODULE: ./src/page-components/landing/LandingPageV2.tsx + 2 modules
var LandingPageV2 = __webpack_require__(51418);
// EXTERNAL MODULE: ./src/hooks/purchases/useAuthAndOpenPurchasePage.ts
var useAuthAndOpenPurchasePage = __webpack_require__(5402);
;// CONCATENATED MODULE: ./src/components/footer/FooterStickyStartTrial.tsx












// TODO No Trial Changes
// const CTA_TEXT = 'Try it for Free';
var CTA_TEXT = "Start Today";
var FooterStickyStartTrial = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var isMobileView = (0,esm.useIsMobileView)();
    var onClickStartSubscriptionForNsi = (0,useAuthAndOpenPurchasePage/* default */.Z)({}).onClickStartSubscriptionForNsi;
    var router = (0,next_router.useRouter)();
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isVisible = ref[0], setIsVisible = ref[1];
    // TODO No Trial Changes
    // const { stripePrices, requestStatus } = useStripePrices({
    //   requestNsi: true,
    // });
    // const freeTrialSubscription = stripePrices?.subscriptions['1 YEAR'];
    // const normalizedPrice = `$${freeTrialSubscription?.pricePerMonth}/month`;
    // const descriptionText =
    //   requestStatus === 'success'
    //     ? `Try first week for free, then ${normalizedPrice} (billed annually)`
    //     : '';
    var descriptionText = "Get Deepstash Pro & replace doomscrolling with personal growth";
    react.useEffect(function() {
        window.addEventListener("scroll", handleScroll);
        return function() {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    var handleScroll = function() {
        if (window.pageYOffset > 0) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        className: "".concat((FooterStickyStartTrial_module_default()).bar, " ").concat(isVisible ? (FooterStickyStartTrial_module_default()).visible : ""),
        bgColor: "rgba(0, 0, 0, 0.7)",
        px: LandingPageV2/* LANDING_PAGE_DEFAULT_PX */.C,
        alignItems: "center",
        justifyContent: "flex-end",
        gridColumnGap: {
            sm: 8,
            md: 32
        },
        zIndex: 10,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isMobileView ? (0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.small.regular) : (0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.medium.regular)), {
                color: esm.color.light.textInverted,
                flex: 1,
                textAlign: {
                    sm: "start",
                    md: "start",
                    lg: "end"
                },
                children: descriptionText
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                flexDirection: "column",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    size: "md",
                    type: "button"
                }, esm.typography.primaryTextFonts.medium.semiBold), {
                    borderRadius: 16,
                    noOfLines: 1,
                    onClick: function() {
                        analytics/* Analytics.logEvent */.c.logEvent({
                            eventName: analytics/* Events.payments.clickStartTrial */.z.payments.clickStartTrial,
                            properties: {
                                url: router.asPath,
                                landingLocation: "footer-sticky"
                            },
                            platforms: [
                                "amplitude"
                            ]
                        });
                        onClickStartSubscriptionForNsi();
                    },
                    children: CTA_TEXT
                }))
            })
        ]
    });
};
/* harmony default export */ var footer_FooterStickyStartTrial = (FooterStickyStartTrial);

// EXTERNAL MODULE: ./src/providers/hooks/useProfile.ts
var useProfile = __webpack_require__(2334);
// EXTERNAL MODULE: ./src/types/enums.ts
var enums = __webpack_require__(41390);
;// CONCATENATED MODULE: ./src/components/layout/components/LogoWithVersion.tsx





var LogoWithVersion = function() {
    var ref = (0,react.useState)(false), isHovering = ref[0], setIsHovering = ref[1];
    var colorMode = (0,esm.useColorMode)().colorMode;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        onMouseEnter: function() {
            return setIsHovering(true);
        },
        onMouseLeave: function() {
            return setIsHovering(false);
        },
        color: esm.color[colorMode].text,
        mb: "1rem"
    }, esm.typography.primaryHeadingFonts.medium.regular), {
        children: [
            "deep",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    fontWeight: 700
                },
                children: "stash"
            }),
            isHovering && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                style: {
                    fontSize: "1.25rem",
                    lineHeight: "1.25rem",
                    color: esm.color[colorMode].textDisabled
                },
                children: " " + "7.4.5"
            })
        ]
    }));
};
/* harmony default export */ var components_LogoWithVersion = (LogoWithVersion);

;// CONCATENATED MODULE: ./src/components/layout/components/Footer.tsx






// import useProfile from 'providers/hooks/useProfile';
// import FooterStickyStartTrial from 'src/components/footer/FooterStickyStartTrial';
// import { UserSubscriptionType } from 'types/enums';










var FOOTER_SECTIONS = [
    {
        id: 0,
        title: "Content",
        links: [
            {
                title: "Ideas",
                href: "/articles/1"
            },
            {
                title: "Collections",
                href: "/collections/1"
            },
            {
                title: "Stories",
                href: "/stories"
            },
            {
                title: "Explore",
                href: "/explore"
            }, 
        ]
    },
    {
        id: 1,
        title: "Product",
        links: [
            // { title: 'How It Works', href: '/how-it-works' },
            {
                title: "Pricing",
                href: "/get-pro"
            },
            {
                title: "Businesses",
                href: "/for-teams"
            }, 
        ]
    },
    {
        id: 2,
        title: "Resources",
        links: [
            {
                title: "Terms",
                href: "/terms-of-service"
            },
            {
                title: "Privacy",
                href: "/privacy-policy"
            },
            {
                title: "Press Kit",
                href: "/press-kit"
            },
            {
                title: "Sitemap",
                href: "https://deepstash.com/sitemap.xml"
            }, 
        ]
    },
    {
        id: 3,
        title: "Company",
        links: [
            {
                title: "About",
                href: "/about"
            },
            {
                title: "Contact",
                href: "/press-kit"
            }, 
        ]
    }, 
];
var SOCIAL_NETWORKS = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.InstagramSvg, {}),
        link: "https://instagram.com/deepstash"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.FacebookSvg, {}),
        link: "https://www.facebook.com/deepstash/"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.TwitterSvg, {}),
        link: "https://twitter.com/deepstash"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.TikTokSvg, {}),
        link: "https://www.tiktok.com/@deepstash.app"
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.YouTubeSvg, {}),
        link: "https://www.youtube.com/c/Deepstash"
    }, 
];
var Footer = /*#__PURE__*/ react.forwardRef(function(_param, ref) {
    var disableNewsletter = _param.disableNewsletter, disableStickyStartTrial = _param.disableStickyStartTrial, props = (0,_object_without_properties/* default */.Z)(_param, [
        "disableNewsletter",
        "disableStickyStartTrial"
    ]);
    var colorMode = (0,esm.useColorMode)().colorMode;
    var isMobileView = (0,esm.useIsMobileView)();
    var isIos = (0,esm.useDeviceDetect)().isIos;
    var router = (0,next_router.useRouter)();
    var profile = (0,useProfile/* default */.Z)().profile;
    var isProUser = (profile === null || profile === void 0 ? void 0 : profile.subscriptionType) === enums/* UserSubscriptionType.Premium */.A5.Premium;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isProUser === false && (disableStickyStartTrial === undefined || disableStickyStartTrial === false) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(footer_FooterStickyStartTrial, {}) : null,
            disableNewsletter === true || profile ? null : /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(newsletter_NewsletterSection, {
                    containerProps: {
                        mt: 64,
                        mb: 32,
                        width: "100%"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                w: "100%",
                ref: ref,
                zIndex: 3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthSectionWrapper/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    backgroundColor: esm.color[colorMode].underground,
                    pt: 16,
                    pb: 60,
                    containerProps: {
                        color: esm.color[colorMode].text,
                        flexDirection: {
                            base: "column",
                            md: "row"
                        },
                        paddingX: {
                            base: 16,
                            md: 0
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                            flexDirection: "column",
                            alignItems: "left",
                            width: {
                                base: "100%",
                                md: (0,global/* getRemWidthFromColumns */._P)(2),
                                lg: (0,global/* getRemWidthFromColumns */._P)(4)
                            },
                            gridGap: "1rem",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_LogoWithVersion, {}),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                                    gridGap: "1rem",
                                    children: SOCIAL_NETWORKS.map(function(sn, index) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                                            target: "_blank",
                                            href: sn.link,
                                            rel: "noopener nofollow noreferrer",
                                            children: sn.icon
                                        }, index);
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                                    gridGap: {
                                        base: 0,
                                        lg: "1rem"
                                    },
                                    flexDirection: {
                                        base: "column",
                                        lg: "row"
                                    },
                                    children: [
                                        (isMobileView && isIos || !isMobileView) && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.AppStoreButton, (0,_object_spread/* default */.Z)({
                                            _hover: undefined,
                                            pr: 0,
                                            pb: 0,
                                            pl: "1rem",
                                            pt: esm.spacing.XXS.rem,
                                            store: "Apple",
                                            w: (0,global/* getRemWidthFromColumns */._P)(2),
                                            h: esm.spacing.toRem(global/* SQUARE_WIDTH */.HC * 1.5)
                                        }, router.pathname === "/producthunt" ? {
                                            url: "https://apps.apple.com/us/app/deepstash-smarter-every-day/id1445023295?ppid=84e3bc79-ff76-4783-a01c-217fd55d891f"
                                        } : {})),
                                        (isMobileView && !isIos || !isMobileView) && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.AppStoreButton, {
                                            _hover: undefined,
                                            pr: 0,
                                            pb: 0,
                                            pl: "1rem",
                                            pt: esm.spacing.XXS.rem,
                                            store: "GooglePlay",
                                            w: (0,global/* getRemWidthFromColumns */._P)(2),
                                            h: esm.spacing.toRem(global/* SQUARE_WIDTH */.HC * 1.5)
                                        })
                                    ]
                                })
                            ]
                        }),
                        FOOTER_SECTIONS.map(function(section) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                                flexDirection: "column",
                                alignItems: "left",
                                width: {
                                    base: "100%",
                                    md: (0,global/* getRemWidthFromColumns */._P)(1.5),
                                    lg: (0,global/* getRemWidthFromColumns */._P)(2)
                                },
                                gridGap: "1rem",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.small.bold), {
                                        children: section.title
                                    })),
                                    section.links.map(function(link, index) {
                                        return link.href.startsWith("https") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                                            href: link.href,
                                            children: link.title
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* default */.Z, {
                                            href: link.href,
                                            passHref: true,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Link, {
                                                _focus: undefined,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                                                    onClick: function() {
                                                        analytics/* Analytics.logEvent */.c.logEvent({
                                                            eventName: analytics/* Events.consumption.footerTap */.z.consumption.footerTap,
                                                            properties: {
                                                                button: ""
                                                            },
                                                            platforms: [
                                                                "amplitude"
                                                            ]
                                                        });
                                                    },
                                                    children: link.title
                                                })
                                            })
                                        }, index);
                                    })
                                ]
                            }, section.id);
                        })
                    ]
                }))
            })
        ]
    });
});
/* harmony default export */ var components_Footer = (Footer);


/***/ }),

/***/ 22591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_components_animation_AnimateInView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79274);
/* harmony import */ var src_components_text_decorations_UnderlineMarkerDrawing__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23696);








var SectionHeader = function(_param) {
    var title = _param.title, preTitle = _param.preTitle, titleColor = _param.titleColor, preTitleColor = _param.preTitleColor, underlineColor = _param.underlineColor, headingSize = _param.headingSize, _showUnderline = _param.showUnderline, showUnderline = _showUnderline === void 0 ? true : _showUnderline, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "title",
        "preTitle",
        "titleColor",
        "preTitleColor",
        "underlineColor",
        "headingSize",
        "showUnderline"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var titleComponent = headingSize ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Heading, {
        size: headingSize,
        zIndex: 1,
        fontSize: {
            base: "2.5rem",
            md: "4rem"
        },
        color: titleColor !== null && titleColor !== void 0 ? titleColor : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
        textAlign: "center",
        fontWeight: 900,
        children: title
    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, {
        zIndex: 1,
        fontSize: {
            base: "2.5rem",
            md: "4rem"
        },
        color: titleColor !== null && titleColor !== void 0 ? titleColor : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
        textAlign: "center",
        fontWeight: 900,
        children: title
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        w: "100%"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_animation_AnimateInView__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variants: {
                    visible: {
                        opacity: 1,
                        translateY: 0
                    },
                    hidden: {
                        opacity: 0,
                        scale: 1,
                        translateY: 32
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, isMobileView ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryHeadingFonts.medium.bold : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryHeadingFonts.large.bold), {
                    color: preTitleColor !== null && preTitleColor !== void 0 ? preTitleColor : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                    textAlign: "center",
                    children: preTitle
                }))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_animation_AnimateInView__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variants: {
                    visible: {
                        opacity: 1,
                        translateY: 0
                    },
                    hidden: {
                        opacity: 0,
                        scale: 1,
                        translateY: 32
                    }
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    position: "relative",
                    children: [
                        titleComponent,
                        showUnderline && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_text_decorations_UnderlineMarkerDrawing__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            position: "absolute",
                            top: {
                                base: "2rem",
                                md: "3rem"
                            },
                            left: 0,
                            height: "35%",
                            zIndex: 0,
                            fill: underlineColor
                        })
                    ]
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionHeader);


/***/ }),

/***/ 57401:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);






var SectionTitle = function(_param) {
    var title = _param.title, preTitle = _param.preTitle, postTitle = _param.postTitle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "title",
        "preTitle",
        "postTitle"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        width: "100%",
        textAlign: {
            base: "center",
            md: "left"
        },
        alignItems: {
            base: "center",
            md: "left"
        },
        justifyContent: {
            base: "center",
            md: "left"
        }
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryHeading, {
            size: "h2",
            children: [
                preTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, isMobileView ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryHeadingFonts.medium.bold : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryHeadingFonts.large.bold), {
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                    children: preTitle
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, {
                    fontSize: {
                        base: "2rem",
                        md: "2.5rem"
                    },
                    fontWeight: "bold",
                    lineHeight: {
                        base: "2rem",
                        md: "2.5rem"
                    },
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                    children: title
                }),
                postTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, isMobileView ? deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryHeadingFonts.medium.bold : deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryHeadingFonts.large.bold), {
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                    children: postTitle
                }))
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SectionTitle);


/***/ }),

/***/ 17005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63069);







var SubsectionHeader = function(_param) {
    var headingSize = _param.headingSize, children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "headingSize",
        "children"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    return headingSize ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryHeading, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        size: headingSize,
        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
        opacity: 0.6
    }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.medium.bold), {
        height: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .SQUARE_WIDTH_REM */ .wY
    }), props), {
        children: children
    })) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
        opacity: 0.6
    }, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.medium.bold), {
        height: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .SQUARE_WIDTH_REM */ .wY
    }), props), {
        children: children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SubsectionHeader);


/***/ }),

/***/ 37066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var hooks_useRouter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98377);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var src_providers_hooks_useProfile__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2334);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(40643);







var HeadMetadata = function(param) {
    var pageMetadata = param.pageMetadata;
    var router = (0,hooks_useRouter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    var routerPath = router.asPath.split("?")[0].split("#")[0];
    var profile = (0,src_providers_hooks_useProfile__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)().profile;
    /**
   * The robots tag [bot must-have] is used by bots to know whether to index the page in their search results.
   * User-only pages, such as search results or settings, are not usually up for indexing. [noindex]
   * Traffic-driving public pages, such as articles and ideas, definitely are. [index - default]
   */ var robotsTag = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
        name: "robots",
        content: pageMetadata.robotsTag
    }, "robots");
    /**
   * Canonical tag [bot must-have]. Used by Google to know what page is the reference one when multiple versions are available.
   * Ex.: https://deepstash.com/article/123 will have the canonical url https://deepstash.com/article/123/the-correct-slug.
   * Our URLs have NO TRAILING SLASH. The trailing slash version redirects (301, permanently) to the slash-less one.**
   */ var canonicalTag = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
        rel: "canonical",
        href: pageMetadata.canonical
    });
    /**
   * We use this function for inserting the description tag
   */ var pageDescription = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
        name: "description",
        content: pageMetadata.pageDescription
    });
    /**
   * Based on the page type, we add additional metadata, such as OpenGraph tags (og:),
   * Twitter tags (for generating Twitter card previews), or Structured Data tags
   * (JSON-LD).
   *
   * For reference, check https://www.notion.so/deepstash/ad9f401a37504c1bae460e6fbafd534e?v=b4e4a2c7d48a449f92e6dc395727524d
   */ var renderOpenGraphTags = function() {
        if (pageMetadata.openGraphTags) {
            var _authorTag;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:url",
                        content: pageMetadata.canonical
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:type",
                        content: pageMetadata.openGraphTags.type
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:title",
                        content: pageMetadata.openGraphTags.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        content: pageMetadata.openGraphTags.description
                    }),
                    pageMetadata.openGraphTags.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:image",
                        content: pageMetadata.openGraphTags.image
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:site_name",
                        content: "Deepstash"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "author",
                        content: (_authorTag = pageMetadata.authorTag) !== null && _authorTag !== void 0 ? _authorTag : "Deepstash"
                    })
                ]
            });
        }
        return null;
    };
    var renderTwitterTags = function() {
        if (pageMetadata.openGraphTags) {
            var ref;
            var ref1, _authorTag;
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:domain",
                        defaultValue: "deepstash.com"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:title",
                        defaultValue: pageMetadata.openGraphTags.title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:description",
                        content: pageMetadata.openGraphTags.description
                    }),
                    pageMetadata.openGraphTags.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:image",
                        content: pageMetadata.openGraphTags.image
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:card",
                        content: (ref1 = (ref = pageMetadata.twitterTags) === null || ref === void 0 ? void 0 : ref.card) !== null && ref1 !== void 0 ? ref1 : "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:label1",
                        defaultValue: "Author"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "twitter:data1",
                        defaultValue: (_authorTag = pageMetadata.authorTag) !== null && _authorTag !== void 0 ? _authorTag : "Deepstash"
                    })
                ]
            });
        }
        return null;
    };
    /**
   * All pages should have a title. If no particular page title is given via the prop,
   * we append ' - Deepstash' to the end of the title. E.g.: My page - Deepstash.
   */ var renderTitleTag = function() {
        if (router.asPath === "/") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: pageMetadata.pageTitle
            });
        } else {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("title", {
                children: [
                    (profile === null || profile === void 0 ? void 0 : profile.newNotificationsCount) ? "(".concat(profile === null || profile === void 0 ? void 0 : profile.newNotificationsCount, ") ") : "",
                    pageMetadata.pageTitle ? pageMetadata.pageTitle + " - " : "",
                    "Deepstash"
                ]
            });
        }
    };
    /**
   *  Schema Structured data
   *  JSON-LD
   */ var getStrucutredData = function() {
        if (pageMetadata.structuredDataObjects) {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: pageMetadata.structuredDataObjects.map(function(dataObject, index) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, dataObject), index);
                })
            });
        }
        return null;
    };
    var iconTags = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "apple-touch-icon",
                sizes: "180x180",
                href: "https://static.deepstash.com/apple-touch-icon".concat(!!(profile === null || profile === void 0 ? void 0 : profile.newNotificationsCount) ? "-unread-notifications" : "", ".png")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "32x32",
                href: "https://static.deepstash.com/favicon-32x32".concat(!!(profile === null || profile === void 0 ? void 0 : profile.newNotificationsCount) ? "-unread-notifications" : "", ".png")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "icon",
                type: "image/png",
                sizes: "16x16",
                href: "https://static.deepstash.com/favicon-16x16".concat(!!(profile === null || profile === void 0 ? void 0 : profile.newNotificationsCount) ? "-unread-notifications" : "", ".png")
            })
        ]
    });
    /**
   * https://developers.facebook.com/docs/applinks/metadata-reference/
   */ var appLinkMetadata = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "al:ios:url",
                content: "https://deepstash.com" + routerPath
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "al:ios:app_store_id",
                content: "1445023295"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "al:ios:app_name",
                content: "Deepstash: Key Ideas for Work"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "al:android:url",
                content: "https://deepstash.com" + routerPath
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "al:android:app_name",
                content: "Deepstash: Key Ideas for Work"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "al:android:package",
                content: "com.deepstash"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "al:web:url",
                content: "https://deepstash.com" + routerPath
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_5__.Box, {
        display: "none",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                renderTitleTag(),
                pageDescription,
                canonicalTag,
                robotsTag,
                getStrucutredData(),
                renderOpenGraphTags(),
                renderTwitterTags(),
                iconTags,
                appLinkMetadata
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeadMetadata);


/***/ }),

/***/ 85429:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ pro_benefits_ProAdSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/providers/hooks/useAuth.ts + 1 modules
var useAuth = __webpack_require__(79139);
// EXTERNAL MODULE: ./src/providers/hooks/useNsi.ts
var useNsi = __webpack_require__(9182);
// EXTERNAL MODULE: ./src/providers/hooks/usePaywall.ts + 1 modules
var usePaywall = __webpack_require__(10098);
// EXTERNAL MODULE: ./src/providers/hooks/useProfile.ts
var useProfile = __webpack_require__(2334);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/services/analytics/index.ts
var analytics = __webpack_require__(62687);
// EXTERNAL MODULE: ./src/components/image/NextImage.tsx + 11 modules
var NextImage = __webpack_require__(91260);
// EXTERNAL MODULE: ./src/components/layout/components/FullWidthSectionWrapper.tsx
var FullWidthSectionWrapper = __webpack_require__(41140);
// EXTERNAL MODULE: ./src/types/enums.ts
var enums = __webpack_require__(41390);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/utils/strings/actionStrings.ts
var actionStrings = __webpack_require__(89134);
// EXTERNAL MODULE: ./src/components/page-sections/value-props/ProComparisonSection.tsx
var ProComparisonSection = __webpack_require__(59553);
// EXTERNAL MODULE: ./src/components/animation/ParallaxEffect.tsx
var ParallaxEffect = __webpack_require__(23108);
// EXTERNAL MODULE: ./src/components/cards/BaseCard.tsx
var BaseCard = __webpack_require__(46039);
// EXTERNAL MODULE: ./src/components/cards/GroupCardSvg.tsx
var GroupCardSvg = __webpack_require__(28907);
// EXTERNAL MODULE: ./src/components/cards/PreviewCardSmall.tsx
var PreviewCardSmall = __webpack_require__(84768);
// EXTERNAL MODULE: ./src/components/layout/components/SectionTitle.tsx
var SectionTitle = __webpack_require__(57401);
;// CONCATENATED MODULE: ./src/page-components/public-pages/get-pro-page/PlayIllustration.tsx





var PlayIllustration = /*#__PURE__*/ react.memo(function(props) {
    var _width, ref, _height, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Icon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: (ref = (_width = props.width) !== null && _width !== void 0 ? _width : props.w) !== null && ref !== void 0 ? ref : 353,
        height: (ref1 = (_height = props.height) !== null && _height !== void 0 ? _height : props.h) !== null && ref1 !== void 0 ? ref1 : 56,
        viewBox: "0 0 353 56",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("g", {
                opacity: "0.4",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M8 22.4141H16.3789V28H8V22.4141ZM16.125 22.4141H24.5039V28H16.125V22.4141ZM24.25 22.4141H32.6289V28H24.25V22.4141ZM48.6758 22.4141H57.0547V28H48.6758V22.4141ZM56.8008 22.4141H65.1797V28H56.8008V22.4141ZM64.9258 22.4141H73.3047V28H64.9258V22.4141ZM73.0508 22.4141H81.4297V28H73.0508V22.4141ZM81.1758 22.4141H89.5547V28H81.1758V22.4141ZM89.3008 22.4141H97.6797V28H89.3008V22.4141ZM113.727 22.4141H122.105V28H113.727V22.4141ZM121.852 22.4141H130.23V28H121.852V22.4141ZM129.977 22.4141H138.355V28H129.977V22.4141ZM138.102 22.4141H146.48V28H138.102V22.4141ZM146.227 22.4141H154.605V28H146.227V22.4141ZM154.352 22.4141H162.73V28H154.352V22.4141ZM178.777 22.4141H187.156V28H178.777V22.4141ZM186.902 22.4141H195.281V28H186.902V22.4141ZM195.027 22.4141H203.406V28H195.027V22.4141ZM203.152 22.4141H211.531V28H203.152V22.4141ZM227.578 22.4141H235.957V28H227.578V22.4141ZM235.703 22.4141H244.082V28H235.703V22.4141ZM8 38.4141H16.3789V44H8V38.4141ZM16.125 38.4141H24.5039V44H16.125V38.4141ZM40.5508 38.4141H48.9297V44H40.5508V38.4141ZM48.6758 38.4141H57.0547V44H48.6758V38.4141ZM56.8008 38.4141H65.1797V44H56.8008V38.4141ZM64.9258 38.4141H73.3047V44H64.9258V38.4141ZM89.3516 38.4141H97.7305V44H89.3516V38.4141ZM97.4766 38.4141H105.855V44H97.4766V38.4141ZM105.602 38.4141H113.98V44H105.602V38.4141ZM130.027 38.4141H138.406V44H130.027V38.4141ZM138.152 38.4141H146.531V44H138.152V38.4141ZM146.277 38.4141H154.656V44H146.277V38.4141ZM154.402 38.4141H162.781V44H154.402V38.4141ZM162.527 38.4141H170.906V44H162.527V38.4141ZM170.652 38.4141H179.031V44H170.652V38.4141ZM178.777 38.4141H187.156V44H178.777V38.4141ZM186.902 38.4141H195.281V44H186.902V38.4141Z",
                    fill: "#605E5C"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                x: "281",
                width: "72",
                height: "48",
                rx: "12",
                fill: "#743C7A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M311.887 15.2395C310.947 14.7283 309.764 15.0623 309.243 15.9856C309.084 16.2689 309 16.5875 309 16.9113V30.089C309 31.1444 309.871 32 310.945 32C311.275 32 311.599 31.9177 311.887 31.7607L323.997 25.1709C324.937 24.6596 325.277 23.4966 324.756 22.5734C324.579 22.2597 324.316 22.0012 323.997 21.8275L311.887 15.2395Z",
                fill: "white"
            })
        ]
    }));
});
/* harmony default export */ var get_pro_page_PlayIllustration = (PlayIllustration);

;// CONCATENATED MODULE: ./src/page-components/public-pages/get-pro-page/SpottyConnectionIllustration.tsx





var SpottyConnectionIllustraton = /*#__PURE__*/ react.memo(function(props) {
    var _width, ref, _height, ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Icon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: (ref = (_width = props.width) !== null && _width !== void 0 ? _width : props.w) !== null && ref !== void 0 ? ref : 78,
        height: (ref1 = (_height = props.height) !== null && _height !== void 0 ? _height : props.h) !== null && ref1 !== void 0 ? ref1 : 78,
        viewBox: "0 0 78 78",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_640_45988)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        d: "M35.3434 9.75036C31.9797 9.75036 28.7573 10.3841 25.8031 11.559C24.9019 11.9171 24.1799 12.6186 23.7959 13.5091C23.4119 14.3995 23.3974 15.4061 23.7556 16.3072C24.1137 17.2084 24.8152 17.9304 25.7056 18.3144C26.5961 18.6984 27.6026 18.7129 28.5038 18.3547C30.6001 17.526 32.9059 17.0629 35.3434 17.0629C39.1311 17.0343 42.8327 18.1924 45.9287 20.3747C49.0247 22.557 51.3596 25.6539 52.6058 29.2309C52.8551 29.9488 53.3219 30.5713 53.9414 31.0116C54.5609 31.452 55.3022 31.6884 56.0622 31.6879C64.2327 31.6879 70.6872 38.1424 70.6872 46.3129C70.7062 49.7246 69.5318 53.0356 67.3673 55.6729C66.7806 56.4234 66.5101 57.3732 66.6131 58.3202C66.7162 59.2673 67.1848 60.1367 67.9193 60.7434C68.6537 61.3501 69.5959 61.6462 70.5453 61.5687C71.4948 61.4912 72.3765 61.0463 73.0028 60.3285C76.2518 56.3822 78.0194 51.4245 77.9997 46.3129C78.0308 40.922 76.0634 35.7107 72.4774 31.6854C68.8915 27.6601 63.9412 25.1061 58.5826 24.5167C56.5325 20.0863 53.2519 16.3388 49.1316 13.7207C45.0113 11.1026 40.2251 9.72441 35.3434 9.75036Z",
                        fill: "#743C7A"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M3.51044 8.38636C4.19599 7.70166 5.12528 7.31708 6.09419 7.31708C7.0631 7.31708 7.99239 7.70166 8.67794 8.38636L19.9441 19.6476C20.0903 19.7695 20.2171 19.9011 20.3341 20.0376L61.9227 61.6311C61.9813 61.6846 62.0382 61.7399 62.0933 61.7969L72.0529 71.7614C72.4122 72.0961 72.7003 72.4997 72.9001 72.9482C73.1 73.3967 73.2074 73.8809 73.2161 74.3718C73.2247 74.8627 73.1344 75.3504 72.9505 75.8056C72.7666 76.2609 72.4929 76.6745 72.1458 77.0217C71.7986 77.3689 71.385 77.6426 70.9297 77.8265C70.4745 78.0103 69.9868 78.1007 69.4959 78.092C69.005 78.0833 68.5208 77.9759 68.0723 77.776C67.6238 77.5762 67.2202 77.2881 66.8854 76.9289L58.1104 68.1587C57.4297 68.2205 56.7465 68.2514 56.0629 68.2514H17.0629C14.8177 68.2676 12.5917 67.8373 10.5143 66.9856C8.43684 66.1338 6.54943 64.8776 4.96179 63.29C3.37416 61.7024 2.11796 59.815 1.26623 57.7375C0.414496 55.6601 -0.0157699 53.4341 0.000441626 51.1889C0.000441626 44.3151 3.94432 38.4456 9.75532 35.7351C9.66527 31.2718 10.7514 26.8635 12.9046 22.9529L3.51044 13.5539C2.82575 12.8683 2.44116 11.939 2.44116 10.9701C2.44116 10.0012 2.82575 9.07191 3.51044 8.38636ZM17.0629 35.3451C17.0629 32.8832 17.5309 30.553 18.3841 28.4324L50.8954 60.9389H17.0629C11.5834 60.9389 7.31294 56.6684 7.31294 51.1889C7.31294 46.5576 10.3549 42.8234 14.5474 41.7509C15.4211 41.5279 16.1816 40.99 16.6828 40.2405C17.184 39.4909 17.3906 38.5826 17.2628 37.69C17.1502 36.913 17.0835 36.13 17.0629 35.3451Z",
                        fill: "#743C7A"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_640_45988",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                        width: "78",
                        height: "78",
                        fill: "white"
                    })
                })
            })
        ]
    }));
});
/* harmony default export */ var SpottyConnectionIllustration = (SpottyConnectionIllustraton);

// EXTERNAL MODULE: ./src/page-components/public-pages/illustrations/PhoneFrame.tsx
var PhoneFrame = __webpack_require__(3015);
// EXTERNAL MODULE: ./src/utils/landingPageData.tsx
var landingPageData = __webpack_require__(74277);
// EXTERNAL MODULE: ./src/utils/metatopics.constants.ts
var metatopics_constants = __webpack_require__(90031);
// EXTERNAL MODULE: ./src/utils/strings/pageStrings.ts
var pageStrings = __webpack_require__(23244);
;// CONCATENATED MODULE: ./src/components/page-sections/pro-benefits/ProBenefitsSection.tsx



















var SOUND_WAVE_HEIGHTS = [
    "60%",
    "20%",
    "40%",
    "30%",
    "90%",
    "80%",
    "25%",
    "50%",
    "20%", 
];
var PHONE_FRAME_PROPS = {
    position: "absolute",
    w: {
        base: "100%",
        md: (0,global/* getPixelWidthFromColumns */.x$)(4),
        lg: (0,global/* getPixelWidthFromColumns */.x$)(6)
    },
    h: {
        base: "calc((100vw - 64) * 2.12)",
        md: (0,global/* getPixelWidthFromColumns */.x$)(4) * 2.12,
        lg: (0,global/* getPixelWidthFromColumns */.x$)(6) * 2.12
    }
};
var ProBenefitsSection = function(_param) {
    var ctaButton = _param.ctaButton, props = (0,_object_without_properties/* default */.Z)(_param, [
        "ctaButton"
    ]);
    var colorMode = (0,esm.useColorMode)().colorMode;
    var isMobileView = (0,esm.useIsMobileView)();
    var renderCardHeader = function(param) {
        var title = param.title, description = param.description, extraIcon = param.extraIcon;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            width: "100%",
            height: "auto",
            p: {
                base: global/* SQUARE_WIDTH_REM */.wY,
                md: global/* BLOCK_WIDTH_REM */.sC
            },
            pb: {
                base: global/* BLOCK_WIDTH_REM */.sC
            },
            color: esm.color[colorMode].textSecondary,
            flexDirection: "column",
            textAlign: {
                base: "center",
                md: "left"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryHeading, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    size: "h4"
                }, esm.typography.primaryHeadingFonts.medium.regular), {
                    mb: esm.spacing.M.rem,
                    children: title
                })),
                extraIcon ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                    alignItems: "center",
                    gridGap: global/* GAP_SIZE_REM */.L3,
                    flexDirection: {
                        base: "column",
                        md: "row"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                            children: description
                        }),
                        extraIcon
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                    children: description
                })
            ]
        });
    };
    var renderCollectionCard = function(collection) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(GroupCardSvg/* default */.Z, {
            data: collection,
            dataType: "collection"
        });
    };
    var _backgroundColor;
    var exploreSection = /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthSectionWrapper/* default */.Z, {
        pb: {
            base: global/* SECTION_GAP_REM */.hM,
            md: esm.spacing.toRem(global/* GAP_SIZE */.DG * 6)
        },
        containerProps: {
            alignItems: "top",
            flexDirection: {
                base: "column",
                md: "row"
            }
        },
        backgroundColor: (_backgroundColor = props.backgroundColor) !== null && _backgroundColor !== void 0 ? _backgroundColor : esm.color[colorMode].background,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                justifyContent: "center",
                width: {
                    base: "100%",
                    md: (0,global/* getRemWidthFromColumns */._P)(4),
                    lg: (0,global/* getRemWidthFromColumns */._P)(6)
                },
                flexDirection: "column",
                textAlign: {
                    base: "center",
                    md: "left"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* default */.Z, {
                        preTitle: pageStrings/* default.get-pro.conceptExplanationTexts.0.headers.0.preTitle */.Z["get-pro"].conceptExplanationTexts[0].headers[0].preTitle,
                        title: pageStrings/* default.get-pro.conceptExplanationTexts.0.headers.0.title */.Z["get-pro"].conceptExplanationTexts[0].headers[0].title,
                        mb: global/* GAP_SIZE_REM */.L3
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Heading, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        w: {
                            base: "100%",
                            md: (0,global/* getRemWidthFromColumns */._P)(4)
                        },
                        mb: {
                            base: global/* GAP_SIZE_REM */.L3,
                            md: esm.spacing.toRem(global/* GAP_SIZE */.DG * 3)
                        },
                        size: "h3",
                        color: esm.color[colorMode].text
                    }, esm.typography.primaryTextFonts.large.regular), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: pageStrings/* default.get-pro.conceptExplanationTexts.0.texts.0 */.Z["get-pro"].conceptExplanationTexts[0].texts[0]
                            }),
                            pageStrings/* default.get-pro.conceptExplanationTexts.0.texts.1 */.Z["get-pro"].conceptExplanationTexts[0].texts[1]
                        ]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseCard/* default */.Z, {
                        width: "100%",
                        height: "auto",
                        flexDirection: "column",
                        children: [
                            renderCardHeader(pageStrings/* default.get-pro.conceptExplanationTexts.0.cardTexts.0 */.Z["get-pro"].conceptExplanationTexts[0].cardTexts[0]),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ParallaxEffect/* default */.Z, {
                                offset: 16,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                                    h: esm.spacing.toRem(384),
                                    position: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                            w: "100%",
                                            h: "100%",
                                            zIndex: 2,
                                            p: global/* GAP_SIZE_REM */.L3,
                                            pt: esm.spacing.toRem(128),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParallaxEffect/* default */.Z, {
                                                offset: 32,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Grid, {
                                                    gridGap: esm.spacing.XL.rem,
                                                    w: "100%",
                                                    h: "100%",
                                                    gridTemplateColumns: {
                                                        base: "1fr 1fr",
                                                        md: "1fr 1fr 1fr 1fr"
                                                    },
                                                    children: metatopics_constants/* METATOPICS.map */.zY.map(function(metatopic, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(PreviewCardSmall/* default */.Z, {
                                                            w: "auto",
                                                            h: "auto",
                                                            name: metatopic.name,
                                                            imageUrl: metatopic.image,
                                                            gridColumn: {
                                                                base: (index + 1) % 2,
                                                                md: (index + 1) % 4
                                                            },
                                                            targetUrl: "/topic/" + (0,global/* formatStringToHashtagCase */.J)(metatopic.name),
                                                            hasShadow: true,
                                                            hasText: false,
                                                            p: esm.spacing.M.rem
                                                        }, metatopic.id);
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            position: "absolute",
                                            w: "auto",
                                            h: "auto",
                                            top: {
                                                base: esm.spacing.toRem(64),
                                                md: esm.spacing.toRem(72)
                                            },
                                            left: {
                                                base: esm.spacing.toRem(32),
                                                md: esm.spacing.toRem(64)
                                            }
                                        }, esm.typography.primaryHeadingFonts.small.bold), {
                                            zIndex: 1,
                                            children: pageStrings/* default.get-pro.phoneTexts.knowledgeLibrary */.Z["get-pro"].phoneTexts.knowledgeLibrary
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneFrame/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, PHONE_FRAME_PROPS), {
                                            backgroundColor: esm.color[colorMode].background
                                        }))
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseCard/* default */.Z, {
                width: {
                    base: "100%",
                    md: (0,global/* getRemWidthFromColumns */._P)(4),
                    lg: (0,global/* getRemWidthFromColumns */._P)(6)
                },
                height: esm.spacing.toRem(824),
                flexDirection: "column",
                children: [
                    renderCardHeader(pageStrings/* default.get-pro.conceptExplanationTexts.0.cardTexts.1 */.Z["get-pro"].conceptExplanationTexts[0].cardTexts[1]),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ParallaxEffect/* default */.Z, {
                        offset: 16,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                            position: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                    w: "100%",
                                    h: "100%",
                                    zIndex: 2,
                                    p: global/* GAP_SIZE_REM */.L3,
                                    pt: esm.spacing.toRem(128),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ParallaxEffect/* default */.Z, {
                                        offset: 32,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Grid, {
                                            gridGap: esm.spacing.XL.rem,
                                            w: "100%",
                                            h: "100%",
                                            gridTemplateColumns: {
                                                base: "1fr",
                                                md: "1fr 1fr"
                                            },
                                            gridRowGap: esm.spacing.toRem(2 * global/* SQUARE_WIDTH */.HC),
                                            children: landingPageData/* LANDING_PAGE_COLLECTIONS.slice */.Qq.slice(6, 8).map(function(collection) {
                                                return renderCollectionCard(collection);
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    position: "absolute",
                                    w: "auto",
                                    h: "auto",
                                    top: {
                                        base: esm.spacing.toRem(64),
                                        md: esm.spacing.toRem(72)
                                    },
                                    left: {
                                        base: esm.spacing.toRem(32),
                                        md: esm.spacing.toRem(64 + global/* BLOCK_WIDTH */.N9)
                                    }
                                }, esm.typography.primaryHeadingFonts.small.bold), {
                                    zIndex: 1,
                                    children: pageStrings/* default.get-pro.phoneTexts.personalGrowth */.Z["get-pro"].phoneTexts.personalGrowth
                                })),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneFrame/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    left: {
                                        base: 0,
                                        md: global/* BLOCK_WIDTH_REM */.sC
                                    }
                                }, PHONE_FRAME_PROPS), {
                                    backgroundColor: esm.color[colorMode].background
                                }))
                            ]
                        })
                    })
                ]
            }),
            isMobileView && ctaButton
        ]
    });
    var _backgroundColor1;
    var takeAnywhereSection = /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthSectionWrapper/* default */.Z, {
        containerProps: {
            alignItems: "top",
            flexDirection: {
                base: "column",
                md: "row"
            }
        },
        backgroundColor: (_backgroundColor1 = props.backgroundColor) !== null && _backgroundColor1 !== void 0 ? _backgroundColor1 : esm.color[colorMode].background,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                justifyContent: "center",
                width: {
                    base: "100%",
                    md: (0,global/* getRemWidthFromColumns */._P)(4),
                    lg: (0,global/* getRemWidthFromColumns */._P)(6)
                },
                flexDirection: "column",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle/* default */.Z, {
                        preTitle: pageStrings/* default.get-pro.conceptExplanationTexts.1.headers.0.preTitle */.Z["get-pro"].conceptExplanationTexts[1].headers[0].preTitle,
                        title: pageStrings/* default.get-pro.conceptExplanationTexts.1.headers.0.title */.Z["get-pro"].conceptExplanationTexts[1].headers[0].title,
                        mb: global/* GAP_SIZE_REM */.L3
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Heading, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        w: {
                            base: "100%",
                            md: (0,global/* getRemWidthFromColumns */._P)(4)
                        },
                        mb: {
                            base: global/* GAP_SIZE_REM */.L3,
                            md: esm.spacing.toRem(global/* GAP_SIZE */.DG * 3)
                        },
                        size: "h3",
                        color: esm.color[colorMode].text
                    }, esm.typography.primaryTextFonts.large.regular), {
                        textAlign: {
                            base: "center",
                            md: "left"
                        },
                        children: pageStrings/* default.get-pro.conceptExplanationTexts.1.texts.0 */.Z["get-pro"].conceptExplanationTexts[1].texts[0]
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseCard/* default */.Z, {
                        width: "100%",
                        height: "auto",
                        mb: global/* GAP_SIZE_REM */.L3,
                        overflow: "hidden",
                        flexDirection: "column",
                        children: [
                            renderCardHeader(pageStrings/* default.get-pro.conceptExplanationTexts.1.cardTexts.0 */.Z["get-pro"].conceptExplanationTexts[1].cardTexts[0]),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ParallaxEffect/* default */.Z, {
                                offset: 16,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                                    h: esm.spacing.toRem(160),
                                    position: "relative",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                                            zIndex: 1,
                                            width: "40%",
                                            height: esm.spacing.toRem(96),
                                            transform: "translateX(-50%) translateY(-50%)",
                                            left: "75%",
                                            position: "absolute",
                                            top: "50%",
                                            justifyContent: "center",
                                            gridGap: "0.5rem",
                                            alignItems: "center",
                                            children: SOUND_WAVE_HEIGHTS.map(function(height, index) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Box, {
                                                    w: "0.5rem",
                                                    h: height,
                                                    backgroundColor: esm.color.light.primary["default"],
                                                    borderRadius: "0.25rem"
                                                }, index);
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneFrame/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            left: "-50%"
                                        }, PHONE_FRAME_PROPS), {
                                            backgroundColor: esm.color[colorMode].background
                                        })),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(get_pro_page_PlayIllustration, {
                                            position: "absolute",
                                            w: "100%",
                                            left: {
                                                base: "-70%",
                                                md: "-43%"
                                            },
                                            top: 64
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(BaseCard/* default */.Z, {
                        width: "100%",
                        height: "auto",
                        children: renderCardHeader((0,_object_spread/* default */.Z)({
                            extraIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SpottyConnectionIllustration, {
                                w: esm.spacing.toRem(78),
                                h: esm.spacing.toRem(78),
                                flexShrink: 0
                            })
                        }, pageStrings/* default.get-pro.conceptExplanationTexts.1.cardTexts.1 */.Z["get-pro"].conceptExplanationTexts[1].cardTexts[1]))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(BaseCard/* default */.Z, {
                width: {
                    base: "100%",
                    md: (0,global/* getRemWidthFromColumns */._P)(4),
                    lg: (0,global/* getRemWidthFromColumns */._P)(6)
                },
                height: esm.spacing.toRem(824),
                flexDirection: "column",
                children: [
                    renderCardHeader(pageStrings/* default.get-pro.conceptExplanationTexts.1.cardTexts.2 */.Z["get-pro"].conceptExplanationTexts[1].cardTexts[2]),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ParallaxEffect/* default */.Z, {
                        offset: 16,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                            position: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
                                    w: "100%",
                                    h: "100%",
                                    zIndex: 2,
                                    p: global/* GAP_SIZE_REM */.L3,
                                    pt: esm.spacing.toRem(128),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ParallaxEffect/* default */.Z, {
                                            offset: 32,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Grid, {
                                                gridGap: esm.spacing.XXXL.rem,
                                                w: "100%",
                                                h: "100%",
                                                gridTemplateColumns: {
                                                    base: "1fr",
                                                    md: "1fr 1fr"
                                                },
                                                children: landingPageData/* LANDING_PAGE_COLLECTIONS.slice */.Qq.slice(8, 10).map(function(stash) {
                                                    return renderCollectionCard(stash);
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                            position: "absolute",
                                            w: "auto",
                                            h: "auto",
                                            top: {
                                                base: esm.spacing.toRem(64),
                                                md: esm.spacing.toRem(72)
                                            },
                                            left: {
                                                base: esm.spacing.toRem(32),
                                                md: esm.spacing.toRem(64 + global/* BLOCK_WIDTH */.N9)
                                            }
                                        }, esm.typography.primaryHeadingFonts.small.bold), {
                                            zIndex: 1,
                                            children: pageStrings/* default.get-pro.phoneTexts.myStashes */.Z["get-pro"].phoneTexts.myStashes
                                        }))
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PhoneFrame/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                    left: {
                                        base: 0,
                                        md: global/* BLOCK_WIDTH_REM */.sC
                                    }
                                }, PHONE_FRAME_PROPS), {
                                    backgroundColor: esm.color[colorMode].background
                                }))
                            ]
                        })
                    })
                ]
            }),
            isMobileView && ctaButton
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        w: "100%"
    }, props), {
        children: [
            exploreSection,
            takeAnywhereSection
        ]
    }));
};
/* harmony default export */ var pro_benefits_ProBenefitsSection = (ProBenefitsSection);

// EXTERNAL MODULE: ./src/components/page-sections/pro-benefits/ProTestimonialsSection.tsx
var ProTestimonialsSection = __webpack_require__(54749);
// EXTERNAL MODULE: ./src/utils/constants.tsx
var constants = __webpack_require__(14531);
;// CONCATENATED MODULE: ./src/components/page-sections/pro-benefits/ProAdSection.tsx














// import SectionHeader from 'src/components/layout/components/SectionHeader';
// import PaywallButtons from 'src/components/paywall/PaywallButtons';


// import { getSourceThemeColor } from 'utils/source.utils';

// import commonStrings from 'utils/strings/commonStrings';




// This will only be visible to NSI / SI non-Pro users
var ProAdSection = function(_param) {
    var _showPrices = _param.showPrices, showPrices = _showPrices === void 0 ? true : _showPrices, // promoCode,
    customCtaText = _param.customCtaText, customOnClickCta = _param.customOnClickCta, _showForPro = _param.showForPro, showForPro = _showForPro === void 0 ? false : _showForPro, _shouldAllowNsi = _param.shouldAllowNsi, shouldAllowNsi = _shouldAllowNsi === void 0 ? false : _shouldAllowNsi, _lifetimeLink = _param.lifetimeLink, lifetimeLink = _lifetimeLink === void 0 ? constants/* STRIPE_URLS.LIFETIME_299 */.b6.LIFETIME_299 : _lifetimeLink, isShort = _param.isShort, props = (0,_object_without_properties/* default */.Z)(_param, [
        "showPrices",
        "customCtaText",
        "customOnClickCta",
        "showForPro",
        "shouldAllowNsi",
        "lifetimeLink",
        "isShort"
    ]);
    var colorMode = (0,esm.useColorMode)().colorMode;
    var router = (0,next_router.useRouter)();
    var isMobileView = (0,esm.useIsMobileView)();
    var profile = (0,useProfile/* default */.Z)().profile;
    var nsiDispatch = (0,useNsi/* default */.Z)().nsiDispatch;
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var onPaywallModalOpen = (0,usePaywall/* default */.Z)().onPaywallModalOpen;
    var hasPremiumSubscription = (0,react.useMemo)(function() {
        if (!profile) {
            return 0;
        }
        return (profile === null || profile === void 0 ? void 0 : profile.subscriptionType) === enums/* UserSubscriptionType.Premium */.A5.Premium;
    }, [
        profile
    ]);
    var onStartPriceClick = (0,react.useCallback)(function(subscriptionType) {
        analytics/* Analytics.logEvent */.c.logEvent({
            eventName: analytics/* Events.payments.claimOfferEvent */.z.payments.claimOfferEvent,
            properties: {
                subscriptionType: subscriptionType,
                isLoggedIn: isLoggedIn,
                location: enums/* PaywallAnalyticsLocation.ProAdCta */.P8.ProAdCta
            },
            platforms: [
                "amplitude"
            ]
        });
        if (isLoggedIn || shouldAllowNsi) {
            if (subscriptionType === "LIFETIME") {
                router.push(lifetimeLink);
            } else {
                onPaywallModalOpen({
                    location: enums/* PaywallAnalyticsLocation.AlreadyLoggedInInfluencer */.P8.AlreadyLoggedInInfluencer,
                    showCloseButton: true,
                    defaultSubscriptionType: subscriptionType
                });
            }
        } else {
            nsiDispatch({
                type: "openAuth",
                payload: {
                    type: "sign-up"
                }
            });
        }
    }, [
        hasPremiumSubscription,
        nsiDispatch,
        isLoggedIn
    ]);
    var ctaButton = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            size: "lg",
            // TODO No Trial Changes
            onClick: function() {
                return(// customOnClickCta ? customOnClickCta() : onStartPriceClick('LIFETIME')
                customOnClickCta ? customOnClickCta() : router.push("/setup"));
            },
            _hover: {
                backgroundColor: esm.color[colorMode === "light" ? "dark" : "light"].top
            },
            width: {
                base: "100%",
                md: (0,global/* getRemWidthFromColumns */._P)(4)
            },
            minHeight: esm.spacing.toRem((isMobileView ? 1.5 : 2) * global/* SQUARE_WIDTH */.HC),
            transition: "background-color 0.3s ease-out",
            backgroundColor: esm.color[colorMode].text
        }, isMobileView ? esm.typography.primaryHeadingFonts.small.semiBold : esm.typography.primaryHeadingFonts.medium.semiBold), {
            children: customCtaText !== null && customCtaText !== void 0 ? customCtaText : actionStrings/* default.startToday */.Z.startToday
        }));
    }, [
        onStartPriceClick,
        isMobileView,
        colorMode,
        customOnClickCta
    ]);
    var ctaButtonSection = /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, {
        pb: global/* SECTION_GAP_REM */.hM,
        backgroundColor: esm.color[colorMode].surface,
        containerProps: {
            flexDirection: "column",
            alignItems: "center"
        },
        children: ctaButton
    });
    return isLoggedIn && (profile === null || profile === void 0 ? void 0 : profile.subscriptionType) === enums/* UserSubscriptionType.Premium */.A5.Premium && !showForPro ? null : /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        backgroundColor: esm.color[colorMode].surface,
        w: "100%",
        pt: isShort ? global/* GAP_SIZE_REM */.L3 : 0,
        children: [
            showPrices && /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, {
                py: {
                    base: esm.spacing.toRem(global/* GAP_SIZE */.DG * 2),
                    md: esm.spacing.toRem(global/* GAP_SIZE */.DG * 4)
                },
                backgroundColor: esm.color[colorMode].surface,
                containerProps: {
                    flexDirection: "column",
                    alignItems: "center",
                    position: "relative"
                },
                children: !isMobileView && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                    imageUrl: "https://static.deepstash.com/illustrations/stashy_superman.svg",
                    wrapperStyle: {
                        width: esm.spacing.toRem(353),
                        height: esm.spacing.toRem(200),
                        position: "absolute",
                        right: 0,
                        bottom: "-".concat(esm.spacing.toRem(global/* GAP_SIZE */.DG * 6))
                    },
                    alt: "stash-superman-illustration"
                })
            }),
            !isShort && /*#__PURE__*/ (0,jsx_runtime.jsx)(pro_benefits_ProBenefitsSection, {
                mt: {
                    base: 0,
                    md: global/* BLOCK_WIDTH_REM */.sC
                },
                backgroundColor: esm.color[colorMode].surface,
                mb: {
                    base: global/* GAP_SIZE_REM */.L3,
                    md: global/* SECTION_GAP_REM */.hM
                },
                ctaButton: ctaButton
            }),
            !isMobileView && !isShort && ctaButtonSection,
            !isShort && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProTestimonialsSection/* default */.Z, {
                mt: {
                    base: global/* SECTION_GAP_REM */.hM,
                    md: global/* BLOCK_WIDTH_REM */.sC
                },
                backgroundColor: esm.color[colorMode].surface
            }),
            !isShort && ctaButtonSection,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ProComparisonSection/* default */.Z, {
                mt: {
                    base: 0,
                    md: global/* BLOCK_WIDTH_REM */.sC
                },
                pb: {
                    base: global/* GAP_SIZE_REM */.L3,
                    md: global/* SECTION_GAP_REM */.hM
                }
            }),
            isShort && ctaButtonSection
        ]
    }));
};
/* harmony default export */ var pro_benefits_ProAdSection = (ProAdSection);


/***/ }),

/***/ 54749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var src_components_animation_AnimateInView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79274);
/* harmony import */ var src_components_cards_ReviewCard__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97683);
/* harmony import */ var src_components_layout_components_FullWidthSectionWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41140);
/* harmony import */ var src_components_layout_components_SectionHeader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22591);
/* harmony import */ var src_page_components_landing_StoreRatingCard__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(88250);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63069);
/* harmony import */ var utils_landingPageData__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(74277);
/* harmony import */ var utils_strings_pageStrings__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(23244);














var NUMBER_OF_REVIEWS_ON_A_SIDE = 4;
var ProTestimonialsSection = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, _param);
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var isIos = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useDeviceDetect)().isIos;
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var reviewsLeft = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return utils_landingPageData__WEBPACK_IMPORTED_MODULE_9__/* .LANDING_PAGE_REVIEWS.filter */ .LX.filter(function(review) {
            return review.platform === (isIos || !isMobileView ? "ios" : "android");
        }).sort(function() {
            return 0.5 - Math.random();
        }).slice(0, NUMBER_OF_REVIEWS_ON_A_SIDE);
    }, [
        isIos,
        isMobileView
    ]);
    var reviewsRight = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return utils_landingPageData__WEBPACK_IMPORTED_MODULE_9__/* .LANDING_PAGE_REVIEWS.filter */ .LX.filter(function(r) {
            return !reviewsLeft.map(function(r) {
                return r.id;
            }).includes(r.id);
        }).filter(function(r) {
            return r.platform !== "ios";
        }).sort(function() {
            return 0.5 - Math.random();
        }).slice(0, NUMBER_OF_REVIEWS_ON_A_SIDE);
    }, [
        reviewsLeft
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({
        w: "100%"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_layout_components_FullWidthSectionWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_layout_components_SectionHeader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    preTitle: utils_strings_pageStrings__WEBPACK_IMPORTED_MODULE_10__/* ["default"].landing.testimonialsHeader.preTitle */ .Z.landing.testimonialsHeader.preTitle,
                    title: utils_strings_pageStrings__WEBPACK_IMPORTED_MODULE_10__/* ["default"].landing.testimonialsHeader.title */ .Z.landing.testimonialsHeader.title,
                    underlineColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].secondary.default
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_animation_AnimateInView__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                variants: {
                    visible: {
                        opacity: 1,
                        translateY: 0
                    },
                    hidden: {
                        opacity: 0,
                        scale: 1,
                        translateY: 32
                    }
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_layout_components_FullWidthSectionWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        containerProps: {
                            gridGap: utils_global__WEBPACK_IMPORTED_MODULE_8__/* .GAP_SIZE_REM */ .L3,
                            alignItems: "center",
                            justifyContent: "space-evenly",
                            paddingY: utils_global__WEBPACK_IMPORTED_MODULE_8__/* .GAP_SIZE_REM */ .L3
                        },
                        children: [
                            (isIos && isMobileView || !isMobileView) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_page_components_landing_StoreRatingCard__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                store: "ios",
                                flexGrow: 1,
                                flexShrink: 0,
                                width: "auto",
                                height: "auto",
                                w: {
                                    base: "100%",
                                    md: (0,utils_global__WEBPACK_IMPORTED_MODULE_8__/* .getRemWidthFromColumns */ ._P)(4)
                                }
                            }),
                            !isMobileView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, {
                                width: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(2),
                                height: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(96),
                                backgroundColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].underground
                            }),
                            (!isIos && isMobileView || !isMobileView) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_page_components_landing_StoreRatingCard__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                store: "android",
                                flexGrow: 1,
                                flexShrink: 0,
                                width: "auto",
                                height: "auto",
                                w: {
                                    base: "100%",
                                    md: (0,utils_global__WEBPACK_IMPORTED_MODULE_8__/* .getRemWidthFromColumns */ ._P)(4)
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_layout_components_FullWidthSectionWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        mb: {
                            base: utils_global__WEBPACK_IMPORTED_MODULE_8__/* .GAP_SIZE_REM */ .L3,
                            md: utils_global__WEBPACK_IMPORTED_MODULE_8__/* .SECTION_GAP_REM */ .hM
                        },
                        containerProps: {
                            alignItems: "center",
                            flexDirection: {
                                base: "column",
                                md: "row"
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                                gridGap: utils_global__WEBPACK_IMPORTED_MODULE_8__/* .GAP_SIZE_REM */ .L3,
                                justifyContent: "center",
                                width: {
                                    base: "100%",
                                    md: (0,utils_global__WEBPACK_IMPORTED_MODULE_8__/* .getRemWidthFromColumns */ ._P)(4),
                                    lg: (0,utils_global__WEBPACK_IMPORTED_MODULE_8__/* .getRemWidthFromColumns */ ._P)(6)
                                },
                                flexDirection: "column",
                                children: reviewsLeft.map(function(review) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_cards_ReviewCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        review: review
                                    }, review.id);
                                })
                            }),
                            !isMobileView && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                                gridGap: utils_global__WEBPACK_IMPORTED_MODULE_8__/* .GAP_SIZE_REM */ .L3,
                                justifyContent: "center",
                                width: {
                                    base: "100%",
                                    md: (0,utils_global__WEBPACK_IMPORTED_MODULE_8__/* .getRemWidthFromColumns */ ._P)(4),
                                    lg: (0,utils_global__WEBPACK_IMPORTED_MODULE_8__/* .getRemWidthFromColumns */ ._P)(6)
                                },
                                flexDirection: "column",
                                children: reviewsRight.map(function(review) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_cards_ReviewCard__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                        review: review
                                    }, review.id);
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ProTestimonialsSection);


/***/ }),

/***/ 59553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40872);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var src_components_animation_AnimateInView__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79274);
/* harmony import */ var src_components_layout_components_FullWidthSectionWrapper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41140);
/* harmony import */ var src_components_layout_components_SectionHeader__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22591);
/* harmony import */ var theme_icons_ProBadgeSvg__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(76476);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(14531);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(63069);
/* harmony import */ var utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51599);
/* harmony import */ var utils_strings_pageStrings__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(23244);















var ProComparisonTableDesktop = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 9166).then(__webpack_require__.bind(__webpack_require__, 39166));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39166)
            ];
        }
    }
});
ProComparisonTableDesktop.displayName = "ProComparisonTableDesktop";
var HEADING_TEXT_STYLE = {
    fontSize: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(20),
    lineHeight: "1.3em",
    textAlign: "center"
};
var ProComparisonSection = function(_param) {
    var props = (0,_swc_helpers_src_extends_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, _param);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useIsMobileView)();
    var BENEFIT_LIST = (0,react__WEBPACK_IMPORTED_MODULE_3__.useMemo)(function() {
        return utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .PRO_BENEFITS_LIST.map */ .vA.map(function(benefit) {
            return {
                name: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.large.regular), {
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                    children: benefit.name.map(function(text, index) {
                        return index % 2 === 0 ? text : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            style: {
                                fontWeight: 800
                            },
                            children: text
                        });
                    })
                })),
                icon: benefit.renderIcon({
                    color: utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .PRO_COLOR */ .zC[colorMode],
                    height: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(32),
                    width: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(32)
                }),
                accessLevel: benefit.accessLevel
            };
        });
    }, [
        colorMode
    ]);
    var mobileLayout = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
        gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
        flexDirection: "column",
        alignItems: "start",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                mb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
                flex: 1,
                w: "100%",
                justifyContent: "center",
                textAlign: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, HEADING_TEXT_STYLE), {
                    textAlign: "center",
                    color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                    width: {
                        base: "100%",
                        md: (0,utils_global__WEBPACK_IMPORTED_MODULE_9__/* .getRemWidthFromColumns */ ._P)(1.5)
                    },
                    children: [
                        utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_10__/* ["default"]["with"] */ .Z["with"],
                        " deep",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                            children: "stash"
                        })
                    ]
                }))
            }),
            BENEFIT_LIST.slice(0, 2).map(function(benefit, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    flexGrow: {
                        base: 0,
                        md: 1
                    },
                    alignItems: "center",
                    gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(16),
                    children: [
                        benefit.icon,
                        benefit.name
                    ]
                }, index);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                mt: utils_global__WEBPACK_IMPORTED_MODULE_9__/* .GAP_SIZE_REM */ .L3,
                mb: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem,
                flex: 1,
                flexDirection: "column",
                alignItems: "center",
                w: "100%",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    alignItems: "center",
                    gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(4),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.PrimaryText, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({}, HEADING_TEXT_STYLE), {
                            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                            children: [
                                utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_10__/* ["default"]["with"] */ .Z["with"],
                                " deep",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                                    children: "stash"
                                })
                            ]
                        })),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(theme_icons_ProBadgeSvg__WEBPACK_IMPORTED_MODULE_7__/* .ProBadgeSvg */ .r, {
                            height: 20
                        })
                    ]
                })
            }),
            BENEFIT_LIST.slice(2).map(function(benefit, index) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                    flexGrow: {
                        base: 0,
                        md: 1
                    },
                    alignItems: "center",
                    gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(16),
                    children: [
                        benefit.icon,
                        benefit.name
                    ]
                }, index);
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Box, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
        w: "100%"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(src_components_layout_components_FullWidthSectionWrapper__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            containerProps: {
                flexDirection: "column",
                gridGap: {
                    base: utils_global__WEBPACK_IMPORTED_MODULE_9__/* .GAP_SIZE_REM */ .L3,
                    md: utils_global__WEBPACK_IMPORTED_MODULE_9__/* .BLOCK_WIDTH_REM */ .sC
                },
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_layout_components_SectionHeader__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    preTitle: utils_strings_pageStrings__WEBPACK_IMPORTED_MODULE_11__/* ["default"].landing.benefitsHeader.preTitle */ .Z.landing.benefitsHeader.preTitle,
                    title: utils_strings_pageStrings__WEBPACK_IMPORTED_MODULE_11__/* ["default"].landing.benefitsHeader.title */ .Z.landing.benefitsHeader.title,
                    underlineColor: utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .PRO_COLOR */ .zC[colorMode]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_animation_AnimateInView__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    variants: {
                        visible: {
                            opacity: 1,
                            translateY: 0
                        },
                        hidden: {
                            opacity: 0,
                            scale: 1,
                            translateY: 32
                        }
                    },
                    children: isMobileView ? mobileLayout : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ProComparisonTableDesktop, {
                        benefits: BENEFIT_LIST
                    })
                })
            ]
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ProComparisonSection);


/***/ }),

/***/ 68415:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var hooks_purchases_useStripePrices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53513);
/* harmony import */ var hooks_useRouter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98377);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14531);
/* harmony import */ var _usePaymentInternals__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(80073);
/* harmony import */ var _InvalidPromoCodeModal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96694);
/* harmony import */ var _PaywallCheckoutModal__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(23091);









var usePaymentCheckoutModal = function(param) {
    var purchaseType = param.purchaseType, promoCodeProp = param.promoCode, expName = param.expName, analyticsLocation = param.analyticsLocation;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17;
    var ref18 = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useDisclosure)(), isCheckoutModalOpen = ref18.isOpen, onCheckoutModalOpen = ref18.onOpen, onCheckoutModalClose = ref18.onClose;
    var router = (0,hooks_useRouter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var ref19 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(promoCodeProp !== null && promoCodeProp !== void 0 ? promoCodeProp : router.query.promo_code), promoCode = ref19[0], setPromoCode = ref19[1];
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        promoCodeProp && setPromoCode(promoCodeProp);
    }, [
        promoCodeProp
    ]);
    var ref20 = (0,hooks_purchases_useStripePrices__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        promoCode: promoCode,
        extraRequestParam: expName,
        requestNsi: true
    }), stripePrices = ref20.stripePrices, errorMessage = ref20.errorMessage;
    var ref21 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(), subscriptionIntentRequestStatus = ref21[0], setSubscriptionIntentRequestStatus = ref21[1];
    var setSubscriptionRequestStatus = function(status) {
        setSubscriptionIntentRequestStatus(status);
    };
    var ref22 = (0,react__WEBPACK_IMPORTED_MODULE_4__.useState)(false), isPromoCodeInvalid = ref22[0], setIsPromoCodeInvalid = ref22[1];
    var ref23 = (0,_usePaymentInternals__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        extraRequestParam: expName,
        selectedSubscriptionOrProductType: purchaseType,
        promoCodes: {
            "1 MONTH": (ref = stripePrices === null || stripePrices === void 0 ? void 0 : stripePrices.subscriptions["1 MONTH"]) === null || ref === void 0 ? void 0 : (ref1 = ref.promotion) === null || ref1 === void 0 ? void 0 : ref1.code,
            "3 MONTH": (ref2 = stripePrices === null || stripePrices === void 0 ? void 0 : stripePrices.subscriptions["1 MONTH"]) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.promotion) === null || ref3 === void 0 ? void 0 : ref3.code,
            "6 MONTH": (ref4 = stripePrices === null || stripePrices === void 0 ? void 0 : stripePrices.subscriptions["1 MONTH"]) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.promotion) === null || ref5 === void 0 ? void 0 : ref5.code,
            "1 YEAR": (ref6 = stripePrices === null || stripePrices === void 0 ? void 0 : stripePrices.subscriptions["1 YEAR"]) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.promotion) === null || ref7 === void 0 ? void 0 : ref7.code,
            LIFETIME: (ref8 = stripePrices === null || stripePrices === void 0 ? void 0 : stripePrices.products["LIFETIME"]) === null || ref8 === void 0 ? void 0 : ref8.promotion_code
        },
        setInvalidPromo: function() {
            return setIsPromoCodeInvalid(true);
        },
        type: purchaseType === "LIFETIME" ? "product" : "subscription"
    }), clientSecret = ref23.clientSecret, subscriptionId = ref23.subscriptionId, stripe = ref23.stripe, elementsOptions = ref23.elementsOptions, chooseSubscriptionPlan = ref23.chooseSubscriptionPlan, deleteStripeSubscriptionIntent = ref23.deleteStripeSubscriptionIntent;
    var onModalOpen = function() {
        onCheckoutModalOpen();
        chooseSubscriptionPlan(setSubscriptionRequestStatus);
    };
    var onCheckoutModalCloseAndDelete = function() {
        onCheckoutModalClose === null || onCheckoutModalClose === void 0 ? void 0 : onCheckoutModalClose();
        // make sure to delete the data
        // otherwise the clientSecret will be corrupted (won't be changed)
        deleteStripeSubscriptionIntent();
    };
    var refetchPricesWithoutPromoAndClose = function() {
        setPromoCode(undefined);
        setIsPromoCodeInvalid(false);
    };
    var toast = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useToast)();
    (0,react__WEBPACK_IMPORTED_MODULE_4__.useEffect)(function() {
        if (errorMessage) {
            toast({
                title: "Error Opening Payment Terminal",
                description: errorMessage,
                status: "error",
                duration: utils_constants__WEBPACK_IMPORTED_MODULE_5__/* .TOAST_TIME */ .du,
                isClosable: true
            });
        }
    }, [
        errorMessage
    ]);
    var ref24, ref25, ref26, ref27, ref28, ref29;
    var checkoutModal = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_InvalidPromoCodeModal__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                refetchPricesWithoutPromoAndClose: refetchPricesWithoutPromoAndClose,
                onClosePaywall: onCheckoutModalClose,
                isOpen: isPromoCodeInvalid
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PaywallCheckoutModal__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                isCheckoutModalOpen: isCheckoutModalOpen,
                onCheckoutModalClose: onCheckoutModalCloseAndDelete,
                clientSecret: clientSecret,
                paymentDetails: {
                    priceAmount: purchaseType === "LIFETIME" ? (ref25 = (ref24 = (ref9 = stripePrices === null || stripePrices === void 0 ? void 0 : stripePrices.products[purchaseType]) === null || ref9 === void 0 ? void 0 : ref9.promotion_price_amount) !== null && ref24 !== void 0 ? ref24 : (ref10 = stripePrices === null || stripePrices === void 0 ? void 0 : stripePrices.products[purchaseType]) === null || ref10 === void 0 ? void 0 : ref10.price_amount) !== null && ref25 !== void 0 ? ref25 : 0 : (ref27 = (ref26 = (ref11 = stripePrices === null || stripePrices === void 0 ? void 0 : stripePrices.subscriptions[purchaseType]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.promotion) === null || ref12 === void 0 ? void 0 : ref12.priceAmount) !== null && ref26 !== void 0 ? ref26 : (ref13 = stripePrices === null || stripePrices === void 0 ? void 0 : stripePrices.subscriptions[purchaseType]) === null || ref13 === void 0 ? void 0 : ref13.priceAmount) !== null && ref27 !== void 0 ? ref27 : 0,
                    priceCurrency: purchaseType === "LIFETIME" ? (ref28 = (ref14 = stripePrices === null || stripePrices === void 0 ? void 0 : stripePrices.products[purchaseType]) === null || ref14 === void 0 ? void 0 : ref14.price_currency) !== null && ref28 !== void 0 ? ref28 : "usd" : (ref29 = (ref15 = stripePrices === null || stripePrices === void 0 ? void 0 : stripePrices.subscriptions[purchaseType]) === null || ref15 === void 0 ? void 0 : ref15.priceCurrency) !== null && ref29 !== void 0 ? ref29 : "usd",
                    subscriptionOrProductType: purchaseType,
                    freeTrial: purchaseType === "LIFETIME" ? undefined : (ref16 = stripePrices === null || stripePrices === void 0 ? void 0 : stripePrices.subscriptions[purchaseType]) === null || ref16 === void 0 ? void 0 : ref16.freeTrial,
                    renewalPriceAmount: purchaseType === "LIFETIME" ? undefined : (ref17 = stripePrices === null || stripePrices === void 0 ? void 0 : stripePrices.subscriptions[purchaseType]) === null || ref17 === void 0 ? void 0 : ref17.priceAmount
                },
                isFromSetup: false,
                subscriptionId: subscriptionId,
                location: analyticsLocation !== null && analyticsLocation !== void 0 ? analyticsLocation : "checkout-modal-opener",
                stripe: stripe,
                elementsOptions: elementsOptions,
                type: purchaseType === "LIFETIME" ? "product" : "subscription"
            })
        ]
    });
    return {
        onOpenCheckoutModal: onModalOpen,
        checkoutModal: checkoutModal,
        subscriptionIntentRequestStatus: subscriptionIntentRequestStatus
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (usePaymentCheckoutModal);


/***/ }),

/***/ 23696:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UnderlineMarkerDrawing */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);





var UnderlineMarkerDrawing = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(props) {
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useColorMode)().colorMode;
    var _fill;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Icon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        viewBox: "0 0 53 13",
        width: "100%",
        height: "100%",
        preserveAspectRatio: "none"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            opacity: 0.6,
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3.788 2.298c-2.867.448-3.186.783-2.335 2.356.935 1.743-1.847 2.921 3.168 2.705-5.369.423-4.103 1.534-3.378 3.56.926 2.542 6.476 1.838 33.523-.204 8.104-.594 12.62-.197 14.92-.555 3.191-.518 2.359-2.49 1.01-3.315l.726-.279c1.911-.726.663-4.262-1.827-5.13-2.19-.758-14.677-.749-26.686.02-15.885 1.075-15.848.318-19.12.842Z",
            fill: (_fill = props.fill) !== null && _fill !== void 0 ? _fill : colorMode === "light" ? "#FFE34C" : "#474733"
        })
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (UnderlineMarkerDrawing);


/***/ }),

/***/ 5402:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export SKU_1YEAR_FREE_TRIAL */
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79139);


var SKU_1YEAR_FREE_TRIAL = "com.deepstash.pro_yearly_subscription";
/**
 * When a NSI user press a button which should start a subscription (eg: 'Start Trial')
 *
 * It will log in the user and then open the page /purchase/subscription
 */ var useAuthAndOpenPurchasePage = function(param) {
    var sku = param.sku;
    var isLoggedIn = (0,providers_hooks_useAuth__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)().isLoggedIn;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var navigateToPurchaseSubscriptionPage = function() {
        router.push("/purchase/subscription/?sku=".concat(sku !== null && sku !== void 0 ? sku : SKU_1YEAR_FREE_TRIAL));
    };
    var onClickStartSubscriptionForNsi = function() {
        if (isLoggedIn) {
            navigateToPurchaseSubscriptionPage();
        } else {
            // nsiDispatch({
            //   type: 'openAuth',
            //   payload: {
            //     type: 'sign-up',
            //     onAuthSuccess: async profile => {
            //       if (profile?.subscription_type !== UserSubscriptionType.Premium) {
            //         navigateToPurchaseSubscriptionPage();
            //       }
            //     },
            //     shouldSkipOnboarding: true,
            //   },
            // });
            router.push("/setup");
        }
    };
    return {
        onClickStartSubscriptionForNsi: onClickStartSubscriptionForNsi
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useAuthAndOpenPurchasePage);


/***/ }),

/***/ 12678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var api_Purchases__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4216);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_normalizers_purchases__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23542);



var useCurrentSubscription = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(), currentSubscription = ref[0], setCurrentSubscription = ref[1];
    var fetchCurrentSubscription = function() {
        api_Purchases__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentUserSubscription */ .m8().then(function(response) {
            var normalizedResponse = (0,utils_normalizers_purchases__WEBPACK_IMPORTED_MODULE_2__/* .normalizeCurrentSubscription */ .e3)(response);
            setCurrentSubscription(normalizedResponse.subscriptionDetails);
        }).catch(function(error) {
            console.log("[useCurrentSubscription]Error getCurrentUserSubscription", error);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        fetchCurrentSubscription();
    }, []);
    return {
        currentSubscription: currentSubscription,
        fetchCurrentSubscription: fetchCurrentSubscription
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useCurrentSubscription);


/***/ }),

/***/ 83410:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ useCookieAgreementToast; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./src/providers/hooks/useAuth.ts + 1 modules
var useAuth = __webpack_require__(79139);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/theme/index.ts
var theme = __webpack_require__(33850);
// EXTERNAL MODULE: ./src/theme/size.ts
var size = __webpack_require__(28953);
// EXTERNAL MODULE: ./src/utils/analytics/gtag.js
var gtag = __webpack_require__(24069);
;// CONCATENATED MODULE: ./src/components/toasts/CookieAgreementToast.tsx












var trackingState = {
    hasAgreed: !!js_cookie_default().get("cookieConsent")
};
var CookieAgreementToast = function(_param) {
    var setHasAgreed = _param.setHasAgreed, onClose = _param.onClose, props = (0,_object_without_properties/* default */.Z)(_param, [
        "setHasAgreed",
        "onClose"
    ]);
    var colorMode = (0,esm.useColorMode)().colorMode;
    var onAgree = function() {
        js_cookie_default().set("cookieConsent", "agreement", {
            expires: 365,
            sameSite: "lax",
            secure:  true && window.location.hostname !== "localhost"
        });
        setHasAgreed(true);
        if (window && window.fbq) {
            window.fbq("consent", "grant");
            window.fbq("track", "PageView");
        }
        if (window) {
            gtag/* grantConsent */.XP();
            gtag/* pageview */.LV(window.location.pathname);
        }
        trackingState.hasAgreed = true;
        onClose();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        color: esm.color[colorMode].text,
        align: "center",
        backgroundColor: esm.color[colorMode].top,
        borderRadius: 32,
        mb: {
            base: esm.spacing.toRem(80),
            md: esm.spacing.toRem(96)
        },
        shadow: "4px",
        p: "".concat(size/* CONTENT_PADDING_M */.dD, "px"),
        w: {
            base: "calc(100vw - 32px)",
            md: "max-content"
        },
        maxW: {
            base: "unset",
            md: "60vw"
        }
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme/* typography.ideaBody */.c.ideaBody), {
                textAlign: "left",
                px: "".concat(size/* CONTENT_PADDING_M */.dD, "px"),
                children: [
                    "To make Deepstash work, we log user data. By using us, you agree to our",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        style: {
                            color: esm.color[colorMode].primary.default,
                            textDecoration: "underline"
                        },
                        href: "/privacy-policy",
                        children: "Privacy Policy"
                    }),
                    ", including cookie policy."
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Button, {
                borderRadius: size/* BORDER_RADIUS_L */.nB,
                size: "lg",
                onClick: onAgree,
                _hover: {
                    backgroundColor: esm.color[colorMode].primary.default
                },
                _active: {
                    backgroundColor: esm.color[colorMode].primary.darker
                },
                _focus: undefined,
                h: "40px",
                w: {
                    base: esm.spacing.toRem(200),
                    lg: esm.spacing.toRem(160)
                },
                backgroundColor: esm.color.success,
                color: esm.color[colorMode].top,
                fontSize: "14px",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryText, {
                    size: "s",
                    display: "flex",
                    flexDir: "row",
                    alignContent: "center",
                    type: "bold",
                    children: "I Agree"
                })
            })
        ]
    }));
};
/* harmony default export */ var toasts_CookieAgreementToast = (CookieAgreementToast);

;// CONCATENATED MODULE: ./src/hooks/useCookieAgreementToast.tsx








function useCookieAgreementToast(flexProps) {
    var toast = (0,esm.useToast)();
    var authDispatch = (0,useAuth/* default */.Z)().authDispatch;
    (0,react.useEffect)(function() {
        setTimeout(function() {
            var consentCookie = js_cookie_default().get("cookieConsent");
            if (!consentCookie) {
                toast({
                    id: "consent",
                    // eslint-disable-next-line react/display-name
                    render: function(onClose) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(toasts_CookieAgreementToast, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, flexProps), {
                            setHasAgreed: function() {
                                authDispatch({
                                    type: "agree-cookies"
                                });
                            },
                            onClose: onClose
                        }));
                    }
                });
            }
        }, 15000);
    }, []);
    return;
}


/***/ }),

/***/ 51418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ LANDING_PAGE_DEFAULT_PX; },
  "Z": function() { return /* binding */ landing_LandingPageV2; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./src/hooks/useCookieAgreementToast.tsx + 1 modules
var useCookieAgreementToast = __webpack_require__(83410);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/faq/OverallFaq.tsx
var OverallFaq = __webpack_require__(82188);
// EXTERNAL MODULE: ./src/components/layout/components/Footer.tsx + 3 modules
var Footer = __webpack_require__(56096);
// EXTERNAL MODULE: ./src/components/layout/components/FullWidthSectionWrapper.tsx
var FullWidthSectionWrapper = __webpack_require__(41140);
// EXTERNAL MODULE: ./src/components/navbar/Navbar.tsx + 2 modules
var Navbar = __webpack_require__(43117);
// EXTERNAL MODULE: ./src/page-components/landing/components-v2/LandingCollectionsSections.tsx + 1 modules
var LandingCollectionsSections = __webpack_require__(14197);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/page-components/landing/components-v2/LandingHeroSection.module.scss
var LandingHeroSection_module = __webpack_require__(28592);
var LandingHeroSection_module_default = /*#__PURE__*/__webpack_require__.n(LandingHeroSection_module);
// EXTERNAL MODULE: ./src/page-components/landing/components-v2/HeroCarouselCard.tsx
var HeroCarouselCard = __webpack_require__(78179);
// EXTERNAL MODULE: ./src/page-components/landing/landing-hero-cards.ts
var landing_hero_cards = __webpack_require__(21838);
// EXTERNAL MODULE: ./src/page-components/landing/components-v2/LandingGoalQuestion.tsx + 2 modules
var LandingGoalQuestion = __webpack_require__(49979);
;// CONCATENATED MODULE: ./src/page-components/landing/components-v2/LandingHeroSection.tsx











var IMAGE_SIZE_XL = {
    WIDTH: 200,
    HEIGHT: 280,
    BORDER_RADIUS: 20
};
// const SECTION_HEIGHT_XL = IMAGE_SIZE_XL.HEIGHT * 2 + 16 + 300;
var SUBTITLE = "Unlimited access to 200,000+ powerful ideas from top books, podcasts, and more.";
var LandingHeroSection = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var renderHeroCarouselCard = function(param) {
        var card = param.card, index = param.index;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroCarouselCard/* default */.Z, {
            title: card.name,
            imageProps: {
                src: card.imageUrl,
                width: IMAGE_SIZE_XL.WIDTH,
                height: IMAGE_SIZE_XL.HEIGHT,
                layout: "fixed",
                style: {
                    borderRadius: IMAGE_SIZE_XL.BORDER_RADIUS
                },
                priority: true
            },
            containerWidth: IMAGE_SIZE_XL.WIDTH,
            containerBorderBottomRadius: IMAGE_SIZE_XL.BORDER_RADIUS
        }, "first-row-".concat(index));
    };
    var renderImages = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
            overflow: "hidden",
            flexDirection: "column",
            gridRowGap: 16,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                    className: "".concat((LandingHeroSection_module_default()).carousel),
                    gridColumnGap: 16,
                    flexWrap: "nowrap",
                    height: IMAGE_SIZE_XL.HEIGHT,
                    children: landing_hero_cards/* LANDING_HERO_CARDS.slice */.n.slice(0, 13).map(function(card, index) {
                        return renderHeroCarouselCard({
                            card: card,
                            index: index
                        });
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                    className: "".concat((LandingHeroSection_module_default()).carousel, " ").concat((LandingHeroSection_module_default()).carousel2),
                    gridColumnGap: 16,
                    flexWrap: "nowrap",
                    height: IMAGE_SIZE_XL.HEIGHT,
                    children: landing_hero_cards/* LANDING_HERO_CARDS.slice */.n.slice(5, 20).map(function(card, index) {
                        return renderHeroCarouselCard({
                            card: card,
                            index: index
                        });
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDirection: "column",
        mb: 32,
        children: [
            renderImages(),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                zIndex: 1,
                w: "100%",
                position: "absolute",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                    background: "linear-gradient(to right, rgba(241,239,235,1) 60%, rgba(241,239,235,0))",
                    // bgColor="red"
                    w: {
                        lg: "90%",
                        xl: "70%"
                    },
                    flexDirection: "column",
                    // height={SECTION_HEIGHT_XL}
                    justifyContent: "center",
                    paddingX: LANDING_PAGE_DEFAULT_PX,
                    gridRowGap: 16,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Heading, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            size: "h1",
                            color: esm.color.light.text
                        }, esm.typography.primaryHeadingFonts.xl.bold), {
                            lineHeight: "1em",
                            fontSize: {
                                lg: "3rem",
                                xl: "4rem"
                            },
                            fontWeight: "800",
                            children: [
                                "BECOME",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "THE SMARTEST",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                "IN THE ROOM"
                            ]
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            maxW: 500
                        }, esm.typography.primaryHeadingFonts.small.regular), {
                            color: esm.color.light.textSecondary,
                            children: SUBTITLE
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                            width: 128,
                            height: 4,
                            bgColor: esm.color.light.underground,
                            borderRadius: 4
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingGoalQuestion/* default */.Z, {})
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_v2_LandingHeroSection = (LandingHeroSection);

// EXTERNAL MODULE: ./src/components/image/NextImage.tsx + 11 modules
var NextImage = __webpack_require__(91260);
// EXTERNAL MODULE: ./src/page-components/landing/components-v2/LandingStartTrialButton.tsx
var LandingStartTrialButton = __webpack_require__(83934);
;// CONCATENATED MODULE: ./src/page-components/landing/components-v2/LandingMobileAppSection.tsx









var TITLE_PHONE = "Got 5 minutes? Plenty for:";
// TODO No Trial Changes
// const CTA_TEXT = 'Start my free week';
var CTA_TEXT = "Start today";
var LandingMobileAppSection = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var isMobileView = (0,esm.useIsMobileView)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        width: "100%",
        flexDirection: {
            md: "column-reverse",
            lg: "row"
        },
        gridColumnGap: 64,
        paddingX: LANDING_PAGE_DEFAULT_PX,
        mt: 88,
        alignItems: {
            md: "center",
            lg: "initial"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                flex: 1,
                width: "100%",
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isMobileView ? (0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.medium.semiBold) : (0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.large.semiBold)), {
                            color: esm.color.light.text,
                            children: TITLE_PHONE
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, isMobileView ? (0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.medium.regular) : (0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.medium.semiBold)), {
                            color: esm.color.light.textSecondary,
                            mt: 16,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                style: {
                                    marginLeft: 32
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "a Book"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "a Podcast"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: "an Article"
                                    })
                                ]
                            })
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                            mt: 32,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingStartTrialButton/* default */.Z, {
                                text: CTA_TEXT,
                                landingLocation: "mobile-app-section"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                flex: 1.3,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
                    wrapperStyle: {
                        width: 500,
                        height: 408,
                        pointerEvents: "none"
                    },
                    objectFit: "contain",
                    imageUrl: "https://static.deepstash.com/phone-landing-image.png"
                })
            })
        ]
    });
};
/* harmony default export */ var components_v2_LandingMobileAppSection = (LandingMobileAppSection);

// EXTERNAL MODULE: ./src/page-components/landing/components-v2/LandingProSection.tsx + 1 modules
var LandingProSection = __webpack_require__(8190);
// EXTERNAL MODULE: ./src/page-components/landing/components-v2/LandingReviewsSection.tsx
var LandingReviewsSection = __webpack_require__(11892);
// EXTERNAL MODULE: ./src/page-components/landing/components-v2/LandingStartJourneySection.tsx
var LandingStartJourneySection = __webpack_require__(62468);
// EXTERNAL MODULE: ./src/page-components/landing/components-v2/LandingStartTrialSection.tsx
var LandingStartTrialSection = __webpack_require__(90182);
// EXTERNAL MODULE: ./src/page-components/landing/components-v2/LandingTopicsSection.tsx
var LandingTopicsSection = __webpack_require__(53121);
// EXTERNAL MODULE: ./src/page-components/landing/components-v2/LandingValuePropsSection.tsx + 1 modules
var LandingValuePropsSection = __webpack_require__(13519);
// EXTERNAL MODULE: ./src/page-components/special-offer/SpecialOfferBannerWrapper.tsx + 1 modules
var SpecialOfferBannerWrapper = __webpack_require__(16923);
;// CONCATENATED MODULE: ./src/page-components/landing/LandingPageV2.tsx



















var LANDING_PAGE_DEFAULT_PX = {
    base: 16,
    md: 100,
    lg: 160
};
var LandingPageV2 = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,esm.useColorMode)(), colorMode = ref.colorMode, setColorMode = ref.setColorMode;
    react.useEffect(function() {
        if (colorMode === "dark") {
            setColorMode("light");
        }
    }, [
        colorMode
    ]);
    (0,useCookieAgreementToast/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                width: "100%",
                flexDirection: "column",
                pb: 32,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                        paddingX: LANDING_PAGE_DEFAULT_PX,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_v2_LandingHeroSection, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FullWidthSectionWrapper/* default */.Z, {
                        mt: 100,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingStartTrialSection/* default */.Z, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingValuePropsSection/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthSectionWrapper/* default */.Z, {
                        containerProps: {
                            flexDirection: "column"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingStartJourneySection/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingCollectionsSections/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingTopicsSection/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_v2_LandingMobileAppSection, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingProSection/* default */.Z, {
                                showProComparison: true
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingReviewsSection/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(OverallFaq/* default */.Z, {
                                mt: 80,
                                mb: 40
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SpecialOfferBannerWrapper/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {
                backgroundColor: esm.color[colorMode].surface,
                disableStickyStartTrial: true
            })
        ]
    });
};
/* harmony default export */ var landing_LandingPageV2 = (LandingPageV2);


/***/ }),

/***/ 88250:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(63069);
/* harmony import */ var utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(51599);








var StoreRatingCard = function(_param) {
    var store = _param.store, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "store"
    ]);
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.useColorMode)().colorMode;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        height: "100%",
        width: "100%",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        cursor: "pointer",
        py: utils_global__WEBPACK_IMPORTED_MODULE_3__/* .SQUARE_WIDTH_REM */ .wY,
        onClick: function() {
            var ref;
            (ref = window === null || window === void 0 ? void 0 : window.open(store === "android" ? "https://play.google.com/store/apps/details?id=com.deepstash" : " https://apps.apple.com/us/app/deepstash-smarter-every-day/id1445023295", "_blank")) === null || ref === void 0 ? void 0 : ref.focus();
        },
        gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.M.rem
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                alignItems: "center",
                children: [
                    Array(store === "ios" ? 5 : 4).fill(1).map(function(_, index) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.FullStarSvg, {
                            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].secondary.default,
                            boxSize: "1.5rem"
                        }, index);
                    }),
                    store === "android" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.HalfStarSvg, {
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].secondary.default,
                        boxSize: "1.5rem"
                    }),
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                        ml: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem,
                        alignItems: "baseline",
                        gridGap: "4px",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryHeadingFonts.medium.regular), {
                            children: utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__/* ["default"].paywall.ratings */ .Z.paywall.ratings[store].rating
                        }))
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryHeadingFonts.small.semiBold), {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].text,
                children: utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__/* ["default"].paywall.ratings */ .Z.paywall.ratings[store].reviewCount
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Flex, {
                alignItems: "center",
                gridGap: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.XS.rem,
                height: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.spacing.toRem(32),
                children: [
                    store === "ios" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.AppStoreColoredSvg, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.GooglePlayColoredSvg, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.typography.primaryTextFonts.large.regular), {
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.color[colorMode].textSecondary,
                        children: utils_strings_commonStrings__WEBPACK_IMPORTED_MODULE_4__/* ["default"].paywall.ratings */ .Z.paywall.ratings[store].title
                    }))
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (StoreRatingCard);


/***/ }),

/***/ 78179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(40643);






var HeroCarouselCard = function(param) {
    var imageProps = param.imageProps, title = param.title, containerWidth = param.containerWidth, containerBorderBottomRadius = param.containerBorderBottomRadius;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_3__.Flex, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, imageProps), {
                objectFit: "cover"
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_3__.Flex, {
                position: "absolute",
                bottom: 0,
                background: "linear-gradient(0deg, rgba(0,0,0,0.7), rgba(0,0,0,0))",
                zIndex: 1,
                w: containerWidth,
                borderBottomRadius: containerBorderBottomRadius,
                pb: 16,
                px: 16,
                pt: 32,
                justifyContent: "center",
                children: title !== undefined ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_3__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_3__.typography.primaryTextFonts.medium.regular), {
                    color: "white",
                    textAlign: "center",
                    children: title
                })) : null
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HeroCarouselCard);


/***/ }),

/***/ 14197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_v2_LandingCollectionsSections; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./src/components/collection/NewCollectionCarousel.tsx
var NewCollectionCarousel = __webpack_require__(11194);
;// CONCATENATED MODULE: ./src/page-components/landing/components-v2/collections_landing_data.ts
var COLLECTIONS_LANDING_DATA = [
    {
        description: "Mastering the greatest pursuit there ever was: Happiness",
        emoji: "\uD83D\uDE03",
        hashtags: [
            "personaldevelopment",
            "health",
            "habits",
            "communication"
        ],
        id: 63,
        image: "https://audio.deepstash.com/covers/collection/202304/how_to_be_happy.png",
        image_blurhash: "LeKyDJxu0yM{t7ayf5ay0yWB-Vt7",
        image_color: "F89067",
        image_compressed: "https://d3t70bohx4vuj7.cloudfront.net/NvuoXCyyOyY5tEx9bwRGUUNT9DVx9pVCwbmCJ37UVG8/resize:fill:600:0/gravity:sm/quality:90/aHR0cHM6Ly9hdWRpby5kZWVwc3Rhc2guY29tL2NvdmVycy9jb2xsZWN0aW9uLzIwMjMwNC9ob3dfdG9fYmVfaGFwcHkucG5n",
        image_preview: "https://preview.deepstash.com/c/63-1647960009.png",
        name: "How to Be Happy",
        skills: [
            "How to find purpose and meaning in life",
            "How to cultivate gratitude",
            "Techniques for managing negative thoughts",
            "Understanding the science of happiness", 
        ],
        time_to_read: 917,
        total_article_sources: 4,
        total_blocks: 100,
        total_book_sources: 3,
        total_podcast_sources: 0,
        total_selfpost_sources: 0,
        total_video_sources: 0
    },
    {
        description: "The best books on building habits",
        emoji: "\uD83D\uDC40",
        hashtags: [
            "productivity",
            "personaldevelopment",
            "problemsolving",
            "books", 
        ],
        id: 101,
        image: "https://audio.deepstash.com/covers/collection/202304/habit_book.png",
        image_blurhash: "LhNl}SRj-6t6}9ofRPfQRjj[ENWB",
        image_color: "BE3241",
        image_compressed: "https://d3t70bohx4vuj7.cloudfront.net/-wtewmT1YUzMDBEHZBJYM0tCthu5m85YgnyMvOJLE3c/resize:fill:600:0/gravity:sm/quality:90/aHR0cHM6Ly9hdWRpby5kZWVwc3Rhc2guY29tL2NvdmVycy9jb2xsZWN0aW9uLzIwMjMwNC9oYWJpdF9ib29rLnBuZw",
        image_preview: "https://preview.deepstash.com/c/101-1660722307.png",
        name: "7 Books on Habits",
        skills: [
            "How to break bad habits",
            "How habits are formed",
            "The importance of consistency",
            "How habits impact productivity and success", 
        ],
        time_to_read: 662,
        total_article_sources: 0,
        total_blocks: 88,
        total_book_sources: 7,
        total_podcast_sources: 0,
        total_selfpost_sources: 0,
        total_video_sources: 0
    },
    {
        description: "What is the best way to live longer? Here are a few factors within your control",
        emoji: "\uD83D\uDEB4‍♂️",
        hashtags: [
            "food",
            "personaldevelopment",
            "health",
            "scienceandnature"
        ],
        id: 93,
        image: "https://audio.deepstash.com/covers/collection/202304/longevity.png",
        image_blurhash: "LwMGw;NGxWog~BjYIot6IVofR*WB",
        image_color: "D6BE97",
        image_compressed: "https://d3t70bohx4vuj7.cloudfront.net/r-MSJktLtnE1imtHcpQ7lKHS1-M8KI7CUHFgT3YjWIc/resize:fill:600:0/gravity:sm/quality:90/aHR0cHM6Ly9hdWRpby5kZWVwc3Rhc2guY29tL2NvdmVycy9jb2xsZWN0aW9uLzIwMjMwNC9sb25nZXZpdHkucG5n",
        image_preview: "https://preview.deepstash.com/c/93-1657277873.png",
        name: "How To Live A Long Life",
        skills: [
            "The importance of physical activity",
            "The role of genetics in lifespan",
            "How to maintain a healthy diet",
            "The impact of stress on longevity", 
        ],
        time_to_read: 855,
        total_article_sources: 4,
        total_blocks: 71,
        total_book_sources: 1,
        total_podcast_sources: 3,
        total_selfpost_sources: 0,
        total_video_sources: 1
    },
    {
        description: "How to prioritize what matters, and how good decisions are made.",
        emoji: "\uD83D\uDC68‍⚖️",
        hashtags: [
            "personaldevelopment",
            "problemsolving",
            "communication",
            "timemanagement", 
        ],
        id: 54,
        image: "https://audio.deepstash.com/covers/collection/202304/making_better_decisions.png",
        image_blurhash: "LaIG.7ofGHWV?[WBWVoLXTofwIWV",
        image_color: "D5A244",
        image_compressed: "https://d3t70bohx4vuj7.cloudfront.net/vGDGOgtF3TFHb04o6kCPsoeKu2Yt0sZgObSaPR8YiKE/resize:fill:600:0/gravity:sm/quality:90/aHR0cHM6Ly9hdWRpby5kZWVwc3Rhc2guY29tL2NvdmVycy9jb2xsZWN0aW9uLzIwMjMwNC9tYWtpbmdfYmV0dGVyX2RlY2lzaW9ucy5wbmc",
        image_preview: "https://preview.deepstash.com/c/54-1647959995.png",
        name: "Making Better Decisions",
        skills: [
            "How to make good decisions",
            "How to manage work stress",
            "How to manage email effectively",
            "How to learn anything fast", 
        ],
        time_to_read: 892,
        total_article_sources: 5,
        total_blocks: 85,
        total_book_sources: 3,
        total_podcast_sources: 0,
        total_selfpost_sources: 0,
        total_video_sources: 1
    },
    {
        description: "This collection will help you make easy routine changes and take back control of your time.",
        emoji: "⏰",
        hashtags: [
            "productivity",
            "personaldevelopment",
            "timemanagement",
            "teamwork",
            "books", 
        ],
        id: 10,
        image: "https://audio.deepstash.com/covers/collection/202304/managing_time_like_a_pro.png",
        image_blurhash: "LfQuf.E.R3IV}6#UnQxsMcRPtSt6",
        image_color: "FECB68",
        image_compressed: "https://d3t70bohx4vuj7.cloudfront.net/vkM81Dfc-dEq8SmVpZzNRbtLPbZdBXQ9ieqQPgTnl74/resize:fill:600:0/gravity:sm/quality:90/aHR0cHM6Ly9hdWRpby5kZWVwc3Rhc2guY29tL2NvdmVycy9jb2xsZWN0aW9uLzIwMjMwNC9tYW5hZ2luZ190aW1lX2xpa2VfYV9wcm8ucG5n",
        image_preview: "https://preview.deepstash.com/c/10-1682337269.png",
        name: "Managing Time Like a Pro",
        skills: [
            "How to set achievable goals",
            "How to manage time for personal and professional life",
            "How to avoid distractions",
            "The importance of taking breaks", 
        ],
        time_to_read: 865,
        total_article_sources: 5,
        total_blocks: 69,
        total_book_sources: 3,
        total_podcast_sources: 0,
        total_selfpost_sources: 0,
        total_video_sources: 0
    }, 
];

;// CONCATENATED MODULE: ./src/page-components/landing/components-v2/LandingCollectionsSections.tsx








var TITLE = "Top Collections";
var SUBTITLE = "Discover the most popular ideas and learn something new in less than 5 minutes a day";
var LandingCollectionsSections = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var isMobileView = (0,esm.useIsMobileView)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        flexDirection: "column",
        width: "100%",
        alignItems: "center",
        mt: isMobileView ? 68 : 120,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.large.semiBold), {
                color: esm.color.light.text,
                textAlign: "center",
                children: TITLE
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                color: esm.color.light.textSecondary,
                textAlign: "center",
                mt: 8,
                children: SUBTITLE
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NewCollectionCarousel/* default */.Z, {
                collections: COLLECTIONS_LANDING_DATA,
                mt: 32
            })
        ]
    });
};
/* harmony default export */ var components_v2_LandingCollectionsSections = (LandingCollectionsSections);


/***/ }),

/***/ 49979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_v2_LandingGoalQuestion; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_extends.mjs
var _extends = __webpack_require__(40872);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./src/hooks/useRouter.ts
var useRouter = __webpack_require__(98377);
// EXTERNAL MODULE: ./src/theme/color-icons/index.ts + 5 modules
var color_icons = __webpack_require__(62387);
;// CONCATENATED MODULE: ./src/theme/color-icons/WorkIcon.tsx





var WorkIcon = /*#__PURE__*/ react.memo(function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Icon, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "48px",
        height: "48px",
        viewBox: "0 0 48 48",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M23.8079 19.6917C23.8991 19.6917 27.2353 19.7489 27.2478 19.8383C28.0537 19.8455 29.11 21.6594 29.2298 22.3382C29.2423 22.4366 30.0223 27.5392 30.1207 27.5267C30.177 27.7315 30.0375 27.9927 30.1359 28.092C30.3854 27.8979 30.5339 27.583 30.4874 27.2503L29.7665 21.4697C29.5912 20.0825 28.407 19.0378 27.0108 19.0378H23.1067V19.5289L23.8079 19.6917Z",
                fill: "#FECA9A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.1179 20.9106C26.4828 20.9106 27.5982 21.1799 27.6482 21.5376C27.8495 21.5394 28.6375 26.1787 28.667 26.3487C28.7171 26.7422 29.2403 28.2797 29.6338 28.2296C29.7752 28.2672 29.8548 28.286 29.9666 28.2368C30.2098 28.0471 30.3547 27.7404 30.3091 27.4157L29.6052 21.7782C29.4335 20.425 28.2788 19.4062 26.9175 19.4062H23.0993L23.093 20.8373L26.1179 20.9106Z",
                fill: "#FCA640"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.1904 19.6917C24.0992 19.6917 20.763 19.7489 20.7505 19.8383C19.9446 19.8455 18.8883 21.6594 18.7685 22.3382C18.7559 22.4366 17.976 27.5392 17.8776 27.5267C17.8213 27.7315 17.9608 27.9927 17.8624 28.092C17.6129 27.8979 17.4644 27.583 17.5109 27.2503L18.2318 21.4697C18.4071 20.0825 19.5913 19.0378 20.9875 19.0378H24.8916V19.5289L24.1904 19.6917Z",
                fill: "#FECA9A"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M21.8805 20.9106C21.5155 20.9106 20.4002 21.1799 20.3501 21.5376C20.1489 21.5394 19.3609 26.1787 19.3314 26.3487C19.2813 26.7422 18.7581 28.2797 18.3645 28.2296C18.2232 28.2672 18.1436 28.286 18.0318 28.2368C17.7885 28.0471 17.6437 27.7404 17.6893 27.4157L18.3932 21.7782C18.5649 20.425 19.7196 19.4062 21.0809 19.4062H24.8991L24.9054 20.8373L21.8805 20.9106Z",
                fill: "#FCA640"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M28.8094 21.9223C28.6458 20.6307 27.5224 20.2014 26.2318 20.2041C26.1817 20.2041 26.0001 20.205 25.95 20.205H24.5494H23.3446L23.1067 20.459V20.6164L23.8428 21.3168H24.5181H25.5055H26.5886C26.7022 21.3168 27.1074 21.3534 27.1924 21.4169C27.4374 21.4983 27.6333 21.6924 27.7227 21.9428C27.754 21.9903 27.797 22.2264 27.8059 22.2854L28.119 24.7889L28.1431 24.9838L28.4275 27.2619C28.4445 27.3987 28.5832 27.9336 28.6985 27.9873C28.7808 28.176 28.8577 28.2118 28.9848 28.1894C29.0974 28.1697 29.2298 28.1098 29.4015 28.0526C29.5259 27.9703 29.5795 27.6885 29.5357 27.3138C29.5017 26.9873 29.2853 25.2996 29.2146 24.8094C29.093 23.9633 28.8094 21.9223 28.8094 21.9223Z",
                fill: "#F58319"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M19.2972 21.9223C19.4609 20.6307 20.5843 20.2014 21.8749 20.2041C21.925 20.2041 22.1066 20.205 22.1567 20.205H23.5573H24.7621L25 20.459V20.6164L24.2639 21.3168H23.5886H22.6012H21.5181C21.4045 21.3168 20.9993 21.3534 20.9143 21.4169C20.6693 21.4983 20.4734 21.6924 20.3839 21.9428C20.3526 21.9903 20.3097 22.2264 20.3008 22.2854L19.9877 24.7889L19.9636 24.9838L19.6792 27.2619C19.6622 27.3987 19.5235 27.9336 19.4081 27.9873C19.3259 28.176 19.2489 28.2118 19.1219 28.1894C19.0092 28.1697 18.8769 28.1098 18.7051 28.0526C18.5808 27.9703 18.5272 27.6885 18.571 27.3138C18.605 26.9873 18.8214 25.2996 18.8921 24.8094C19.0137 23.9633 19.2972 21.9223 19.2972 21.9223Z",
                fill: "url(#paint0_radial_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.0001 42.7825C29.4338 42.7825 33.8386 38.3776 33.8386 32.944C33.8386 27.5103 29.4338 23.1055 24.0001 23.1055C18.5665 23.1055 14.1616 27.5103 14.1616 32.944C14.1616 38.3776 18.5665 42.7825 24.0001 42.7825Z",
                fill: "url(#paint1_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.0003 41.0717C28.489 41.0717 32.1278 37.4328 32.1278 32.9442C32.1278 28.4555 28.489 24.8167 24.0003 24.8167C19.5116 24.8167 15.8728 28.4555 15.8728 32.9442C15.8728 37.4328 19.5116 41.0717 24.0003 41.0717Z",
                fill: "url(#paint2_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.0001 40.2157C28.016 40.2157 31.2716 36.9601 31.2716 32.9442C31.2716 28.9282 28.016 25.6726 24.0001 25.6726C19.9841 25.6726 16.7285 28.9282 16.7285 32.9442C16.7285 36.9601 19.9841 40.2157 24.0001 40.2157Z",
                fill: "url(#paint3_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M13.8125 5.21729L22.2557 17.0324C22.5777 17.4886 22.7566 18.0342 22.7566 18.5887V20.4223H25.4747V18.5887C25.4747 18.0342 25.2958 17.4886 24.9738 17.0324L16.5306 5.21729H13.8125Z",
                fill: "url(#paint4_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M11.4783 5.21729L19.9215 17.0324C20.2435 17.4886 20.4224 18.0342 20.4224 18.5887V20.4223H22.8373V18.5887C22.8373 18.0342 22.6584 17.4886 22.3364 17.0324L13.8932 5.21729H11.4783Z",
                fill: "url(#paint5_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M16.3889 5.21729L24.8321 17.0324C25.1541 17.4886 25.333 18.0342 25.333 18.5887V20.4223H27.578V18.5619C27.578 17.9984 27.3991 17.4528 27.0771 16.9967L18.6339 5.21729H16.3889Z",
                fill: "url(#paint6_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M34.1874 5.21729L25.7441 17.0324C25.4221 17.4886 25.2433 18.0342 25.2433 18.5887V20.4223H22.5251V18.5887C22.5251 18.0342 22.704 17.4886 23.026 17.0324L31.4692 5.21729H34.1874Z",
                fill: "url(#paint7_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36.5216 5.21729L33.9636 8.79492L30.7705 13.267L29.4915 15.0558L28.0784 17.0324C27.7564 17.4886 27.5775 18.0342 27.5775 18.5887V20.4223H25.1626V18.5887C25.1626 18.0342 25.3415 17.4886 25.6635 17.0324L27.0766 15.0558L28.3556 13.267L31.5487 8.79492L34.1067 5.21729H36.5216Z",
                fill: "url(#paint8_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M36.5216 5.21729L33.9636 8.79492L30.7705 13.267L29.4915 15.0558L28.0784 17.0324C27.7564 17.4886 27.5775 18.0342 27.5775 18.5887V20.4223H25.1626V18.5887C25.1626 18.0342 25.3415 17.4886 25.6635 17.0324L27.0766 15.0558L28.3556 13.267L31.5487 8.79492L34.1067 5.21729H36.5216Z",
                fill: "url(#paint9_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M31.6114 5.21729L29.0534 8.79492L25.8604 13.267L24.5814 15.0558L23.1682 17.0324C22.8462 17.4886 22.6673 18.0342 22.6673 18.5887V20.4223H20.4224V18.5619C20.4224 17.9984 20.6012 17.4528 20.9232 16.9967L22.3185 15.0558L23.5975 13.267L26.7995 8.79492L28.0875 7.0061L29.3665 5.21729H31.6114Z",
                fill: "url(#paint10_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M22.8373 18.6335V22.2112H21.3168C20.8248 22.2112 20.4224 21.8087 20.4224 21.3168V19.528C20.4224 19.036 20.8248 18.6335 21.3168 18.6335H22.8373Z",
                fill: "url(#paint11_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M25.2434 18.6335H22.6675V22.2112H25.2434V18.6335Z",
                fill: "url(#paint12_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.5775 19.528V21.3168C27.5775 21.8087 27.175 22.2112 26.6831 22.2112H25.1626V18.6335H26.6831C27.175 18.6335 27.5775 19.036 27.5775 19.528Z",
                fill: "url(#paint13_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M27.5775 19.528V21.3168C27.5775 21.8087 27.175 22.2112 26.6831 22.2112H25.1626V18.6335H26.6831C27.175 18.6335 27.5775 19.036 27.5775 19.528Z",
                fill: "url(#paint14_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                opacity: "0.6",
                d: "M35.2428 7.00635L33.9638 8.79517L30.7708 13.2672L29.4918 15.056H22.3186L23.5976 13.2672L26.7996 8.79517L28.0875 7.00635H35.2428Z",
                fill: "url(#paint15_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M26.4041 27.083H22.9346L20.187 29.0623V32.7876L22.9346 31.0408V38.7479H26.4041V27.083Z",
                fill: "url(#paint16_linear_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.0001 42.7825C29.4338 42.7825 33.8386 38.3776 33.8386 32.944C33.8386 27.5103 29.4338 23.1055 24.0001 23.1055C18.5665 23.1055 14.1616 27.5103 14.1616 32.944C14.1616 38.3776 18.5665 42.7825 24.0001 42.7825Z",
                fill: "url(#paint17_radial_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.0003 41.0717C28.489 41.0717 32.1278 37.4328 32.1278 32.9442C32.1278 28.4555 28.489 24.8167 24.0003 24.8167C19.5116 24.8167 15.8728 28.4555 15.8728 32.9442C15.8728 37.4328 19.5116 41.0717 24.0003 41.0717Z",
                fill: "url(#paint18_radial_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                d: "M24.0003 41.0717C28.489 41.0717 32.1278 37.4328 32.1278 32.9442C32.1278 28.4555 28.489 24.8167 24.0003 24.8167C19.5116 24.8167 15.8728 28.4555 15.8728 32.9442C15.8728 37.4328 19.5116 41.0717 24.0003 41.0717Z",
                fill: "url(#paint19_radial_210_88259)"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint0_radial_210_88259",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(21.8374 25.1513) rotate(180) scale(3.47568 3.61714)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#F58319"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.856",
                                stopColor: "#F5A919"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.997",
                                stopColor: "#F5A919"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint1_linear_210_88259",
                        x1: "14.6822",
                        y1: "22.1368",
                        x2: "30.9721",
                        y2: "41.0303",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFB46E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.352",
                                stopColor: "#FFA826"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.453",
                                stopColor: "#FDA623"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.579",
                                stopColor: "#F6911B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.663",
                                stopColor: "#F09813"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F08D13"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint2_linear_210_88259",
                        x1: "31.1869",
                        y1: "40.1307",
                        x2: "15.3728",
                        y2: "24.3167",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFBC6E"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.352",
                                stopColor: "#FFA826"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.453",
                                stopColor: "#FD8C23"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.579",
                                stopColor: "#F6911B"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.663",
                                stopColor: "#F07D13"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F08D13"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint3_linear_210_88259",
                        x1: "17.7884",
                        y1: "25.5823",
                        x2: "30.1196",
                        y2: "40.1969",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFDECB"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.359375",
                                stopColor: "#FFCD92"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F99132"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint4_linear_210_88259",
                        x1: "15.079",
                        y1: "6.18056",
                        x2: "22.4149",
                        y2: "16.6559",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#F9EAE7"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.616",
                                stopColor: "#F0D7D5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.69",
                                stopColor: "#E0C5C3"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.896",
                                stopColor: "#B89896"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#A88685"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint5_linear_210_88259",
                        x1: "12.2179",
                        y1: "6.00258",
                        x2: "20.6299",
                        y2: "17.6111",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.614",
                                stopColor: "#FEA032"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.751",
                                stopColor: "#E2772A"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.907",
                                stopColor: "#C85E22"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#BF591F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint6_linear_210_88259",
                        x1: "16.8746",
                        y1: "5.83174",
                        x2: "23.4351",
                        y2: "14.8063",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#BB5F1D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.638",
                                stopColor: "#AE6A03"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.746",
                                stopColor: "#985C02"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.906",
                                stopColor: "#7D3D01"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#733801"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint7_linear_210_88259",
                        x1: "28.3558",
                        y1: "6.43011",
                        x2: "28.3558",
                        y2: "21.5447",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFF8F5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.278",
                                stopColor: "#FFF2EF"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.427",
                                stopColor: "#FFF8F5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.508",
                                stopColor: "#FBEEEC"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.63",
                                stopColor: "#F0D7D5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B59997"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint8_linear_210_88259",
                        x1: "30.8421",
                        y1: "4.81748",
                        x2: "30.8421",
                        y2: "19.8158",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF6C47"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.2",
                                stopColor: "#FF6744"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.445",
                                stopColor: "#FE583C"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.657",
                                stopColor: "#FE4532"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#D43829"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint9_linear_210_88259",
                        x1: "25.9023",
                        y1: "6.00258",
                        x2: "34.3142",
                        y2: "17.6111",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.614",
                                stopColor: "#FEA032"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.751",
                                stopColor: "#E2772A"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.907",
                                stopColor: "#C85E22"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#BF591F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint10_linear_210_88259",
                        x1: "20.908",
                        y1: "5.83174",
                        x2: "27.4685",
                        y2: "14.8063",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#BB5F1D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.638",
                                stopColor: "#AE6A03"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.746",
                                stopColor: "#985C02"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.906",
                                stopColor: "#7D3D01"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#733801"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint11_linear_210_88259",
                        x1: "21.5",
                        y1: "18.5",
                        x2: "21.7864",
                        y2: "21.9764",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#BB5F1D"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.25",
                                stopColor: "#AE6A03"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.536458",
                                stopColor: "#985C02"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.734375",
                                stopColor: "#7D3D01"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#733801"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint12_linear_210_88259",
                        x1: "23.9554",
                        y1: "18.9189",
                        x2: "23.9554",
                        y2: "22.475",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFF8F5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.274",
                                stopColor: "#FBEEEC"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.689",
                                stopColor: "#F0D7D5"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#B59997"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint13_linear_210_88259",
                        x1: "26.3701",
                        y1: "18.5396",
                        x2: "26.3701",
                        y2: "22.0681",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FF6C47"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.2",
                                stopColor: "#FF6744"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.445",
                                stopColor: "#FE583C"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.657",
                                stopColor: "#FE4532"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#D43829"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint14_linear_210_88259",
                        x1: "26.5",
                        y1: "18.5",
                        x2: "26.8348",
                        y2: "21.9677",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FEA032"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.583333",
                                stopColor: "#E2772A"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.776042",
                                stopColor: "#C85E22"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#BF591F"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint15_linear_210_88259",
                        x1: "28.7807",
                        y1: "7.72545",
                        x2: "28.7807",
                        y2: "14.5364",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFF8F5",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.54",
                                stopColor: "#FFF8F5",
                                stopOpacity: "0.6"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#FFF8F5",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("linearGradient", {
                        id: "paint16_linear_210_88259",
                        x1: "9.46751",
                        y1: "13.2384",
                        x2: "35.0485",
                        y2: "46.3504",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFD494"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.352",
                                stopColor: "#FFA826"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.581",
                                stopColor: "#F38A2A"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "1",
                                stopColor: "#F07D13"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint17_radial_210_88259",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(25.0833 34.1541) scale(13.6487)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFDFC2",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.725",
                                stopColor: "#FFDFC2",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.83",
                                stopColor: "#FFDCC2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.962",
                                stopColor: "#FFDFC2",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint18_radial_210_88259",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(24.3616 31.2984) scale(12.2382)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFE477",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.725",
                                stopColor: "#FFE477",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.83",
                                stopColor: "#FFEEAB"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.962",
                                stopColor: "#FFE477",
                                stopOpacity: "0"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("radialGradient", {
                        id: "paint19_radial_210_88259",
                        cx: "0",
                        cy: "0",
                        r: "1",
                        gradientUnits: "userSpaceOnUse",
                        gradientTransform: "translate(24.3616 31.2984) scale(12.2382)",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                stopColor: "#FFE3C2",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.725",
                                stopColor: "#FFD8C2",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.83",
                                stopColor: "#FFE3C2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("stop", {
                                offset: "0.962",
                                stopColor: "#FFDFC2",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
});
/* harmony default export */ var color_icons_WorkIcon = (WorkIcon);

// EXTERNAL MODULE: ./src/types/enums.ts
var enums = __webpack_require__(41390);
;// CONCATENATED MODULE: ./src/page-components/setup/setup-likes.constants.ts




var EXTRA_SOURCE_DATA = {
    ideas: [],
    suggestedTopics: [],
    sourceSubtype: 0,
    status: enums/* ArticleStatus.PUBLISHED */.af.PUBLISHED,
    totalComments: 0,
    totalReactions: 0,
    topReactions: [],
    userData: {
        firstName: "",
        lastName: "",
        id: -1
    }
};
var SETUP_LIKE_ENTITIES = [
    (0,_object_spread/* default */.Z)({
        title: "Atomic Habits",
        sourceType: enums/* SourceType.BOOK */.PO.BOOK,
        id: 118080,
        deepstashArticles: [
            118080
        ],
        description: "Written by James Clear",
        image: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1655988385l/40121378.jpg",
        imageColor: "#EFE9DF"
    }, EXTRA_SOURCE_DATA),
    (0,_object_spread/* default */.Z)({
        title: "The Compound Effect",
        sourceType: enums/* SourceType.BOOK */.PO.BOOK,
        id: 127082,
        deepstashArticles: [
            127082
        ],
        description: "Written by Darren Hardy",
        image: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1337205071i/9420697.jpg",
        imageColor: "#A41527"
    }, EXTRA_SOURCE_DATA),
    (0,_object_spread/* default */.Z)({
        title: "Ultralearning",
        sourceType: enums/* SourceType.BOOK */.PO.BOOK,
        id: 43722,
        deepstashArticles: [
            43722
        ],
        description: "Written by Scott H. Young",
        image: "https://book2action-5d2aff0.divio-media.net/filer_public/8e/e8/8ee8d5a0-004c-4c95-bdcd-abba9e6c877e/ultralearning__master_hard_skills_outsmart_the_competition_and_accelerate_your_career.png",
        imageColor: "#00989D"
    }, EXTRA_SOURCE_DATA),
    (0,_object_spread/* default */.Z)({
        title: "How to Win Friends and Influence People",
        sourceType: enums/* SourceType.BOOK */.PO.BOOK,
        id: 62746,
        deepstashArticles: [
            62746
        ],
        description: "Written by Dan Carnegie",
        image: "https://i.gr-assets.com/images/S/compressed.photo.goodreads.com/books/1442726934l/4865._SY475_.jpg",
        imageColor: "#EB363A"
    }, EXTRA_SOURCE_DATA),
    (0,_object_spread/* default */.Z)({
        title: "Deep Work",
        sourceType: enums/* SourceType.BOOK */.PO.BOOK,
        id: 50623,
        deepstashArticles: [
            50623
        ],
        description: "Written by Cal Newport",
        image: "https://images-na.ssl-images-amazon.com/images/S/compressed.photo.goodreads.com/books/1448550444i/27985224.jpg",
        imageColor: "#C8A906"
    }, EXTRA_SOURCE_DATA),
    (0,_object_spread/* default */.Z)({
        title: "Huberman Lab",
        sourceType: enums/* SourceType.PODCAST */.PO.PODCAST,
        id: 102347,
        deepstashArticles: [
            102347,
            122526,
            151730
        ],
        description: "Podcast on Science",
        image: "https://i.scdn.co/image/ab6765630000ba8a163bf8f74577a2246184654b",
        imageColor: "#4B9CC2"
    }, EXTRA_SOURCE_DATA),
    (0,_object_spread/* default */.Z)({
        title: "The Joe Rogan Experience",
        sourceType: enums/* SourceType.PODCAST */.PO.PODCAST,
        id: 1701,
        deepstashArticles: [
            1701,
            144802
        ],
        description: "Podcast on Life & Everything",
        image: "https://i.scdn.co/image/9af79fd06e34dea3cd27c4e1cd6ec7343ce20af4",
        imageColor: "#A51D21"
    }, EXTRA_SOURCE_DATA),
    (0,_object_spread/* default */.Z)({
        title: "WorkLife with Adam Grant",
        sourceType: enums/* SourceType.PODCAST */.PO.PODCAST,
        id: 61970,
        deepstashArticles: [
            61970
        ],
        description: "Podcast on Work",
        image: "https://pi.tedcdn.com/r/pb-assets.tedcdn.com/system/baubles/files/000/009/379/original/TED_WLS2_Logo_3000x3000_.png?1634320261?w=320",
        imageColor: "#223746"
    }, EXTRA_SOURCE_DATA), 
];
var SETUP_GOALS = {
    productivity: {
        title: "Increase Productivity",
        collections: [
            {
                id: 4,
                name: "Productivity hacks",
                image: "https://audio.deepstash.com/covers/collection/202304/productivity_hacks.png"
            },
            {
                id: 5,
                name: "Beat Procrastination",
                image: "https://audio.deepstash.com/covers/collection/202304/beat_procrastination.png"
            },
            {
                id: 96,
                name: "Productivity Systems",
                image: "https://audio.deepstash.com/covers/collection/202304/productivity_systems.png"
            },
            {
                id: 91,
                name: "Music and Productivity",
                image: "https://audio.deepstash.com/covers/collection/202304/music_productivity.png"
            },
            {
                id: 69,
                name: "The Imposter Cure",
                image: "https://audio.deepstash.com/covers/collection/202304/the_imposter_cure.png"
            }, 
        ]
    },
    work: {
        title: "Win at Work",
        collections: [
            {
                id: 103,
                name: "How to Run an Effective Meeting",
                image: "https://audio.deepstash.com/covers/collection/202304/meeting.png"
            },
            {
                id: 124,
                name: "How To Stop Wasting Time",
                image: "https://audio.deepstash.com/covers/collection/202304/wasting_time.png"
            },
            {
                id: 49,
                name: "Managing Email Effectively",
                image: "https://audio.deepstash.com/covers/collection/202304/managing_email_efficiently.png"
            },
            {
                id: 104,
                name: "Business Writing",
                image: "https://audio.deepstash.com/covers/collection/202304/writing_b.png"
            },
            {
                id: 40,
                name: "The Art of Leadership",
                image: "https://audio.deepstash.com/covers/collection/202304/the_art_of_leadership.png"
            }, 
        ]
    },
    habits: {
        title: "Build Better Habits",
        collections: [
            {
                id: 106,
                name: "The Psychology of Willpower",
                image: "https://audio.deepstash.com/covers/collection/202304/willpower.png"
            },
            {
                id: 51,
                name: "Managing Work Stress",
                image: "https://audio.deepstash.com/covers/collection/202304/managing_work_stress.png"
            },
            {
                id: 111,
                name: "How To Break Bad Habits",
                image: "https://audio.deepstash.com/covers/collection/202304/bad_habits.png"
            },
            {
                id: 23,
                name: "Unlocking your Creative Potential",
                image: "https://audio.deepstash.com/covers/collection/202304/unlocking_your_creative_potential.png"
            },
            {
                id: 101,
                name: "7 Books on Habits",
                image: "https://audio.deepstash.com/covers/collection/202304/habit_book.png"
            }, 
        ]
    },
    money: {
        title: "Earn More Money",
        collections: [
            {
                id: 37,
                name: "How to Succeed at Investing",
                image: "https://audio.deepstash.com/covers/collection/202304/how_to_succeed_at_investing.png"
            },
            {
                id: 38,
                name: "How to Start Investing Today",
                image: "https://audio.deepstash.com/covers/collection/202304/how_to_start_investing_today.png"
            },
            {
                id: 21,
                name: "No More Broke",
                image: "https://audio.deepstash.com/covers/collection/202304/no_more_broke.png"
            },
            {
                id: 12,
                name: "Lessons From Self Made Billionaires",
                image: "https://audio.deepstash.com/covers/collection/202304/lessons_from_self_made_billionaires.png"
            },
            {
                id: 134,
                name: "The Psychology of Money",
                image: "https://audio.deepstash.com/covers/collection/202304/money_psychology.png"
            }, 
        ]
    },
    happiness: {
        title: "Be Happy",
        collections: [
            {
                id: 63,
                name: "How to be happy",
                image: "https://audio.deepstash.com/covers/collection/202304/how_to_be_happy.png"
            },
            {
                id: 17,
                name: "Managing Perfectionism",
                image: "https://audio.deepstash.com/covers/collection/202304/managing_perfectionism.png"
            },
            {
                id: 52,
                name: "Happiness At Work",
                image: "https://audio.deepstash.com/covers/collection/202304/happiness_at_work.png"
            },
            {
                id: 61,
                name: "Sleep Better",
                image: "https://audio.deepstash.com/covers/collection/202304/sleep_better.png"
            },
            {
                id: 18,
                name: "The glorification of busy",
                image: "https://audio.deepstash.com/covers/collection/202304/the_glorification_of_busy.png"
            }, 
        ]
    },
    social: {
        title: "Improve Social Life",
        collections: [
            {
                id: 126,
                name: "Conversation Starters",
                image: "https://audio.deepstash.com/covers/collection/202304/conversation_starters.png"
            },
            {
                id: 7,
                name: "Think Outside The Box",
                image: "https://audio.deepstash.com/covers/collection/202304/think_outside_the_box.png"
            },
            {
                id: 102,
                name: "How To Be Effortlessly Charismatic",
                image: "https://audio.deepstash.com/covers/collection/202304/charisma.png"
            },
            {
                id: 98,
                name: "Master Public Speaking",
                image: "https://audio.deepstash.com/covers/collection/202304/public_speaking.png"
            },
            {
                id: 55,
                name: "Giving Effective Feedback",
                image: "https://audio.deepstash.com/covers/collection/202304/giving_effective_feedback.png"
            }, 
        ]
    }
};
var SETUP_ACHIEVEMENT_GOALS_QUESTION = {
    title: "What do you want to achieve?",
    subtitle: "You will get recommendations that help you achieve your goals.",
    options: [
        {
            title: SETUP_GOALS.productivity.title,
            CustomElement: color_icons/* ProductivityIcon */.i3
        },
        {
            title: SETUP_GOALS.work.title,
            CustomElement: color_icons_WorkIcon
        },
        {
            title: SETUP_GOALS.habits.title,
            CustomElement: color_icons/* HabitsIcon */.sr
        },
        {
            title: SETUP_GOALS.money.title,
            CustomElement: color_icons/* MoneyIcon */.Ws
        },
        {
            title: SETUP_GOALS.happiness.title,
            CustomElement: color_icons/* HappinessIcon */.mI
        },
        {
            title: SETUP_GOALS.social.title,
            CustomElement: color_icons/* SocializingIcon */.Z3
        }, 
    ]
};
var SETUP_TIME_SPENT_QUESTON = {
    title: "How much time do you want to spend on your personal growth?",
    subtitle: "We will tailor your content based on this.",
    options: [
        {
            title: "Easy",
            text: "5 min/day",
            emoji: "✌️"
        },
        {
            title: "Common",
            text: "10 min/day",
            emoji: "\uD83D\uDC4C"
        },
        {
            title: "Serious",
            text: "15 min/day",
            emoji: "✊"
        },
        {
            title: "Intensive",
            text: "20 min/day",
            emoji: "\uD83D\uDCAA"
        }, 
    ]
};
var SETUP_CONTENT_VALUE_PROP = {
    title: "Unlock 200,000+ ideas on pretty much any topic.",
    subtitle: "Created by the smartest people around & well-organized so you can explore at will.",
    image: "https://static.deepstash.com/phone-landing-image.png",
    options: []
};
var SETUP_TIME_VALUE_PROP = {
    title: "With Deepstash you will save on several hours of reading every week.",
    subtitle: "You will essentially read 2-4x more than what the average person reads!",
    image: "https://static.deepstash.com/phone-landing-image.png",
    options: []
};
var SETUP_GENDER_QUESTION = {
    title: "Select your gender",
    options: [
        {
            emoji: "\uD83D\uDC68",
            title: "Male"
        },
        {
            emoji: "\uD83D\uDC69",
            title: "Female"
        },
        {
            emoji: "\uD83E\uDDD1",
            title: "Other"
        }, 
    ]
};
var SETUP_AGE_QUESTION = {
    title: "What is your age?",
    options: [
        {
            title: "20s",
            text: "18-29 years"
        },
        {
            title: "30s",
            text: "30-39 years"
        },
        {
            title: "40s",
            text: "40-49 years"
        },
        {
            title: "50+",
            text: "50+ years"
        }, 
    ]
};
var SETUP_READING_TIME_QUESTION = {
    title: "When do you read books or listen to podcasts?",
    subtitle: "We will send you content based on your preference.",
    options: [
        {
            emoji: "☕️",
            title: "In the morning"
        },
        {
            emoji: "\uD83C\uDFC3",
            title: "While working out"
        },
        {
            emoji: "\uD83D\uDE99",
            title: "On my commute"
        },
        {
            emoji: "\uD83D\uDECC",
            title: "While taking a break"
        }, 
    ]
};
var SETUP_STEPS = {
    "content-value-prop": SETUP_CONTENT_VALUE_PROP,
    "time-value-prop": SETUP_TIME_VALUE_PROP,
    time: SETUP_TIME_SPENT_QUESTON,
    achieve: SETUP_ACHIEVEMENT_GOALS_QUESTION,
    age: SETUP_AGE_QUESTION,
    gender: SETUP_GENDER_QUESTION,
    "time-of-the-day": SETUP_READING_TIME_QUESTION
};

// EXTERNAL MODULE: ./src/services/analytics/index.ts
var analytics = __webpack_require__(62687);
// EXTERNAL MODULE: ./src/providers/hooks/useNsi.ts
var useNsi = __webpack_require__(9182);
;// CONCATENATED MODULE: ./src/page-components/landing/components-v2/LandingGoalQuestion.tsx












// List of indexes of goals that are shown on the homepage
var GOAL_WHITELIST = [
    0,
    1,
    2,
    3
];
var LandingGoalQuestion = function(_param) {
    var props = (0,_extends/* default */.Z)({}, _param);
    var isMobileView = (0,esm.useIsMobileView)();
    var colorMode = (0,esm.useColorMode)().colorMode;
    var router = (0,useRouter/* default */.Z)();
    var nsiDispatch = (0,useNsi/* default */.Z)().nsiDispatch;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState([]), 2), checkedIndexes = ref[0], setCheckedIndexes = ref[1];
    var onClickOption = function(param) {
        var index = param.index;
        setCheckedIndexes(function(prevCheckedOptions) {
            var findOption = prevCheckedOptions.find(function(prevSelectedOption) {
                return prevSelectedOption === index;
            });
            if (findOption === undefined) {
                return (0,_to_consumable_array/* default */.Z)(prevCheckedOptions).concat([
                    index
                ]);
            } else {
                return prevCheckedOptions.filter(function(prevSelectedOption) {
                    return prevSelectedOption !== index;
                });
            }
        });
    };
    var onClickContinue = function() {
        var achievements = checkedIndexes.map(function(optionIndex) {
            return SETUP_ACHIEVEMENT_GOALS_QUESTION.options[optionIndex];
        });
        analytics/* Analytics.logEvent */.c.logEvent({
            eventName: analytics/* Events.onboarding.clickContinueGoalLanding */.z.onboarding.clickContinueGoalLanding,
            properties: {
                goals: achievements.map(function(achievement) {
                    return achievement.title;
                })
            },
            platforms: [
                "amplitude"
            ]
        });
        var _title;
        nsiDispatch({
            type: "set-goal",
            payload: {
                setupGoal: (_title = achievements[0].title) !== null && _title !== void 0 ? _title : ""
            }
        });
        router.push("/setup");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        flexDirection: "column",
        gridRowGap: 4,
        maxW: 440
    }, props), {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                maxW: 450
            }, esm.typography.primaryHeadingFonts.small.semiBold), {
                color: esm.color[colorMode].text,
                mb: 8,
                children: "What brings you to Deepstash?"
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                flexDirection: "column",
                gridRowGap: 4,
                borderRadius: 8,
                overflow: "hidden",
                children: SETUP_ACHIEVEMENT_GOALS_QUESTION.options.map(function(goal, index) {
                    var isSelected = checkedIndexes.find(function(checkedIndex) {
                        return checkedIndex === index;
                    }) !== undefined;
                    return GOAL_WHITELIST.includes(index) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        flexDirection: "row",
                        alignItems: "center",
                        bgColor: isSelected ? esm.color[colorMode].top : esm.color[colorMode].surface,
                        px: 8,
                        py: 8,
                        gridColumnGap: 4,
                        _hover: {
                            cursor: "pointer",
                            bgColor: isSelected ? esm.color[colorMode].top : esm.color[colorMode].underground
                        },
                        onClick: function() {
                            onClickOption({
                                index: index
                            });
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Checkbox, {
                                isChecked: isSelected,
                                onChange: function() {
                                    return;
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                                color: esm.color[colorMode].text,
                                children: goal.title
                            }))
                        ]
                    }, "goal-".concat(index)) : null;
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PrimaryButton, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    size: "lg",
                    type: "button",
                    borderRadius: 16,
                    mt: 8
                }, isMobileView ? esm.typography.primaryTextFonts.medium.semiBold : esm.typography.primaryTextFonts.large.semiBold), {
                    isDisabled: checkedIndexes.length === 0,
                    onClick: onClickContinue
                }), isMobileView ? {
                    width: "100%"
                } : {}), {
                    children: "Continue"
                }))
            })
        ]
    }));
};
/* harmony default export */ var components_v2_LandingGoalQuestion = (LandingGoalQuestion);


/***/ }),

/***/ 8190:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_v2_LandingProSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/page-components/landing/components-v2/LandingStartTrialButton.tsx
var LandingStartTrialButton = __webpack_require__(83934);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/theme/icons/HistorySvg.tsx
var HistorySvg = __webpack_require__(19146);
// EXTERNAL MODULE: ./src/theme/icons/ProBadgeSvg.tsx
var ProBadgeSvg = __webpack_require__(76476);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/utils/strings/commonStrings.ts
var commonStrings = __webpack_require__(51599);
;// CONCATENATED MODULE: ./src/page-components/landing/components-v2/ProComparison.tsx











var ProComparisonTableDesktop = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 9166).then(__webpack_require__.bind(__webpack_require__, 39166));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(39166)
            ];
        }
    }
});
ProComparisonTableDesktop.displayName = "ProComparisonTableDesktop";
var HEADING_TEXT_STYLE = {
    fontSize: esm.spacing.toRem(20),
    lineHeight: "1.3em",
    textAlign: "center"
};
var ProComparison = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var colorMode = (0,esm.useColorMode)().colorMode;
    var isMobileView = (0,esm.useIsMobileView)();
    var BENEFIT_LIST = (0,react.useMemo)(function() {
        return [
            {
                name: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                    color: esm.color[colorMode].textSecondary,
                    children: [
                        commonStrings/* default.benefits.0.0 */.Z.benefits[0][0],
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                fontWeight: 800
                            },
                            children: commonStrings/* default.benefits.0.1 */.Z.benefits[0][1]
                        })
                    ]
                })),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.LibrarySvg, {
                    color: esm.color.light.pro.primary,
                    height: esm.spacing.toRem(32),
                    width: esm.spacing.toRem(32)
                }),
                accessLevel: "si"
            },
            {
                name: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                    color: esm.color[colorMode].textSecondary,
                    children: [
                        commonStrings/* default.benefits.1.0 */.Z.benefits[1][0],
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                fontWeight: 800
                            },
                            children: commonStrings/* default.benefits.1.1 */.Z.benefits[1][1]
                        })
                    ]
                })),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.PhoneSvg, {
                    color: esm.color.light.pro.primary,
                    height: esm.spacing.toRem(32),
                    width: esm.spacing.toRem(32)
                }),
                accessLevel: "si"
            },
            {
                name: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                    color: esm.color[colorMode].textSecondary,
                    children: [
                        commonStrings/* default.benefits.2.0 */.Z.benefits[2][0],
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                fontWeight: 800
                            },
                            children: commonStrings/* default.benefits.2.1 */.Z.benefits[2][1]
                        }),
                        commonStrings/* default.benefits.2.2 */.Z.benefits[2][2]
                    ]
                })),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.StashedSvg, {
                    color: esm.color.light.pro.primary,
                    height: esm.spacing.toRem(32),
                    width: esm.spacing.toRem(32)
                }),
                accessLevel: "pro"
            },
            {
                name: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                    color: esm.color[colorMode].textSecondary,
                    children: [
                        commonStrings/* default.benefits.3.0 */.Z.benefits[3][0],
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                fontWeight: 800
                            },
                            children: commonStrings/* default.benefits.3.1 */.Z.benefits[3][1]
                        })
                    ]
                })),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(HistorySvg/* HistorySvg */.X, {
                    color: esm.color.light.pro.primary,
                    height: esm.spacing.toRem(32),
                    width: esm.spacing.toRem(32)
                }),
                accessLevel: "pro"
            },
            {
                name: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                    color: esm.color[colorMode].textSecondary,
                    children: [
                        commonStrings/* default.benefits.4.0 */.Z.benefits[4][0],
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                fontWeight: 800
                            },
                            children: commonStrings/* default.benefits.4.1 */.Z.benefits[4][1]
                        }),
                        commonStrings/* default.benefits.4.2 */.Z.benefits[4][2]
                    ]
                })),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.HeadphonesSvg, {
                    color: esm.color.light.pro.primary,
                    height: esm.spacing.toRem(32),
                    width: esm.spacing.toRem(32)
                }),
                accessLevel: "pro"
            },
            {
                name: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                    color: esm.color[colorMode].textSecondary,
                    children: [
                        commonStrings/* default.benefits.5.0 */.Z.benefits[5][0],
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                fontWeight: 800
                            },
                            children: commonStrings/* default.benefits.5.1 */.Z.benefits[5][1]
                        }),
                        commonStrings/* default.benefits.5.2 */.Z.benefits[5][2]
                    ]
                })),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.DownloadSvg, {
                    color: esm.color.light.pro.primary,
                    height: esm.spacing.toRem(32),
                    width: esm.spacing.toRem(32)
                }),
                accessLevel: "pro"
            },
            {
                name: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                    color: esm.color[colorMode].textSecondary,
                    children: [
                        commonStrings/* default.benefits.6.0 */.Z.benefits[6][0],
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            style: {
                                fontWeight: 800
                            },
                            children: commonStrings/* default.benefits.6.1 */.Z.benefits[6][1]
                        })
                    ]
                })),
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.BookSvg, {
                    color: esm.color.light.pro.primary,
                    height: esm.spacing.toRem(32),
                    width: esm.spacing.toRem(32)
                }),
                accessLevel: "pro"
            }, 
        ];
    }, [
        colorMode
    ]);
    var mobileLayout = /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        gridGap: esm.spacing.M.rem,
        flexDirection: "column",
        alignItems: "start",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                mb: esm.spacing.M.rem,
                flex: 1,
                w: "100%",
                justifyContent: "center",
                textAlign: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.PrimaryText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, HEADING_TEXT_STYLE), {
                    textAlign: "center",
                    color: esm.color[colorMode].text,
                    width: {
                        base: "100%",
                        md: (0,global/* getRemWidthFromColumns */._P)(1.5)
                    },
                    children: [
                        commonStrings/* default.with */.Z["with"],
                        " deep",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                            children: "stash"
                        })
                    ]
                }))
            }),
            BENEFIT_LIST.slice(0, 2).map(function(benefit, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                    flexGrow: {
                        base: 0,
                        md: 1
                    },
                    alignItems: "center",
                    gridGap: esm.spacing.toRem(16),
                    children: [
                        benefit.icon,
                        benefit.name
                    ]
                }, index);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                mt: global/* GAP_SIZE_REM */.L3,
                mb: esm.spacing.M.rem,
                flex: 1,
                flexDirection: "column",
                alignItems: "center",
                w: "100%",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                    alignItems: "center",
                    gridGap: esm.spacing.toRem(4),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.PrimaryText, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, HEADING_TEXT_STYLE), {
                            color: esm.color[colorMode].text,
                            children: [
                                commonStrings/* default.with */.Z["with"],
                                " deep",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                    children: "stash"
                                })
                            ]
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProBadgeSvg/* ProBadgeSvg */.r, {
                            height: 20
                        })
                    ]
                })
            }),
            BENEFIT_LIST.slice(2).map(function(benefit, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                    flexGrow: {
                        base: 0,
                        md: 1
                    },
                    alignItems: "center",
                    gridGap: esm.spacing.toRem(16),
                    children: [
                        benefit.icon,
                        benefit.name
                    ]
                }, index);
            })
        ]
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
        w: "100%",
        justifyContent: "center",
        mt: 32,
        children: isMobileView ? mobileLayout : /*#__PURE__*/ (0,jsx_runtime.jsx)(ProComparisonTableDesktop, {
            benefits: BENEFIT_LIST
        })
    });
};
/* harmony default export */ var components_v2_ProComparison = (ProComparison);

;// CONCATENATED MODULE: ./src/page-components/landing/components-v2/LandingProSection.tsx








var TITLE_PRO = "A small investment, an incredible growth opportunity";
var SUBTITLE_PRO = "Get access to 200,000+ powerful ideas from top books, podcasts, and more.";
// TODO No Trial Changes
// const CTA_TEXT = 'Start my free week';
var CTA_TEXT = "Get Deepstash Pro today";
var LandingProSection = function(_param) {
    var showProComparison = _param.showProComparison, boxTextProps = _param.boxTextProps, _landingLocation = _param.landingLocation, landingLocation = _landingLocation === void 0 ? "pro-section" : _landingLocation, trialInfoStyleProps = _param.trialInfoStyleProps, props = (0,_object_without_properties/* default */.Z)(_param, [
        "showProComparison",
        "boxTextProps",
        "landingLocation",
        "trialInfoStyleProps"
    ]);
    // TODO No Trial Changes
    // const { stripePrices, requestStatus } = useStripePrices({
    //   requestNsi: true,
    // });
    // const freeTrialSubscription = stripePrices?.subscriptions['1 YEAR'];
    // const normalizedPrice = `$${freeTrialSubscription?.pricePerMonth}/month`;
    // const seventhDayFormatted = React.useMemo(() => {
    //   return getSeventhDateFromToday();
    // }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        px: {
            base: 16,
            md: 0
        },
        flexDirection: "column",
        alignItems: "center",
        mt: {
            sm: 16,
            md: 88
        }
    }, props), {
        children: [
            showProComparison ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_v2_ProComparison, {}) : null,
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                justifyContent: "space-between",
                flexDirection: "column",
                alignItems: "center",
                mt: 64,
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryHeadingFonts.large.semiBold), {
                        color: esm.color.light.text,
                        textAlign: "center",
                        children: TITLE_PRO
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                        color: esm.color.light.textSecondary,
                        textAlign: "center",
                        mt: 8,
                        children: SUBTITLE_PRO
                    })),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        flexDirection: {
                            lg: "row",
                            md: "column",
                            sm: "column"
                        },
                        width: "100%",
                        bgColor: "#CCE2EF",
                        borderRadius: 8,
                        mt: {
                            sm: 16,
                            md: 64
                        },
                        py: 32,
                        px: {
                            sm: 16,
                            md: 48,
                            lg: 64
                        },
                        justifyContent: "space-between",
                        gridColumnGap: 32,
                        gridRowGap: 16
                    }, trialInfoStyleProps), {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                                color: esm.color.light.text
                            }), boxTextProps), {
                                children: "Enjoy unlimited access to 100+ tailored journeys & all mobile app features."
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                                flexDirection: "column",
                                justifyContent: "center",
                                width: "100%",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingStartTrialButton/* default */.Z, {
                                    text: CTA_TEXT,
                                    landingLocation: landingLocation,
                                    bgColor: esm.color.light.pro.primary,
                                    _active: {
                                        bgColor: "#082E4E"
                                    }
                                })
                            })
                        ]
                    }))
                ]
            })
        ]
    }));
};
/* harmony default export */ var components_v2_LandingProSection = (LandingProSection);


/***/ }),

/***/ 11892:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(51351);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);
/* harmony import */ var _StoreRatingCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88250);
/* harmony import */ var utils_landingPageData__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74277);
/* harmony import */ var src_components_cards_ReviewCard__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(97683);









var TITLE = "What our members say";
var NUMBER_OF_REVIEWS_ON_A_SIDE = 3;
var LandingReviewsSection = function(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useIsMobileView)();
    var isIos = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useDeviceDetect)().isIos;
    var colorMode = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useColorMode)().colorMode;
    var reviewsLeft = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return utils_landingPageData__WEBPACK_IMPORTED_MODULE_4__/* .LANDING_PAGE_REVIEWS.filter */ .LX.filter(function(review) {
            return review.platform === "ios";
        })// .sort(() => 0.5 - Math.random())
        .slice(0, NUMBER_OF_REVIEWS_ON_A_SIDE);
    }, [
        isIos,
        isMobileView
    ]);
    var reviewsRight = react__WEBPACK_IMPORTED_MODULE_1__.useMemo(function() {
        return utils_landingPageData__WEBPACK_IMPORTED_MODULE_4__/* .LANDING_PAGE_REVIEWS.filter */ .LX.filter(function(r) {
            return !reviewsLeft.map(function(r) {
                return r.id;
            }).includes(r.id);
        }).filter(function(r) {
            return r.platform === "android";
        })// .sort(() => 0.5 - Math.random())
        .slice(0, NUMBER_OF_REVIEWS_ON_A_SIDE);
    }, [
        reviewsLeft
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
        paddingX: {
            base: 16,
            md: 0
        },
        flexDirection: "column",
        mt: {
            sm: 48,
            md: 88
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryHeadingFonts.large.semiBold), {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color.light.text,
                textAlign: "center",
                children: TITLE
            })),
            isMobileView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StoreRatingCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    store: isIos ? "ios" : "android",
                    flexGrow: 1,
                    flexShrink: 0,
                    width: "auto",
                    height: "auto"
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                flexDirection: {
                    sm: "column",
                    md: "row",
                    lg: "row"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StoreRatingCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        store: "ios",
                        flexGrow: 1,
                        flexShrink: 0,
                        width: "auto",
                        height: "auto"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_StoreRatingCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        store: "android",
                        flexGrow: 1,
                        flexShrink: 0,
                        width: "auto",
                        height: "auto"
                    })
                ]
            }),
            isMobileView ? isIos ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                flexDirection: "column",
                flex: 1,
                gridRowGap: 16,
                children: reviewsLeft.map(function(review) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_cards_ReviewCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        review: review,
                        bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].surface
                    }, review.id);
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                flexDirection: "column",
                flex: 1,
                gridRowGap: 16,
                children: reviewsRight.map(function(review) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_cards_ReviewCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        review: review,
                        bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].surface
                    }, review.id);
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                flex: 1,
                flexDirection: "row",
                gridColumnGap: 32,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                        flexDirection: "column",
                        flex: 1,
                        gridRowGap: 16,
                        children: reviewsLeft.map(function(review) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_cards_ReviewCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                review: review,
                                bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].surface
                            }, review.id);
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                        flexDirection: "column",
                        flex: 1,
                        gridRowGap: 16,
                        children: reviewsRight.map(function(review) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_cards_ReviewCard__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                review: review,
                                bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color[colorMode].surface
                            }, review.id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LandingReviewsSection);


/***/ }),

/***/ 62468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51351);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);
/* harmony import */ var hooks_useRouter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98377);
/* harmony import */ var _LandingStartTrialButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83934);








var TITLE = "Start your journey today";
// TODO No Trial Changes
// const SUBTITLE1 =
//   'Embark on the journey of becoming better & smarter with a 7-day free trial.';
// const SUBTITLE2 = "Cancel anytime if Deepstash doesn't work for you.";
var SUBTITLE1 = "Embark on the journey of becoming better & smarter.";
var SUBTITLE2 = "Get the mobile app & never stop exploring.";
// TODO No Trial Changes
// const CTA_TEXT = 'Start my free week';
var CTA_TEXT = "Start today";
var LandingStartJourneySection = function(param) {
    var param = param !== null ? param : (0,_swc_helpers_src_throw_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(new TypeError("Cannot destructure undefined"));
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useIsMobileView)();
    var router = (0,hooks_useRouter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
        paddingX: {
            base: 16,
            md: 0
        },
        justifyContent: "space-between",
        flexDirection: "column",
        alignItems: "center",
        mt: 24,
        width: "100%",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryHeadingFonts.large.semiBold), {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color.light.text,
                textAlign: "center",
                children: TITLE
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.large.regular), {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color.light.textSecondary,
                textAlign: "center",
                mt: 8,
                children: [
                    SUBTITLE1,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    SUBTITLE2
                ]
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                mt: 32,
                gridColumnGap: 32,
                flexDirection: {
                    sm: "column",
                    md: "row"
                },
                gridRowGap: 16,
                flex: 1,
                w: "100%",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingStartTrialButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        text: CTA_TEXT,
                        landingLocation: "start-journey"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.PrimaryButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
                        size: "lg",
                        type: "button",
                        borderRadius: 16,
                        bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color.light.top,
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color.light.text,
                        _active: {
                            bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color.light.surface
                        },
                        onClick: function() {
                            router.push("/collections/1");
                        }
                    }, isMobileView ? deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.medium.semiBold : deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryHeadingFonts.small.semiBold), {
                        children: "Explore Library"
                    }))
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LandingStartJourneySection);


/***/ }),

/***/ 83934:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);
/* harmony import */ var hooks_purchases_useAuthAndOpenPurchasePage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5402);
/* harmony import */ var services_analytics__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62687);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);









// TODO No Trial Changes
// const CTA_TEXT = 'Try it for Free';
var CTA_TEXT = "Start Today";
var LandingStartTrialButton = function(_param) {
    var _text = _param.text, text = _text === void 0 ? CTA_TEXT : _text, landingLocation = _param.landingLocation, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(_param, [
        "text",
        "landingLocation"
    ]);
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useIsMobileView)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var onClickStartSubscriptionForNsi = (0,hooks_purchases_useAuthAndOpenPurchasePage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}).onClickStartSubscriptionForNsi;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.PrimaryButton, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        size: "lg",
        type: "button",
        borderRadius: 16
    }, isMobileView ? deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.medium.semiBold : deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryHeadingFonts.small.semiBold), {
        onClick: function() {
            services_analytics__WEBPACK_IMPORTED_MODULE_4__/* .Analytics.logEvent */ .c.logEvent({
                eventName: services_analytics__WEBPACK_IMPORTED_MODULE_4__/* .Events.payments.clickStartTrial */ .z.payments.clickStartTrial,
                properties: {
                    url: router.asPath,
                    landingLocation: landingLocation
                },
                platforms: [
                    "amplitude"
                ]
            });
            onClickStartSubscriptionForNsi();
        }
    }), props), {
        children: text
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (LandingStartTrialButton);


/***/ }),

/***/ 90182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);
/* harmony import */ var _LandingStartTrialButton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(83934);






var TITLE = "Explore the World's Best Ideas";
// TODO No Trial Changes
// const SUBTITLE =
//   'Try Deepstash free for 7 days. We’ll remind you about your trial via email. Cancel anytime in 15 seconds.';
var SUBTITLE = "Join today and uncover 100+ curated journeys from 50+ topics. Unlock access to our mobile app with extensive features.";
var LandingStartTrialSection = function(param) {
    var isCentered = param.isCentered;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
        px: {
            base: 16,
            md: 0
        },
        mt: {
            sm: 48,
            md: 32
        },
        mb: 32,
        justifyContent: "space-between",
        gridColumnGap: 32,
        gridRowGap: 16,
        flexDirection: isCentered ? "column" : {
            sm: "column",
            md: "row"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                flexDirection: "column",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryHeadingFonts.large.semiBold), {
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color.light.text,
                        textAlign: isCentered ? "center" : {
                            sm: "center",
                            md: "initial"
                        },
                        children: TITLE
                    })),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.large.regular), {
                        color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color.light.textSecondary,
                        textAlign: isCentered ? "center" : {
                            sm: "center",
                            md: "initial"
                        },
                        children: SUBTITLE
                    }))
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                flexDirection: "column",
                justifyContent: "center",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_LandingStartTrialButton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    landingLocation: "start-trial-section"
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LandingStartTrialSection);


/***/ }),

/***/ 53121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);
/* harmony import */ var utils_metatopics_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90031);
/* harmony import */ var src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91260);
/* harmony import */ var src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50752);
/* harmony import */ var utils_global__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63069);









var TITLE = "What are you interested in?";
var SUBTITLE = "Over 200,000+ of ideas from books, podcasts, articles, and more.";
var TOPIC_IMAGE_SIZE = 24;
var LandingTopicsSection = function(param) {
    var topicChipTextProps = param.topicChipTextProps;
    var isMobileView = (0,deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.useIsMobileView)();
    var renderTopic = function(param) {
        var metaTopic = param.metaTopic;
        var formatTopic = (0,utils_global__WEBPACK_IMPORTED_MODULE_6__/* .formatStringToHashtagCase */ .J)(metaTopic.name);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_navigation_NextLink__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
            href: "/topic/".concat(formatTopic),
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Link, {
                _focus: undefined,
                _hover: undefined,
                title: metaTopic.name,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                    bgColor: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color.light.top,
                    px: 16,
                    py: 8,
                    borderRadius: 20,
                    gridColumnGap: 8,
                    alignItems: "center",
                    _hover: {
                        cursor: "pointer",
                        boxShadow: "0px 6px 14px -6px rgba(0, 0, 0, 0.12), 0px 10px 32px -4px rgba(0, 0, 0, 0.1)"
                    },
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(src_components_image_NextImage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                            wrapperStyle: {
                                width: TOPIC_IMAGE_SIZE,
                                height: TOPIC_IMAGE_SIZE,
                                pointerEvents: "none"
                            },
                            objectFit: "contain",
                            imageUrl: metaTopic.image,
                            priority: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                            color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color.light.text,
                            noOfLines: 1
                        }, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.medium.regular, topicChipTextProps), {
                            children: metaTopic.name
                        }))
                    ]
                }, "topic-".concat(metaTopic.id))
            })
        });
    };
    var renderTopicRow = function(param) {
        var startIndex = param.startIndex, endIndex = param.endIndex;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
            gridColumnGap: 8,
            maxWidth: "100%",
            justifyContent: "center",
            children: utils_metatopics_constants__WEBPACK_IMPORTED_MODULE_3__/* .METATOPICS.slice */ .zY.slice(startIndex, endIndex).map(function(metaTopic) {
                return renderTopic({
                    metaTopic: metaTopic
                });
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
        paddingX: {
            base: 16,
            md: 0
        },
        flexDirection: "column",
        alignItems: "center",
        mt: {
            sm: 48,
            md: 128
        },
        overflow: "hidden",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryHeadingFonts.large.semiBold), {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color.light.text,
                textAlign: "center",
                children: TITLE
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Text, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.typography.primaryTextFonts.large.regular), {
                color: deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.color.light.textSecondary,
                textAlign: "center",
                mt: 8,
                children: SUBTITLE
            })),
            isMobileView ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                flexDirection: "column",
                gridRowGap: 8,
                mt: 32,
                children: [
                    renderTopicRow({
                        startIndex: 0,
                        endIndex: 2
                    }),
                    renderTopicRow({
                        startIndex: 2,
                        endIndex: 4
                    }),
                    renderTopicRow({
                        startIndex: 4,
                        endIndex: 6
                    }),
                    renderTopicRow({
                        startIndex: 6,
                        endIndex: 8
                    }),
                    renderTopicRow({
                        startIndex: 8,
                        endIndex: 10
                    }),
                    renderTopicRow({
                        startIndex: 10,
                        endIndex: 12
                    }),
                    renderTopicRow({
                        startIndex: 12,
                        endIndex: 14
                    }),
                    renderTopicRow({
                        startIndex: 14,
                        endIndex: 16
                    }),
                    renderTopicRow({
                        startIndex: 16,
                        endIndex: 18
                    }),
                    renderTopicRow({
                        startIndex: 18,
                        endIndex: 20
                    }),
                    renderTopicRow({
                        startIndex: 20,
                        endIndex: 22
                    })
                ]
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Flex, {
                flexDirection: "column",
                gridRowGap: 8,
                mt: 32,
                pb: 24,
                children: [
                    renderTopicRow({
                        startIndex: 0,
                        endIndex: 4
                    }),
                    renderTopicRow({
                        startIndex: 4,
                        endIndex: 9
                    }),
                    renderTopicRow({
                        startIndex: 9,
                        endIndex: 13
                    }),
                    renderTopicRow({
                        startIndex: 13,
                        endIndex: 18
                    }),
                    renderTopicRow({
                        startIndex: 18,
                        endIndex: 22
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LandingTopicsSection);


/***/ }),

/***/ 13519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_v2_LandingValuePropsSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./src/components/animation/Lottie.jsx
var Lottie = __webpack_require__(71137);
;// CONCATENATED MODULE: ./src/page-components/landing/components-v2/ValuePropItem.tsx






var ValuePropItem = function(param) {
    var preTitle = param.preTitle, title = param.title, subtitle = param.subtitle, startingIllustration = param.startingIllustration, lottieAnimationData = param.lottieAnimationData, _direction = param.direction, direction = _direction === void 0 ? "left" : _direction;
    //   const isMobileView = useIsMobileView();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
        justifyContent: "space-between",
        gridColumnGap: {
            sm: 16,
            md: 64
        },
        flexDirection: {
            sm: "column",
            md: direction === "left" ? "row" : "row-reverse"
        },
        gridRowGap: 16,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                flexDirection: "column",
                flex: 1.3,
                gridRowGap: 16,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.bold), {
                                color: esm.color.light.text,
                                textTransform: "uppercase",
                                letterSpacing: 2,
                                textAlign: {
                                    sm: "center",
                                    md: "unset"
                                },
                                children: preTitle
                            })),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Heading, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                size: "h4"
                            }, esm.typography.primaryHeadingFonts.large.semiBold), {
                                color: esm.color.light.text,
                                textAlign: {
                                    sm: "center",
                                    md: "unset"
                                },
                                children: title
                            }))
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, esm.typography.primaryTextFonts.large.regular), {
                        color: esm.color.light.textSecondary,
                        fontSize: {
                            sm: "1rem",
                            md: "1.3rem"
                        },
                        lineHeight: {
                            sm: "1.3rem",
                            md: "2.1rem"
                        },
                        textAlign: {
                            sm: "center",
                            md: "unset"
                        },
                        children: subtitle
                    }))
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                flex: 1,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                    position: "relative",
                    alignItems: "center",
                    borderRadius: 16,
                    overflow: "hidden",
                    mx: {
                        sm: 48,
                        md: 0
                    },
                    children: [
                        startingIllustration,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Lottie/* default */.Z, {
                            style: {
                                position: "relative",
                                // width: '100%',
                                // height: '100%',
                                cursor: "default",
                                bgColor: "blue"
                            },
                            options: {
                                loop: true,
                                autoplay: false,
                                animationData: lottieAnimationData
                            },
                            isClickToPauseDisabled: true,
                            speed: 1
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_v2_ValuePropItem = (ValuePropItem);

// EXTERNAL MODULE: ./src/theme/animations/landing_1.json
var landing_1 = __webpack_require__(56642);
// EXTERNAL MODULE: ./src/theme/animations/landing_2.json
var landing_2 = __webpack_require__(96466);
// EXTERNAL MODULE: ./src/theme/animations/landing_3.json
var landing_3 = __webpack_require__(46265);
// EXTERNAL MODULE: ./src/page-components/landing/illustrations/LandingIllustration1.tsx
var LandingIllustration1 = __webpack_require__(55005);
// EXTERNAL MODULE: ./src/page-components/landing/illustrations/LandingIllustration2.tsx
var LandingIllustration2 = __webpack_require__(97558);
// EXTERNAL MODULE: ./src/page-components/landing/illustrations/LandingIllustration3.tsx
var LandingIllustration3 = __webpack_require__(92115);
// EXTERNAL MODULE: ./src/components/layout/components/FullWidthSectionWrapper.tsx
var FullWidthSectionWrapper = __webpack_require__(41140);
;// CONCATENATED MODULE: ./src/page-components/landing/components-v2/LandingValuePropsSection.tsx












var LandingValuePropsSection = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
        flexDirection: "column",
        // paddingX={LANDING_PAGE_DEFAULT_PX}
        py: {
            sm: 40,
            md: 80
        },
        my: 24,
        gridRowGap: {
            sm: 48,
            md: 80
        },
        bgColor: esm.color.light.surface,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(FullWidthSectionWrapper/* default */.Z, {
            containerProps: {
                flexDirection: "column",
                gridRowGap: {
                    sm: 48,
                    md: 80
                }
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_v2_ValuePropItem, {
                    preTitle: "Discover",
                    title: "Your Next Big Idea",
                    subtitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            "Ideas come from books, articles, podcasts & more.",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "We make it ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "easy"
                            }),
                            " by picking the best ideas from a",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "200,000+ catalogue"
                            }),
                            " on thousands of topics."
                        ]
                    }),
                    direction: "left",
                    startingIllustration: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingIllustration1/* default */.Z, {
                        position: "absolute"
                    }),
                    lottieAnimationData: landing_1
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_v2_ValuePropItem, {
                    preTitle: "Learn Anything",
                    title: "Remember Everything",
                    subtitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            "The idea format helps ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "10M+ people"
                            }),
                            " remember the ideas that ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "help them grow"
                            }),
                            ". Join the community. Save and remember ideas. Share & discover."
                        ]
                    }),
                    direction: "right",
                    startingIllustration: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingIllustration2/* default */.Z, {
                        position: "absolute"
                    }),
                    lottieAnimationData: landing_2
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(components_v2_ValuePropItem, {
                    preTitle: "Get Creative",
                    title: "Build a Reading Habit",
                    subtitle: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            '"Creativity is just connecting the dots." -',
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "Steve Jobs."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "With Deepstash, you will build stronger",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "reading habits"
                            }),
                            " through",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                children: "bite-sized recommendations"
                            }),
                            " throughout the day."
                        ]
                    }),
                    direction: "left",
                    startingIllustration: /*#__PURE__*/ (0,jsx_runtime.jsx)(LandingIllustration3/* default */.Z, {
                        position: "absolute"
                    }),
                    lottieAnimationData: landing_3
                })
            ]
        })
    });
};
/* harmony default export */ var components_v2_LandingValuePropsSection = (LandingValuePropsSection);


/***/ }),

/***/ 55005:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LandingIllustration1 */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);





var LandingIllustration1 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Icon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "1700",
        height: "1080",
        viewBox: "0 0 1700 1080",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_251_19310)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "1700",
                        height: "1080",
                        fill: "#FFD775"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M2956.22 -786.237C2815.02 -777.808 2430.34 -541.805 2312.11 -442.229C2181.82 -332.611 1980.8 -129.129 1871.36 7.19186C1748.58 160.085 1602.85 324.932 1445.42 393.524C1277.31 466.795 1110.05 464.893 944.698 368.783C779.347 272.672 683.836 66.1113 675.36 -165.781C668.058 -364.36 806.229 -683.727 948.123 -794.522L960.26 -811.107L-25.0109 -822.307L-48.1602 -793.486C-536.43 -231.907 -430.484 990.808 106.288 1481.15C413.053 1760.93 761.681 1784.67 1124.9 1712.31C1432.8 1650.96 1672.18 1446.46 1930.76 1245.66C2206.22 1031.69 2466.03 796.446 2750.65 595.95C2997.93 422.369 3365.59 316.904 3724.48 383.658C4083.38 450.413 4239.39 642.684 4325.35 858.88L4330.14 868.532L4348.79 -772.589L2961.86 -788.354L2956.22 -786.237Z",
                        fill: "#B395B6"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M3252.22 -1729.24C3111.02 -1720.81 2726.34 -1484.81 2608.11 -1385.23C2477.82 -1275.61 2276.8 -1072.13 2167.36 -935.808C2044.58 -782.915 1898.85 -618.068 1741.42 -549.476C1573.31 -476.205 1406.05 -478.107 1240.7 -574.217C1075.35 -670.328 979.836 -876.889 971.36 -1108.78C964.058 -1307.36 1102.23 -1626.73 1244.12 -1737.52L1256.26 -1754.11L270.989 -1765.31L247.84 -1736.49C-240.43 -1174.91 -134.484 47.8085 402.288 538.152C709.053 817.933 1057.68 841.673 1420.9 769.312C1728.8 707.956 1968.18 503.456 2226.76 302.665C2502.22 88.687 2762.03 -146.554 3046.65 -347.05C3293.93 -520.631 3661.59 -626.096 4020.48 -559.342C4379.38 -492.587 4535.39 -300.316 4621.35 -84.1201L4626.14 -74.468L4644.79 -1715.59L3257.86 -1731.35L3252.22 -1729.24Z",
                        fill: "#A784AA"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1667.04 1218.88C1672.13 1158.77 1694.06 1093.56 1666 1036.96C1639.12 982.728 1573.74 979.526 1520.55 976.858C1518.32 976.858 1515.88 976.655 1513.34 976.604C1537.22 932.028 1565.73 887.324 1583.62 840.487C1610.15 771.005 1532.5 730.596 1475.96 717C1475.96 717 1485.03 758.577 1489.91 778.476C1485.46 785.287 1475.55 800.231 1470.6 807.448C1457.89 826.077 1443.97 844.07 1431.21 862.825C1413.42 888.773 1395.05 915.051 1376.15 939.525C1365.04 953.884 1338.82 957.111 1322.22 963.287C1277.5 979.933 1243.76 1017.55 1218.73 1057.32C1186.94 1107.92 1160.51 1161.87 1135 1215.77",
                        fill: "#EBF1F4"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1667.04 1218.88C1672.13 1158.77 1694.06 1093.56 1666 1036.96C1639.12 982.728 1573.74 979.526 1520.55 976.858C1518.32 976.858 1515.88 976.655 1513.34 976.604C1537.22 932.028 1565.73 887.324 1583.62 840.487C1610.15 771.005 1532.5 730.596 1475.96 717C1475.96 717 1485.03 758.577 1489.91 778.476C1485.46 785.287 1475.55 800.231 1470.6 807.448C1457.89 826.077 1443.97 844.07 1431.21 862.825C1413.42 888.773 1395.05 915.051 1376.15 939.525C1365.04 953.884 1338.82 957.111 1322.22 963.287C1277.5 979.933 1243.76 1017.55 1218.73 1057.32C1186.94 1107.92 1160.51 1161.87 1135 1215.77",
                        stroke: "#323130",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1526.88 783.25L1533.75 779.5",
                        stroke: "#323130",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1543.75 797.625L1550.62 794.5",
                        stroke: "#323130",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1508.75 818.25C1513.8 826.726 1535.22 829.187 1542.5 822.674",
                        stroke: "#323130",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M126.686 957.072C130.409 958.235 135.148 958.786 139.787 955.996C144.125 953.41 146.878 948.591 147.34 944.708C147.802 940.824 143.008 938.615 145.099 934.557C147.191 930.5 152.654 927.951 157.082 926.944C161.51 925.937 166.061 925.618 170.395 923.005C175.32 920.032 178.586 914.731 179.374 910.267",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M204.304 991.014C203.2 987.603 202.648 983.144 205.163 978.36C207.494 973.889 211.888 970.654 215.447 969.723C219.006 968.793 221.08 973.097 224.782 970.588C228.485 968.08 230.771 962.539 231.651 958.181C232.531 953.824 232.78 949.435 235.135 944.966C238.958 937.712 248.052 914.828 252.14 913.514",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M83.5864 953.103L90.9255 963.571",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M50.9066 935.291C51.7944 937.004 53.2072 938.354 54.9372 939.142",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M52.6674 958.96L58.5364 958.612",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M21.1598 981.578C20.4476 987.142 20.6149 993.485 24.6294 997.042C28.3561 1000.39 34.3944 999.978 38.9632 997.461C43.5319 994.944 45.2711 987.212 50.3172 986.586C55.3633 985.959 59.2388 990.736 61.1549 995.45C63.0709 1000.16 64.2135 1005.58 67.9701 1008.9C72.2448 1012.66 78.9281 1012.51 84.2229 1009.94C89.5177 1007.36 93.6679 1002.78 97.3566 998.137C101.494 992.94 105.283 987.465 108.697 981.755",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M10.0442 1029.74L17.942 1029.65",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M20.3975 1064.84C36.4305 1063.78 47.9198 1043.33 63.9412 1043.82",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M95.8788 1043.32C93.4215 1043.84 91.1127 1045.01 89.1856 1046.72",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M96.8299 1069.74C95.7437 1070.41 94.8152 1071.32 94.1209 1072.41C93.4265 1073.5 92.9861 1074.73 92.8361 1076",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M125.728 1065.05L116.337 1074.81C107.443 1084.05 94.4181 1101.28 96.8969 1109.54C99.3757 1117.8 111.943 1109.94 117.234 1108.86C111.636 1115.35 106.394 1122.77 105.336 1131.25C104.278 1139.73 108.721 1149.16 116.768 1150.68",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M194.077 942.892L159.754 980.555L134.108 1019.52",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M151.99 1043.44C151.583 1045.24 151.523 1047.08 151.812 1048.86C152.101 1050.64 152.733 1052.33 153.672 1053.83",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M189.391 1017.2C182.76 1029.49 175.917 1042.69 177.745 1056.26C178.415 1061.1 180.275 1067.05 183.469 1070.62C188.897 1076.74 199.573 1073.46 205.335 1067.13C207.1 1065.19 208.692 1062.76 208.455 1060.2C208.131 1057.05 204.929 1054.85 201.83 1054.88C198.671 1055.18 195.667 1056.62 193.35 1058.94C185.552 1065.95 177.636 1081.1 177.613 1093.7C177.59 1106.31 188.918 1110.98 194.75 1111.83C200.582 1112.68 207.483 1108.75 208.435 1102.71C208.711 1101.17 208.429 1099.61 207.642 1098.31C206.985 1097.49 206.146 1096.85 205.189 1096.43C204.232 1096.01 203.183 1095.83 202.125 1095.9C192.591 1095.91 185.759 1107.44 186.722 1117.15C187.685 1126.86 193.879 1134.83 199.828 1142.22",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M213.033 1029.21C212.502 1033.26 215.27 1036.98 218.705 1038.82C222.141 1040.66 226.169 1041.05 230.045 1041.58C235.384 1042.3 240.797 1043.4 245.496 1045.99C250.196 1048.58 254.1 1053.02 255.141 1058.45",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M227.125 1077.18C228.182 1079.19 229.905 1080.72 231.997 1081.52",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M310.041 806.111C310.987 821.101 309.94 839.698 309.765 854.635C309.725 857.658 308.958 861.488 305.809 861.81C304.632 861.834 303.447 861.566 302.369 861.03C294.843 857.961 287.678 854.046 281.038 849.374",
                        fill: "#0083CC"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M310.041 806.111C310.987 821.101 309.94 839.698 309.765 854.635C309.725 857.658 308.958 861.488 305.809 861.81C304.632 861.834 303.447 861.566 302.369 861.03C294.843 857.961 287.678 854.046 281.038 849.374",
                        stroke: "#2C2B2A",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M257.893 774.352C257.893 774.352 230.294 791.444 218.019 798.322C216.155 799.229 214.521 800.484 213.206 802.017C212.556 802.792 212.147 803.732 212.02 804.742C211.892 805.752 212.05 806.796 212.478 807.769C213.315 809.097 214.484 810.223 215.871 811.036C221.371 814.898 234.993 822.179 234.993 822.179",
                        fill: "#0083CC"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M257.893 774.352C257.893 774.352 230.294 791.444 218.019 798.322C216.155 799.229 214.521 800.484 213.206 802.017C212.556 802.792 212.147 803.732 212.02 804.742C211.892 805.752 212.05 806.796 212.478 807.769C213.315 809.097 214.484 810.223 215.871 811.036C221.371 814.898 234.993 822.179 234.993 822.179",
                        stroke: "#2C2B2A",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M230.481 814.343C230.59 808.429 235.024 802.02 237.918 796.386C242.204 788.201 246.744 780.155 251.538 772.246C280.581 724.355 318.507 682.171 363.652 647.543C367.299 644.759 373.074 642.128 376.47 645.682C378.405 647.733 378.305 650.679 378.006 653.287C374.227 685.476 361.322 715.435 347.53 744.439C330.39 780.457 311.595 815.883 287.457 847.801C286.245 849.406 281.67 848.974 279.721 847.917L238.156 825.363C232.357 822.21 230.42 818.407 230.481 814.343Z",
                        fill: "#DBEEF7",
                        stroke: "#2C2B2A",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M327.071 713.348L306.512 703.861L291.598 723.028L315.251 734.166L339.181 749.325L347.846 727.379L327.071 713.348Z",
                        fill: "#743C7A"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M277.344 797.76C269.754 811.04 252.359 836.281 252.359 836.281",
                        stroke: "#2C2B2A",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M269.938 851.889L265.562 864.831C265.485 865.2 265.261 865.517 264.934 865.719C264.718 865.772 264.488 865.777 264.261 865.735C264.035 865.692 263.818 865.603 263.626 865.473L224.976 846.534L236.503 833.527",
                        fill: "#D44C3A"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M269.938 851.889L265.562 864.831C265.485 865.2 265.261 865.517 264.934 865.719C264.718 865.772 264.488 865.777 264.261 865.735C264.035 865.692 263.818 865.603 263.626 865.473L224.976 846.534L236.503 833.527",
                        stroke: "#2C2B2A",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M250.427 889.824C250.018 885.485 249.843 881.146 249.902 876.822",
                        stroke: "#2C2B2A",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M228.81 899.106C229.865 890.148 232.012 881.401 235.211 873.032",
                        stroke: "#2C2B2A",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M224.751 862.907C219.77 868.772 213.823 873.819 207.112 877.876",
                        stroke: "#2C2B2A",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M348.887 726.064C336.886 714.624 321.835 706.497 305.573 702.676",
                        stroke: "#2C2B2A",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M339.221 751.475C324.316 739.883 307.536 730.71 289.644 724.373",
                        stroke: "#2C2B2A",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1467.12 196.871C1446.06 206.931 1441.7 199.199 1458.02 184.952C1441.08 170.607 1446.51 163.005 1467.32 171.691C1475.79 148.99 1483.5 150.721 1483.54 174.773C1505.39 174.303 1506.76 182.769 1484.06 190.436C1486.18 216.502 1481.96 214.696 1467.12 196.871Z",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M489.117 956.871C468.057 966.931 463.704 959.2 480.018 944.952C463.083 930.607 468.509 923.005 489.321 931.691C497.794 908.99 505.498 910.721 505.539 934.773C527.393 934.303 528.761 942.769 506.062 950.436C508.184 976.503 503.96 974.697 489.117 956.871Z",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M385.117 126.871C364.057 136.931 359.704 129.199 376.018 114.952C359.083 100.607 364.509 93.0047 385.321 101.691C393.794 78.9898 401.498 80.7207 401.539 104.773C423.393 104.303 424.761 112.769 402.062 120.436C404.184 146.502 399.96 144.696 385.117 126.871Z",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1638.12 473.871C1617.06 483.93 1612.7 476.199 1629.02 461.952C1612.08 447.607 1617.51 440.004 1638.32 448.691C1646.79 425.99 1654.5 427.72 1654.54 451.773C1676.39 451.303 1677.76 459.769 1655.06 467.436C1657.18 493.502 1652.96 491.696 1638.12 473.871Z",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M169.117 427.872C148.057 437.932 143.704 430.201 160.018 415.954C143.083 401.608 148.509 394.006 169.321 402.692C177.794 379.991 185.498 381.722 185.539 405.775C207.393 405.305 208.761 413.77 186.062 421.437C188.184 447.504 183.96 445.698 169.117 427.872Z",
                        stroke: "black",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_251_19310",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "1700",
                        height: "1080",
                        fill: "white"
                    })
                })
            })
        ]
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (LandingIllustration1);


/***/ }),

/***/ 97558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LandingIllustration2 */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);





var LandingIllustration2 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Icon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "1700",
        height: "1080",
        viewBox: "0 0 1700 1080",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_251_19494)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "1700",
                        height: "1080",
                        fill: "#CCE2EF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "-84",
                        y: "-50",
                        width: "4695",
                        height: "626",
                        fill: "#CCE2EF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M-129 1865.98C128.85 2039.48 463.949 2111.89 779.133 2090.47C1242.48 2059.24 1629.88 2060.45 2051.58 1865.98L2387.79 2117.04C2762.72 1944.15 3171.45 1766.89 3575.05 1854.24C3905.93 1925.9 4171.32 1579.04 4459.5 1756.75C4978.37 2076.44 5609.19 2206.63 6213 2129.24L6213 433.513C5650.23 183.831 5004.68 150.392 4415.95 332.487C3860.72 529.082 3495.02 -175.68 2920.32 -89.6871C2395.87 -11.2372 1721.82 463.856 1295.44 123.938C1113.33 -10.4826 940.572 242.217 747.599 123.938C484.335 -35.7466 178.221 -110.347 -129 -89.6874L-129 1865.98Z",
                        fill: "#99C6DF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M-129 1945.4C57.3001 2070.76 299.413 2123.09 527.138 2107.61C861.911 2085.04 1141.81 2085.91 1446.5 1945.4L1689.41 2126.81C1960.31 2001.88 2255.62 1873.79 2547.22 1936.91C2786.29 1988.69 2978.04 1738.06 3186.25 1866.47C3561.14 2097.47 4016.91 2191.54 4453.17 2135.62L4453.17 910.335C4046.56 729.921 3580.15 705.759 3154.78 837.336C2753.62 979.391 2489.4 470.148 2074.17 532.285C1695.25 588.97 1208.24 932.26 900.175 686.645C768.598 589.516 643.779 772.109 504.354 686.645C314.142 571.261 92.971 517.357 -129 532.285L-129 1945.4Z",
                        fill: "#66A9CE"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                        style: {
                            mixBlendMode: "lighten"
                        },
                        opacity: "0.6",
                        filter: "url(#filter0_f_251_19494)",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M594.324 -63.6133C663.615 -6.80759 760.135 96.831 1033.37 74.7026",
                                stroke: "#F7C76D",
                                strokeWidth: "19.3739"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M487.169 14.2607C611.863 91.7201 718.537 179.794 1050.44 165.374",
                                stroke: "#F7C76D",
                                strokeWidth: "19.3739"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M417 135.693C562.11 189.478 880.963 314.033 1123.45 227.45",
                                stroke: "#F7C76D",
                                strokeWidth: "19.3739"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M744.146 306.14C864.616 311.99 986.081 320.509 1109.86 316.971C1413.29 308.298 1098.52 308.367 1372.84 288.17",
                                stroke: "#F7C76D",
                                strokeWidth: "19.3739"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M993.541 384.828C1236.04 374.589 1472.87 364.94 1660.17 316.486",
                                stroke: "#F7C76D",
                                strokeWidth: "19.3739"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M1258.1 440.097C1529.82 441.919 1679.29 425.827 1844.34 366.613C1877 354.896 1909.82 343.92 1949.39 334.182",
                                stroke: "#F7C76D",
                                strokeWidth: "19.3739"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                d: "M1426.89 473.042C1545.75 458.387 1664.95 445.026 1777.12 426.301C2080.77 375.61 1737.43 428.629 1997.75 377.745",
                                stroke: "#F7C76D",
                                strokeWidth: "19.3739"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1196.32 234.022C1187.25 233.591 1176.68 232.186 1172.1 224.342C1169.88 220.025 1169.4 215.015 1170.77 210.354C1175.16 192.581 1199.31 183.15 1214.52 193.465C1208.81 183.377 1202.89 171.747 1206.4 160.706C1210.12 149.008 1223.9 142.57 1236.06 144.338C1248.21 146.107 1258.73 154.041 1266.66 163.313C1265 154.134 1266.45 144.661 1270.78 136.4C1275.12 128.14 1282.09 121.565 1290.59 117.72C1299.09 113.875 1308.63 112.98 1317.7 115.178C1326.76 117.376 1334.84 122.541 1340.63 129.852C1354.98 147.988 1351.97 174.241 1344.26 195.959C1352.69 192.898 1361.53 190.019 1370.49 190.767C1379.44 191.515 1388.62 196.82 1391.25 205.412C1394.34 215.432 1387.45 226.337 1378.24 231.37C1369.04 236.403 1358.16 236.992 1347.68 237.468C1297.33 239.735 1246.91 234.022 1196.32 234.022Z",
                        fill: "white",
                        stroke: "#323130",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M410 142.889C413.963 138.681 418.318 134.228 424.292 132.925C432.943 131.024 442.441 137.948 442.305 145.944C443.439 140.758 446.268 135.477 451.455 133.006C456.643 130.536 464.401 132.219 466.216 137.242",
                        stroke: "#323130",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M527.031 82.0997C532.986 80.7056 539.279 81.0233 545.022 83.0081C550.766 84.9929 555.672 88.5447 559.048 93.1635C559.602 89.196 561.662 85.5212 564.883 82.7589C568.104 79.9965 572.288 78.3158 576.728 78",
                        stroke: "#323130",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M511.831 158.121C513.635 155.256 516.014 152.716 518.848 150.628C521.873 148.727 525.957 147.912 529.163 149.46C530.461 150.191 531.549 151.186 532.338 152.366C533.126 153.545 533.593 154.875 533.7 156.248C533.914 158.974 533.539 161.712 532.596 164.311C533.222 160.893 534.556 157.61 536.528 154.632C538.706 151.781 542.487 149.65 546.283 150.193C550.079 150.736 553.119 154.754 551.365 157.836",
                        stroke: "#323130",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M623.825 109.033C628.997 111.422 631.523 116.798 632.687 121.916C633.852 127.034 634.2 132.409 636.68 137.12C638.576 133.845 641.233 130.974 644.471 128.7C647.708 126.426 651.452 124.803 655.449 123.938",
                        stroke: "#323130",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M731.69 142.414C737.111 141.948 742.548 143.146 747.114 145.811C751.679 148.476 755.103 152.452 756.826 157.089C758.768 153.487 761.764 150.427 765.493 148.234C769.223 146.041 773.545 144.799 778 144.641",
                        stroke: "#323130",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M328.528 307.649C335.485 307.8 343.041 307.8 348.647 303.787C357.51 297.522 357.222 284.626 353.721 274.628C350.774 266.174 345.634 257.87 337.369 253.922C329.104 249.974 317.427 252.162 313.394 260.209C306.902 238.623 297.507 216.952 280.357 201.782C263.207 186.612 236.728 179.553 216.099 189.874C195.47 200.194 187.095 230.641 203.646 246.498C194.783 235.362 178.409 228.517 165.114 234.267C151.819 240.018 147.698 261.045 160.129 268.405C154.499 266.433 148.404 266.064 142.565 267.342C136.726 268.619 131.387 271.49 127.18 275.615C122.748 280.12 119.757 286.622 121.508 292.608C124.344 302.35 136.863 305.311 147.255 306.341C207.48 312.22 268.103 306.319 328.528 307.649Z",
                        fill: "white",
                        stroke: "#323130",
                        strokeWidth: "6",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1576.38 36.1715C1588.2 30.6349 1601.51 29.1564 1614.25 31.966C1620.57 33.4256 1626.5 36.2289 1631.63 40.185C1636.77 44.1411 1640.99 49.1573 1644.02 54.8922C1645.82 58.6313 1647.14 62.582 1647.96 66.6513C1652.22 87.291 1644.91 110.258 1628.62 123.65C1612.33 137.043 1587.53 139.574 1569.42 128.672C1542.43 112.34 1541.06 72.5104 1558.99 49.0534C1563.56 43.3134 1569.56 38.8719 1576.38 36.1715V36.1715Z",
                        fill: "#F7C76D",
                        stroke: "#323130",
                        strokeWidth: "8.16605",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1476 121.772C1483.59 119.075 1491.31 116.772 1499.13 114.872",
                        stroke: "#323130",
                        strokeWidth: "8.16605",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1476 22.4111C1483.36 24.8055 1490.86 26.8497 1498.46 28.5356",
                        stroke: "#323130",
                        strokeWidth: "8.16605",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1525.56 195.898L1537.87 181.139",
                        stroke: "#323130",
                        strokeWidth: "8.16605",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1633.62 180.795C1634.76 187.943 1636.28 195.022 1638.2 202",
                        stroke: "#323130",
                        strokeWidth: "8.16605",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1689.87 139.268L1707.3 152.273",
                        stroke: "#323130",
                        strokeWidth: "8.16605",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M1690.36 4.0376L1706.69 -10.253",
                        stroke: "#323130",
                        strokeWidth: "8.16605",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("filter", {
                        id: "filter0_f_251_19494",
                        x: "349.633",
                        y: "-535.051",
                        width: "3816.72",
                        height: "1118.76",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("feGaussianBlur", {
                                stdDeviation: "32",
                                result: "effect1_foregroundBlur_251_19494"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                        id: "clip0_251_19494",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            width: "1700",
                            height: "1080",
                            fill: "white"
                        })
                    })
                ]
            })
        ]
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (LandingIllustration2);


/***/ }),

/***/ 92115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LandingIllustration3 */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40643);





var LandingIllustration3 = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_2__.Icon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "1700",
        height: "1080",
        viewBox: "0 0 1700 1080",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("g", {
                clipPath: "url(#clip0_251_19371)",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "1700",
                        height: "1080",
                        fill: "#CDB9CF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        x: "1137",
                        y: "196",
                        width: "3468",
                        height: "1283",
                        fill: "#CDB9CF"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M2956.22 -795.237C2815.02 -786.808 2430.34 -550.805 2312.11 -451.229C2181.82 -341.611 1980.8 -138.129 1871.36 -1.80814C1748.58 151.085 1602.85 315.932 1445.42 384.524C1277.31 457.795 1110.05 455.893 944.698 359.783C779.347 263.672 683.836 57.1113 675.36 -174.781C668.058 -373.36 806.229 -692.727 948.123 -803.522L960.26 -820.107L-25.0109 -831.307L-48.1602 -802.486C-536.43 -240.907 -430.484 981.808 106.288 1472.15C413.053 1751.93 761.681 1775.67 1124.9 1703.31C1432.8 1641.96 1672.18 1437.46 1930.76 1236.66C2206.22 1022.69 2466.03 787.446 2750.65 586.95C2997.93 413.369 3365.59 307.904 3724.48 374.658C4083.38 441.413 4239.39 633.684 4325.35 849.88L4330.14 859.532L4348.79 -781.589L2961.86 -797.354L2956.22 -795.237Z",
                        fill: "#FBC262"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        d: "M3252.22 -1738.24C3111.02 -1729.81 2726.34 -1493.81 2608.11 -1394.23C2477.82 -1284.61 2276.8 -1081.13 2167.36 -944.808C2044.58 -791.915 1898.85 -627.068 1741.42 -558.476C1573.31 -485.205 1406.05 -487.107 1240.7 -583.217C1075.35 -679.328 979.836 -885.889 971.36 -1117.78C964.058 -1316.36 1102.23 -1635.73 1244.12 -1746.52L1256.26 -1763.11L270.989 -1774.31L247.84 -1745.49C-240.43 -1183.91 -134.484 38.8085 402.288 529.152C709.053 808.933 1057.68 832.673 1420.9 760.312C1728.8 698.956 1968.18 494.456 2226.76 293.665C2502.22 79.687 2762.03 -155.554 3046.65 -356.05C3293.93 -529.631 3661.59 -635.096 4020.48 -568.342C4379.38 -501.587 4535.39 -309.316 4621.35 -93.1201L4626.14 -83.468L4644.79 -1724.59L3257.86 -1740.35L3252.22 -1738.24Z",
                        fill: "#FBB75E"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("defs", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("clipPath", {
                    id: "clip0_251_19371",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                        width: "1700",
                        height: "1080",
                        fill: "white"
                    })
                })
            })
        ]
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (LandingIllustration3);


/***/ }),

/***/ 21838:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ LANDING_HERO_CARDS; }
/* harmony export */ });
var LANDING_HERO_CARDS = [
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/productivity_hacks.png",
        name: "Productivity Hacks"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/think_outside_the_box.png",
        name: "Think Outside the Box"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/managing_time_like_a_pro.png",
        name: "Manage Time Like a Pro"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/how_to_be_more_mindful.png",
        name: "How to be More Mindful"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/the_glorification_of_busy.png",
        name: "Be Productive"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/top_7_ted_talks_in_customer_success.png",
        name: "TED Talks"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/7_days_with_seth_godin.png",
        name: "Marketing with Seth Godin"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/top_7_books_for_product_managers.png",
        name: "Stoic Life"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/how_to_start_investing_today.png",
        name: "Learn to Invest"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/managing_email_efficiently.png",
        name: "Managing Email Efficiently"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/sleep_better.png",
        name: "Sleep Better"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/how_to_be_happy.png",
        name: "How to be Happy"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/elon_musk.png",
        name: "Inside the Mind of Elon Musk"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/da_vinci.png",
        name: "The Genius of DaVinci"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/charisma.png",
        name: "Learn Charisma"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/vulnerable.png",
        name: "Avoid Bad Habits"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/recover_burnout.png",
        name: "Recover from Burnout"
    },
    {
        imageUrl: "https://audio.deepstash.com/covers/collection/202304/joining_a_new_team.png",
        name: "Joining a New Team"
    }, 
];


/***/ }),

/***/ 3015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export PhoneFrame */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var PhoneFrame = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.memo(function(props) {
    var _width, ref, _height, ref1, _backgroundColor;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Icon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: (ref = (_width = props.width) !== null && _width !== void 0 ? _width : props.w) !== null && ref !== void 0 ? ref : 479,
        height: (ref1 = (_height = props.height) !== null && _height !== void 0 ? _height : props.h) !== null && ref1 !== void 0 ? ref1 : 1014,
        viewBox: "0 0 479 1014",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        backgroundColor: "unset",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "8",
                y: "8",
                width: "463",
                height: "998",
                rx: "56",
                stroke: "#323130",
                strokeWidth: "16",
                fill: (_backgroundColor = props.backgroundColor) !== null && _backgroundColor !== void 0 ? _backgroundColor : ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M143 15H335V27.9632C335 39.0292 326.029 48 314.963 48H163.037C151.971 48 143 39.0292 143 27.9632V15Z",
                fill: "#323130"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M191 0H287V3.94937C287 5.36722 287 6.07615 286.724 6.6177C286.481 7.09406 286.094 7.48135 285.618 7.72407C285.076 8 284.367 8 282.949 8H195.051C193.633 8 192.924 8 192.382 7.72407C191.906 7.48135 191.519 7.09406 191.276 6.6177C191 6.07615 191 5.36722 191 3.94937V0Z",
                fill: "#605E5C"
            })
        ]
    }));
});
/* harmony default export */ __webpack_exports__["Z"] = (PhoneFrame);


/***/ }),

/***/ 16923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ special_offer_SpecialOfferBannerWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__(36808);
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);
// EXTERNAL MODULE: ./src/providers/hooks/useAuth.ts + 1 modules
var useAuth = __webpack_require__(79139);
// EXTERNAL MODULE: ./src/providers/hooks/useProfile.ts
var useProfile = __webpack_require__(2334);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/types/enums.ts
var enums = __webpack_require__(41390);
// EXTERNAL MODULE: ./node_modules/deepstash-ui/esm/index.js + 78 modules
var esm = __webpack_require__(40643);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/providers/hooks/useNsi.ts
var useNsi = __webpack_require__(9182);
// EXTERNAL MODULE: ./src/services/analytics/index.ts
var analytics = __webpack_require__(62687);
// EXTERNAL MODULE: ./src/components/image/NextImage.tsx + 11 modules
var NextImage = __webpack_require__(91260);
// EXTERNAL MODULE: ./src/components/paywall/paywall-checkout-modal/usePaymentCheckoutModal.tsx
var usePaymentCheckoutModal = __webpack_require__(68415);
// EXTERNAL MODULE: ./src/utils/global.ts
var global = __webpack_require__(63069);
// EXTERNAL MODULE: ./src/utils/strings/actionStrings.ts
var actionStrings = __webpack_require__(89134);
;// CONCATENATED MODULE: ./src/page-components/special-offer/SpecialOfferBanner.tsx













var SpecialOfferBanner = function(param) {
    var sale = param.sale, onCloseCb = param.onCloseCb;
    var isMobileView = (0,esm.useIsMobileView)();
    var router = (0,next_router.useRouter)();
    var profile = (0,useProfile/* default */.Z)().profile;
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var couponCode = sale.couponCode, iconUrl = sale.iconUrl, mobileCta = sale.mobileCta, style = sale.style, title = sale.title, url = sale.url;
    var onClose = function(e) {
        e.stopPropagation();
        onCloseCb();
    };
    var icon = !!iconUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* default */.Z, {
        wrapperStyle: {
            width: isMobileView ? 36 : 48,
            height: isMobileView ? 36 : 48,
            pointerEvents: "none"
        },
        objectFit: "contain",
        imageUrl: iconUrl
    }) : null;
    var ref = (0,usePaymentCheckoutModal/* default */.Z)({
        purchaseType: "1 YEAR",
        promoCode: couponCode,
        analyticsLocation: "global-bottom-banner"
    }), checkoutModal = ref.checkoutModal, onOpenCheckoutModal = ref.onOpenCheckoutModal, subscriptionIntentRequestStatus = ref.subscriptionIntentRequestStatus;
    var nsiDispatch = (0,useNsi/* default */.Z)().nsiDispatch;
    var onStartPriceClick = (0,react.useCallback)(function() {
        if (isLoggedIn) {
            onOpenCheckoutModal();
        } else {
            nsiDispatch({
                type: "openAuth",
                payload: {
                    type: "sign-up",
                    shouldSkipOnboarding: true,
                    discountCode: couponCode,
                    onAuthSuccess: function(_profile) {
                        isMobileView && router.push(url);
                    }
                }
            });
        }
    }, [
        profile === null || profile === void 0 ? void 0 : profile.subscriptionType,
        nsiDispatch,
        isLoggedIn,
        onOpenCheckoutModal
    ]);
    var _textColor;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            checkoutModal,
            !isLoggedIn || (profile === null || profile === void 0 ? void 0 : profile.subscriptionType) !== enums/* UserSubscriptionType.Premium */.A5.Premium ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                left: "50%",
                transform: "translateX(-50%)",
                width: {
                    base: "calc(100% - 2rem)",
                    md: (0,global/* getRemWidthFromColumns */._P)(6),
                    lg: (0,global/* getRemWidthFromColumns */._P)(10)
                },
                onClick: function() {
                    analytics/* Analytics.logEvent */.c.logEvent({
                        eventName: analytics/* Events.payments.clickOfferBanner */.z.payments.clickOfferBanner,
                        properties: {
                            location: router.asPath
                        },
                        platforms: [
                            "amplitude"
                        ]
                    });
                    onStartPriceClick();
                },
                cursor: "pointer",
                boxShadow: "0px 6px 16px rgba(19, 19, 19, 0.8); 0px 8px 4px rgba(19, 19, 19, 0.4);",
                position: "fixed",
                justifyContent: "space-between",
                borderRadius: "1rem",
                zIndex: 1000,
                bottom: esm.spacing.M.rem,
                backgroundColor: style.backgroundColor,
                alignItems: "center",
                p: esm.spacing.M.rem,
                m: {
                    base: esm.spacing.toRem(4),
                    md: esm.spacing.M.rem
                },
                color: (_textColor = style.textColor) !== null && _textColor !== void 0 ? _textColor : esm.color.light.textInverted,
                border: "2px solid ".concat(style.borderColor),
                flexDirection: {
                    base: "column",
                    md: "row"
                },
                children: [
                    !isMobileView && /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        gridGap: 8,
                        children: [
                            icon,
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                                flexDirection: "column",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                                        fontSize: {
                                            base: "1rem",
                                            md: "1rem"
                                        },
                                        opacity: 0.9,
                                        fontWeight: 500,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            style: {
                                                fontWeight: 700,
                                                color: style.accentColor
                                            },
                                            children: title
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                                        fontSize: {
                                            base: "1.5rem",
                                            md: "1.5rem"
                                        },
                                        fontWeight: 700,
                                        children: "67% OFF | 1-Year Pro Subscription"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Flex, {
                        w: isMobileView ? "100%" : "auto",
                        alignItems: "center",
                        gridGap: esm.spacing.XS.rem,
                        children: [
                            isMobileView && icon,
                            subscriptionIntentRequestStatus === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Spinner, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Flex, {
                                alignItems: "center",
                                justifyContent: "center",
                                padding: 8,
                                paddingX: 12,
                                borderRadius: 16,
                                backgroundColor: "transparent",
                                flex: 1,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Text, {
                                    color: style.textColor,
                                    fontSize: {
                                        base: "1.25rem",
                                        md: "1.25rem"
                                    },
                                    fontWeight: 600,
                                    children: isMobileView ? mobileCta : actionStrings/* default.claimOffer */.Z.claimOffer
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                style: {
                                    color: esm.color.dark.text,
                                    opacity: 0.4,
                                    marginLeft: esm.spacing.XXS.rem,
                                    marginRight: esm.spacing.XXS.rem
                                },
                                children: "|"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.CloseSvg, {
                                onClick: onClose
                            })
                        ]
                    })
                ]
            }) : null
        ]
    });
};
/* harmony default export */ var special_offer_SpecialOfferBanner = (SpecialOfferBanner);

;// CONCATENATED MODULE: ./src/page-components/special-offer/SpecialOfferBannerWrapper.tsx







var SALES = {
    easter: {
        couponCode: "EASTER2549",
        iconUrl: "https://static.deepstash.com/illustrations/paywall_price_icon_bunny.svg",
        style: {
            backgroundColor: "#EE6F68",
            borderColor: "#278E7C",
            accentColor: "#FFE7E5",
            textColor: "#FFFFFF"
        },
        url: "/easter",
        title: "Easter is Here! Grab the sales!",
        mobileCta: "View the Easter Offer"
    },
    "mothers-day": {
        couponCode: "MOTHER2549",
        iconUrl: "https://static.deepstash.com/illustrations/paywall_price_icon_mother.svg",
        style: {
            backgroundColor: "#FCECE8",
            borderColor: "#EE717B",
            accentColor: "#EE717B",
            textColor: "#D25E68"
        },
        url: "/mothers-day",
        title: "Celebrating all mothers around the world...",
        mobileCta: "View our Mother's Day Offer"
    },
    "fathers-day": {
        couponCode: "FATHER2549",
        iconUrl: "https://static.deepstash.com/illustrations/paywall_price_icon_father.svg",
        style: {
            backgroundColor: "#E1F3FB",
            borderColor: "#186D9C",
            accentColor: "#2C83B3",
            textColor: "#186D9C"
        },
        url: "/fathers-day",
        title: "Celebrating all fathers around the world...",
        mobileCta: "View our Father's Day Offer"
    },
    "independence-day": {
        couponCode: "INDEPENDENCE2549",
        iconUrl: "https://static.deepstash.com/illustrations/paywall_price_icon_eagle.svg",
        style: {
            backgroundColor: "#16385D",
            borderColor: "#CF1715",
            accentColor: "#D5E5ED",
            textColor: "#FFFFFF"
        },
        url: "/independence-day",
        title: "In the name of independence...",
        mobileCta: "View the Independence Day Offer"
    },
    autumn: {
        couponCode: "AUTUMN2549",
        iconUrl: "https://static.deepstash.com/illustrations/paywall_price_icon_autumn_leaves.svg",
        style: {
            backgroundColor: "#D05034",
            borderColor: "#89441E",
            accentColor: "#FFFFFF",
            textColor: "#FFFFFF"
        },
        url: "/autumn-special",
        title: "Autumn is here! Grab the sales!",
        mobileCta: "View our Autumn Sale Offer"
    },
    halloween: {
        couponCode: "HALLOWEEN2549",
        iconUrl: "https://static.deepstash.com/illustrations/paywall_price_icon_halloween.svg",
        style: {
            backgroundColor: "#FEF0C7",
            borderColor: "#F79009",
            accentColor: "#F79009",
            textColor: "#3B3F44"
        },
        url: "/halloween",
        title: "Boo! Prices so low they will scare you!",
        mobileCta: "View our Halloween Offer"
    },
    "black-friday": {
        couponCode: "BLACKFRIDAY2529",
        iconUrl: "https://static.deepstash.com/illustrations/paywall_price_icon_black_friday.svg",
        style: {
            backgroundColor: "#000000",
            borderColor: "#A43832",
            accentColor: "#A43832",
            textColor: "#FFFFFF"
        },
        url: "/blackfriday24",
        title: "Black Friday is here!",
        mobileCta: "View our Black Friday Offer"
    },
    christmas: {
        couponCode: "HOLIDAYS2549",
        iconUrl: "https://static.deepstash.com/illustrations/paywall_price_icon_xmas.svg",
        style: {
            backgroundColor: "#D92D20",
            borderColor: "#FFFFFF",
            accentColor: "#FFFFFF",
            textColor: "#FFFFFF"
        },
        url: "/xmas",
        title: "Deck the halls with microlearning!",
        mobileCta: "View our Christmas Offer"
    },
    "new-year": {
        couponCode: "NEWYEARS2649",
        iconUrl: "https://static.deepstash.com/illustrations/paywall_price_icon_nye.svg",
        style: {
            backgroundColor: "#1E1640",
            borderColor: "#FFA600",
            accentColor: "#FFA600",
            textColor: "#FFFFFF"
        },
        url: "/new-year-offer",
        title: "Kickstart 2025 with a strong microlearning habit!",
        mobileCta: "View our New Year Offer"
    }
};
var SALE_TIMELINE = [
    {
        sale: SALES.easter,
        start: new Date("2025-04-14T00:00:00"),
        end: new Date("2025-04-21T00:00:00")
    },
    {
        sale: SALES["mothers-day"],
        start: new Date("2025-05-01T00:00:00"),
        end: new Date("2025-05-07T00:00:00")
    },
    {
        sale: SALES["fathers-day"],
        start: new Date("2025-06-12T00:00:00"),
        end: new Date("2025-06-18T00:00:00")
    },
    {
        sale: SALES["independence-day"],
        start: new Date("2025-07-01T00:00:00"),
        end: new Date("2025-07-09T00:00:00")
    },
    {
        sale: SALES["autumn"],
        start: new Date("2025-09-04T00:00:00"),
        end: new Date("2025-09-11T00:00:00")
    },
    {
        sale: SALES["halloween"],
        start: new Date("2025-10-27T00:00:00"),
        end: new Date("2025-11-03T00:00:00")
    },
    {
        sale: SALES["black-friday"],
        start: new Date("2025-11-24T00:00:00"),
        end: new Date("2025-12-07T00:00:00")
    },
    {
        sale: SALES["christmas"],
        start: new Date("2025-12-20T00:00:00"),
        end: new Date("2025-12-27T00:00:00")
    },
    {
        sale: SALES["new-year"],
        start: new Date("2025-12-30T00:00:00"),
        end: new Date("2026-01-06T00:00:00")
    }, 
];
var getCurrentSale = function(currentDate) {
    var currentSale = undefined;
    for(var i = 0; i < SALE_TIMELINE.length; i++){
        var nextSale = SALE_TIMELINE[i];
        if (nextSale.start <= currentDate && nextSale.end > currentDate) {
            currentSale = nextSale.sale;
            break;
        }
    }
    return currentSale;
};
var SpecialOfferBannerWrapper = function() {
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var profile = (0,useProfile/* default */.Z)().profile;
    var isLoggedIn = (0,useAuth/* default */.Z)().isLoggedIn;
    var ref1 = (0,react.useRef)(getCurrentSale(new Date())), currentSale = ref1.current;
    (0,react.useEffect)(function() {
        if (!js_cookie_default().get("special_offer_banner_seen")) setIsVisible(true);
    }, [
        js_cookie_default().get("special_offer_banner_seen")
    ]);
    var onCloseCb = function() {
        // Only hide it for a day is the user is logged in
        isLoggedIn && js_cookie_default().set("special_offer_banner_seen", "true", {
            expires: 1 / 24
        });
        setIsVisible(false);
    };
    if (!isVisible) return null;
    // Do not show the banner if:
    // the user is not logged in
    // OR the user is Pro
    // OR there is no active sale
    return currentSale && (!isLoggedIn || // profile?.promotionalSale ||
    (profile === null || profile === void 0 ? void 0 : profile.subscriptionType) !== enums/* UserSubscriptionType.Premium */.A5.Premium) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(special_offer_SpecialOfferBanner, {
        onCloseCb: onCloseCb,
        sale: currentSale
    }) : null;
};
/* harmony default export */ var special_offer_SpecialOfferBannerWrapper = (SpecialOfferBannerWrapper);


/***/ }),

/***/ 96546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ LayoutContext; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var LayoutContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.createContext)({
    remeasureLayoutCallbackRef: undefined
});
LayoutContext.displayName = "LayoutContext";
var LayoutProvider = function(param) {
    var remeasureLayoutCallback = param.remeasureLayoutCallback, children = param.children;
    var remeasureLayoutCallbackRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(remeasureLayoutCallback);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        remeasureLayoutCallbackRef.current = remeasureLayoutCallback;
    }, [
        remeasureLayoutCallback
    ]);
    var layoutProviderState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            remeasureLayoutCallbackRef: remeasureLayoutCallbackRef
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LayoutContext.Provider, {
        value: layoutProviderState,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LayoutProvider);


/***/ }),

/***/ 76476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ProBadgeSvg; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var deepstash_ui__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(40643);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);





var SvgComponent = function(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(deepstash_ui__WEBPACK_IMPORTED_MODULE_1__.Icon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "47",
        height: "24",
        viewBox: "0 0 47 24",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.000244141",
                y: "6.10352e-05",
                width: "46.1538",
                height: "24",
                rx: "7.38461",
                fill: "url(#paint0_linear_1602_3040)"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "0.000244141",
                y: "6.10352e-05",
                width: "46.1538",
                height: "24",
                rx: "7.38461",
                fill: "url(#paint1_linear_1602_3040)",
                fillOpacity: "0.4"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M10.1175 17.7734H7.45908V7.2559H12.1446C13.1969 7.2559 14.0388 7.38329 14.6702 7.63806C15.3015 7.89283 15.7557 8.30821 16.0326 8.88421C16.3095 9.46021 16.448 10.2411 16.448 11.227C16.448 12.1574 16.3095 12.9162 16.0326 13.5033C15.7557 14.0793 15.3015 14.5057 14.6702 14.7827C14.0388 15.0596 13.1969 15.1981 12.1446 15.1981H10.1175V17.7734ZM11.7126 9.43252H10.1175V13.0214H11.7126C12.4991 13.0214 13.0252 12.8885 13.2911 12.6227C13.5569 12.3568 13.6898 11.8916 13.6898 11.227C13.6898 10.5956 13.5569 10.1414 13.2911 9.86452C13.0252 9.57652 12.4991 9.43252 11.7126 9.43252ZM20.5184 17.7734H17.8599V7.2559H22.8778C24.1959 7.2559 25.1541 7.55498 25.7522 8.15314C26.3614 8.74021 26.6661 9.60975 26.6661 10.7617C26.6661 11.6257 26.4501 12.3679 26.0181 12.9882C25.5861 13.5974 25.0156 13.9796 24.3067 14.1347L24.2901 14.1845C24.567 14.3617 24.8716 14.6553 25.2039 15.0651C25.5362 15.475 25.863 15.9236 26.1842 16.411C26.5165 16.8873 26.8101 17.3359 27.0648 17.7568V17.7734H23.9744L22.1799 15.115C22.0248 14.8824 21.8974 14.7162 21.7978 14.6165C21.7091 14.5168 21.5984 14.4559 21.4654 14.4337C21.3436 14.4116 21.1442 14.4005 20.8673 14.4005H20.5184V17.7734ZM22.4458 9.4159H20.5184V12.2405H22.4458C22.9996 12.2405 23.3818 12.1297 23.5922 11.9082C23.8138 11.6867 23.9245 11.3267 23.9245 10.8282C23.9245 10.3297 23.8138 9.96975 23.5922 9.74821C23.3818 9.52667 22.9996 9.4159 22.4458 9.4159ZM28.2367 12.5064C28.2367 11.1661 28.3863 10.1027 28.6853 9.31621C28.9955 8.52975 29.5217 7.96483 30.2638 7.62144C31.017 7.27806 32.0638 7.10637 33.4041 7.10637C34.4121 7.10637 35.2484 7.20052 35.913 7.38883C36.5776 7.57714 37.1038 7.88175 37.4915 8.30267C37.8792 8.7236 38.1506 9.28298 38.3056 9.98083C38.4718 10.6676 38.5549 11.5094 38.5549 12.5064C38.5549 13.5144 38.4718 14.3673 38.3056 15.0651C38.1506 15.7519 37.8792 16.3057 37.4915 16.7267C37.1038 17.1476 36.5776 17.4522 35.913 17.6405C35.2484 17.8288 34.4121 17.923 33.4041 17.923C32.3961 17.923 31.5598 17.8288 30.8952 17.6405C30.2306 17.4522 29.7044 17.1476 29.3167 16.7267C28.929 16.3057 28.6521 15.7519 28.486 15.0651C28.3198 14.3673 28.2367 13.5144 28.2367 12.5064ZM33.4041 15.5968C34.113 15.5968 34.6447 15.5082 34.9992 15.331C35.3536 15.1537 35.5918 14.8436 35.7136 14.4005C35.8355 13.9464 35.8964 13.315 35.8964 12.5064C35.8964 11.7088 35.8355 11.0885 35.7136 10.6454C35.5918 10.2024 35.3536 9.89221 34.9992 9.71498C34.6447 9.52667 34.113 9.43252 33.4041 9.43252C32.7063 9.43252 32.1746 9.52667 31.809 9.71498C31.4546 9.89221 31.2109 10.2024 31.078 10.6454C30.9561 11.0885 30.8952 11.7088 30.8952 12.5064C30.8952 13.315 30.9561 13.9464 31.078 14.4005C31.2109 14.8436 31.4546 15.1537 31.809 15.331C32.1746 15.5082 32.7063 15.5968 33.4041 15.5968Z",
                fill: "white"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "1.00024",
                y: "1.00006",
                width: "44.1538",
                height: "22",
                rx: "6.38461",
                stroke: "black",
                strokeOpacity: "0.2",
                strokeWidth: "2"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint0_linear_1602_3040",
                        x1: "14.9944",
                        y1: "21.3552",
                        x2: "24.5515",
                        y2: "-0.556791",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "0.0001",
                                stopColor: "#9B07F6"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "1",
                                stopColor: "#0085FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("linearGradient", {
                        id: "paint1_linear_1602_3040",
                        x1: "0.225161",
                        y1: "3.64503",
                        x2: "17.834",
                        y2: "33.9144",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                stopColor: "white",
                                stopOpacity: "0.5"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "0.131313",
                                stopColor: "white",
                                stopOpacity: "0.82"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "0.208333",
                                stopColor: "white"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "0.28125",
                                stopColor: "white",
                                stopOpacity: "0.78"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("stop", {
                                offset: "0.612059",
                                stopColor: "white",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    }));
};
var ProBadgeSvg = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_2__.memo(SvgComponent);


/***/ }),

/***/ 74277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gw": function() { return /* binding */ PRODUCT_HUNT_COLLECTIONS; },
/* harmony export */   "Ip": function() { return /* binding */ LANDING_PAGE_SOURCES; },
/* harmony export */   "LX": function() { return /* binding */ LANDING_PAGE_REVIEWS; },
/* harmony export */   "Qq": function() { return /* binding */ LANDING_PAGE_COLLECTIONS; },
/* harmony export */   "fG": function() { return /* binding */ LANDING_PAGE_IDEAS; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* eslint-disable @typescript-eslint/ban-ts-comment */ // Landing Page Data
// @ts-nocheck


// Reviews
var LANDING_PAGE_REVIEWS = [
    {
        id: 0,
        name: "samz905",
        title: "Amazing quick bites for the inquisitive!",
        text: "Don’t look further if you love learning new things. A refreshing concept that provides quick ideas for busy thought leaders.",
        platform: "ios",
        imageUrl: "https://static.deepstash.com/profile/1.png"
    },
    {
        id: 1,
        name: "Shankul Varada",
        text: "Best app ever! You heard it right. This app has helped me get back on my quest to get things done while equipping myself with knowledge everyday.",
        platform: "ios",
        imageUrl: "https://static.deepstash.com/profile/3.png"
    },
    {
        id: 2,
        name: "Ashley Anthony",
        text: "This app is LOADED with RELEVANT, HELPFUL, AND EDUCATIONAL material. It is creatively intellectual, yet minimal enough to not overstimulate and create a learning block. I am exceptionally impressed with this app!",
        platform: "ios",
        imageUrl: "https://static.deepstash.com/profile/4.png"
    },
    {
        id: 3,
        name: "Sean Green",
        text: "Great interesting short snippets of informative articles. Highly recommended to anyone who loves information and lacks patience.",
        platform: "ios",
        imageUrl: "https://static.deepstash.com/profile/5.png"
    },
    {
        id: 4,
        name: "Ghazala Begum",
        text: "Even five minutes a day will improve your thinking. I've come across new ideas and learnt to improve existing ways to become more motivated, confident and happier.",
        platform: "android",
        imageUrl: "https://lh3.googleusercontent.com/a-/AOh14GjGXBdpXBkYWavU_Uy3PadRBt5l3aKV2hykiihLSA"
    },
    {
        id: 5,
        name: "Giovanna Scalzone",
        text: "Brilliant. It feels fresh and encouraging. So many interesting pieces of information that are just enough to absorb and apply. So happy I found this.",
        platform: "android",
        imageUrl: "https://lh3.googleusercontent.com/a-/AOh14Gim03kWuEM_Hnc1RB0XaLF-N9TVHYIZT4NaN0XB7w"
    },
    {
        id: 6,
        name: "Laetitia Berton",
        text: "I have only been using it for a few days now, but I have found answers to questions I had never consciously formulated, or to problems I face everyday at work or at home. I wish I had found this earlier, highly recommended!",
        platform: "android",
        imageUrl: "https://lh3.googleusercontent.com/a-/AOh14GiaxpWuIcuvSwV5Qng0f2F7CGGU6scPXWl1TZ77Lg"
    },
    {
        id: 7,
        name: "Jamyson Haug",
        text: "Great for quick bits of information and interesting ideas around whatever topics you are interested in. Visually, it looks great as well.",
        platform: "android",
        imageUrl: "https://lh3.googleusercontent.com/a-/AOh14GimAQUHXLihNV5EZsOSmLA9BXGg-9kmoDNmV5kruA"
    }, 
];
var LANDING_PAGE_IDEAS = [
    [
        {
            title: "Habits are mental shortcuts",
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: "A habit is a routine or behavior that is carried out repeatedly and most of the time automatically."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "When you are faced with a problem repeatedly, your brain starts to automate the process of solving it.",
                    " ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: "Your habits are sets of automatic solutions that solve the problems you come across regularly."
                    })
                ]
            })
        },
        {
            title: "Focus on systems, not on goals",
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: "Goals are good for establishing a direction, but systems are best for making progress."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "Goals are about the results you hope to reach. Systems are about the mechanisms that lead to those results."
                ]
            })
        }, 
    ],
    [
        {
            title: "Specialization is for Insects",
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    "You have one life. We tend to define people by a few narrow identities, ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: "but humans are broader then that."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "We are creators, parents, partners etc. Putting people in boxes goes against human nature."
                ]
            })
        },
        {
            title: "Read for Understanding",
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    "Books read is a vanity metric, a signal for intellect, but a weak one.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "You should ",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: "read books for understanding"
                    }),
                    ". If a book looses your interest, drop it."
                ]
            })
        }, 
    ],
    [
        {
            title: "How To Read 1000 Books A Year?",
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    "Reading thousands of books in a year isn't a tough job. To do this it's not necessary to be a smart or advanced reader. You just need to follow these steps:",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "Fill the funnel"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "Make it effortless"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "The blog post mindset"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                children: "Go deep"
                            })
                        ]
                    })
                ]
            })
        },
        {
            title: "1. Fill The Funnel",
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    "If we wanto read more books, then we need to have loads and loads of books coming into the top of our funnel.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "This means when we have tonnes of books that we're checking out, and only later are we deciding, if it's the book that we're actually want to read properly.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "A simple way to start doing this is to start reading summaries of the books first and filter out what really connects to you!"
                ]
            })
        }, 
    ],
    [
        {
            title: "What If Thoughts Came But Didn’t Go?",
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: "Imagine if you could take a pill that would double your intelligence. What would that feel like?"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: "You’d be able to keep more thoughts in your head. You could draw new connections between ideas. You could solve problems you’ve been stuck on for years."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "Such a pill may not exist, but there already is a cognitive enhancing tool, and it doesn’t require brain-altering drugs."
                ]
            })
        },
        {
            title: "Intelligence, Our RAM And The n-Back Task",
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: "Cognitive scientists believe that working memory is one of the major components of intelligence. Working memory (WM) is like the RAM for your mind. It consists of all the things you’re keeping in mind simultaneously."
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "A common test of working memory is the n-back task. In this test, experimenters will repeat a string of digits and then, at a random point, ask you to recall the input from n steps previously."
                ]
            })
        }, 
    ],
    [
        {
            title: "The Pleasure Of Doomscrolling",
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    "Humans are fascinated by bad news. The appeal of ‘wrong’ is a striking psychological phenomenon that baffles many researchers.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "Just like we cannot look away from a car accident happening in front of our eyes, doomscrolling or endlessly scrolling through news feeds and social media content can feel soothing."
                ]
            })
        },
        {
            title: "Sucked In A Vortex Of Information",
            content: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    "Doomscrolling is a modern equivalent of the late-night 11 o’clock news that many families watched before going to sleep.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "People find a topic and then get sucked in a vortex of information, provided by never-ending news cycles.",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("b", {
                        children: "We are biologically driven towards attending to our worried mind and searching for answers about the things we are afraid of."
                    })
                ]
            })
        }, 
    ], 
];
// Sources
var LANDING_PAGE_SOURCES = [
    {
        author: "James Clear",
        blocks: [],
        content: "",
        context: "",
        created_at: "2022-01-11T05:23:56.884433",
        description: "The #1 New York Times bestseller. Over 3 million copies sold! Tiny Changes, Remarkable Results No matter your goals, Atomic Habits offers a proven framework for improving--every day. James Clear, one of the world's leading experts on habit formation, reveals practical strategies that will teach you exactly how to form good habits, break bad ones, and master the tiny behaviors that lead to remarkable results. If you're having trouble changing your habits, the problem isn't you. The problem is your system. Bad habits repeat themselves again and again not because you don't want to change, but because you have the wrong system for change. You do not rise to the level of your goals. You fall to the level of your systems. Here, you'll get a proven system that can take you to new heights. Clear is known for his ability to distill complex topics into simple behaviors that can be easily applied to daily life and work. Here, he draws on the most proven ideas from biology, psychology, and neuroscience to create an easy-to-understand guide for making good habits inevitable and bad habits impossible. Along the way, readers will be inspired and entertained with true stories from Olympic gold medalists, award-winning artists, business leaders, life-saving physicians, and star comedians who have used the science of small habits to master their craft and vault to the top of their field. Learn how to: • make time for new habits (even when life gets crazy); • overcome a lack of motivation and willpower; • design your environment to make success easier; • get back on track when you fall off course; ...and much more. Atomic Habits will reshape the way you think about progress and success, and give you the tools and strategies you need to transform your habits--whether you are a team looking to win a championship, an organization hoping to redefine an industry, or simply an individual who wishes to quit smoking, lose weight, reduce stress, or achieve any other goal.",
        id: 35971,
        image: "https://books.google.com/books/content?id=XfFvDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
        image_blurhash: "L9RCrJ%h%Mxu%fMdozRQCTx[-ooy",
        image_compressed: "https://books.google.com/books/content?id=XfFvDwAAQBAJ&printsec=frontcover&img=1&zoom=1&edge=curl&source=gbs_api",
        image_preview: "https://preview.deepstash.com/a/118080-1641958449.png",
        source_subtype: 0,
        source_type: 1,
        status: 3,
        suggested_hashtags: [
            "books"
        ],
        title: "Atomic Habits",
        top_reactions: [
            {
                reaction_id: 2,
                total_users: 172
            },
            {
                reaction_id: 5,
                total_users: 10
            },
            {
                reaction_id: 3,
                total_users: 6
            }, 
        ],
        total_blocks: 15,
        total_comments: 7,
        total_likes: 613,
        total_reactions: 190,
        total_reads: 24091,
        total_saves: 8600,
        type: 1,
        updated_at: "2022-01-12T03:34:07.829084",
        url: "https://books.google.com/books/about/Atomic_Habits.html?hl=&id=XfFvDwAAQBAJ",
        user_data: {
            bio: "Life goes on ",
            first_name: "Zankhu",
            has_profile: true,
            id: 1475761,
            image_preview: "https://preview.deepstash.com/u/1475761-1642517985.png",
            last_name: "G",
            photo: "https://d1dfxfqogsjixt.cloudfront.net/profile/1475761-1642517977.jpeg",
            photo_blurhash: "LYJQ+qD4NGt,^+Dixaxaay%Ls.w{",
            subscription_type: 2,
            url: null,
            username: "zankhu21"
        }
    },
    {
        author: "PowerfulJRE",
        blocks: [],
        content: "Naval Ravikant is an entrepreneur and angel investor, a co-author of Venture Hacks, and a co-maintainer of AngelList.",
        context: null,
        created_at: "2020-12-10T12:54:54.507336",
        description: "Naval Ravikant is an entrepreneur and angel investor, a co-author of Venture Hacks, and a co-maintainer of AngelList.",
        id: 1701,
        image: "https://i.ytimg.com/vi/3qHkcs3kG44/mqdefault.jpg",
        image_blurhash: "LXIOFJR+01xtERslRjX8V@NGjYs.",
        image_compressed: "https://d3t70bohx4vuj7.cloudfront.net/5vPGnYESDLfolmHE9LRQYCtIUC31n_M8koGPYy_JzVM/resize:fill:500:0/gravity:sm/aHR0cHM6Ly9pLnl0aW1nLmNvbS92aS8zcUhrY3Mza0c0NC9tcWRlZmF1bHQuanBn",
        image_preview: "https://preview.deepstash.com/a/1701-1624018537.png",
        source_subtype: 1,
        source_type: 3,
        stash_published_in: {
            description: null,
            emoji: "\uD83C\uDF3B",
            id: 678437,
            image: null,
            image_compressed: null,
            image_preview: "https://preview.deepstash.com/s/678437-1624018660.png",
            name: "Self Improvement",
            thematic: false,
            topics: []
        },
        status: 3,
        suggested_blocks: [],
        title: "The Joe Rogan Experience #1309 - Naval Ravikant",
        top_reactions: [
            {
                reaction_id: 2,
                total_users: 41
            }, 
        ],
        total_blocks: 18,
        total_comments: 0,
        total_likes: 113,
        total_reactions: 41,
        total_reads: 5066,
        total_saves: 2490,
        type: 0,
        updated_at: "2021-03-10T16:23:26.119228",
        url: "https://www.youtube.com/watch?v=3qHkcs3kG44",
        user_data: {
            bio: "Believer of Peace, Follower of Happiness",
            first_name: "Joanne",
            has_profile: true,
            id: 861580,
            image_preview: "https://preview.deepstash.com/u/861580-1624018530.png",
            last_name: "(Jo)",
            photo: "https://d1dfxfqogsjixt.cloudfront.net/profile/jojo_the2nd.png",
            photo_blurhash: "LZIy:%t60z9u%L$*snEMS#ofayay",
            subscription_type: 2,
            url: null,
            username: "jojo_thend"
        }
    },
    {
        author: "Ali Abdaal",
        blocks: [],
        content: "In this video I'll be going over a few methods that allow me to read up to 1000 books every year. <br><br>✍️ The best summaries of books (Shortform) - https://go.aliabdaal.com/shortform<br>\uD83D\uDCDA My Goodreads profile: https://www.goodreads.com/user/show/45329045-ali-abdaal<br>\uD83C\uDFA7 Sign up to Audible here: https://audible.com/aliabdaal<br>\uD83C\uDF9E Naval excerpt courtesy of Joe Rogan: https://www.youtube.com/watch?v=3qHkcs3kG44<br>\uD83D\uDCD6 How to Read a Book: https://geni.us/HkStXXO<br><br>00:00 Intro<br>00:58 Fill the funnel<br>03:08 Make it effortless<br>05:13 The blog post mindset<br>07:29 Go deep<br><br>MY FREE ONLINE COURSES:<br>\uD83D\uDE80  Productivity Masterclass - Principles and Tools to Boost Your Productivity - https://go.aliabdaal.com/course/productivity<br>\uD83C\uDFAC  Video Editing with Final Cut Pro X - From Beginner to YouTuber - https://go.aliabdaal.com/course/video-editing<br>\uD83C\uDF93  How to Study for Exams - An Evidence-Based Masterclass - https://go.aliabdaal.com/course/studying<br><br>PART-TIME YOUTUBER ACADEMY:<br>\uD83C\uDF7F My 6-week live online course - https://academy.aliabdaal.com<br><br>MY FAVOURITE GEAR:<br>\uD83C\uDFA5  My YouTube Camera Gear - https://kit.co/AliAbdaal<br>⌨️  My Keyboard - Wireless Coral mechanical keyboard (Cherry Blue) - https://go.aliabdaal.com/keyboard <br>\uD83D\uDCDD  My favourite iPad Screen Protector - Paperlike - https://go.aliabdaal.com/paperlike <br>\uD83C\uDF92 My Desk Accessories + Todo List - Ugmonk - https://go.aliabdaal.com/ugmonk<br><br>MY FAVOURITE SOFTWARE:<br>\uD83D\uDCDA  How I remember what I read (Readwise) - https://go.aliabdaal.com/readwise <br>\uD83C\uDFB5  Where I get my Music (amazing for YouTubers) - https://go.aliabdaal.com/epidemicsound<br><br>\uD83C\uDF99 My weekly podcast - https://www.notoverthinking.com<br>My brother and I host a weekly podcast where we discuss happiness, creativity and the human condition. You can find it by searching “Not Overthinking” on any podcast app (eg: Spotify, Apple Podcasts, Google Podcasts etc). <br><br>BE MY FRIEND:<br>\uD83D\uDC8C  Sign up to my weekly email newsletter - https://aliabdaal.com/friendzone/<br>\uD83C\uDF0D  My website / blog - https://www.aliabdaal.com <br> <br>\uD83D\uDCF8  Instagram - https://instagram.com/aliabdaal<br>\uD83D\uDC26  Twitter - https://twitter.com/aliabdaal<br>\uD83C\uDFAE  Twitch - https://twitch.tv/aliabdaal<br><br>WHO AM I:<br>I'm Ali, a junior doctor working in Cambridge, UK. I make videos about medicine, technology, productivity and lifestyle design. I also have a weekly podcast with my brother (https://www.notoverthinking.com), and I write a weekly email newsletter that contains some quick thoughts + links to interesting things (https://email.aliabdaal.com).<br><br>\uD83C\uDF0D  My website / blog - https://www.aliabdaal.com <br><br>GET IN TOUCH:<br>If you’d like to talk, I’d love to hear from you. Tweeting @AliAbdaal directly will be the quickest way to get a response, but if your question is very long, feel free to email me at hi@aliabdaal.com. I try my best to reply to things but there sadly aren't enough hours in the day to respond to everyone \uD83D\uDE2D<br><br>PS: Some of the links in this description are affiliate links that I get a kickback from \uD83D\uDE1C",
        context: null,
        created_at: "2021-10-06T16:12:48.142480",
        description: "In this video I'll be going over a few methods that allow me to read up to 1000 books every year. <br><br>✍️ The best summaries of books (Shortform) - https://go.aliabdaal.com/shortform<br>\uD83D\uDCDA My Goodreads profile: https://www.goodreads.com/user/show/45329045-ali-abdaal<br>\uD83C\uDFA7 Sign up to Audible here: https://audible.com/aliabdaal<br>\uD83C\uDF9E Naval excerpt courtesy of Joe Rogan: https://www.youtube.com/watch?v=3qHkcs3kG44<br>\uD83D\uDCD6 How to Read a Book: https://geni.us/HkStXXO<br><br>00:00 Intro<br>00:58 Fill the funnel<br>03:08 Make it effortless<br>05:13 The blog post mindset<br>07:29 Go deep<br><br>MY FREE ONLINE COURSES:<br>\uD83D\uDE80  Productivity Masterclass - Principles and Tools to Boost Your Productivity - https://go.aliabdaal.com/course/productivity<br>\uD83C\uDFAC  Video Editing with Final Cut Pro X - From Beginner to YouTuber - https://go.aliabdaal.com/course/video-editing<br>\uD83C\uDF93  How to Study for Exams - An Evidence-Based Masterclass - https://go.aliabdaal.com/course/studying<br><br>PART-TIME YOUTUBER ACADEMY:<br>\uD83C\uDF7F My 6-week live online course - https://academy.aliabdaal.com<br><br>MY FAVOURITE GEAR:<br>\uD83C\uDFA5  My YouTube Camera Gear - https://kit.co/AliAbdaal<br>⌨️  My Keyboard - Wireless Coral mechanical keyboard (Cherry Blue) - https://go.aliabdaal.com/keyboard <br>\uD83D\uDCDD  My favourite iPad Screen Protector - Paperlike - https://go.aliabdaal.com/paperlike <br>\uD83C\uDF92 My Desk Accessories + Todo List - Ugmonk - https://go.aliabdaal.com/ugmonk<br><br>MY FAVOURITE SOFTWARE:<br>\uD83D\uDCDA  How I remember what I read (Readwise) - https://go.aliabdaal.com/readwise <br>\uD83C\uDFB5  Where I get my Music (amazing for YouTubers) - https://go.aliabdaal.com/epidemicsound<br><br>\uD83C\uDF99 My weekly podcast - https://www.notoverthinking.com<br>My brother and I host a weekly podcast where we discuss happiness, creativity and the human condition. You can find it by searching “Not Overthinking” on any podcast app (eg: Spotify, Apple Podcasts, Google Podcasts etc). <br><br>BE MY FRIEND:<br>\uD83D\uDC8C  Sign up to my weekly email newsletter - https://aliabdaal.com/friendzone/<br>\uD83C\uDF0D  My website / blog - https://www.aliabdaal.com <br> <br>\uD83D\uDCF8  Instagram - https://instagram.com/aliabdaal<br>\uD83D\uDC26  Twitter - https://twitter.com/aliabdaal<br>\uD83C\uDFAE  Twitch - https://twitch.tv/aliabdaal<br><br>WHO AM I:<br>I'm Ali, a junior doctor working in Cambridge, UK. I make videos about medicine, technology, productivity and lifestyle design. I also have a weekly podcast with my brother (https://www.notoverthinking.com), and I write a weekly email newsletter that contains some quick thoughts + links to interesting things (https://email.aliabdaal.com).<br><br>\uD83C\uDF0D  My website / blog - https://www.aliabdaal.com <br><br>GET IN TOUCH:<br>If you’d like to talk, I’d love to hear from you. Tweeting @AliAbdaal directly will be the quickest way to get a response, but if your question is very long, feel free to email me at hi@aliabdaal.com. I try my best to reply to things but there sadly aren't enough hours in the day to respond to everyone \uD83D\uDE2D<br><br>PS: Some of the links in this description are affiliate links that I get a kickback from \uD83D\uDE1C",
        id: 100470,
        image: "https://i.ytimg.com/vi/XiGaXVJHwhc/mqdefault.jpg",
        image_blurhash: "LMI=cC8|V;.T~pD%%3I.DiRiaLE0",
        image_compressed: "https://d3t70bohx4vuj7.cloudfront.net/aV0rcGZmSHIaL9Xtovi52TZ6z7qtukLa3oYlFg0nrmo/resize:fill:500:0/gravity:sm/aHR0cHM6Ly9pLnl0aW1nLmNvbS92aS9YaUdhWFZKSHdoYy9tcWRlZmF1bHQuanBn",
        image_preview: "https://preview.deepstash.com/a/100470-1633538632.png",
        source_subtype: 1,
        source_type: 2,
        stash_published_in: {
            description: null,
            emoji: "\uD83D\uDCDA",
            id: 2315228,
            image: null,
            image_compressed: "",
            image_preview: "https://preview.deepstash.com/s/2315228-1623755169.png",
            name: "Books",
            thematic: false,
            topics: []
        },
        status: 3,
        suggested_blocks: [],
        title: "How to ‘Read’ 1000 Books a Year",
        top_reactions: [
            {
                reaction_id: 2,
                total_users: 20
            }, 
        ],
        total_blocks: 6,
        total_comments: 0,
        total_likes: 42,
        total_reactions: 20,
        total_reads: 1840,
        total_saves: 272,
        type: 0,
        updated_at: "2021-10-06T16:43:49.522565",
        url: "https://youtu.be/XiGaXVJHwhc",
        user_data: {
            bio: "17 | A start-up guy, Content creator, soloprenuer and a podcaster. Founder, Blast. Building Snakcards and more.\nStashing about entrepreneurship, self-help, spirituality and the most interesting stuff I read.",
            first_name: "Aditya",
            has_profile: true,
            id: 1136132,
            image_preview: "https://preview.deepstash.com/u/1136132-1650491553.png",
            last_name: "Mulukuri",
            photo: "https://d1dfxfqogsjixt.cloudfront.net/profile/1136132-1650491551.jpeg",
            photo_blurhash: "LQG*NC={^%E3~9xZf5Ip9uIpM|WV",
            subscription_type: 2,
            url: "https://expy.bio/adityamulukuri",
            username: "adityamulukuri"
        }
    },
    {
        author: "scotthyoung.com",
        blocks: [],
        content: '<p>Imagine if you could take a pill that would double your intelligence. What would that feel like?</p><p>You’d be able to keep more thoughts in your head. You could draw new connections between ideas. You could solve problems you’ve been stuck on for years.</p><p>Such a pill may not exist, but there already is a cognitive enhancing tool, and it doesn’t require brain-altering drugs.</p><h2>Writing to Think Better</h2><p>Writing your thoughts is the key to better thinking.</p><p>Cognitive scientists believe that working memory is one of the major components of intelligence. Working memory is like the RAM for your mind. It consists of all the things you’re keeping in mind simultaneously.</p><p dir="ltr">A common test of working memory is the <a href="https://en.wikipedia.org/wiki/N-back" dir="ltr">n-back task</a>. In this test, experimenters will repeat a string of digits and then, at a random point, ask you to recall the input from <em dir="ltr">n</em> steps previously.</p><img src="https://www.scotthyoung.com/blog/wp-content/uploads/2018/11/n-back.png" alt="How to Improve Your Thinking" width="745" height="631" srcset="https://www.scotthyoung.com/blog/wp-content/uploads/2018/11/n-back.png 800w, https://www.scotthyoung.com/blog/wp-content/uploads/2018/11/n-back-300x254.png 300w, https://www.scotthyoung.com/blog/wp-content/uploads/2018/11/n-back-768x651.png 768w"><p>This test is hard because the numbers you need to repeat back will keep changing. You need to hold all the current numbers in your head, without forgetting any of them.</p><p>People who can hold more numbers in their heads, have higher working memories and are often more intelligent generally. Being able to keep more things in mind at the same time is a big part of what makes some people smarter than others.</p><p>Now consider that, if one change to the test were made, performance would become almost perfect, even if the n-back test was asking for the last one hundred or ten thousand digits. That change? Allowing participants to write down the numbers as they hear them. Now reciting off huge lists of numbers is trivial, no matter the length.</p><h2>Paper as an Extension of Your Mind</h2><p>While writing may not literally increase your working memory, many cognitive scientists now believe that such external representations may form important parts of our cognition. This externalized cognition extends the space of thinking and literally makes us smarter, even if our brains are just the same as before.</p><p>Just as writing helps with numerical and mnemonic tasks, it can help you think more clearly about your life problems as well.</p><p dir="ltr"><strong dir="ltr">First, by jotting down your thoughts on paper, you can hold more ideas than you could in your limited working memory.</strong> This means you can more easily work through thoughts that have several parts which are difficult to keep in mind simultaneously.</p><p dir="ltr"><strong dir="ltr">Second, writing allows editing</strong>. If I write down an idea, then later notice a contradiction further down the page, I can go back and edit it. Editing mentally quickly becomes exhausting as, like in the n-back task, the old information interferes with the new.</p><p dir="ltr"><strong dir="ltr">Third, writing allows for longer thoughts.</strong> Have you ever had a conversation where, as you were listening, you forgot the point you were eager to make? Ideas bubble up and pop all the time in our minds, it’s only with writing that you can capture it.</p><h2>How to Start Thinking Better</h2><p>There’s a few ways you can improving your thinking with writing:</p><h3>1. Have a written meeting, before your face-to-face one.</h3><p>Are you going to discuss something with colleagues? Pretend the meeting isn’t happening and that you need to communicate your plans entirely via email. Draft up an email with your thoughts.</p><p>It doesn’t matter whether you send the email or not. Having thought through your ideas clearly, you’ll be able to communicate them intelligently when the meeting comes.</p><h3>2. Vexing problems should start with paper and pen.</h3><p>Are you struggling with an important problem in life or work? Your first instinct should be to get a piece of paper and start writing it down. Jot down all the elements of the problem, including all your different ideas for a solution.</p><p>Many problems which feel overwhelming are suddenly simplified once you write them down.</p><h3>3. Confusions are cleared up by writing down explanations.</h3><p dir="ltr">One of my most popular studying tactics was the <a href="https://www.youtube.com/watch?v=FrNqSLPaZLc" dir="ltr">Feynman Technique</a>. This technique boils down to using writing to make it easier to understand hard problems in math, science and other subjects.</p><p>Often, simply the act of writing down an explanation will resolve confusions. This is because the different components of the ideas are too large and numerous to stitch together into a completed understanding. Writing it down solves this capacity constraint and allows you to piece together a completed idea.</p><h2>Writing Doesn’t Record Your Thoughts, It Is Your Thinking</h2><p dir="ltr"><a href="https://jamesclear.com/" dir="ltr">James Clear</a>, a friend of mine and bestselling author, once told me that he doesn’t write to record his thoughts, but to figure out what he even thinks about a topic.</p><p>I feel the same way. Without writing, it isn’t simply that I would have tons of unrecorded ideas, bumping around in my skull, but that those ideas wouldn’t exist. They are created by the act of writing, much more so than they are being recorded.</p><p>If you don’t write regularly, the quality of your thinking suffers. Writing gives you access to an external brain, sharpens your ideas and makes your thoughts smarter.</p><BLOCKQUOTE><p>Consider this: Take whichever problem you find most challenging right now. It could be a life problem, relationships, academic or professional. Try writing about it every day for the next thirty days. You’ll be surprised at how many difficulties disappear once you’re able to write about it.</p></BLOCKQUOTE>',
        context: "It is often difficult to establish what we think before we have put it down in words. In many cases, we simply do not know what we want to say until we have tried to say it. After all, writing is thinking on paper, isn’t it?",
        created_at: "2022-03-04T13:29:42.519384",
        description: "Being able to think clearly is not easy. Working memory is limited, making thinking harder. Luckily, there's a tool to expand and improve your thinking.",
        id: 128074,
        image: "https://www.scotthyoung.com/blog/wp-content/uploads/2018/11/n-back.png",
        image_blurhash: "L7S$ouof~qofs:RjozofM_WARjoz",
        image_compressed: "https://d3t70bohx4vuj7.cloudfront.net/4rmx_uKjNnM0usfA4nvOx0uBsPZs62EmeZnkrLUsxOM/resize:fill:600:0/gravity:sm/quality:90/aHR0cHM6Ly93d3cuc2NvdHRoeW91bmcuY29tL2Jsb2cvd3AtY29udGVudC91cGxvYWRzLzIwMTgvMTEvbi1iYWNrLnBuZw",
        image_preview: "https://preview.deepstash.com/a/128074-1646480500.png",
        source_subtype: 0,
        source_type: 0,
        status: 3,
        suggested_hashtags: [
            "problemsolving",
            "personaldevelopment",
            "write",
            "writing",
            "health", 
        ],
        title: "How to Think Better",
        top_reactions: [
            {
                reaction_id: 5,
                total_users: 5
            },
            {
                reaction_id: 3,
                total_users: 1
            },
            {
                reaction_id: 1,
                total_users: 1
            }, 
        ],
        total_blocks: 15,
        total_comments: 0,
        total_likes: 0,
        total_reactions: 8,
        total_reads: 3963,
        total_saves: 1224,
        type: 0,
        updated_at: "2022-03-05T12:03:55.892107",
        url: "https://www.scotthyoung.com/blog/2018/12/14/think-better/",
        user_data: {
            bio: "“An idea is something that won’t work unless you do.” - Thomas A. Edison",
            first_name: "Xarikleia",
            has_profile: true,
            id: 1386670,
            image_preview: "https://preview.deepstash.com/u/1386670-1658310265.png",
            last_name: "",
            photo: "https://d1dfxfqogsjixt.cloudfront.net/profile/1386670-1637023019.jpeg",
            photo_blurhash: "LNQvwRj[_3j[~qfQM{fQD%fQWBfQ",
            subscription_type: 2,
            url: null,
            username: "xarikleia"
        }
    },
    {
        author: null,
        blocks: [],
        content: '<div><a rel="">By Jessica Klein</a></div><div><span>3rd March 2021</span></div><div>Why does endlessly looking for bad news feel so strangely gratifying – and can we break the habit?</div><p>Article continues below</p><div>S</div><p>Since the beginning of the pandemic, Emily Bernstein, 29, has been scrolling and scrolling and scrolling. As a Los Angeles-based comedy writer, Bernstein needs to read through Twitter and news sites for material. But it’s not just her job that keeps her reading: it’s the compulsion of ‘doomscrolling’ – trawling through feeds without pause, no matter how bad the news is or how many trolls’ comments she reads.</p><p>“I found myself in bed at night scrolling news sites and knowing this is not healthy for me… so why am I doing this?” says Bernstein.</p><p>It’s a question many doomscrollers have been asking themselves. There are multiple reasons why the urge to read may be so strong: the feeling of safety in knowledge, especially during difficult times; the design of social-media platforms that constantly refresh and boost the loudest voices; and, of course, the human fascination aspect. “It’s like not being able to look away when you see a car accident,” says Bernstein.</p><p dir="ltr">Beyond knowing intuitively that doomscrolling makes us feel awful, studies conducted during the pandemic have corroborated this, linking both anxiety and depression to <a href="https://link.springer.com/article/10.1007/s00406-020-01171-6" dir="ltr">the consumption of Covid-19 related media</a> and <a href="https://www.jmir.org/2020/6/e20185/pdf" dir="ltr">increased time spent on smartphones</a>. So, why do we keep endlessly scrolling \xad– and why can the practice feel oddly soothing? And could there actually be surprising upsides to keeping our eyes locked on our feeds?</p><picture><source media="(min-width:1200px)" srcset="https://ychef.files.bbci.co.uk/1600x900/p0980twc.webp" type="image/webp"><source media="(min-width:1200px)" srcset="https://ychef.files.bbci.co.uk/1600x900/p0980twc.jpg" type="image/jpeg"><source media="(min-width:880px)" srcset="https://ychef.files.bbci.co.uk/1280x720/p0980twc.webp" type="image/webp"><source media="(min-width:880px)" srcset="https://ychef.files.bbci.co.uk/1280x720/p0980twc.jpg" type="image/jpeg"><source media="(min-width:576px)" srcset="https://ychef.files.bbci.co.uk/976x549/p0980twc.webp" type="image/webp"><source media="(min-width:576px)" srcset="https://ychef.files.bbci.co.uk/976x549/p0980twc.jpg" type="image/jpeg"><source media="(min-width:224px)" srcset="https://ychef.files.bbci.co.uk/624x351/p0980twc.webp" type="image/webp"><source media="(min-width:224px)" srcset="https://ychef.files.bbci.co.uk/624x351/p0980twc.jpg" type="image/jpeg"><img title="“I found myself in bed at night scrolling news sites and knowing this is not healthy for me… so why am I doing this?&quot; – Emily Bernstein (Credit: Henrique Andrade)" src="https://ychef.files.bbci.co.uk/976x549/p0980twc.jpg" alt="“I found myself in bed at night scrolling news sites and knowing this is not healthy for me… so why am I doing this?&quot; – Emily Bernstein (Credit: Henrique Andrade)" width="687" height="386"></picture><p>“I found myself in bed at night scrolling news sites and knowing this is not healthy for me… so why am I doing this?" – Emily Bernstein (Credit: Henrique Andrade)</p><p><strong>The ‘pleasure’ of doomscrolling</strong></p><p dir="ltr">Most of us spent some portion of 2020 doomscrolling \xad– so much so that the Oxford English Dictionary <a href="https://pages.oup.com/ol/word-of-the-year-2020" dir="ltr">named it a word of the year</a>, and even added it to the dictionary.</p><p>But doomscrolling isn’t really a new human behaviour. Though the term seems to have entered the public lexicon in early 2020 around the start of Covid-19-related lockdowns, the public has long held the can’t-look-away-from-a-car-crash mentality Bernstein mentions when it comes to consuming news.</p><p>“The precursor to going online was that people would watch the 11 o’clock news, [which] was terrifying,” says Dean McKay, a Fordham University psychology professor who specialises in compulsive behaviour and anxiety disorders. That terror, when witnessed from the comfort of the viewer’s home, however, had a potentially calming effect. McKay describes the attitude as people acknowledging “things are pretty horrible, [but] I’m comfortable, so I\'m going to be able to sleep well tonight knowing that [I can feel good about] my station in life”.</p><p dir="ltr">McKay suggests doomscrolling could be a “modern equivalent”. But, unlike the 2300 news, it doesn’t stop at a fixed hour. During the uniquely uncertain and scary times of 2020, it’s no surprise that people like Bernstein scrolled well into the night. They <em dir="ltr">needed</em> information – at first because little was available about the virus, and then because they got sucked into the never-ending news cycle about it.</p><p>As Pamela Rutledge, director of the California-based Media Psychology Research Center, puts it, doomscrolling “really just describes the compulsive need to try and get answers when we’re afraid”.&nbsp; After all, we do have to assess whether new information constitutes a threat. “We are biologically driven to attend to that,” says Rutledge.</p><BLOCKQUOTE><h2>Doomscrolling really just describes the compulsive need to try and get answers when we’re afraid – Pamela Rutledge</h2></BLOCKQUOTE><p>“Unfortunately, journalism to some degree plays to that tendency,” she adds. Provocative headlines and stories draw in readers because they elicit fear and urgency \xad\xad– as Bernstein says, “There’s a sense of, if I know all the latest news, I can better protect myself and my family.”</p><p>This feels reasonable – but most people scroll well past the point of ascertaining any valuable information. Bernstein, for instance, starts doomscrolling sessions by reading the news, but she regularly winds up scrolling through comment sections beneath the articles. “I know it\'s just going to be a bunch of psychopaths insulting other psychopaths,” she says. “I truly don\'t know why I do it.” She’s drawn, in a way, to the negativity.</p><p>McKay sees a possible evolutionary explanation for this. All human emotional states emerged because they were somehow adaptive. So, wanting to vicariously feel a certain emotion from reading news or comments, like anger or despair, may be a way for us to “practice evolved coping mechanisms” we’ve developed for managing negative life events. Being scared, for example, puts us on high alert, which is useful in dangerous situations. In that sense, says McKay, “[doomscrolling] is almost like an information and strategy gathering approach”.</p><p dir="ltr">So, yes, the pandemic has compounded this perceived need for information and news-induced emotions. But people who’ve been unable to socialise or work outside the home during the pandemic have also had more <em dir="ltr">time</em> to scroll. A German survey from late March and early April of 2020 showed a connection between “frequency, duration, and diversity of media exposure” to <a href="https://link.springer.com/article/10.1007/s00406-020-01171-6" dir="ltr">increased depression symptoms and both general and pandemic-related anxiety</a>. Researchers from Dartmouth College also found <a href="https://www.jmir.org/2020/6/e20185/pdf" dir="ltr">increased phone usage linked with more anxiety, depression and sedentary behavior</a>s among college students as Covid-19 concerns increased in March.</p><picture><source media="(min-width:1200px)" srcset="https://ychef.files.bbci.co.uk/1600x900/p0980tv3.webp" type="image/webp"><source media="(min-width:1200px)" srcset="https://ychef.files.bbci.co.uk/1600x900/p0980tv3.jpg" type="image/jpeg"><source media="(min-width:880px)" srcset="https://ychef.files.bbci.co.uk/1280x720/p0980tv3.webp" type="image/webp"><source media="(min-width:880px)" srcset="https://ychef.files.bbci.co.uk/1280x720/p0980tv3.jpg" type="image/jpeg"><source media="(min-width:576px)" srcset="https://ychef.files.bbci.co.uk/976x549/p0980tv3.webp" type="image/webp"><source media="(min-width:576px)" srcset="https://ychef.files.bbci.co.uk/976x549/p0980tv3.jpg" type="image/jpeg"><source media="(min-width:224px)" srcset="https://ychef.files.bbci.co.uk/624x351/p0980tv3.webp" type="image/webp"><source media="(min-width:224px)" srcset="https://ychef.files.bbci.co.uk/624x351/p0980tv3.jpg" type="image/jpeg"><img title="When we feel out of control, doomscrolling can help us feel like we\'re gathering essential information – no matter how bad the news (Credit: Alamy)" src="https://ychef.files.bbci.co.uk/976x549/p0980tv3.jpg" alt="When we feel out of control, doomscrolling can help us feel like we\'re gathering essential information – no matter how bad the news (Credit: Alamy)" width="687" height="386"></picture><p>When we feel out of control, doomscrolling can help us feel like we\'re gathering essential information – no matter how bad the news (Credit: Alamy)</p><p><strong>The feed in your head</strong></p><p>For Rebecca Linton, 28, who works as a shoe prototyper in Denver, Colorado, doomscrolling during the pandemic has been about “trying to figure out what was going to happen next”, she says.</p><p>After the “novelty of being stuck inside and being able to craft all the time” during early lockdowns wore off, Linton found herself “consuming every possible news source about Covid, quarantine and the future that I possibly could”, she says. She often found herself getting sucked into the doomscrolling rabbit hole because she was trying to answer a specific question about what was going on – and that would just lead her to read different angles of the same story. It would also bring up entirely new questions she felt the need to answer, further lengthening her doomscrolling session and creating a self-perpetuating feed of bad news.</p><p>This behaviour of dwelling in a kind of endless feed can look a lot like Generalised Anxiety Disorder (GAD), says psychologist Jade Wu: “GAD is basically a Twitter feed of worries in your head.” Since GAD is associated with problems like muscle tensions, fatigue and depression, Wu says she imagines “similar effects” could happen to habitual doomscrollers.</p><p>“Doomscrolling is kind of like practicing having GAD,” she says. “If you run everyday, that\'s going to impact your muscles. If you doomscroll every day, that’s going to impact your psychology and your brain.”</p><BLOCKQUOTE><h2>Generalised Anxiety Disorder is basically a Twitter feed of worries in your head – Jane Wu</h2></BLOCKQUOTE><p>Doomscrolling also mimics gambling behaviours, because we don’t only scroll for bad news, but also anything uplifting. “We are hooked by the possibility of good news on the horizon,” Wu says (or even just finding a cute puppy video for some temporary relief). She compares doomscrolling, in that sense, to playing the slots. A gambler keeps pressing the lever in hope of winning, though it’s more likely they lose. Losing, for doomscrollers, means exposure to the same bad news, and the negative psychological and physical effects that come with it.</p><p>This “variable reinforcement schedule”, says Wu, “is the most addictive pattern of reward”. It’s why slot machines are designed the way they are – and social media feeds, too.</p><p><strong>‘The real world outside is not all trolls’</strong></p><p>If doomscrolling is slots-level addicting, and probably not the best for our mental health, how do we stop?</p><p>Rutledge stresses that awareness of our doomscrolling habits is the best way to quit them. For people on diets, for instance, keeping “food logs”, she says, is “one of the biggest predictors of success” for losing weight because it makes people aware of their current habits. The same could go for doomscrolling. Keep track of how much time you spend doing it to “identify the negative tendency”, Rutledge continues, “then you take steps to change it”.</p><p>Rutledge suggests setting a timer to stay alert to how long you’re spending on your phone, establishing a time at night when you put your phone down for the day, or having your partner remind you to turn it off.</p><p>That last suggestion works for Linton. Her partner has also got into doomscrolling in the past year, so they “actively support” each other’s efforts to stop, she says. “I find the most helpful thing is to get physical distance,” says Bernstein. “I’ll get off the internet, go on a walk and realise that the real world outside is not all trolls.”</p><picture><source media="(min-width:624px)" srcset="https://ychef.files.bbci.co.uk/1024x1280/p098cjvd.webp" type="image/webp"><source media="(min-width:624px)" srcset="https://ychef.files.bbci.co.uk/1024x1280/p098cjvd.jpg" type="image/jpeg"><source media="(min-width:485px)" srcset="https://ychef.files.bbci.co.uk/885x1280/p098cjvd.webp" type="image/webp"><source media="(min-width:485px)" srcset="https://ychef.files.bbci.co.uk/885x1280/p098cjvd.jpg" type="image/jpeg"><source media="(min-width:320px)" srcset="https://ychef.files.bbci.co.uk/720x900/p098cjvd.webp" type="image/webp"><source media="(min-width:320px)" srcset="https://ychef.files.bbci.co.uk/720x900/p098cjvd.jpg" type="image/jpeg"><img title="Rebecca Linton has tried to curate her social feeds to make sure she\'s seeing more good news than before – a kind of antidote to doomscrolling (Credit: Alec Linton)" src="https://ychef.files.bbci.co.uk/720x900/p098cjvd.jpg" alt="Rebecca Linton has tried to curate her social feeds to make sure she\'s seeing more good news than before – a kind of antidote to doomscrolling (Credit: Alec Linton)" width="592" height="740"></picture><p>Rebecca Linton has tried to curate her social feeds to make sure she\'s seeing more good news than before – a kind of antidote to doomscrolling (Credit: Alec Linton)</p><p><strong>A future of… hopescrolling?</strong></p><p dir="ltr">McKay says he saw a report not long ago that we were <a href="https://www.cnn.com/2020/12/27/politics/anthony-fauci-biden-coronavirus-cnntv/index.html" dir="ltr">entering into the darkest days of the pandemic</a>, “but juxtaposed right next to it is [news] like, ‘here’s how many vaccines are getting rolled out’,” he says. “And suddenly, you have potentially less of a bleak picture.”</p><p>That slot machine analogy looks more favourable in this light. Maybe doomscrollers aren’t scrolling to seek out more doom and gloom – they’re doing what McKay tentatively calls “hopescrolling”.</p><p>Bernstein even heard the term “joyscrolling” used in recent months, “like on certain days that were particularly great… people were like, ‘I can’t stop joyscrolling!’”.&nbsp;</p><p>A day of scrolling through positive news can’t necessarily erase or counteract the habits we’ve formed from months of doomscrolling and their negative effects on our mental wellbeing. However, understanding that scrolling through good news brings us joy could help make us more aware of how our online behaviour affects our emotional state, which Rutledge says is the key to changing our behaviours. Linton, for one, has blocked people who she’s realised are “not bringing valuable information” to her social feeds and has tried to curate her Instagram so it’s full of accounts with more positive content – the kind she can feel good scrolling through.</p><p>“I think it\'s unrealistic to say one day Covid will be over, and I\'m never going to [doomscroll] again,” says Bernstein. “I do think it\'ll decrease, but that\'s also a thing I realised – I have to put in the work to do that.”</p>',
        context: null,
        created_at: "2021-03-06T21:05:04.888894",
        description: "bbc.com",
        id: 58202,
        image: "https://ychef.files.bbci.co.uk/976x549/p0980twc.jpg",
        image_blurhash: null,
        image_compressed: "https://d3t70bohx4vuj7.cloudfront.net/xFwfzSytQ8ldxhsWcY2Q-R7p9pfCRX4w0A8JajW8fTc/resize:fill:500:0/gravity:sm/aHR0cHM6Ly95Y2hlZi5maWxlcy5iYmNpLmNvLnVrLzk3Nng1NDkvcDA5ODB0d2MuanBn",
        image_preview: "https://preview.deepstash.com/a/58202-1620429982.png",
        images: [
            "https://ychef.files.bbci.co.uk/976x549/p0980twc.jpg",
            "https://ychef.files.bbci.co.uk/1600x900/p0980twc.webp",
            "https://ychef.files.bbci.co.uk/1600x900/p0980twc.jpg",
            "https://ychef.files.bbci.co.uk/1280x720/p0980twc.webp",
            "https://ychef.files.bbci.co.uk/1280x720/p0980twc.jpg",
            "https://ychef.files.bbci.co.uk/976x549/p0980twc.webp",
            "https://ychef.files.bbci.co.uk/976x549/p0980twc.jpg",
            "https://ychef.files.bbci.co.uk/624x351/p0980twc.webp",
            "https://ychef.files.bbci.co.uk/624x351/p0980twc.jpg",
            "https://ychef.files.bbci.co.uk/976x549/p0980tv3.jpg",
            "https://ychef.files.bbci.co.uk/1600x900/p0980tv3.webp",
            "https://ychef.files.bbci.co.uk/1600x900/p0980tv3.jpg",
            "https://ychef.files.bbci.co.uk/1280x720/p0980tv3.webp",
            "https://ychef.files.bbci.co.uk/1280x720/p0980tv3.jpg",
            "https://ychef.files.bbci.co.uk/976x549/p0980tv3.webp",
            "https://ychef.files.bbci.co.uk/976x549/p0980tv3.jpg",
            "https://ychef.files.bbci.co.uk/624x351/p0980tv3.webp",
            "https://ychef.files.bbci.co.uk/624x351/p0980tv3.jpg",
            "https://ychef.files.bbci.co.uk/720x900/p098cjvd.jpg",
            "https://ychef.files.bbci.co.uk/1024x1280/p098cjvd.webp",
            "https://ychef.files.bbci.co.uk/1024x1280/p098cjvd.jpg",
            "https://ychef.files.bbci.co.uk/885x1280/p098cjvd.webp",
            "https://ychef.files.bbci.co.uk/885x1280/p098cjvd.jpg",
            "https://ychef.files.bbci.co.uk/720x900/p098cjvd.webp",
            "https://ychef.files.bbci.co.uk/720x900/p098cjvd.jpg", 
        ],
        source_subtype: 0,
        source_type: 4,
        stash_published_in: {
            description: null,
            emoji: "\uD83C\uDF3B",
            id: 678357,
            image: null,
            image_compressed: null,
            image_preview: "https://preview.deepstash.com/s/678357-1620474999.png",
            name: "Self Improvement",
            thematic: false,
            topics: []
        },
        status: 3,
        title: "The darkly soothing compulsion of 'doomscrolling'",
        top_reactions: [
            {
                reaction_id: 2,
                total_users: 18
            }, 
        ],
        total_blocks: 7,
        total_comments: 0,
        total_likes: 24,
        total_reactions: 18,
        total_reads: 3741,
        total_saves: 664,
        type: 0,
        updated_at: "2021-03-08T16:15:00.123243",
        url: "https://www.bbc.com/worklife/article/20210226-the-darkly-soothing-compulsion-of-doomscrolling",
        user_data: {
            bio: "I share what I find online.",
            first_name: "Yahya",
            has_profile: true,
            id: 861564,
            image_preview: "https://preview.deepstash.com/u/861564-1620474181.png",
            last_name: "Patel",
            photo: "https://d1dfxfqogsjixt.cloudfront.net/profile/yahyap.png",
            photo_blurhash: "LfLVz2xZ14V[E*%Lw}$%9~xG?Fbu",
            subscription_type: 2,
            url: null,
            username: "yahyap"
        }
    }, 
];
// Collections
var LANDING_PAGE_COLLECTIONS = [
    {
        id: 70,
        name: "How to Properly Read a Book",
        description: "A guide on how to better read & digest a book.",
        emoji: "\uD83D\uDCD8",
        ideaCount: 59,
        imageUrl: "https://static.deepstash.com/collection/70.svg"
    },
    {
        id: 14,
        name: "How to Be More Mindful",
        description: "Getting started with mindfulness.",
        emoji: "\uD83E\uDDD8",
        ideaCount: 39,
        imageUrl: "https://static.deepstash.com/collection/14.svg"
    },
    {
        id: 17,
        name: "Managing Perfectionism",
        description: "Or how to let go of being perfect.",
        emoji: "\uD83D\uDCAF",
        ideaCount: 46,
        imageUrl: "https://static.deepstash.com/collection/17.svg"
    },
    {
        id: 13,
        name: "Handling Difficult People",
        description: "How smart people handle difficult people.",
        emoji: "\uD83D\uDC65",
        ideaCount: 42,
        imageUrl: "https://static.deepstash.com/collection/13.svg"
    },
    {
        id: 69,
        name: "The Imposter Cure",
        description: "You need to shake the feeling that you're a fraud.",
        emoji: "\uD83D\uDE30",
        ideaCount: 46,
        imageUrl: "https://static.deepstash.com/collection/69.svg"
    },
    {
        id: 10,
        name: "Managing Time Like a Pro",
        description: "Time management tips for a productivity master.",
        emoji: "⏰",
        ideaCount: 53,
        imageUrl: "https://static.deepstash.com/collection/10.svg"
    },
    {
        id: 7,
        name: "Think Outside the Box",
        description: "Organize your thinking and boost your creativity.",
        emoji: "\uD83E\uDD61",
        ideaCount: 31,
        imageUrl: "https://static.deepstash.com/collection/7.svg"
    },
    {
        id: 11,
        name: "Lifelong Learning 101",
        description: "Or how to turn yourself into a super-learner.",
        emoji: "\uD83C\uDF93",
        ideaCount: 44,
        imageUrl: "https://static.deepstash.com/collection/11.svg"
    },
    {
        id: 12,
        name: "Self-Made Billionaires Secrets",
        description: "Change how you think about money and success.",
        emoji: "\uD83D\uDCB5",
        ideaCount: 47,
        imageUrl: "https://static.deepstash.com/collection/12.svg"
    },
    {
        id: 75,
        name: "Inside The Mind of Elon Musk",
        description: "A deep dive into how Elon's brain works.",
        emoji: "\uD83E\uDDE0",
        ideaCount: 75,
        imageUrl: "https://static.deepstash.com/collection/75.svg"
    }, 
];
var PRODUCT_HUNT_COLLECTIONS = [
    {
        id: 12,
        name: "Lessons From Self Made Billionaires",
        description: "We bring you lessons from self-made billionaires to point you in the right direction",
        emoji: "\uD83D\uDCB5",
        ideaCount: 47,
        imageUrl: "https://audio.deepstash.com/collections/lessons_from_self_made_billionaires.png"
    },
    {
        id: 19,
        name: "Joining A New Team",
        description: "How to Collaborate, Build trust and other tips to create a smooth transition in your new endeavour",
        emoji: "\uD83C\uDF31",
        ideaCount: 61,
        imageUrl: "https://audio.deepstash.com/collections/joining_a_new_team.png"
    },
    {
        id: 75,
        name: "Inside The Mind of Elon Musk",
        description: "Dig into this collection about Elon Musk to see how his brain works, the future he envisions for the world, and a lot more.",
        emoji: "\uD83E\uDDE0",
        ideaCount: 42,
        imageUrl: "https://audio.deepstash.com/collections/elon_musk.png"
    },
    {
        id: 30,
        name: "How to Sell Anything ",
        description: "Expert tips on how to tap into the human psyche and turn potential customers into actual ones",
        emoji: "\uD83D\uDC68‍\uD83D\uDCBC",
        ideaCount: 81,
        imageUrl: "https://audio.deepstash.com/collections/how_to_sell_anything.png"
    },
    {
        id: 33,
        name: "How To Build A Company",
        description: "A go-to guide, for entrepreneurs for building a company from the ground up.",
        emoji: "⚒",
        ideaCount: 115,
        imageUrl: "https://audio.deepstash.com/collections/how_to_build_a_company.png"
    },
    {
        id: 44,
        name: "Leading in Product Management ",
        description: "Best Practices to Align Stakeholders, Guide Development Teams, and Create Value Together",
        emoji: "\uD83D\uDC65",
        ideaCount: 68,
        imageUrl: "https://audio.deepstash.com/collections/leading_in_product_management.png"
    },
    {
        id: 60,
        name: "The Startup Collection",
        description: "From the drawing board to fruition: A comprehensive guide to Startups.",
        emoji: "\uD83E\uDDD1‍\uD83D\uDCBB",
        ideaCount: 95,
        imageUrl: "https://audio.deepstash.com/collections/the_startup_collection.png"
    },
    {
        id: 68,
        name: "Introduction to Web 3.0",
        description: "Web 3.0 is bigger than Blockchain and NFTs. Let us find out how the next phase of the internet unfolds.",
        emoji: "\uD83C\uDF10",
        ideaCount: 36,
        imageUrl: "https://audio.deepstash.com/collections/introduction_to_web30.png"
    },
    {
        id: 39,
        name: "The Psychology Of The Ultimate Entrepreneur ",
        description: "Mindsets, Philosophies, And Understandings Of Ultra Successful Entrepreneurs Like Elon Musk, Jeff Bezos and more",
        emoji: "\uD83D\uDD74",
        ideaCount: 39,
        imageUrl: "https://audio.deepstash.com/collections/the_psychology_of_the_ultimate_entrepreneur.png"
    },
    {
        id: 23,
        name: "Unlocking your Creative Potential",
        description: "Practical exercises, tools and concepts to help you develop and enhance your creative thinking ",
        emoji: "\uD83D\uDD8C",
        ideaCount: 38,
        imageUrl: "https://audio.deepstash.com/collections/unlocking_your_creative_potential.png"
    }, 
];


/***/ }),

/***/ 40792:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bar":"FooterStickyStartTrial_bar__qMg5q","visible":"FooterStickyStartTrial_visible__TPqxL"};

/***/ }),

/***/ 28592:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"carousel":"LandingHeroSection_carousel__EqmQG","slide":"LandingHeroSection_slide__qx5JY","carousel2":"LandingHeroSection_carousel2__6rg0N","carouselSmallScreen":"LandingHeroSection_carouselSmallScreen___f41V"};

/***/ }),

/***/ 56642:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"v":"4.8.0","meta":{"g":"LottieFiles AE ","a":"","k":"","d":"","tc":""},"fr":60,"ip":0,"op":771,"w":1920,"h":1080,"nm":"C1","ddd":0,"assets":[{"id":"comp_0","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":45,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[43.5,43.5,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-4.562,-2.625]],"o":[[0,0],[4.562,2.625]],"v":[[-19.312,14],[-9.75,22.125]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.827450980392,0.827450980392,0.827450980392,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":77,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[43.5,43.5,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-4.125,-14.938]],"o":[[0,0],[2.128,7.704]],"v":[[2.375,-23],[21.75,-5.188]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.827450980392,0.827450980392,0.827450980392,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"main dot","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[43,42,0],"ix":2},"a":{"a":0,"k":[-358.5,-32.5,0],"ix":1},"s":{"a":0,"k":[62.619,62.619,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[93,93],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.83137254902,0.298039215686,0.227450980392,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-358.5,-32.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1812,"st":0,"bm":0}]},{"id":"comp_1","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"grafica 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[254.5,331,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-20.5,-1]],"o":[[0,0],[20.5,1]],"v":[[136.5,223.5],[198.5,210.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 5","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-31.75,-0.25]],"o":[[0,0],[31.75,0.25]],"v":[[93.25,215.25],[201,197.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 4","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.25,-35.5],[-5.75,0.75],[1.75,27.5]],"o":[[0,0],[1.25,35.5],[5.75,-0.75],[-1.75,-27.5]],"v":[[144.5,108],[109,144],[145.5,180.25],[179,141.75]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 3","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-180.5,144],[-164.75,142.25]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 2","np":3,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[19.5,6.5],[0,0],[11.25,-12.5],[0,0],[-5,32.25],[0,0],[10.5,-7.25]],"o":[[-19.5,-6.5],[0,0],[133,-25.25],[4.167,-21.583],[-2.75,-30.75],[0,0],[7.25,-15]],"v":[[-44,128],[-95.25,148.25],[-210.5,257.5],[43.5,236.5],[61,139.5],[23.75,130.25],[-45.75,185]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 12","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[257.75,745.832,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-31.5,1.649]],"o":[[50.5,-2.522],[0,0]],"v":[[-201.75,-226.211],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Shape Layer 11","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[258.5,716.832,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[69.75,-6.343],[0,0]],"v":[[-208.25,-223.585],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Shape Layer 10","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[258.5,687.082,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-45.981,1.335]],"o":[[69.75,-6.343],[9,-0.261]],"v":[[-208.25,-223.585],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Shape Layer 9","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[259,657.582,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-45.981,1.335]],"o":[[74.75,-0.851],[9,-0.261]],"v":[[-208.25,-223.585],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Shape Layer 8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[379.5,379.219,0],"ix":2},"a":{"a":0,"k":[-137.75,-243.281,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-124,-4.32]],"o":[[39.75,-0.374],[52.003,1.812]],"v":[[-208,-230.747],[-67.5,-232.292]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Shape Layer 13","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[129.75,124.001,0],"ix":2},"a":{"a":0,"k":[-137.5,-237.249,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-124,-4.32]],"o":[[0,0],[52.003,1.812]],"v":[[-207.75,-225.017],[-48,-231.098]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Shape Layer 7","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[379.5,309.001,0],"ix":2},"a":{"a":0,"k":[-137.5,-237.249,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-124,-4.32]],"o":[[0,0],[52.003,1.812]],"v":[[-207.75,-225.017],[-67.25,-226.562]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Shape Layer 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[379.75,245.3,0],"ix":2},"a":{"a":0,"k":[-135.5,-241.95,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-66.5,4.036]],"o":[[0,0],[51.939,-3.153]],"v":[[-206,-231.464],[-65,-232.053]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"Shape Layer 5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[379.75,178.612,0],"ix":2},"a":{"a":0,"k":[-135.5,-242.888,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-50.5,-1.216]],"o":[[0,0],[52.019,1.253]],"v":[[-206,-231.464],[-65,-232.053]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"Shape Layer 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[137.75,377.681,0],"ix":2},"a":{"a":0,"k":[-127.25,-235.319,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-93.25,-8.14]],"o":[[0,0],[21.3,1.859]],"v":[[-206.25,-220.958],[-48.25,-225.846]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"Shape Layer 14","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[388.625,120.317,0],"ix":2},"a":{"a":0,"k":[-125.375,-243.683,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-51.425,-5.724]],"o":[[0,0],[21.25,2.365]],"v":[[-204.75,-232.18],[-63.625,-231.815]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":13,"ty":4,"nm":"Shape Layer 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[138.625,311.317,0],"ix":2},"a":{"a":0,"k":[-125.375,-243.683,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-51.425,-5.724]],"o":[[0,0],[21.25,2.365]],"v":[[-204.75,-232.18],[-46,-231.337]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":14,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[138.375,246.072,0],"ix":2},"a":{"a":0,"k":[-126.625,-252.428,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-51.708,-1.877]],"o":[[0,0],[52,1.888]],"v":[[-206,-237.433],[-47.25,-244.469]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":15,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[138.375,181.183,0],"ix":2},"a":{"a":0,"k":[-125.875,-249.317,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-51.5,-5]],"o":[[0,0],[51.5,5]],"v":[[-205.5,-236],[-46.25,-238.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":16,"ty":4,"nm":"text 22","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.283]},"t":254,"s":[59]},{"t":288,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[226.997,688.226,0],"ix":2},"a":{"a":0,"k":[85,-355.866,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[57.628,-4.086],[0,0]],"v":[[46,-339.602],[187.75,-340.678]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":200,"s":[0]},{"t":240,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":1800,"st":80,"bm":0},{"ddd":0,"ind":17,"ty":4,"nm":"text 21","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.283]},"t":254,"s":[59]},{"t":288,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[275.122,659.964,0],"ix":2},"a":{"a":0,"k":[133.125,-356.006,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-44.622,0.9]],"o":[[54.378,-3.078],[0,0]],"v":[[46.375,-341.148],[187.375,-341.833]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":160,"s":[0]},{"t":200,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":1800,"st":40,"bm":0},{"ddd":0,"ind":18,"ty":4,"nm":"text 19","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.5]},"t":158,"s":[59]},{"t":218,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[105.125,238,0],"ix":2},"a":{"a":0,"k":[136.5,-356,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[69.125,-3.495],[0,0]],"v":[[91,-315.946],[250,-315.543]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":98,"s":[0]},{"t":138,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":-102,"op":1800,"st":-22,"bm":0},{"ddd":0,"ind":19,"ty":4,"nm":"text 18","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.5]},"t":158,"s":[59]},{"t":218,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[143.5,246.625,0],"ix":2},"a":{"a":0,"k":[136.5,-356,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-59.125,-0.874]],"o":[[0,0],[0,0]],"v":[[51.375,-354.253],[210.5,-358.083]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":58,"s":[0]},{"t":98,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":-102,"op":1800,"st":-62,"bm":0},{"ddd":0,"ind":20,"ty":4,"nm":"text 17","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.5]},"t":158,"s":[59]},{"t":218,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[126.062,183.625,0],"ix":2},"a":{"a":0,"k":[115.062,-356,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[76.875,-4.301],[0,0]],"v":[[47,-356.134],[206.75,-357.411]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":18,"s":[0]},{"t":58,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":-102,"op":1800,"st":-102,"bm":0},{"ddd":0,"ind":21,"ty":4,"nm":"foaie 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263,419,0],"ix":2},"a":{"a":0,"k":[-70,61.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[490,807],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":10,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.172548989689,0.168626987233,0.16470600203,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":0.5,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.972549019608,0.972549019608,0.972549019608,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-70,61.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":-333,"op":1800,"st":0,"bm":0}]},{"id":"comp_2","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 19","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[246,419,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[1.375,-7.875],[-1.625,-5.625],[0.375,6.5],[3.25,11.062],[-0.125,-5.5],[0,0]],"o":[[-3.125,-6.625],[1.375,5.25],[3,5.375],[-3.625,-11.312],[-3.125,-4.75],[3.75,8.125],[0,0]],"v":[[-208,-403],[-221.375,-403.625],[-207.125,-366.625],[-194.75,-369.5],[-202.375,-394.5],[-211.5,-392.5],[-204.125,-373.375]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.384313732386,0.384313732386,0.384313732386,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"munti","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[133.5,669.51,0],"ix":2},"a":{"a":0,"k":[-130,250.51,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-6.5,-11.75],[-2,-6.25]],"o":[[0,0],[2.75,-7.25],[2,6.25]],"v":[[-148.25,214.25],[-133.75,214.75],[-121.5,212.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[-17.5,87.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[70,70],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 4","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-6.5,-11.75],[-2,-6.25]],"o":[[0,0],[2.75,-7.25],[2,6.25]],"v":[[-148.25,214.25],[-133.75,214.75],[-121.5,212.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 3","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-148.5,330.5],[-139.75,307.5],[-125,325],[-88.25,222.25],[-49,298.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 2","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-222.5,326.5],[-180.5,242],[-143.5,310.5],[-134.5,262.75],[-119,286.25]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[11.5,-16.75],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"dude shape","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[284.5,384,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-9.25,-9.5]],"o":[[0,0],[9.25,9.5]],"v":[[157.75,-82.5],[172.75,-85]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 4","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-13.5,-17.5]],"o":[[0,0],[13.5,17.5]],"v":[[150,-92.5],[173.75,-94.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.21960785985,0.215686291456,0.211764723063,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 3","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-6.5,0],[5.25,-3.125],[-0.705,-6.136],[6.375,-3.125],[0,0]],"o":[[0,0],[1.271,8.958],[6.125,2],[0.792,6.896],[-0.219,6.138],[0,0]],"v":[[5,-130.5],[28.25,-130.375],[7.5,-112.875],[25.375,-108],[9.625,-94.375],[24.5,-83.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607844949,0.215686276555,0.211764708161,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[25,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 2","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-24.5,13.5],[0,0],[-58,-64],[0,0],[0,0],[-6,-20.75]],"o":[[0,0],[0,-15.5],[0,0],[-14.75,0],[0,0],[0,0],[6,20.75]],"v":[[48,-25.5],[76.5,-56.5],[76,-114],[141,-110.75],[126.5,-110.5],[129.5,-57.75],[165.25,-31.25]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607844949,0.215686276555,0.211764708161,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Shape Layer 18","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[386.75,145.832,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-31.5,1.649]],"o":[[50.5,-2.522],[0,0]],"v":[[-201.75,-226.211],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Shape Layer 12","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[128.75,146.832,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-31.5,1.649]],"o":[[50.5,-2.522],[0,0]],"v":[[-201.75,-226.211],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Shape Layer 17","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[387.5,116.832,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[69.75,-6.343],[0,0]],"v":[[-208.25,-223.585],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Shape Layer 11","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[129.5,117.832,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[69.75,-6.343],[0,0]],"v":[[-208.25,-223.585],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Shape Layer 16","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[387.5,87.082,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-45.981,1.335]],"o":[[69.75,-6.343],[9,-0.261]],"v":[[-208.25,-223.585],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Shape Layer 10","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[129.5,88.082,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-45.981,1.335]],"o":[[69.75,-6.343],[9,-0.261]],"v":[[-208.25,-223.585],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"Shape Layer 15","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[388,57.582,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-45.981,1.335]],"o":[[74.75,-0.851],[9,-0.261]],"v":[[-208.25,-223.585],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"Shape Layer 9","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[130,58.582,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-45.981,1.335]],"o":[[74.75,-0.851],[9,-0.261]],"v":[[-208.25,-223.585],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"Shape Layer 8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[391.5,725.219,0],"ix":2},"a":{"a":0,"k":[-137.75,-243.281,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-124,-4.32]],"o":[[39.75,-0.374],[52.003,1.812]],"v":[[-208,-230.747],[-67.5,-232.292]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":13,"ty":4,"nm":"Shape Layer 13","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[128.75,327.001,0],"ix":2},"a":{"a":0,"k":[-137.5,-237.249,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-124,-4.32]],"o":[[0,0],[52.003,1.812]],"v":[[-207.75,-225.017],[-48,-231.098]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":14,"ty":4,"nm":"Shape Layer 7","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[391.5,655.001,0],"ix":2},"a":{"a":0,"k":[-137.5,-237.249,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-124,-4.32]],"o":[[0,0],[52.003,1.812]],"v":[[-207.75,-225.017],[-67.25,-226.562]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":15,"ty":4,"nm":"Shape Layer 6","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[391.75,591.3,0],"ix":2},"a":{"a":0,"k":[-135.5,-241.95,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-66.5,4.036]],"o":[[0,0],[51.939,-3.153]],"v":[[-206,-231.464],[-65,-232.053]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":16,"ty":4,"nm":"Shape Layer 5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[391.75,524.612,0],"ix":2},"a":{"a":0,"k":[-135.5,-242.888,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-50.5,-1.216]],"o":[[0,0],[52.019,1.253]],"v":[[-206,-231.464],[-65,-232.053]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":17,"ty":4,"nm":"Shape Layer 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[136.75,580.681,0],"ix":2},"a":{"a":0,"k":[-127.25,-235.319,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-93.25,-8.14]],"o":[[0,0],[21.3,1.859]],"v":[[-206.25,-220.958],[-48.25,-225.846]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":18,"ty":4,"nm":"Shape Layer 14","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[400.625,466.317,0],"ix":2},"a":{"a":0,"k":[-125.375,-243.683,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-51.425,-5.724]],"o":[[0,0],[21.25,2.365]],"v":[[-204.75,-232.18],[-63.625,-231.815]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":19,"ty":4,"nm":"Shape Layer 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[137.625,514.317,0],"ix":2},"a":{"a":0,"k":[-125.375,-243.683,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-51.425,-5.724]],"o":[[0,0],[21.25,2.365]],"v":[[-204.75,-232.18],[-46,-231.337]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":20,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[137.375,449.072,0],"ix":2},"a":{"a":0,"k":[-126.625,-252.428,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-51.708,-1.877]],"o":[[0,0],[52,1.888]],"v":[[-206,-237.433],[-47.25,-244.469]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":21,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[137.375,384.183,0],"ix":2},"a":{"a":0,"k":[-125.875,-249.317,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-51.5,-5]],"o":[[0,0],[51.5,5]],"v":[[-205.5,-236],[-46.25,-238.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":22,"ty":4,"nm":"text 17","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.5]},"t":648,"s":[59]},{"t":708,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[102.25,387.375,0],"ix":2},"a":{"a":0,"k":[93.25,-356,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[64.25,-3.965],[0,0]],"v":[[49.5,-356.672],[208.375,-357.747]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":508,"s":[0]},{"t":548,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":122,"op":1818,"st":162,"bm":0},{"ddd":0,"ind":23,"ty":4,"nm":"text 18","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.5]},"t":648,"s":[59]},{"t":708,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[342.375,617.25,0],"ix":2},"a":{"a":0,"k":[93.25,-356,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-98.125,-0.067]],"o":[[0,0],[0,0]],"v":[[-190.75,-444.575],[-31.5,-448.271]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":548,"s":[0]},{"t":588,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":122,"op":1818,"st":202,"bm":0},{"ddd":0,"ind":24,"ty":4,"nm":"text 19","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.5]},"t":648,"s":[59]},{"t":708,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[342.375,645.75,0],"ix":2},"a":{"a":0,"k":[93.25,-356,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-53.25,-0.269]],"o":[[81.875,-2.487],[0,0]],"v":[[-191,-426.43],[-31.25,-425.624]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":588,"s":[0]},{"t":628,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":104,"op":1818,"st":242,"bm":0},{"ddd":0,"ind":25,"ty":4,"nm":"text 21","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.283]},"t":520,"s":[59]},{"t":554,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[386.873,394.915,0],"ix":2},"a":{"a":0,"k":[133.375,-356.015,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[75.752,-3.061],[0,0]],"v":[[68.25,-317.828],[208.5,-317.321]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":386,"s":[0]},{"t":426,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":1800,"st":182,"bm":0},{"ddd":0,"ind":26,"ty":4,"nm":"text 23","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.283]},"t":520,"s":[59]},{"t":554,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[389.748,448.915,0],"ix":2},"a":{"a":0,"k":[136.25,-356.015,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-75.373,2.126]],"o":[[0,0],[0,0]],"v":[[67.5,-279.656],[209.125,-279.87]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":466,"s":[0]},{"t":506,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":40,"op":1840,"st":262,"bm":0},{"ddd":0,"ind":27,"ty":4,"nm":"text 22","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.283]},"t":520,"s":[59]},{"t":554,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[389.748,421.915,0],"ix":2},"a":{"a":0,"k":[136.25,-356.015,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[68.25,-300.489],[208.125,-300.917]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":426,"s":[0]},{"t":466,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":1800,"st":222,"bm":0},{"ddd":0,"ind":28,"ty":4,"nm":"foaie 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263,419,0],"ix":2},"a":{"a":0,"k":[-70,61.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[490,807],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":10,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.172548989689,0.168626987233,0.16470600203,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":0.5,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.972549019608,0.972549019608,0.972549019608,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-70,61.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0}]},{"id":"comp_3","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"grafica 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[254.5,331,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-20.5,-1]],"o":[[0,0],[20.5,1]],"v":[[136.5,223.5],[198.5,210.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 5","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-31.75,-0.25]],"o":[[0,0],[31.75,0.25]],"v":[[93.25,215.25],[201,197.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 4","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.25,-35.5],[-5.75,0.75],[1.75,27.5]],"o":[[0,0],[1.25,35.5],[5.75,-0.75],[-1.75,-27.5]],"v":[[144.5,108],[109,144],[145.5,180.25],[179,141.75]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 3","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-180.5,144],[-164.75,142.25]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 2","np":3,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[19.5,6.5],[0,0],[11.25,-12.5],[0,0],[-5,32.25],[0,0],[10.5,-7.25]],"o":[[-19.5,-6.5],[0,0],[133,-25.25],[4.167,-21.583],[-2.75,-30.75],[0,0],[7.25,-15]],"v":[[-44,128],[-95.25,148.25],[-210.5,257.5],[43.5,236.5],[61,139.5],[23.75,130.25],[-45.75,185]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 32","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[257.75,745.832,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-31.5,1.649]],"o":[[50.5,-2.522],[0,0]],"v":[[-201.75,-226.211],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Shape Layer 31","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[258.5,716.832,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[69.75,-6.343],[0,0]],"v":[[-208.25,-223.585],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Shape Layer 30","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[258.5,687.082,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-45.981,1.335]],"o":[[69.75,-6.343],[9,-0.261]],"v":[[-208.25,-223.585],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Shape Layer 29","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[259,657.582,0],"ix":2},"a":{"a":0,"k":[-138,-234.918,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-45.981,1.335]],"o":[[74.75,-0.851],[9,-0.261]],"v":[[-208.25,-223.585],[-67.75,-225.129]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Shape Layer 28","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[379.5,379.219,0],"ix":2},"a":{"a":0,"k":[-137.75,-243.281,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-124,-4.32]],"o":[[39.75,-0.374],[52.003,1.812]],"v":[[-208,-230.747],[-67.5,-232.292]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Shape Layer 27","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[129.75,124.001,0],"ix":2},"a":{"a":0,"k":[-137.5,-237.249,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-124,-4.32]],"o":[[0,0],[52.003,1.812]],"v":[[-207.75,-225.017],[-48,-231.098]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Shape Layer 26","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[379.5,309.001,0],"ix":2},"a":{"a":0,"k":[-137.5,-237.249,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-124,-4.32]],"o":[[0,0],[52.003,1.812]],"v":[[-207.75,-225.017],[-67.25,-226.562]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":4,"nm":"Shape Layer 25","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[379.75,245.3,0],"ix":2},"a":{"a":0,"k":[-135.5,-241.95,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-66.5,4.036]],"o":[[0,0],[51.939,-3.153]],"v":[[-206,-231.464],[-65,-232.053]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":10,"ty":4,"nm":"Shape Layer 24","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[379.75,178.612,0],"ix":2},"a":{"a":0,"k":[-135.5,-242.888,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-50.5,-1.216]],"o":[[0,0],[52.019,1.253]],"v":[[-206,-231.464],[-65,-232.053]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":11,"ty":4,"nm":"Shape Layer 23","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[137.75,377.681,0],"ix":2},"a":{"a":0,"k":[-127.25,-235.319,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-93.25,-8.14]],"o":[[0,0],[21.3,1.859]],"v":[[-206.25,-220.958],[-48.25,-225.846]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":12,"ty":4,"nm":"Shape Layer 22","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[388.625,120.317,0],"ix":2},"a":{"a":0,"k":[-125.375,-243.683,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-51.425,-5.724]],"o":[[0,0],[21.25,2.365]],"v":[[-204.75,-232.18],[-63.625,-231.815]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":13,"ty":4,"nm":"Shape Layer 21","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[138.625,311.317,0],"ix":2},"a":{"a":0,"k":[-125.375,-243.683,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-51.425,-5.724]],"o":[[0,0],[21.25,2.365]],"v":[[-204.75,-232.18],[-46,-231.337]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":14,"ty":4,"nm":"Shape Layer 20","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[138.375,246.072,0],"ix":2},"a":{"a":0,"k":[-126.625,-252.428,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-51.708,-1.877]],"o":[[0,0],[52,1.888]],"v":[[-206,-237.433],[-47.25,-244.469]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":15,"ty":4,"nm":"Shape Layer 19","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[138.375,181.183,0],"ix":2},"a":{"a":0,"k":[-125.875,-249.317,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-51.5,-5]],"o":[[0,0],[51.5,5]],"v":[[-205.5,-236],[-46.25,-238.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.219607858097,0.215686289469,0.211764720842,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,104.707],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0},{"ddd":0,"ind":16,"ty":4,"nm":"text 37","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.283]},"t":254,"s":[59]},{"t":288,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[226.997,688.226,0],"ix":2},"a":{"a":0,"k":[85,-355.866,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[57.628,-4.086],[0,0]],"v":[[46,-339.602],[187.75,-340.678]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":200,"s":[0]},{"t":240,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":1800,"st":80,"bm":0},{"ddd":0,"ind":17,"ty":4,"nm":"text 36","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.283]},"t":254,"s":[59]},{"t":288,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[275.122,659.964,0],"ix":2},"a":{"a":0,"k":[133.125,-356.006,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-44.622,0.9]],"o":[[54.378,-3.078],[0,0]],"v":[[46.375,-341.148],[187.375,-341.833]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":160,"s":[0]},{"t":200,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":0,"op":1800,"st":40,"bm":0},{"ddd":0,"ind":18,"ty":4,"nm":"text 35","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.5]},"t":158,"s":[59]},{"t":218,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[105.125,238,0],"ix":2},"a":{"a":0,"k":[136.5,-356,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[69.125,-3.495],[0,0]],"v":[[91,-315.946],[250,-315.543]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":98,"s":[0]},{"t":138,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":-102,"op":1800,"st":-22,"bm":0},{"ddd":0,"ind":19,"ty":4,"nm":"text 34","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.5]},"t":158,"s":[59]},{"t":218,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[143.5,246.625,0],"ix":2},"a":{"a":0,"k":[136.5,-356,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-59.125,-0.874]],"o":[[0,0],[0,0]],"v":[[51.375,-354.253],[210.5,-358.083]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.2],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":58,"s":[0]},{"t":98,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":-102,"op":1800,"st":-62,"bm":0},{"ddd":0,"ind":20,"ty":4,"nm":"text 33","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.167],"y":[0.5]},"t":158,"s":[59]},{"t":218,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[126.062,183.625,0],"ix":2},"a":{"a":0,"k":[115.062,-356,0],"ix":1},"s":{"a":0,"k":[100,186,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[76.875,-4.301],[0,0]],"v":[[47,-356.134],[206.75,-357.411]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,0,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":8,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"tm","s":{"a":0,"k":0,"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.21],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":18,"s":[0]},{"t":58,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false}],"ip":-102,"op":1800,"st":-102,"bm":0},{"ddd":0,"ind":42,"ty":4,"nm":"foaie 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[263,419,0],"ix":2},"a":{"a":0,"k":[-70,61.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[490,807],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":10,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.172548989689,0.168626987233,0.16470600203,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":0.5,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.960784313725,0.960784313725,0.960784313725,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-70,61.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.14],"y":[1]},"o":{"x":[0.14],"y":[0]},"t":655,"s":[100]},{"t":676,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.25,"y":1},"o":{"x":0.333,"y":0},"t":627,"s":[635.166,606.138,0],"to":[0,-110.167,0],"ti":[0,110.167,0]},{"t":743,"s":[635.166,-54.862,0]}],"ix":2},"a":{"a":0,"k":[43.5,43.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.21,0.21,0.21],"y":[1,1,1]},"o":{"x":[0.72,0.72,0.72],"y":[0,0,0]},"t":470,"s":[0,0,100]},{"t":660,"s":[100,100,100]}],"ix":6}},"ao":0,"w":87,"h":87,"ip":0,"op":771,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.14],"y":[1]},"o":{"x":[0.14],"y":[0]},"t":522,"s":[100]},{"t":548,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.25,"y":1},"o":{"x":0.333,"y":0},"t":490,"s":[1275,645,0],"to":[0,-67.708,0],"ti":[0,67.708,0]},{"t":603,"s":[1275,238.75,0]}],"ix":2},"a":{"a":0,"k":[43.5,43.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":360,"s":[0,0,100]},{"t":488,"s":[100,100,100]}],"ix":6}},"ao":0,"w":87,"h":87,"ip":0,"op":771,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.14],"y":[1]},"o":{"x":[0.14],"y":[0]},"t":261,"s":[100]},{"t":281,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.25,"y":1},"o":{"x":0.333,"y":0},"t":246,"s":[594,831,0],"to":[0,-162.5,0],"ti":[0,162.5,0]},{"t":362,"s":[594,-144,0]}],"ix":2},"a":{"a":0,"k":[43.5,43.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.21,0.21,0.21],"y":[1,1,1]},"o":{"x":[0.72,0.72,0.72],"y":[0,0,0]},"t":114,"s":[0,0,100]},{"t":280,"s":[100,100,100]}],"ix":6}},"ao":0,"w":87,"h":87,"ip":0,"op":771,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.14],"y":[1]},"o":{"x":[0.14],"y":[0]},"t":160,"s":[100]},{"t":184,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.25,"y":1},"o":{"x":0.333,"y":0},"t":132,"s":[620,389,0],"to":[0,-88.5,0],"ti":[0,88.5,0]},{"t":248,"s":[620,-142,0]}],"ix":2},"a":{"a":0,"k":[43.5,43.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.21,0.21,0.21],"y":[1,1,1]},"o":{"x":[0.72,0.72,0.72],"y":[0,0,0]},"t":0,"s":[0,0,100]},{"t":166,"s":[100,100,100]}],"ix":6}},"ao":0,"w":87,"h":87,"ip":0,"op":771,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":0,"nm":"Foaie 1","refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":346,"s":[-1.939]},{"t":690,"s":[-1.939]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":306,"s":[960,540,0],"to":[-58,0,0],"ti":[58,0,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.167,"y":0.167},"t":346,"s":[612,540,0],"to":[0,0,0],"ti":[0,0,0]},{"t":690,"s":[612,540,0]}],"ix":2},"a":{"a":0,"k":[263.5,419,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Brightness & Contrast","np":5,"mn":"ADBE Brightness & Contrast 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"Brightness","mn":"ADBE Brightness & Contrast 2-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":306,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":386,"s":[-91]},{"t":690,"s":[-91]}],"ix":1}},{"ty":0,"nm":"Contrast","mn":"ADBE Brightness & Contrast 2-0002","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"Use Legacy (supports HDR)","mn":"ADBE Brightness & Contrast 2-0003","ix":3,"v":{"a":0,"k":0,"ix":3}}]}],"w":527,"h":838,"ip":0,"op":346,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":0,"nm":"Foaie 2","refId":"comp_2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":306,"s":[10.538]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":346,"s":[-1.939]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":386,"s":[-1.939]},{"t":690,"s":[-1.939]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":306,"s":[960,540,0],"to":[66.333,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":346,"s":[1358,540,0],"to":[0,0,0],"ti":[66.333,0,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.167,"y":0.167},"t":386,"s":[960,540,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0},"t":690,"s":[960,540,0],"to":[-58,0,0],"ti":[58,0,0]},{"t":731,"s":[612,540,0]}],"ix":2},"a":{"a":0,"k":[263.5,419,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Brightness & Contrast","np":5,"mn":"ADBE Brightness & Contrast 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"Brightness","mn":"ADBE Brightness & Contrast 2-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":306,"s":[-27]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":386,"s":[0]},{"t":690,"s":[0]}],"ix":1}},{"ty":0,"nm":"Contrast","mn":"ADBE Brightness & Contrast 2-0002","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"Use Legacy (supports HDR)","mn":"ADBE Brightness & Contrast 2-0003","ix":3,"v":{"a":0,"k":0,"ix":3}}]}],"w":527,"h":838,"ip":0,"op":731,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":0,"nm":"Foaie 1","refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":690,"s":[10.538]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":731,"s":[-1.939]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":770,"s":[-1.939]},{"t":1380,"s":[-1.939]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":690,"s":[960,540,0],"to":[66.333,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":731,"s":[1358,540,0],"to":[0,0,0],"ti":[124.333,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":770,"s":[960,540,0],"to":[-124.333,0,0],"ti":[58,0,0]},{"t":1380,"s":[612,540,0]}],"ix":2},"a":{"a":0,"k":[263.5,419,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Brightness & Contrast","np":5,"mn":"ADBE Brightness & Contrast 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"Brightness","mn":"ADBE Brightness & Contrast 2-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.65],"y":[1.014]},"o":{"x":[0.316],"y":[0]},"t":690,"s":[-27]},{"i":{"x":[0.65],"y":[1.367]},"o":{"x":[0.182],"y":[-0.191]},"t":731,"s":[0]},{"i":{"x":[0.671],"y":[1]},"o":{"x":[0.182],"y":[0.033]},"t":770,"s":[0]},{"t":1380,"s":[-91]}],"ix":1}},{"ty":0,"nm":"Contrast","mn":"ADBE Brightness & Contrast 2-0002","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"Use Legacy (supports HDR)","mn":"ADBE Brightness & Contrast 2-0003","ix":3,"v":{"a":0,"k":0,"ix":3}}]}],"w":527,"h":838,"ip":691,"op":771,"st":410,"bm":0},{"ddd":0,"ind":8,"ty":0,"nm":"Foaie 2","refId":"comp_2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":306,"s":[10.538]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":346,"s":[-1.939]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":386,"s":[-1.939]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":690,"s":[-1.939]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":731,"s":[-1.939]},{"t":770,"s":[10.538]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":306,"s":[960,540,0],"to":[66.333,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":346,"s":[1358,540,0],"to":[0,0,0],"ti":[66.333,0,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.167,"y":0.167},"t":386,"s":[960,540,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0},"t":690,"s":[960,540,0],"to":[-58,0,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":1},"o":{"x":0.333,"y":0},"t":731,"s":[612,540,0],"to":[0,0,0],"ti":[-58,0,0]},{"t":770,"s":[960,540,0]}],"ix":2},"a":{"a":0,"k":[263.5,419,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Brightness & Contrast","np":5,"mn":"ADBE Brightness & Contrast 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"Brightness","mn":"ADBE Brightness & Contrast 2-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":306,"s":[-27]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":386,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":690,"s":[0]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0]},"t":731,"s":[0]},{"t":770,"s":[-27]}],"ix":1}},{"ty":0,"nm":"Contrast","mn":"ADBE Brightness & Contrast 2-0002","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"Use Legacy (supports HDR)","mn":"ADBE Brightness & Contrast 2-0003","ix":3,"v":{"a":0,"k":0,"ix":3}}]}],"w":527,"h":838,"ip":731,"op":771,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":0,"nm":"Foaie 3","refId":"comp_3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":306,"s":[4.639]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":346,"s":[10.538]},{"t":690,"s":[10.538]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":306,"s":[960,540,0],"to":[66.333,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":346,"s":[1358,540,0],"to":[0,0,0],"ti":[66.333,0,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.167,"y":0.167},"t":386,"s":[960,540,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0},"t":690,"s":[960,540,0],"to":[66.333,0,0],"ti":[-66.333,0,0]},{"t":731,"s":[1358,540,0]}],"ix":2},"a":{"a":0,"k":[263.5,419,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Brightness & Contrast","np":5,"mn":"ADBE Brightness & Contrast 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"Brightness","mn":"ADBE Brightness & Contrast 2-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":306,"s":[-91]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":386,"s":[-27]},{"t":690,"s":[-27]}],"ix":1}},{"ty":0,"nm":"Contrast","mn":"ADBE Brightness & Contrast 2-0002","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"Use Legacy (supports HDR)","mn":"ADBE Brightness & Contrast 2-0003","ix":3,"v":{"a":0,"k":0,"ix":3}}]}],"w":527,"h":838,"ip":0,"op":691,"st":0,"bm":0},{"ddd":0,"ind":10,"ty":0,"nm":"Foaie 1","refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":346,"s":[-1.939]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":386,"s":[4.639]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":690,"s":[4.639]},{"t":731,"s":[4.639]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":306,"s":[960,540,0],"to":[-58,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":346,"s":[612,540,0],"to":[0,0,0],"ti":[-58,0,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.167,"y":0.167},"t":386,"s":[960,540,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.167,"y":0},"t":690,"s":[960,540,0],"to":[66.333,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":731,"s":[1358,540,0],"to":[0,0,0],"ti":[66.333,0,0]},{"t":770,"s":[960,540,0]}],"ix":2},"a":{"a":0,"k":[263.5,419,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"ef":[{"ty":5,"nm":"Brightness & Contrast","np":5,"mn":"ADBE Brightness & Contrast 2","ix":1,"en":1,"ef":[{"ty":0,"nm":"Brightness","mn":"ADBE Brightness & Contrast 2-0001","ix":1,"v":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":306,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":386,"s":[-91]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":690,"s":[-91]},{"t":770,"s":[-91]}],"ix":1}},{"ty":0,"nm":"Contrast","mn":"ADBE Brightness & Contrast 2-0002","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":7,"nm":"Use Legacy (supports HDR)","mn":"ADBE Brightness & Contrast 2-0003","ix":3,"v":{"a":0,"k":0,"ix":3}}]}],"w":527,"h":838,"ip":346,"op":771,"st":0,"bm":0}],"markers":[]}');

/***/ }),

/***/ 96466:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"v":"4.8.0","meta":{"g":"LottieFiles AE ","a":"","k":"","d":"","tc":""},"fr":60,"ip":0,"op":281,"w":1920,"h":1080,"nm":"C2 Main","ddd":0,"assets":[{"id":"comp_0","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"casti","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.142},"t":3,"s":[934,436,0],"to":[-1.271,0.083,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0.142},"t":20,"s":[926.375,436.5,0],"to":[0,0,0],"ti":[-1.271,0.083,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":37,"s":[934,436,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.142},"t":43,"s":[934,436,0],"to":[-1.271,0.083,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0.142},"t":60,"s":[926.375,436.5,0],"to":[0,0,0],"ti":[-1.271,0.083,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":77,"s":[934,436,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.142},"t":84,"s":[934,436,0],"to":[-1.271,0.083,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0.142},"t":101,"s":[926.375,436.5,0],"to":[0,0,0],"ti":[-1.271,0.083,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":118,"s":[934,436,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.142},"t":125,"s":[934,436,0],"to":[-1.271,0.083,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0.142},"t":142,"s":[926.375,436.5,0],"to":[0,0,0],"ti":[-1.271,0.083,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":159,"s":[934,436,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.142},"t":164,"s":[934,436,0],"to":[-1.271,0.083,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0.142},"t":181,"s":[926.375,436.5,0],"to":[0,0,0],"ti":[-1.271,0.083,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":198,"s":[934,436,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.142},"t":204,"s":[934,436,0],"to":[-1.271,0.083,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0.142},"t":221,"s":[926.375,436.5,0],"to":[0,0,0],"ti":[-1.271,0.083,0]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":238,"s":[934,436,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.142},"t":243,"s":[934,436,0],"to":[-1.271,0.083,0],"ti":[0,0,0]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0.142},"t":260,"s":[926.375,436.5,0],"to":[0,0,0],"ti":[-1.271,0.083,0]},{"t":277,"s":[934,436,0]}],"ix":2},"a":{"a":0,"k":[215,-65,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[2.375,3.25],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[-16.312,-124],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 3","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-4.247,-2.472],[0,0],[-2.901,-0.06],[0,0],[7.286,3.686],[0,0]],"o":[[3.126,-2.699],[6.281,3.656],[0,0],[3.416,0.07],[0,0],[-6.624,-3.351],[0,0]],"v":[[-51.25,-155.375],[-37.625,-161],[-27.625,-141.625],[-18.875,-145],[-9.375,-141.25],[-19.625,-163.5],[-41.25,-162]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.898039275525,0.898039275525,0.898039275525,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[15,18.25],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[-16.375,-124],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 2","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[32.625,40.75],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[-18.688,-124.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":281,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Dude Casti","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[711,500,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-58.562,-126.938],[-59.312,-122.25]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":20,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-64.562,-127.062],[-65.312,-122.375]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":40,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-58.562,-126.938],[-59.312,-122.25]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":60,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-64.562,-127.062],[-65.312,-122.375]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":80,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-58.562,-126.938],[-59.312,-122.25]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":100,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-64.562,-127.062],[-65.312,-122.375]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":120,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-58.562,-126.938],[-59.312,-122.25]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":140,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-64.562,-127.062],[-65.312,-122.375]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":160,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-58.562,-126.938],[-59.312,-122.25]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":180,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-64.562,-127.062],[-65.312,-122.375]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":200,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-58.562,-126.938],[-59.312,-122.25]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":220,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-64.562,-127.062],[-65.312,-122.375]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":240,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-58.562,-126.938],[-59.312,-122.25]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":260,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-64.562,-127.062],[-65.312,-122.375]],"c":false}]},{"t":280,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-58.562,-126.938],[-59.312,-122.25]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"ochi 2","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-72.062,-128.375],[-72.75,-123.312]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":20,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-78.062,-128.5],[-78.75,-123.438]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":40,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-72.062,-128.375],[-72.75,-123.312]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":60,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-78.062,-128.5],[-78.75,-123.438]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":80,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-72.062,-128.375],[-72.75,-123.312]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":100,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-78.062,-128.5],[-78.75,-123.438]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":120,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-72.062,-128.375],[-72.75,-123.312]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":140,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-78.062,-128.5],[-78.75,-123.438]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":160,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-72.062,-128.375],[-72.75,-123.312]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":180,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-78.062,-128.5],[-78.75,-123.438]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":200,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-72.062,-128.375],[-72.75,-123.312]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":220,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-78.062,-128.5],[-78.75,-123.438]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":240,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-72.062,-128.375],[-72.75,-123.312]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":260,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-78.062,-128.5],[-78.75,-123.438]],"c":false}]},{"t":280,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-72.062,-128.375],[-72.75,-123.312]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"ochi 1","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-57.75,-112],[-75.562,-104]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":20,"s":[{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-63.75,-112.125],[-81.562,-104.125]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":40,"s":[{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-57.75,-112],[-75.562,-104]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":60,"s":[{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-63.75,-112.125],[-81.562,-104.125]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":80,"s":[{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-57.75,-112],[-75.562,-104]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":100,"s":[{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-63.75,-112.125],[-81.562,-104.125]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":120,"s":[{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-57.75,-112],[-75.562,-104]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":140,"s":[{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-63.75,-112.125],[-81.562,-104.125]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":160,"s":[{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-57.75,-112],[-75.562,-104]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":180,"s":[{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-63.75,-112.125],[-81.562,-104.125]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":200,"s":[{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-57.75,-112],[-75.562,-104]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":220,"s":[{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-63.75,-112.125],[-81.562,-104.125]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":240,"s":[{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-57.75,-112],[-75.562,-104]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":260,"s":[{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-63.75,-112.125],[-81.562,-104.125]],"c":false}]},{"t":280,"s":[{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-57.75,-112],[-75.562,-104]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"gura","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-10,-64],[6.688,-60.312]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":20,"s":[{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-16.312,-62.812],[0.375,-59.125]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":40,"s":[{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-10,-64],[6.688,-60.312]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":60,"s":[{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-16.312,-62.812],[0.375,-59.125]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":80,"s":[{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-10,-64],[6.688,-60.312]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":100,"s":[{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-16.312,-62.812],[0.375,-59.125]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":120,"s":[{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-10,-64],[6.688,-60.312]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":140,"s":[{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-16.312,-62.812],[0.375,-59.125]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":160,"s":[{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-10,-64],[6.688,-60.312]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":180,"s":[{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-16.312,-62.812],[0.375,-59.125]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":200,"s":[{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-10,-64],[6.688,-60.312]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":220,"s":[{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-16.312,-62.812],[0.375,-59.125]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":240,"s":[{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-10,-64],[6.688,-60.312]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":260,"s":[{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-16.312,-62.812],[0.375,-59.125]],"c":false}]},{"t":280,"s":[{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-10,-64],[6.688,-60.312]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"umar","np":3,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.625,-154.75],[0,0]],"o":[[-3.875,64.25],[-5.25,6.5],[0,0]],"v":[[-59.75,71.75],[-62.75,292.25],[-76.938,310.625]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"intre picioare","np":3,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-118.75,7.875],[-110,15.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"stanga covert 2","np":3,"cix":2,"bm":0,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.062,-21.25]],"o":[[0,0],[0,1.25]],"v":[[-106,-7.125],[-117.688,78.812]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"stanga covert 1","np":3,"cix":2,"bm":0,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-2.5,-2.5]],"o":[[0,0],[2.5,2.5]],"v":[[12,9.875],[22.75,23.375]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.898039275525,0.898039275525,0.898039275525,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"mana stanga 4","np":3,"cix":2,"bm":0,"ix":8,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-5.5,0.125],[0.473,-4.903],[5.785,0.076],[-1.5,15],[-28.75,10.375]],"o":[[1.448,-2.379],[4.925,-0.112],[-0.555,5.759],[-19.125,-0.25],[2.461,-24.609],[0,0]],"v":[[7,101.375],[14.375,95.25],[23.5,106.875],[12,119.875],[-11.625,79.625],[31.5,19.25]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949019667682,0.937254961799,0.921568687289,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"mana stanga 3","np":3,"cix":2,"bm":0,"ix":9,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[5.462,-0.603],[-0.785,-5.246],[-6.239,0.689],[0.893,5.973]],"o":[[-5.273,0.582],[0.928,6.208],[6.003,-0.663],[-0.813,-5.435]],"v":[[28,93.625],[19,106.75],[32,120.375],[40.5,104.375]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949019667682,0.937254961799,0.921568687289,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"mana stanga 2","np":3,"cix":2,"bm":0,"ix":10,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[5.703,-0.562],[-0.479,-5.351],[-4.502,0.444],[0.449,5.013]],"o":[[-5.347,0.527],[0.404,4.506],[5.009,-0.494],[-0.511,-5.708]],"v":[[41.625,88.75],[35.125,103.5],[43.875,113.875],[52.875,101.75]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949019667682,0.937254961799,0.921568687289,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"mana stanga 1","np":3,"cix":2,"bm":0,"ix":11,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.5,15],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[14.5,-15],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-48.75,-154.25],[-98,-114.875],[-75,-112],[-79,-60.875],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-130,301],[-110.018,308.884],[-104.114,311.213],[-91.452,311.194],[33.25,311],[30.5,124.25],[34.5,94.5],[60.75,58.75],[83,9],[6.5,-60.25],[11.75,-128.5],[-3.75,-149.5]],"c":true}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":20,"s":[{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.5,15],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[14.5,-15],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-55,-153.125],[-104.25,-113.75],[-81.25,-110.875],[-85.25,-59.75],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-133,310.812],[-104,310.935],[-91.001,310.99],[-61.952,310.819],[33.25,311],[30.5,124.25],[34.5,94.5],[60.75,58.75],[83,9],[0.25,-59.125],[5.5,-127.375],[-10,-148.375]],"c":true}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":40,"s":[{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.5,15],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[14.5,-15],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-48.75,-154.25],[-98,-114.875],[-75,-112],[-79,-60.875],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-130,301],[-110.018,308.884],[-104.114,311.213],[-91.452,311.194],[33.25,311],[30.5,124.25],[34.5,94.5],[60.75,58.75],[83,9],[6.5,-60.25],[11.75,-128.5],[-3.75,-149.5]],"c":true}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":60,"s":[{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.5,15],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[14.5,-15],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-55,-153.125],[-104.25,-113.75],[-81.25,-110.875],[-85.25,-59.75],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-133,310.812],[-104,310.935],[-91.001,310.99],[-61.952,310.819],[33.25,311],[30.5,124.25],[34.5,94.5],[60.75,58.75],[83,9],[0.25,-59.125],[5.5,-127.375],[-10,-148.375]],"c":true}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":80,"s":[{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.5,15],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[14.5,-15],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-48.75,-154.25],[-98,-114.875],[-75,-112],[-79,-60.875],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-130,301],[-110.018,308.884],[-104.114,311.213],[-91.452,311.194],[33.25,311],[30.5,124.25],[34.5,94.5],[60.75,58.75],[83,9],[6.5,-60.25],[11.75,-128.5],[-3.75,-149.5]],"c":true}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":100,"s":[{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.5,15],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[14.5,-15],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-55,-153.125],[-104.25,-113.75],[-81.25,-110.875],[-85.25,-59.75],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-133,310.812],[-104,310.935],[-91.001,310.99],[-61.952,310.819],[33.25,311],[30.5,124.25],[34.5,94.5],[60.75,58.75],[83,9],[0.25,-59.125],[5.5,-127.375],[-10,-148.375]],"c":true}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":120,"s":[{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.5,15],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[14.5,-15],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-48.75,-154.25],[-98,-114.875],[-75,-112],[-79,-60.875],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-130,301],[-110.018,308.884],[-104.114,311.213],[-91.452,311.194],[33.25,311],[30.5,124.25],[34.5,94.5],[60.75,58.75],[83,9],[6.5,-60.25],[11.75,-128.5],[-3.75,-149.5]],"c":true}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":140,"s":[{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.5,15],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[14.5,-15],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-55,-153.125],[-104.25,-113.75],[-81.25,-110.875],[-85.25,-59.75],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-133,310.812],[-104,310.935],[-91.001,310.99],[-61.952,310.819],[33.25,311],[30.5,124.25],[34.5,94.5],[60.75,58.75],[83,9],[0.25,-59.125],[5.5,-127.375],[-10,-148.375]],"c":true}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":160,"s":[{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.5,15],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[14.5,-15],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-48.75,-154.25],[-98,-114.875],[-75,-112],[-79,-60.875],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-130,301],[-110.018,308.884],[-104.114,311.213],[-91.452,311.194],[33.25,311],[30.5,124.25],[34.5,94.5],[60.75,58.75],[83,9],[6.5,-60.25],[11.75,-128.5],[-3.75,-149.5]],"c":true}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":180,"s":[{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.5,15],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[14.5,-15],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-55,-153.125],[-104.25,-113.75],[-81.25,-110.875],[-85.25,-59.75],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-133,310.812],[-104,310.935],[-91.001,310.99],[-61.952,310.819],[33.25,311],[30.5,124.25],[34.5,94.5],[60.75,58.75],[83,9],[0.25,-59.125],[5.5,-127.375],[-10,-148.375]],"c":true}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":200,"s":[{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.5,15],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[14.5,-15],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-48.75,-154.25],[-98,-114.875],[-75,-112],[-79,-60.875],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-130,301],[-110.018,308.884],[-104.114,311.213],[-91.452,311.194],[33.25,311],[30.5,124.25],[34.5,94.5],[60.75,58.75],[83,9],[6.5,-60.25],[11.75,-128.5],[-3.75,-149.5]],"c":true}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":220,"s":[{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.5,15],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[14.5,-15],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-55,-153.125],[-104.25,-113.75],[-81.25,-110.875],[-85.25,-59.75],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-133,310.812],[-104,310.935],[-91.001,310.99],[-61.952,310.819],[33.25,311],[30.5,124.25],[34.5,94.5],[60.75,58.75],[83,9],[0.25,-59.125],[5.5,-127.375],[-10,-148.375]],"c":true}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":240,"s":[{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.5,15],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[14.5,-15],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-48.75,-154.25],[-98,-114.875],[-75,-112],[-79,-60.875],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-130,301],[-110.018,308.884],[-104.114,311.213],[-91.452,311.194],[33.25,311],[30.5,124.25],[34.5,94.5],[60.75,58.75],[83,9],[6.5,-60.25],[11.75,-128.5],[-3.75,-149.5]],"c":true}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":260,"s":[{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.5,15],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[14.5,-15],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-55,-153.125],[-104.25,-113.75],[-81.25,-110.875],[-85.25,-59.75],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-133,310.812],[-104,310.935],[-91.001,310.99],[-61.952,310.819],[33.25,311],[30.5,124.25],[34.5,94.5],[60.75,58.75],[83,9],[0.25,-59.125],[5.5,-127.375],[-10,-148.375]],"c":true}]},{"t":280,"s":[{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-14.5,15],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[14.5,-15],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-48.75,-154.25],[-98,-114.875],[-75,-112],[-79,-60.875],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-130.062,300.875],[-110.032,308.855],[-104.114,311.213],[-91.452,311.194],[33.25,311],[30.5,124.25],[34.5,94.5],[60.75,58.75],[83,9],[6.5,-60.25],[11.75,-128.5],[-3.75,-149.5]],"c":true}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949019670486,0.937254965305,0.92156869173,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"body","np":3,"cix":2,"bm":0,"ix":12,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":281,"st":0,"bm":0}]},{"id":"comp_1","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[],"ip":0,"op":281,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"dude vorba carte","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":-68.546,"ix":10},"p":{"a":0,"k":[1190.562,381.125,0],"ix":2},"a":{"a":0,"k":[210.562,-215.125,0],"ix":1},"s":{"a":0,"k":[171.048,201.929,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[8.992,6.851],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.313725501299,0.313725501299,0.313725501299,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[218.653,-233.482],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[80.593,113.716],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[200.262,-226.495],[208.393,-223.016],[202.078,-218.519],[222.458,-212.334],[207.157,-205.711]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.313725501299,0.313725501299,0.313725501299,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1.75,10.75],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,101.433],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 2","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0.734,-0.111],[0,0],[0,0]],"o":[[0,0],[0,0],[-0.734,0.111],[0,0],[0,0]],"v":[[203.705,-237.352],[215.512,-231.705],[208.529,-226.786],[223.139,-222.205],[213.394,-216.3]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.313725501299,0.313725501299,0.313725501299,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-1.75,10.75],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,101.433],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ty":"rc","d":1,"s":{"a":0,"k":[34.625,53.5],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"r":{"a":0,"k":5,"ix":4},"nm":"Rectangle Path 1","mn":"ADBE Vector Shape - Rect","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":2,"ix":5},"lc":1,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[210.562,-215.125],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Rectangle 1","np":3,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":281,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"dude vorba 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1244.5,333.75,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[82.97,82.97,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-2.19,-6.296],[-21.167,5.65],[14.436,38.144],[32.994,0.452]],"o":[[24.256,38.87],[4.226,12.149],[17.033,-4.546],[-8.006,-21.154],[-32.994,-0.452]],"v":[[-12.957,-21.996],[-37.589,59.359],[2.636,86.703],[43.54,-29.227],[-14.162,-64.933]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949019667682,0.937254961799,0.921568687289,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-58.562,-126.938],[-59.312,-122.25]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"ochi 2","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-72.062,-128.375],[-72.75,-123.312]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"ochi 1","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[4.312,-6],[10.938,0.312]],"o":[[-4.312,6],[-10.938,-0.312]],"v":[[-57.75,-112],[-75.562,-104]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"gura","np":3,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-10,-64],[6.688,-60.312]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"umar","np":3,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.625,-154.75],[0,0]],"o":[[-3.875,64.25],[-5.25,6.5],[0,0]],"v":[[-59.75,71.75],[-62.75,292.25],[-76.938,310.625]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"intre picioare","np":3,"cix":2,"bm":0,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-118.75,7.875],[-110,15.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"stanga covert 2","np":3,"cix":2,"bm":0,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.062,-21.25]],"o":[[0,0],[0,1.25]],"v":[[-106,-7.125],[-117.688,78.812]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"stanga covert 1","np":3,"cix":2,"bm":0,"ix":8,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[26.946,7.821],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-48.75,-154.25],[-98,-114.875],[-75,-112],[-79,-60.875],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-132.561,311.245],[-110.47,311.144],[-104.114,311.213],[-91.452,311.194],[33.25,311],[30.5,124.25],[30.131,70.093],[29.413,20.483],[29.969,-19.926],[6.5,-60.25],[11.75,-128.5],[-3.75,-149.5]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949019670486,0.937254965305,0.92156869173,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"body","np":3,"cix":2,"bm":0,"ix":9,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":281,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"dude vorba 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[985.169,388.31,0],"ix":2},"a":{"a":0,"k":[-32.831,77.81,0],"ix":1},"s":{"a":0,"k":[-87.147,87.147,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":0,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-61.037,-100.837],[-65.483,-95.817],[-61.897,-91.729],[-56.017,-95.458]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":10,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-61.037,-100.837],[-65.483,-95.817],[-61.682,-94.669],[-56.017,-95.458]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":20,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-60.965,-98.04],[-67.993,-96.175],[-62.399,-91.298],[-56.017,-95.458]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":30,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-60.965,-98.04],[-67.993,-96.175],[-61.969,-93.737],[-56.017,-95.458]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":40,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-60.965,-98.04],[-64.479,-95.673],[-61.682,-89.362],[-58.383,-95.315]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":50,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-60.965,-98.04],[-67.348,-95.673],[-61.467,-93.163],[-53.65,-95.386]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":60,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-61.109,-100.191],[-67.348,-95.673],[-61.467,-93.163],[-53.65,-95.386]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":70,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-61.539,-97.394],[-69.069,-96.534],[-63.834,-90.581],[-53.65,-95.386]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":80,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-61.037,-100.837],[-65.483,-95.817],[-61.897,-91.729],[-56.017,-95.458]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":90,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-61.037,-100.837],[-65.483,-95.817],[-61.682,-94.669],[-56.017,-95.458]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":100,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-60.965,-98.04],[-67.993,-96.175],[-62.399,-91.298],[-56.017,-95.458]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":110,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-60.965,-98.04],[-67.993,-96.175],[-61.969,-93.737],[-56.017,-95.458]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":120,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-60.965,-98.04],[-64.479,-95.673],[-61.682,-89.362],[-58.383,-95.315]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":130,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-60.965,-98.04],[-67.348,-95.673],[-61.467,-93.163],[-53.65,-95.386]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":140,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-61.109,-100.191],[-67.348,-95.673],[-61.467,-93.163],[-53.65,-95.386]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":150,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-61.539,-97.394],[-69.069,-96.534],[-63.834,-90.581],[-53.65,-95.386]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":160,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-61.037,-100.837],[-65.483,-95.817],[-61.897,-91.729],[-56.017,-95.458]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":170,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-61.037,-100.837],[-65.483,-95.817],[-61.682,-94.669],[-56.017,-95.458]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":180,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-60.965,-98.04],[-67.993,-96.175],[-62.399,-91.298],[-56.017,-95.458]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":190,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-60.965,-98.04],[-67.993,-96.175],[-61.969,-93.737],[-56.017,-95.458]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":200,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-60.965,-98.04],[-64.479,-95.673],[-61.682,-89.362],[-58.383,-95.315]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":210,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-60.965,-98.04],[-67.348,-95.673],[-61.467,-93.163],[-53.65,-95.386]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":220,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-61.109,-100.191],[-67.348,-95.673],[-61.467,-93.163],[-53.65,-95.386]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":230,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-61.539,-97.394],[-69.069,-96.534],[-63.834,-90.581],[-53.65,-95.386]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":240,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-61.037,-100.837],[-65.483,-95.817],[-61.897,-91.729],[-56.017,-95.458]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":250,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-61.037,-100.837],[-65.483,-95.817],[-61.682,-94.669],[-56.017,-95.458]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":260,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-60.965,-98.04],[-67.993,-96.175],[-62.399,-91.298],[-56.017,-95.458]],"c":true}]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":270,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-60.965,-98.04],[-67.993,-96.175],[-61.969,-93.737],[-56.017,-95.458]],"c":true}]},{"t":280,"s":[{"i":[[2.451,0.093],[0.222,-2.224],[-1.851,-0.07],[-0.237,2.368]],"o":[[-2.234,-0.085],[-0.184,1.843],[2.379,0.09],[0.244,-2.44]],"v":[[-61.037,-100.837],[-65.483,-95.817],[-61.897,-91.729],[-56.017,-95.458]],"c":true}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":4,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949019667682,0.937254961799,0.921568687289,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[25,32.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[137,137],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"gura","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[10.75,1.5],[15.318,6.867],[4.32,2.179],[-2.021,0.89],[0,0],[3.941,3.44],[-2.309,0.505],[0,0],[-3.586,8.276],[0,0],[-3.649,3.492],[-0.849,-1.659],[0,0],[-25.625,9.375]],"o":[[-14.461,12.26],[-18.455,-2.575],[-4.415,-1.979],[-1.972,-0.995],[5.428,-2.391],[0,0],[-1.781,-1.554],[4.976,-1.089],[0,0],[3.815,-8.806],[0,0],[1.346,-1.288],[2.086,4.076],[0,0],[25.625,-9.375]],"v":[[30.88,60.317],[-22.411,67],[-65.217,49.943],[-70.227,47.239],[-71.447,38.051],[-65.118,36.402],[-71.899,33.483],[-68.053,24.262],[-64.28,24.338],[-80.114,14.242],[-56.411,16],[-54.786,1.25],[-47.661,5.25],[-41.661,19.625],[9.089,20.25]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":1,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"mana","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-58.562,-126.938],[-59.312,-122.25]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"ochi 2","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-72.062,-128.375],[-72.75,-123.312]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"ochi 1","np":3,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[-7.625,-0.938],[0,0]],"o":[[7.625,0.938],[0,0]],"v":[[-10,-64],[6.688,-60.312]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"umar","np":3,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-1.625,-154.75],[0,0]],"o":[[-3.875,64.25],[-5.25,6.5],[0,0]],"v":[[-59.75,71.75],[-62.75,292.25],[-76.938,310.625]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"intre picioare","np":3,"cix":2,"bm":0,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-118.75,7.875],[-110,15.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"stanga covert 2","np":3,"cix":2,"bm":0,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0.062,-21.25]],"o":[[0,0],[0,1.25]],"v":[[-106,-7.125],[-117.688,78.812]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"stanga covert 1","np":3,"cix":2,"bm":0,"ix":8,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[14.815,-2.834],[0,0],[0,0],[-0.25,-4.625],[18,-20],[-41.5,-23],[-9.5,-70],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[-7.822,11.48],[0.25,24],[50.25,10.75],[2.603,22.668],[8.005,3.407]],"o":[[-28.75,5.5],[0,0],[0,0],[-19.5,3.375],[-23.371,25.968],[0,0],[-1.25,2.5],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[10.294,-15.109],[-0.25,-24],[1.25,-12],[-0.993,-8.643],[-13.879,-5.907]],"v":[[-48.75,-154.25],[-98,-114.875],[-75,-112],[-79,-60.875],[-130.75,-25.25],[-117.75,78.75],[-112.25,284.5],[-133.442,311.041],[-112.887,311.179],[-104.114,311.213],[-91.452,311.194],[33.25,311],[30.5,124.25],[31.203,60.318],[45.756,43.025],[61.125,-9.625],[6.5,-60.25],[11.75,-128.5],[-3.75,-149.5]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949019670486,0.937254965305,0.92156869173,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"body","np":3,"cix":2,"bm":0,"ix":9,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":281,"st":0,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"bulina 4","parent":6,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.25],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":143,"s":[100]},{"t":153,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.889},"o":{"x":0.77,"y":0},"t":118,"s":[1096.957,255.391,0],"to":[0,-98.986,0],"ti":[0,98.986,0]},{"t":178,"s":[1096.957,-338.522,0]}],"ix":2},"a":{"a":0,"k":[-459.5,100.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.31,0.31,0.31],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.34,0.34,16.667]},"t":68,"s":[0,0,100]},{"t":88,"s":[42.609,42.609,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-4.75,-1.5]],"o":[[0,0],[4.75,1.5]],"v":[[-483.75,135.75],[-474.25,142]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":46,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":2,"lj":1,"ml":1,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 2","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-2.75,-24]],"o":[[0,0],[2.75,24]],"v":[[-451.25,65.25],[-425.25,95]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":46,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[99,99],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.83137254902,0.298039215686,0.227450980392,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-459.5,100.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false}],"ip":48,"op":281,"st":48,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"bulina 3","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.25],"y":[1]},"o":{"x":[0.167],"y":[0.117]},"t":256,"s":[100]},{"t":263,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.903},"o":{"x":0.77,"y":0},"t":220,"s":[1780.75,366.7,0],"to":[0,-113.833,0],"ti":[0,113.833,0]},{"t":280,"s":[1780.75,-316.3,0]}],"ix":2},"a":{"a":0,"k":[-459.5,100.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.31,0.31,0.31],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.216,0.216,16.667]},"t":170,"s":[0,0,100]},{"t":190,"s":[77,77,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-4.75,-1.5]],"o":[[0,0],[4.75,1.5]],"v":[[-483.75,135.75],[-474.25,142]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":46,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":2,"lj":1,"ml":1,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 2","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-2.75,-24]],"o":[[0,0],[2.75,24]],"v":[[-451.25,65.25],[-425.25,95]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":46,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[99,99],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.83137254902,0.298039215686,0.227450980392,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-459.5,100.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false}],"ip":150,"op":281,"st":150,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"bulina 2","parent":5,"sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.25],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":203,"s":[100]},{"t":213,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.819},"o":{"x":0.77,"y":0},"t":160,"s":[564.296,406.374,0],"to":[0,-61.033,0],"ti":[0,61.033,0]},{"t":220,"s":[564.296,40.177,0]}],"ix":2},"a":{"a":0,"k":[-459.5,100.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.31,0.31,0.31],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.321,0.321,16.667]},"t":110,"s":[0,0,100]},{"t":130,"s":[-42.036,42.036,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-4.75,-1.5]],"o":[[0,0],[4.75,1.5]],"v":[[-483.75,135.75],[-474.25,142]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":46,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":2,"lj":1,"ml":1,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 2","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-2.75,-24]],"o":[[0,0],[2.75,24]],"v":[[-451.25,65.25],[-425.25,95]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":46,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[99,99],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.83137254902,0.298039215686,0.227450980392,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-459.5,100.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false}],"ip":90,"op":281,"st":90,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"bulina","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.25],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":104,"s":[100]},{"t":114,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.77,"y":0},"t":63,"s":[126.5,338.7,0],"to":[0,-66.167,0],"ti":[0,66.167,0]},{"t":123,"s":[126.5,-58.3,0]}],"ix":2},"a":{"a":0,"k":[-459.5,100.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.31,0.31,0.31],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0.167,0.167,16.667]},"t":13,"s":[0,0,100]},{"t":33,"s":[100,100,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-4.75,-1.5]],"o":[[0,0],[4.75,1.5]],"v":[[-483.75,135.75],[-474.25,142]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":46,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":2,"lj":1,"ml":1,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 2","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-2.75,-24]],"o":[[0,0],[2.75,24]],"v":[[-451.25,65.25],[-425.25,95]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[1,1,1,1],"ix":3},"o":{"a":0,"k":46,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[99,99],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.83137254902,0.298039215686,0.227450980392,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-459.5,100.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false}],"ip":4,"op":281,"st":-7,"bm":0},{"ddd":0,"ind":5,"ty":0,"nm":"dude casti","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[903,510,0],"ix":2},"a":{"a":0,"k":[960,540,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":1920,"h":1080,"ip":0,"op":281,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":0,"nm":"Pre-comp 1","refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[968,590,0],"ix":2},"a":{"a":0,"k":[960,540,0],"ix":1},"s":{"a":0,"k":[115,115,100],"ix":6}},"ao":0,"w":1920,"h":1080,"ip":0,"op":281,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"dude tableta","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1702.69,671.624,0],"ix":2},"a":{"a":0,"k":[-761.31,161.624,0],"ix":1},"s":{"a":0,"k":[-108.727,108.727,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[2.14,-12.33],[0,0],[0.953,-8.239],[0,0],[0.809,-9.448],[-31.291,6.954],[-0.441,14.518],[0.713,16.712]],"o":[[0,0],[-1.623,9.352],[0,0],[-1.427,12.33],[0,0],[0.234,9.751],[14.674,-3.261],[0.579,-19.082],[0,0]],"v":[[-615.845,109.146],[-654.936,112.859],[-624.985,128.643],[-658.999,131.081],[-632.034,148.391],[-656.865,157.047],[-594.038,168.452],[-575.187,102.624],[-576.716,45.56]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.941177009134,0.925490016563,0.909803981407,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 4","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[1.223,-2.853]],"o":[[7.235,3.057],[-1.223,2.853]],"v":[[-682.794,107.21],[-681.062,120.966]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549024224,0.168627455831,0.164705887437,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 3","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[15.693,10.19],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549024224,0.168627455831,0.164705887437,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[-681.571,121.578],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[68.493,82.54],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.31,"y":1},"o":{"x":0.333,"y":0},"t":40,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-696.375,-129.5],[-703.75,-120.625]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.333,"y":0},"t":47,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-703.712,-120.589],[-703.75,-120.625]],"c":false}]},{"t":54,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-696.375,-129.5],[-703.75,-120.625]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[97.105,92.582],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":1,"k":[{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":40,"s":[100]},{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":46,"s":[100]},{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":47,"s":[0]},{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":48,"s":[100]},{"t":54,"s":[100]}],"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"ochi 2","np":3,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":40,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-696.375,-129.5],[-703.75,-120.625]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":47,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-703.75,-120.625],[-703.75,-120.625]],"c":false}]},{"t":54,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-696.375,-129.5],[-703.75,-120.625]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":1,"k":[{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":40,"s":[100]},{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":46,"s":[100]},{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":47,"s":[0]},{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":48,"s":[100]},{"t":54,"s":[100]}],"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"ochi 1","np":3,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[8.425,10.454],[-5.633,-3.211],[2.181,6.222]],"o":[[-8.59,6.085],[5.727,3.265],[-3.057,-2.816]],"v":[[-721.505,-103.02],[-720.897,-81.069],[-703.125,-89.75]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"gura","np":3,"cix":2,"bm":0,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[1.75,-16.25],[-3.924,-4.988],[0,0]],"o":[[0,0],[-0.68,6.31],[6.128,7.789],[0,0]],"v":[[-742,221.5],[-767.75,470],[-760.25,487.5],[-738.25,507.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"intre picioare","np":3,"cix":2,"bm":0,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-69.75,15.5],[2.204,2.694],[0,0],[-7.656,3.075],[2.611,2.327],[0,0],[-9.618,3.332],[2.491,1.999],[0,0]],"o":[[0,0],[3.398,-0.755],[-3.528,-4.312],[0,0],[3.82,-1.534],[-5.824,-5.189],[0,0],[3.018,-1.046],[-19.625,-15.75],[0,0]],"v":[[-860,153.5],[-731,155.75],[-728,146.875],[-744.5,139.25],[-718,137.625],[-716.625,127.375],[-737.5,120.25],[-707,118.75],[-705.75,109.25],[-750.5,95.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"mana dreapta","np":3,"cix":2,"bm":0,"ix":8,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-19.23,-4.132],[0,0],[-6.625,7.25],[0,0],[1.375,8.625],[-9.5,0.25],[5.948,7.629],[0,0]],"o":[[0,0],[15.125,3.25],[0,0],[2.875,-7.5],[0,0],[-1.75,-11.625],[9.5,-0.25],[-9.739,-12.491],[0,0]],"v":[[-834.125,101],[-856,151.875],[-771,161.75],[-726.75,152.375],[-745.875,139.25],[-714,132.875],[-737.75,119.375],[-703.5,112.375],[-753.5,94.375]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949019667682,0.937254961799,0.921568687289,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"fill mana","np":3,"cix":2,"bm":0,"ix":9,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[1.18,-3.198],[0.666,-3.706],[-12.395,0.012],[-1.978,7.116]],"o":[[-2.767,7.5],[5.353,0.982],[1.259,-3.249],[-4.424,-3.889]],"v":[[-712.737,50.696],[-757.949,175.623],[-653.789,185.56],[-617.536,65.142]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":1,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"foaie fata","np":3,"cix":2,"bm":0,"ix":10,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.25,"y":1},"o":{"x":0.167,"y":0.167},"t":43,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-857,52.5],[-757.75,74],[-712.622,73.334]],"c":false}]},{"i":{"x":0.25,"y":1},"o":{"x":0.167,"y":0.167},"t":63,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-857,52.5],[-757.75,74],[-715.475,84.136]],"c":false}]},{"i":{"x":0.25,"y":1},"o":{"x":0.167,"y":0.167},"t":69,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-857,52.5],[-757.75,74],[-715.475,84.136]],"c":false}]},{"i":{"x":0.25,"y":1},"o":{"x":0.167,"y":0},"t":99,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-857,52.5],[-757.75,74],[-712.622,73.334]],"c":false}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":184,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-857,52.5],[-757.75,74],[-712.622,73.334]],"c":false}]},{"i":{"x":0.25,"y":1},"o":{"x":0.167,"y":0.167},"t":195,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[33.083,7.167],[0,0],[0,0]],"v":[[-857,52.5],[-757.75,74],[-715.095,82.695]],"c":false}]},{"i":{"x":0.25,"y":1},"o":{"x":0.167,"y":0.167},"t":204,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-857,52.5],[-757.75,74],[-715.475,84.136]],"c":false}]},{"i":{"x":0.25,"y":1},"o":{"x":0.167,"y":0.167},"t":210,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-857,52.5],[-757.75,74],[-715.475,84.136]],"c":false}]},{"t":240,"s":[{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[-857,52.5],[-757.75,74],[-712.622,73.334]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"cover mana 1","np":3,"cix":2,"bm":0,"ix":13,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0.507,-2.063],[0,0],[0,0],[0,0],[-3.896,13.653],[1.834,0.46],[32.451,5.597]],"o":[[-3.584,14.583],[0,0],[0,0],[0,0],[0.519,-1.819],[-31.94,-8.017],[-2.094,-0.361]],"v":[[-721.21,23.346],[-727.834,69.71],[-723.724,69.789],[-631.538,84.894],[-615.496,45.434],[-619.004,40.975],[-715.609,20.304]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":0,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":59,"s":[20]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":103,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":152,"s":[20]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":197,"s":[100]},{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":249,"s":[20]},{"t":276,"s":[100]}],"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"lumina","np":3,"cix":2,"bm":0,"ix":14,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[18.138,-2.895],[7.3,-9.981],[0,0],[20.452,-14.987],[5.837,-19.263],[-0.918,-25.032],[-12.425,-15.957],[0,0],[0,0],[0,0],[0,0],[0,0],[-2.235,23.473],[-6.736,5.318],[0,0],[-3.314,11.084],[2.348,15.296],[19.587,21.096],[0,0],[0,0],[0,0],[30,29.75]],"o":[[-9.931,1.585],[-19.207,26.26],[0,0],[-17.891,13.11],[-7.264,23.973],[0.741,20.21],[9.66,12.405],[0,0],[0,0],[0,0],[0,0],[0,0],[1.649,-17.322],[7.91,-6.245],[0,0],[9.136,-30.558],[-3.956,-25.776],[-33.956,-36.573],[0,0],[0,0],[0,0],[-13.042,-12.933]],"v":[[-723.5,-183.375],[-752,-159.625],[-802.125,-75.875],[-881.25,-50.875],[-909.25,2.625],[-920,77],[-904.375,135.625],[-860.625,153.25],[-877.75,506.75],[-643.875,507.875],[-669.625,479.875],[-655.252,271.978],[-647.453,201.67],[-638.05,147.035],[-616.432,154.55],[-581.534,147.573],[-576.822,43.104],[-610.364,-23.429],[-683.25,-74.5],[-664.25,-95.5],[-640.125,-84.75],[-675.25,-171.875]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949019667682,0.937254961799,0.921568687289,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"body 1","np":3,"cix":2,"bm":0,"ix":15,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":281,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":4,"nm":"Dude Foi","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[196.69,675.624,0],"ix":2},"a":{"a":0,"k":[-761.31,161.624,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-638.875,59.5],[-729.625,60.5],[-730.875,72.625],[-723.631,72.365],[-721.621,67.038],[-663.625,73.746],[-639.25,76.625]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":80,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-638.875,59.5],[-729.625,60.5],[-730.875,72.625],[-723.631,72.365],[-721.621,67.038],[-663.625,73.746],[-639.25,76.625]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":100,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-638.573,50.439],[-729.323,51.439],[-730.875,72.625],[-723.631,72.365],[-721.621,67.038],[-663.625,73.746],[-639.25,76.625]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":130,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-638.573,50.439],[-729.323,51.439],[-730.875,72.625],[-723.631,72.365],[-721.621,67.038],[-663.625,73.746],[-639.25,76.625]],"c":true}]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0.167},"t":200,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-638.573,50.439],[-729.323,51.439],[-730.875,72.625],[-723.631,72.365],[-721.621,67.038],[-663.625,73.746],[-639.25,76.625]],"c":true}]},{"t":220,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-638.875,59.5],[-729.625,60.5],[-730.875,72.625],[-723.631,72.365],[-721.621,67.038],[-663.625,73.746],[-639.25,76.625]],"c":true}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":1,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"foaie mijloc","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0.167},"t":0,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-667.125,41.5],[-749.375,46.75],[-746.5,73.375],[-723.688,72.438],[-721.562,66.875],[-663.938,73.875]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":80,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-667.125,41.5],[-749.375,46.75],[-746.5,73.375],[-723.688,72.438],[-721.562,66.875],[-663.938,73.875]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":100,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-666.219,52.373],[-748.469,57.623],[-746.5,73.375],[-723.688,72.438],[-721.562,66.875],[-663.938,73.875]],"c":true}]},{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":130,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-666.219,52.373],[-748.469,57.623],[-746.5,73.375],[-723.688,72.438],[-721.562,66.875],[-663.938,73.875]],"c":true}]},{"i":{"x":0.833,"y":1},"o":{"x":0.167,"y":0.167},"t":200,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-666.219,52.373],[-748.469,57.623],[-746.5,73.375],[-723.688,72.438],[-721.562,66.875],[-663.938,73.875]],"c":true}]},{"t":220,"s":[{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[-667.125,41.5],[-749.375,46.75],[-746.5,73.375],[-723.688,72.438],[-721.562,66.875],[-663.938,73.875]],"c":true}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":1,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"foaie spate","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.31,"y":1},"o":{"x":0.333,"y":0},"t":40,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-696.375,-129.5],[-703.75,-120.625]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.333,"y":0},"t":47,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-703.712,-120.589],[-703.75,-120.625]],"c":false}]},{"t":54,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-696.375,-129.5],[-703.75,-120.625]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[97.105,92.582],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":1,"k":[{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":40,"s":[100]},{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":46,"s":[100]},{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":47,"s":[0]},{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":48,"s":[100]},{"t":54,"s":[100]}],"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"ochi 2","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":40,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-696.375,-129.5],[-703.75,-120.625]],"c":false}]},{"i":{"x":0.31,"y":1},"o":{"x":0.167,"y":0.167},"t":47,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-703.75,-120.625],[-703.75,-120.625]],"c":false}]},{"t":54,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-696.375,-129.5],[-703.75,-120.625]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":1,"k":[{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":40,"s":[100]},{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":46,"s":[100]},{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":47,"s":[0]},{"i":{"x":[0.31],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":48,"s":[100]},{"t":54,"s":[100]}],"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"ochi 1","np":3,"cix":2,"bm":0,"ix":4,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-12.625,-4.25]],"o":[[0,0],[12.625,4.25]],"v":[[-720.125,-103.25],[-703.125,-89.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"gura","np":3,"cix":2,"bm":0,"ix":5,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[1.75,-16.25],[-3.924,-4.988],[0,0]],"o":[[0,0],[-0.68,6.31],[6.128,7.789],[0,0]],"v":[[-742,221.5],[-767.75,470],[-760.25,487.5],[-738.25,507.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"intre picioare","np":3,"cix":2,"bm":0,"ix":6,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-69.75,15.5],[2.204,2.694],[0,0],[-7.656,3.075],[2.611,2.327],[0,0],[-9.618,3.332],[2.491,1.999],[0,0]],"o":[[0,0],[3.398,-0.755],[-3.528,-4.312],[0,0],[3.82,-1.534],[-5.824,-5.189],[0,0],[3.018,-1.046],[-19.625,-15.75],[0,0]],"v":[[-860,153.5],[-731,155.75],[-728,146.875],[-744.5,139.25],[-718,137.625],[-716.625,127.375],[-737.5,120.25],[-707,118.75],[-705.75,109.25],[-750.5,95.75]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"mana dreapta","np":3,"cix":2,"bm":0,"ix":7,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-19.23,-4.132],[0,0],[-6.625,7.25],[0,0],[1.375,8.625],[-9.5,0.25],[5.948,7.629],[0,0]],"o":[[0,0],[15.125,3.25],[0,0],[2.875,-7.5],[0,0],[-1.75,-11.625],[9.5,-0.25],[-9.739,-12.491],[0,0]],"v":[[-834.125,101],[-856,151.875],[-771,161.75],[-726.75,152.375],[-745.875,139.25],[-714,132.875],[-737.75,119.375],[-703.5,112.375],[-753.5,94.375]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949019667682,0.937254961799,0.921568687289,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"fill mana","np":3,"cix":2,"bm":0,"ix":8,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[-721.5,67],[-768.75,190.5],[-670.5,195.75],[-621,79]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":1,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"foaie fata","np":3,"cix":2,"bm":0,"ix":9,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[93.75,22.75],[0,0]],"v":[[-860,67.5],[-708.75,71.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"cover mana 1","np":3,"cix":2,"bm":0,"ix":12,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[18.138,-2.895],[7.3,-9.981],[0,0],[20.452,-14.987],[5.837,-19.263],[-0.918,-25.032],[-12.425,-15.957],[0,0],[0,0],[0,0],[0,0],[0,0],[-2,78],[9.798,24.167],[0,0],[0,0],[0,0],[30,29.75]],"o":[[-9.931,1.585],[-19.207,26.26],[0,0],[-17.891,13.11],[-7.264,23.973],[0.741,20.21],[9.66,12.405],[0,0],[0,0],[0,0],[0,0],[0,0],[0.668,-26.069],[-18.75,-46.25],[0,0],[0,0],[0,0],[-13.042,-12.933]],"v":[[-723.5,-183.375],[-752,-159.625],[-802.125,-75.875],[-881.25,-50.875],[-909.25,2.625],[-920,77],[-904.375,135.625],[-860.625,153.25],[-877.75,506.75],[-643.875,507.875],[-669.625,479.875],[-646.75,149],[-602.5,59],[-623,-16.5],[-683.25,-74.5],[-664.25,-95.5],[-640.125,-84.75],[-675.25,-171.875]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.172549019608,0.16862745098,0.164705882353,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":7,"ix":5},"lc":2,"lj":2,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.949019667682,0.937254961799,0.921568687289,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"body 1","np":3,"cix":2,"bm":0,"ix":13,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":281,"st":0,"bm":0}],"markers":[]}');

/***/ }),

/***/ 46265:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"v":"4.8.0","meta":{"g":"LottieFiles AE ","a":"","k":"","d":"","tc":""},"fr":60,"ip":0,"op":421,"w":1920,"h":1080,"nm":"MAIN D2 C3 v1","ddd":0,"assets":[{"id":"comp_0","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"dot 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":0,"s":[69,81.875,0],"to":[0,-0.812,0],"ti":[0,1.917,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":60,"s":[69,77,0],"to":[0,-1.917,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":120,"s":[69,70.375,0],"to":[0,0,0],"ti":[0,-1.917,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":180,"s":[69,77,0],"to":[0,1.917,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":240,"s":[69,81.875,0],"to":[0,0,0],"ti":[0,1.917,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":300,"s":[69,77,0],"to":[0,-1.917,0],"ti":[0,-0.812,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":360,"s":[69,70.375,0],"to":[0,0.812,0],"ti":[0,-1.917,0]},{"i":{"x":0.667,"y":0.667},"o":{"x":0.333,"y":0.333},"t":420,"s":[69,81.875,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":480,"s":[69,81.875,0],"to":[0,-0.812,0],"ti":[0,1.917,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":540,"s":[69,77,0],"to":[0,-1.917,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":600,"s":[69,70.375,0],"to":[0,0,0],"ti":[0,-1.917,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":660,"s":[69,77,0],"to":[0,1.917,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":720,"s":[69,81.875,0],"to":[0,0,0],"ti":[0,1.917,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":780,"s":[69,77,0],"to":[0,-1.917,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":840,"s":[69,70.375,0],"to":[0,0,0],"ti":[0,-1.917,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":900,"s":[69,77,0],"to":[0,1.917,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":960,"s":[69,81.875,0],"to":[0,0,0],"ti":[0,1.917,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":1020,"s":[69,77,0],"to":[0,-1.917,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":1080,"s":[69,70.375,0],"to":[0,0,0],"ti":[0,-1.917,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":1140,"s":[69,77,0],"to":[0,1.917,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":1200,"s":[69,81.875,0],"to":[0,0,0],"ti":[0,1.917,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":1260,"s":[69,77,0],"to":[0,-1.917,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":1320,"s":[69,70.375,0],"to":[0,0,0],"ti":[0,-1.917,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":1380,"s":[69,77,0],"to":[0,1.917,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":1440,"s":[69,81.875,0],"to":[0,0,0],"ti":[0,1.917,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":1500,"s":[69,77,0],"to":[0,-1.917,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":1560,"s":[69,70.375,0],"to":[0,0,0],"ti":[0,-1.917,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":1620,"s":[69,77,0],"to":[0,1.917,0],"ti":[0,-0.812,0]},{"t":1680,"s":[69,81.875,0]}],"ix":2},"a":{"a":0,"k":[-338.5,-20.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-9.25,-3.5]],"o":[[0,0],[9.25,3.5]],"v":[[-372.5,11.75],[-358.5,24.25]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.949019607843,0.937254901961,0.921568627451,1],"ix":3},"o":{"a":0,"k":28,"ix":4},"w":{"a":0,"k":5,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 2","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-3.25,-25.5]],"o":[[0,0],[3.25,25.5]],"v":[[-326.25,-63.75],[-294,-26]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.949019607843,0.937254901961,0.921568627451,1],"ix":3},"o":{"a":0,"k":62,"ix":4},"w":{"a":0,"k":9,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[111,111],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.83137254902,0.298039215686,0.227450980392,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[-338.5,-20.5],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":1800,"st":0,"bm":0}]},{"id":"comp_1","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"bec4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-659,91],[-489.5,69.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.964705822515,1,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":13,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 2","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-626.5,35],[-485,21.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.964705822515,1,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":13,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":600,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"bec3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[43.013,46.061],[-13.546,-10.733],[-19.232,4.11],[-18.645,14.136],[1.458,23.123],[2.5,-32.5],[-33.976,-14.666],[-29.391,14.383],[26.5,-1],[17.657,-24.782],[0,0]],"o":[[0,0],[-63.5,-68],[15.415,12.213],[22.881,-4.89],[18.463,-13.997],[-0.965,-15.304],[-2.838,36.897],[30.042,12.968],[23.5,-11.5],[-30.407,1.147],[-24.348,34.172],[0,0]],"v":[[-590.5,-68],[-618,-215.5],[-694,-205],[-604,-188.5],[-539,-215],[-494.5,-267.5],[-554,-253],[-477.5,-180.5],[-381.5,-201],[-408.5,-235],[-473.5,-191.5],[-504.5,-69.5]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.964705822515,1,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":13,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":600,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"bec2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[6.419,-47.477],[-14.651,-4.597],[-49.67,5.799],[-7.045,18.469]],"o":[[0,0],[0,0],[-2.057,15.217],[47.713,14.972],[19.633,-2.292],[19.091,-50.049]],"v":[[-448,-35],[-647.5,-31],[-692.5,105.5],[-671.5,146.5],[-522,159],[-474.5,123.5]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.964705822515,1,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":13,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":600,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"bec1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-7.824,7.671],[-20.468,15.434],[-18.726,18.233],[-7.363,16.935],[3.775,15.553],[16.394,13.684],[32.003,9.27],[36.718,-0.256],[33.941,-10.246],[32.894,-21.484],[7.427,-14.097],[0.924,-19.486],[-11.185,-17.655],[-16.173,-10.285],[-16.38,-14.124],[0,0]],"o":[[2.225,-7.276],[18.305,-17.946],[20.869,-15.736],[13.231,-12.883],[6.381,-14.677],[-5.037,-20.752],[-25.579,-21.351],[-35.269,-10.216],[-35.453,0.247],[-37.612,11.355],[-13.341,8.713],[-9.093,17.259],[-0.99,20.876],[10.257,16.191],[18.25,11.606],[12.324,10.627],[0,0]],"v":[[-463,-36],[-452,-61],[-390,-106.5],[-328,-154.5],[-295,-199],[-288,-246.5],[-320,-302],[-409,-347.5],[-518.5,-359.5],[-624,-346],[-730.5,-295.5],[-759.5,-257.5],[-779.5,-202.5],[-765,-141.5],[-719,-107],[-662,-76],[-635.5,-35]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.964705822515,1,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":13,"ix":5},"lc":2,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":600,"st":0,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1609.75,546,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[35.294,35.294,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1659,728,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[57.516,57.516,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1418,372,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[28.35,28.35,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":21,"s":[0]},{"t":31,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":0,"s":[1548,1115,0],"to":[0.5,-129.167,0],"ti":[-0.5,129.167,0]},{"t":120,"s":[1551,340,0]}],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":260,"s":[35.294,35.294,100]},{"t":280,"s":[0,0,100]}],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1359,888,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[84.15,84.15,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":249,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":250,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":274,"s":[0]},{"t":284,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":131,"s":[1461,75,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.79,"y":0},"t":257,"s":[1461,1003,0],"to":[0,0,0],"ti":[0,0,0]},{"t":362,"s":[1461,75,0]}],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":111,"s":[81.046,81.046,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":131,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":255,"s":[0,0,100]},{"t":256,"s":[81.046,81.046,100]}],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1177,362,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[37.908,37.908,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":53,"s":[0]},{"t":63,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":25,"s":[1208,1119,0],"to":[0,-79.333,0],"ti":[0,79.333,0]},{"t":145,"s":[1208,643,0]}],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[37.908,37.908,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":327,"s":[37.908,37.908,100]},{"t":347,"s":[0,0,100]}],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":9,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1700,987,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[45.752,45.752,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":10,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1790,410,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[45.752,45.752,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":11,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1095,157,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[45.752,45.752,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":12,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":79,"s":[0]},{"t":89,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":55,"s":[1735,1139,0],"to":[0,-171,0],"ti":[0,171,0]},{"t":175,"s":[1735,113,0]}],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[45.752,45.752,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":268,"s":[45.752,45.752,100]},{"t":288,"s":[0,0,100]}],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":13,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":47,"s":[0]},{"t":57,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":0,"s":[1096,1136,0],"to":[2.167,-51,0],"ti":[-2.167,51,0]},{"t":120,"s":[1109,830,0]}],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[54.82,54.82,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":220,"s":[54.82,54.82,100]},{"t":240,"s":[0,0,100]}],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":14,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[867,767,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[39.134,39.134,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":425,"st":0,"bm":0},{"ddd":0,"ind":15,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1017,340,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[31.291,31.291,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":425,"st":0,"bm":0},{"ddd":0,"ind":16,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[828,82,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[74.428,74.428,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":425,"st":0,"bm":0},{"ddd":0,"ind":17,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":55,"s":[0]},{"t":65,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":29,"s":[788,1131,0],"to":[0,-135.667,0],"ti":[0,135.667,0]},{"t":149,"s":[788,317,0]}],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[53.595,53.595,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":370,"s":[53.595,53.595,100]},{"t":390,"s":[0,0,100]}],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":18,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1440,522,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[53.595,53.595,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":19,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[507,49,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[22.222,22.222,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":20,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[59,300,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[22.222,22.222,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":21,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[644,367,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[22.222,22.222,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":22,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[195,773,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[22.222,22.222,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":23,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":297,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":298,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":314,"s":[0]},{"t":324,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":186,"s":[591,849,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":303,"s":[591,1134,0],"to":[0,0,0],"ti":[0,0,0]},{"t":348,"s":[591,849,0]}],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":166,"s":[22.222,22.222,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":186,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":302,"s":[0,0,100]},{"t":303,"s":[22.222,22.222,100]}],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":24,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[363,999,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[75.817,75.817,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":25,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[861,969,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[53.595,53.595,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":26,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[96,580,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[73.203,73.203,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":27,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":23,"s":[0]},{"t":33,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":0,"s":[115,1139,0],"to":[0,-172.333,0],"ti":[0,172.333,0]},{"t":120,"s":[115,105,0]}],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":1,"s":[53.595,53.595,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":291,"s":[53.595,53.595,100]},{"t":311,"s":[0,0,100]}],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":28,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[677,641,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[53.595,53.595,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":29,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[99,885,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[53.595,53.595,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":30,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[267,654,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[29.984,29.984,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":31,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":131,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":132,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":151,"s":[0]},{"t":161,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":132,"s":[349,346,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":140,"s":[349,1113,0],"to":[0,0,0],"ti":[0,0,0]},{"t":202,"s":[349,346,0]}],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":25,"s":[29.984,29.984,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":35,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":139,"s":[0,0,100]},{"t":140,"s":[29.984,29.984,100]}],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":561,"st":0,"bm":0},{"ddd":0,"ind":32,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":251,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":252,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":282,"s":[0]},{"t":292,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":250,"s":[574,426,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":275,"s":[574,1095,0],"to":[0,0,0],"ti":[0,0,0]},{"t":353,"s":[574,426,0]}],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":70,"s":[29.984,29.984,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":80,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":274,"s":[0,0,100]},{"t":275,"s":[29.984,29.984,100]}],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":33,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[319,513,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[53.595,53.595,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":34,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[544,353,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[29.003,29.003,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":35,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[471,270,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[35.539,35.539,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":36,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[433,699,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[35.539,35.539,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":37,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[321,201,0],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[35.539,35.539,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":38,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":163,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":173,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":350,"s":[100]},{"t":370,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":131,"s":[457,1145,0],"to":[0,-113.833,0],"ti":[0,113.833,0]},{"t":251,"s":[457,462,0]}],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[76.062,76.062,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":39,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":115,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":125,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":350,"s":[100]},{"t":370,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":92,"s":[588,1128,0],"to":[0,-154.167,0],"ti":[0,154.167,0]},{"t":212,"s":[588,203,0]}],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[55.147,55.147,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":40,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":100,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":110,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":350,"s":[100]},{"t":370,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":78,"s":[181,1115,0],"to":[0,-126.167,0],"ti":[0,126.167,0]},{"t":198,"s":[181,358,0]}],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":0,"k":[39.869,39.869,100],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":41,"ty":0,"nm":"Dot","refId":"comp_0","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":309,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":310,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":337,"s":[0]},{"t":347,"s":[100]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":202,"s":[960,540,0],"to":[0,0,0],"ti":[0,0,0]},{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":312,"s":[960,1168,0],"to":[0,0,0],"ti":[0,0,0]},{"t":392,"s":[960,540,0]}],"ix":2},"a":{"a":0,"k":[72,76.5,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":182,"s":[100,100,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":202,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":311,"s":[0,0,100]},{"t":312,"s":[100,100,100]}],"ix":6}},"ao":0,"w":144,"h":153,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":42,"ty":0,"nm":"Bec","refId":"comp_1","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":308,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":314,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":318,"s":[60]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":327,"s":[35]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":332,"s":[60]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":338,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":387,"s":[100]},{"t":412,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[960,540,0],"ix":1},"s":{"a":0,"k":[101,101,100],"ix":6}},"ao":0,"w":1920,"h":1080,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":43,"ty":0,"nm":"Bec","refId":"comp_1","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":306,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":316,"s":[60]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":322,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":325,"s":[35]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":334,"s":[60]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":336,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":387,"s":[100]},{"t":412,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[960,540,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":1920,"h":1080,"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":44,"ty":4,"nm":"Shape Layer 15","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.637],"y":[0.998]},"o":{"x":[0.303],"y":[0]},"t":154,"s":[0]},{"i":{"x":[0.836],"y":[1]},"o":{"x":[0.197],"y":[6.396]},"t":155,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":207,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":211,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":216,"s":[70]},{"t":221,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[1169.214,731.571,0],"ix":2},"a":{"a":0,"k":[-506.786,153.571,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":154,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-474,72.75],[-468.25,61.5]],"c":false}]},{"t":196,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-566.5,252.25],[-468.321,65.143]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":45,"ty":4,"nm":"Shape Layer 23","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":385,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":391.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":400.428,"s":[70]},{"t":409,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":312,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[738,449],[730,444]],"c":false}]},{"t":358,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[738,449],[391,350]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":46,"ty":4,"nm":"Shape Layer 22","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":257,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":263.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":272.428,"s":[70]},{"t":281,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":19,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[204,-177.5],[221,-175]],"c":false}]},{"t":56,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[58,-200],[220,-176.5]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":47,"ty":4,"nm":"Shape Layer 21","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":257,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":263.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":272.428,"s":[70]},{"t":281,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":135,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[48,-200],[57,-201]],"c":false}]},{"t":172,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-171,-213],[57,-201]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":48,"ty":4,"nm":"Shape Layer 20","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":257,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":263.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":272.428,"s":[70]},{"t":281,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":143,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-142.5,-434],[-136,-462]],"c":false}]},{"t":180,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-172,-212],[-136,-462]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":49,"ty":4,"nm":"Shape Layer 19","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":257,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":263.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":272.428,"s":[70]},{"t":281,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":138,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-316,-172],[-308.5,-174]],"c":false}]},{"t":175,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-316,-172],[-171,-218]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":50,"ty":4,"nm":"Shape Layer 18","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":196,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":202.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":211.428,"s":[70]},{"t":220,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":45,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-273.5,109],[-285,97]],"c":false}]},{"t":82,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-94,225],[-285,97]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":51,"ty":4,"nm":"Shape Layer 17","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":196,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":202.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":211.428,"s":[70]},{"t":220,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":72,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-100,431],[-100,413]],"c":false}]},{"t":109,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-100,431],[-94,228]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":52,"ty":4,"nm":"Shape Layer 16","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":137,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":143.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":152.428,"s":[70]},{"t":161,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":71,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-862,345],[-846,355]],"c":false}]},{"t":108,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-862,345],[-598,461]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":53,"ty":4,"nm":"Shape Layer 14","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":252,"s":[0]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":253,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":331,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":337.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":346.428,"s":[70]},{"t":355,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":253,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-360,-307.5],[-370.5,-337.5]],"c":false}]},{"t":288,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-313.5,-173],[-370.5,-337.5]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":54,"ty":4,"nm":"Shape Layer 13","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":295,"s":[0]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":296,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":343,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":349.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":358.428,"s":[70]},{"t":367,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":296,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-504.5,-81],[-477,-95]],"c":false}]},{"t":340,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-504.5,-81],[-317.5,-170.5]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":55,"ty":4,"nm":"Shape Layer 12","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":328,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":334.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":343.428,"s":[70]},{"t":352,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":170,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-416,-184],[-419,-188]],"c":false}]},{"t":218,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-416,-184],[-487.5,-270]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":56,"ty":4,"nm":"Shape Layer 11","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":334,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":340.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":349.428,"s":[70]},{"t":358,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":253,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-501,-261],[-487.5,-271]],"c":false}]},{"t":287,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-613,-193],[-487.5,-271]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":57,"ty":4,"nm":"Shape Layer 10","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":338,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":344.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":353.428,"s":[70]},{"t":362,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":295,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-527,161],[-526.5,150]],"c":false}]},{"t":333,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-527,161],[-504.5,-77]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":58,"ty":4,"nm":"Shape Layer 9","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":332,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":338.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":347.428,"s":[70]},{"t":356,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":240,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-643.5,-29.5],[-655,-41.5]],"c":false}]},{"t":272,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-643.5,-29.5],[-782,-175.5]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":59,"ty":4,"nm":"Shape Layer 8","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":343,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":349.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":358.428,"s":[70]},{"t":367,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":106,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-645,-18.75],[-642,-26.5]],"c":false}]},{"t":152,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-695,115],[-642,-26.5]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":60,"ty":4,"nm":"Shape Layer 7","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":330,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":336.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":345.428,"s":[70]},{"t":354,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":79,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-689.25,118],[-694,116]],"c":false}]},{"t":139,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-527,161],[-694,116]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":61,"ty":4,"nm":"Shape Layer 6","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":251,"s":[0]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":252,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":339,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":345.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":354.428,"s":[70]},{"t":363,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":252,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-640.5,-340.75],[-627.5,-342]],"c":false}]},{"t":273,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-640.5,-340.75],[-372.5,-336.5]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":62,"ty":4,"nm":"Shape Layer 5","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.833],"y":[0.833]},"o":{"x":[0.167],"y":[0.167]},"t":239,"s":[0]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0]},"t":240,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":335,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":341.857,"s":[45]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":350.428,"s":[70]},{"t":359,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.833,"y":0.833},"o":{"x":0.167,"y":0.167},"t":240,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-779.5,-180.5],[-774.5,-188.5]],"c":false}]},{"t":277,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[-779.5,-180.5],[-637,-338]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":63,"ty":4,"nm":"Shape Layer 4","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":216,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":219,"s":[40]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":223,"s":[80]},{"t":229,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":67,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[697.75,185],[699.25,191.75]],"c":false}]},{"t":127,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[649.25,4.75],[699.25,191.75]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":64,"ty":4,"nm":"Shape Layer 3","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":232,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":235,"s":[40]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":239,"s":[80]},{"t":245,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":123,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[645.625,-6.625],[649.25,4.75]],"c":false}]},{"t":183,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[590.875,-201.625],[649.25,4.75]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":65,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":206,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":209,"s":[40]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":213,"s":[80]},{"t":219,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":104,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[479.75,-16.25],[489.5,-29.25]],"c":false}]},{"t":164,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[479.75,-16.25],[591.25,-201.5]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":66,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":197,"s":[100]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":200,"s":[40]},{"i":{"x":[0.17],"y":[1]},"o":{"x":[0.167],"y":[0.167]},"t":204,"s":[80]},{"t":210,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[960,540,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":42,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[456.5,-168],[457.75,-161.75]],"c":false}]},{"t":102,"s":[{"i":[[0,0],[0,0]],"o":[[0,0],[0,0]],"v":[[456.5,-168],[480,-15]],"c":false}]}],"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.18431372549,0.18431372549,0.18431372549,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":3,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":421,"st":0,"bm":0},{"ddd":0,"ind":67,"ty":4,"nm":"thunder","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":182,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":186,"s":[40]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":192,"s":[20]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":200,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":262,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":266,"s":[20]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":271,"s":[40]},{"t":275,"s":[0]}],"ix":11},"r":{"a":0,"k":-39.158,"ix":10},"p":{"a":0,"k":[1497.09,427.024,0],"ix":2},"a":{"a":0,"k":[525.5,-203.5,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0]],"v":[[444.891,34.611],[457.876,131.58],[547.392,64.315]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.964705822515,1,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":21,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 2","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0]],"v":[[569,-411],[418.651,-163.367],[622,-233],[458.876,130.579]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.964705822515,1,0,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":21,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":463,"st":42,"bm":0}],"markers":[]}');

/***/ })

}]);